// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[4]!../../node_modules/leaflet/dist/leaflet.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23636f83%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27rgba%28255, 255, 255, 0.87%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27rgba%28255, 255, 255, 0.87%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27rgba%28255, 255, 255, 0.87%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 21, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23998fed%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.87%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%232eb85c%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23e55353%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23e55353%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2844, 56, 74, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27var%28--cui-body-color%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%232d1cc5%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%2844, 56, 74, 0.95%29%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.87%29%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.87%29%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27currentColor%27 stroke-width=%272.25%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 11 14%27%3E%3Cpath fill=%27rgba%28255, 255, 255, 0.38%29%27 d=%27M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 11 14%27%3E%3Cpath fill=%27rgba%28255, 255, 255, 0.87%29%27 d=%27M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.6%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.87%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
   * CoreUI  v4.3.0 (https://coreui.io)
   * Copyright (c) 2023 creativeLabs Łukasz Holeczek
   * Licensed under MIT (https://github.com/coreui/coreui/blob/main/LICENSE)
   */
:root {
  --cui-blue: #0d6efd;
  --cui-indigo: #6610f2;
  --cui-purple: #6f42c1;
  --cui-pink: #d63384;
  --cui-red: #dc3545;
  --cui-orange: #fd7e14;
  --cui-yellow: #ffc107;
  --cui-green: #198754;
  --cui-teal: #20c997;
  --cui-cyan: #0dcaf0;
  --cui-black: #000015;
  --cui-white: #fff;
  --cui-gray: #8a93a2;
  --cui-gray-dark: #636f83;
  --cui-gray-100: #ebedef;
  --cui-gray-200: #d8dbe0;
  --cui-gray-300: #c4c9d0;
  --cui-gray-400: #b1b7c1;
  --cui-gray-500: #9da5b1;
  --cui-gray-600: #8a93a2;
  --cui-gray-700: #768192;
  --cui-gray-800: #636f83;
  --cui-gray-900: #4f5d73;
  --cui-primary: #321fdb;
  --cui-secondary: #9da5b1;
  --cui-success: #2eb85c;
  --cui-info: #39f;
  --cui-warning: #f9b115;
  --cui-danger: #e55353;
  --cui-light: #ebedef;
  --cui-dark: #4f5d73;
  --cui-primary-rgb: 50, 31, 219;
  --cui-secondary-rgb: 157, 165, 177;
  --cui-success-rgb: 46, 184, 92;
  --cui-info-rgb: 51, 153, 255;
  --cui-warning-rgb: 249, 177, 21;
  --cui-danger-rgb: 229, 83, 83;
  --cui-light-rgb: 235, 237, 239;
  --cui-dark-rgb: 79, 93, 115;
  --cui-white-rgb: 255, 255, 255;
  --cui-black-rgb: 0, 0, 21;
  --cui-body-color-rgb: 44, 56, 74;
  --cui-body-bg-rgb: 255, 255, 255;
  --cui-font-sans-serif: "Aldrich", "Helvetica Neue", Arial, sans-serif;
  --cui-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --cui-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --cui-body-font-family: var(--cui-font-sans-serif);
  --cui-body-font-size: 1rem;
  --cui-body-font-weight: 400;
  --cui-body-line-height: 1.5;
  --cui-body-color: rgba(44, 56, 74, 0.95);
  --cui-body-color-rgb: 44, 56, 74;
  --cui-body-bg: #fff;
  --cui-body-bg-rgb: 255, 255, 255;
  --cui-emphasis-color: #000015;
  --cui-emphasis-color-rgb: 0, 0, 21;
  --cui-secondary-color: rgba(44, 56, 74, 0.681);
  --cui-secondary-color-rgb: 44, 56, 74;
  --cui-secondary-bg: #d8dbe0;
  --cui-secondary-bg-rgb: 216, 219, 224;
  --cui-tertiary-color: rgba(44, 56, 74, 0.38);
  --cui-tertiary-color-rgb: 44, 56, 74;
  --cui-tertiary-bg: #ebedef;
  --cui-tertiary-bg-rgb: 235, 237, 239;
  --cui-high-emphasis: rgba(44, 56, 74, 0.95);
  --cui-medium-emphasis: rgba(44, 56, 74, 0.681);
  --cui-disabled: rgba(44, 56, 74, 0.38);
  --cui-high-emphasis-inverse: rgba(255, 255, 255, 0.87);
  --cui-medium-emphasis-inverse: rgba(255, 255, 255, 0.6);
  --cui-disabled-inverse: rgba(255, 255, 255, 0.38);
  --cui-heading-color: inherit;
  --cui-link-color: #321fdb;
  --cui-link-color-rgb: 50, 31, 219;
  --cui-link-decoration: underline;
  --cui-link-hover-color: #2819af;
  --cui-link-hover-color-rgb: 40, 25, 175;
  --cui-code-color: #d63384;
  --cui-highlight-bg: #fff3cd;
  --cui-border-width: 1px;
  --cui-border-style: solid;
  --cui-border-color: #d8dbe0;
  --cui-border-color-translucent: rgba(0, 0, 21, 0.175);
  --cui-border-radius: 0.375rem;
  --cui-border-radius-sm: 0.25rem;
  --cui-border-radius-lg: 0.5rem;
  --cui-border-radius-xl: 1rem;
  --cui-border-radius-xxl: 2rem;
  --cui-border-radius-2xl: var(--cui-border-radius-xxl);
  --cui-border-radius-pill: 50rem;
  --cui-box-shadow: 0 0.5rem 1rem rgba(0, 0, 21, 0.15);
  --cui-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 21, 0.075);
  --cui-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 21, 0.175);
  --cui-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 21, 0.075);
  --cui-focus-ring-width: 0.25rem;
  --cui-focus-ring-opacity: 0.25;
  --cui-focus-ring-color: rgba(50, 31, 219, 0.25);
  --cui-form-valid-color: #2eb85c;
  --cui-form-valid-border-color: #2eb85c;
  --cui-form-invalid-color: #e55353;
  --cui-form-invalid-border-color: #e55353; }

*,
*::before,
*::after {
  box-sizing: border-box; }

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth; } }

body {
  margin: 0;
  font-family: "Aldrich", "Helvetica Neue", Arial, sans-serif;
  font-family: var(--cui-body-font-family);
  font-size: 1rem;
  font-size: var(--cui-body-font-size);
  font-weight: 400;
  font-weight: var(--cui-body-font-weight);
  line-height: 1.5;
  line-height: var(--cui-body-line-height);
  color: rgba(44, 56, 74, 0.95);
  color: var(--cui-body-color);
  text-align: var(--cui-body-text-align);
  background-color: #fff;
  background-color: var(--cui-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 21, 0); }

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  border-top: var(--cui-border-width) solid;
  opacity: 0.25; }

h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: inherit;
  color: var(--cui-heading-color); }

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw); }
  @media (min-width: 1200px) {
    h1, .h1 {
      font-size: 2.5rem; } }

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw); }
  @media (min-width: 1200px) {
    h2, .h2 {
      font-size: 2rem; } }

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw); }
  @media (min-width: 1200px) {
    h3, .h3 {
      font-size: 1.75rem; } }

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw); }
  @media (min-width: 1200px) {
    h4, .h4 {
      font-size: 1.5rem; } }

h5, .h5 {
  font-size: 1.25rem; }

h6, .h6 {
  font-size: 1rem; }

p {
  margin-top: 0;
  margin-bottom: 1rem; }

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none; }

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit; }

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem; }

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0; }

dt {
  font-weight: 700; }

dd {
  margin-bottom: .5rem; }
  html:not([dir="rtl"]) dd {
    margin-left: 0; }
  *[dir="rtl"] dd {
    margin-right: 0; }

blockquote {
  margin: 0 0 1rem; }

b,
strong {
  font-weight: bolder; }

small, .small {
  font-size: 0.875em; }

mark, .mark {
  padding: 0.1875em;
  background-color: #fff3cd;
  background-color: var(--cui-highlight-bg); }

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline; }

sub {
  bottom: -.25em; }

sup {
  top: -.5em; }

a {
  color: rgba(50, 31, 219, 1);
  color: rgba(var(--cui-link-color-rgb), var(--cui-link-opacity, 1));
  text-decoration: underline; }
  a:hover {
    --cui-link-color-rgb: var(--cui-link-hover-color-rgb); }

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none; }

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-family: var(--cui-font-monospace);
  font-size: 1em; }

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
  color: var(--cui-pre-color, ); }
  pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal; }

code {
  font-size: 0.875em;
  color: #d63384;
  color: var(--cui-code-color);
  word-wrap: break-word; }
  a > code {
    color: inherit; }

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: #fff;
  color: var(--cui-kbd-color, var(--cui-body-bg));
  background-color: rgba(44, 56, 74, 0.95);
  background-color: var(--cui-kbd-bg, var(--cui-body-color));
  border-radius: 0.25rem; }
  kbd kbd {
    padding: 0;
    font-size: 1em; }

figure {
  margin: 0 0 1rem; }

img,
svg {
  vertical-align: middle; }

table {
  caption-side: bottom;
  border-collapse: collapse; }

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: rgba(44, 56, 74, 0.681);
  color: var(--cui-table-caption-color, var(--cui-secondary-color));
  text-align: left; }

th {
  text-align: inherit;
  text-align: -webkit-match-parent; }

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0; }

label {
  display: inline-block; }

button {
  border-radius: 0; }

button:focus:not(:focus-visible) {
  outline: 0; }

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit; }

button,
select {
  text-transform: none; }

[role="button"] {
  cursor: pointer; }

select {
  word-wrap: normal; }
  select:disabled {
    opacity: 1; }

[list]:not([type="date"]):not([type="datetime-local"]):not([type="month"]):not([type="week"]):not([type="time"])::-webkit-calendar-picker-indicator {
  display: none !important; }

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button; }
  button:not(:disabled),
  [type="button"]:not(:disabled),
  [type="reset"]:not(:disabled),
  [type="submit"]:not(:disabled) {
    cursor: pointer; }

::-moz-focus-inner {
  padding: 0;
  border-style: none; }

textarea {
  resize: vertical; }

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0; }

legend {
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit; }
  html:not([dir="rtl"]) legend {
    float: left; }
  *[dir="rtl"] legend {
    float: right; }
  @media (min-width: 1200px) {
    legend {
      font-size: 1.5rem; } }
  legend + * {
    clear: left; }

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0; }

::-webkit-inner-spin-button {
  height: auto; }

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px; }

*[dir="rtl"] [type="tel"],
*[dir="rtl"] [type="url"],
*[dir="rtl"] [type="email"],
*[dir="rtl"] [type="number"] {
  direction: ltr; }

::-webkit-search-decoration {
  -webkit-appearance: none; }

::-webkit-color-swatch-wrapper {
  padding: 0; }

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button; }

::file-selector-button {
  font: inherit;
  -webkit-appearance: button; }

output {
  display: inline-block; }

iframe {
  border: 0; }

summary {
  display: list-item;
  cursor: pointer; }

progress {
  vertical-align: baseline; }

[hidden] {
  display: none !important; }

.lead {
  font-size: 1.25rem;
  font-weight: 300; }

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-1 {
      font-size: 5rem; } }

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-2 {
      font-size: 4.5rem; } }

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-3 {
      font-size: 4rem; } }

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-4 {
      font-size: 3.5rem; } }

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-5 {
      font-size: 3rem; } }

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-6 {
      font-size: 2.5rem; } }

.list-unstyled {
  list-style: none; }
  html:not([dir="rtl"]) .list-unstyled {
    padding-left: 0; }
  *[dir="rtl"] .list-unstyled {
    padding-right: 0; }

.list-inline {
  list-style: none; }
  html:not([dir="rtl"]) .list-inline {
    padding-left: 0; }
  *[dir="rtl"] .list-inline {
    padding-right: 0; }

.list-inline-item {
  display: inline-block; }
  html:not([dir="rtl"]) .list-inline-item:not(:last-child) {
    margin-right: 0.5rem; }
  *[dir="rtl"] .list-inline-item:not(:last-child) {
    margin-left: 0.5rem; }

.initialism {
  font-size: 0.875em;
  text-transform: uppercase; }

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem; }
  .blockquote > :last-child {
    margin-bottom: 0; }

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #8a93a2; }
  .blockquote-footer::before {
    content: "\\2014\\00A0"; }

.img-fluid {
  max-width: 100%;
  height: auto; }

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  background-color: var(--cui-thumbnail-bg, var(--cui-body-bg));
  border: 1px solid #d8dbe0;
  border: var(--cui-border-width) solid var(--cui-thumbnail-border-color, var(--cui-border-color));
  border-radius: 0.375rem;
  border-radius: var(--cui-border-radius);
  max-width: 100%;
  height: auto; }

.figure {
  display: inline-block; }

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1; }

.figure-caption {
  font-size: 0.875em;
  color: rgba(44, 56, 74, 0.681);
  color: var(--cui-figure-caption-color, var(--cui-secondary-color)); }

.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl,
.container-xxl {
  --cui-gutter-x: 1.5rem;
  --cui-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--cui-gutter-x) * .5);
  padding-left: calc(var(--cui-gutter-x) * .5);
  margin-right: auto;
  margin-left: auto; }

@media (min-width: 576px) {
  .container, .container-sm {
    max-width: 540px; } }

@media (min-width: 768px) {
  .container, .container-sm, .container-md {
    max-width: 720px; } }

@media (min-width: 992px) {
  .container, .container-sm, .container-md, .container-lg {
    max-width: 960px; } }

@media (min-width: 1200px) {
  .container, .container-sm, .container-md, .container-lg, .container-xl {
    max-width: 1140px; } }

@media (min-width: 1400px) {
  .container, .container-sm, .container-md, .container-lg, .container-xl, .container-xxl {
    max-width: 1320px; } }

:root {
  --cui-breakpoint-xs: 0;
  --cui-breakpoint-sm: 576px;
  --cui-breakpoint-md: 768px;
  --cui-breakpoint-lg: 992px;
  --cui-breakpoint-xl: 1200px;
  --cui-breakpoint-xxl: 1400px;
  --cui-mobile-breakpoint: md; }

.row {
  --cui-gutter-x: 1.5rem;
  --cui-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--cui-gutter-y));
  margin-right: calc(-.5 * var(--cui-gutter-x));
  margin-left: calc(-.5 * var(--cui-gutter-x)); }
  .row > * {
    flex-shrink: 0;
    width: 100%;
    max-width: 100%;
    padding-right: calc(var(--cui-gutter-x) * .5);
    padding-left: calc(var(--cui-gutter-x) * .5);
    margin-top: var(--cui-gutter-y); }

.col {
  flex: 1 0; }

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto; }

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%; }

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%; }

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333%; }

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%; }

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%; }

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66667%; }

.col-auto {
  flex: 0 0 auto;
  width: auto; }

.col-1 {
  flex: 0 0 auto;
  width: 8.33333%; }

.col-2 {
  flex: 0 0 auto;
  width: 16.66667%; }

.col-3 {
  flex: 0 0 auto;
  width: 25%; }

.col-4 {
  flex: 0 0 auto;
  width: 33.33333%; }

.col-5 {
  flex: 0 0 auto;
  width: 41.66667%; }

.col-6 {
  flex: 0 0 auto;
  width: 50%; }

.col-7 {
  flex: 0 0 auto;
  width: 58.33333%; }

.col-8 {
  flex: 0 0 auto;
  width: 66.66667%; }

.col-9 {
  flex: 0 0 auto;
  width: 75%; }

.col-10 {
  flex: 0 0 auto;
  width: 83.33333%; }

.col-11 {
  flex: 0 0 auto;
  width: 91.66667%; }

.col-12 {
  flex: 0 0 auto;
  width: 100%; }

html:not([dir="rtl"]) .offset-1 {
  margin-left: 8.33333%; }

*[dir="rtl"] .offset-1 {
  margin-right: 8.33333%; }

html:not([dir="rtl"]) .offset-2 {
  margin-left: 16.66667%; }

*[dir="rtl"] .offset-2 {
  margin-right: 16.66667%; }

html:not([dir="rtl"]) .offset-3 {
  margin-left: 25%; }

*[dir="rtl"] .offset-3 {
  margin-right: 25%; }

html:not([dir="rtl"]) .offset-4 {
  margin-left: 33.33333%; }

*[dir="rtl"] .offset-4 {
  margin-right: 33.33333%; }

html:not([dir="rtl"]) .offset-5 {
  margin-left: 41.66667%; }

*[dir="rtl"] .offset-5 {
  margin-right: 41.66667%; }

html:not([dir="rtl"]) .offset-6 {
  margin-left: 50%; }

*[dir="rtl"] .offset-6 {
  margin-right: 50%; }

html:not([dir="rtl"]) .offset-7 {
  margin-left: 58.33333%; }

*[dir="rtl"] .offset-7 {
  margin-right: 58.33333%; }

html:not([dir="rtl"]) .offset-8 {
  margin-left: 66.66667%; }

*[dir="rtl"] .offset-8 {
  margin-right: 66.66667%; }

html:not([dir="rtl"]) .offset-9 {
  margin-left: 75%; }

*[dir="rtl"] .offset-9 {
  margin-right: 75%; }

html:not([dir="rtl"]) .offset-10 {
  margin-left: 83.33333%; }

*[dir="rtl"] .offset-10 {
  margin-right: 83.33333%; }

html:not([dir="rtl"]) .offset-11 {
  margin-left: 91.66667%; }

*[dir="rtl"] .offset-11 {
  margin-right: 91.66667%; }

.g-0,
.gx-0 {
  --cui-gutter-x: 0; }

.g-0,
.gy-0 {
  --cui-gutter-y: 0; }

.g-1,
.gx-1 {
  --cui-gutter-x: 0.25rem; }

.g-1,
.gy-1 {
  --cui-gutter-y: 0.25rem; }

.g-2,
.gx-2 {
  --cui-gutter-x: 0.5rem; }

.g-2,
.gy-2 {
  --cui-gutter-y: 0.5rem; }

.g-3,
.gx-3 {
  --cui-gutter-x: 1rem; }

.g-3,
.gy-3 {
  --cui-gutter-y: 1rem; }

.g-4,
.gx-4 {
  --cui-gutter-x: 1.5rem; }

.g-4,
.gy-4 {
  --cui-gutter-y: 1.5rem; }

.g-5,
.gx-5 {
  --cui-gutter-x: 3rem; }

.g-5,
.gy-5 {
  --cui-gutter-y: 3rem; }

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0; }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%; }
  html:not([dir="rtl"]) .offset-sm-0 {
    margin-left: 0; }
  *[dir="rtl"] .offset-sm-0 {
    margin-right: 0; }
  html:not([dir="rtl"]) .offset-sm-1 {
    margin-left: 8.33333%; }
  *[dir="rtl"] .offset-sm-1 {
    margin-right: 8.33333%; }
  html:not([dir="rtl"]) .offset-sm-2 {
    margin-left: 16.66667%; }
  *[dir="rtl"] .offset-sm-2 {
    margin-right: 16.66667%; }
  html:not([dir="rtl"]) .offset-sm-3 {
    margin-left: 25%; }
  *[dir="rtl"] .offset-sm-3 {
    margin-right: 25%; }
  html:not([dir="rtl"]) .offset-sm-4 {
    margin-left: 33.33333%; }
  *[dir="rtl"] .offset-sm-4 {
    margin-right: 33.33333%; }
  html:not([dir="rtl"]) .offset-sm-5 {
    margin-left: 41.66667%; }
  *[dir="rtl"] .offset-sm-5 {
    margin-right: 41.66667%; }
  html:not([dir="rtl"]) .offset-sm-6 {
    margin-left: 50%; }
  *[dir="rtl"] .offset-sm-6 {
    margin-right: 50%; }
  html:not([dir="rtl"]) .offset-sm-7 {
    margin-left: 58.33333%; }
  *[dir="rtl"] .offset-sm-7 {
    margin-right: 58.33333%; }
  html:not([dir="rtl"]) .offset-sm-8 {
    margin-left: 66.66667%; }
  *[dir="rtl"] .offset-sm-8 {
    margin-right: 66.66667%; }
  html:not([dir="rtl"]) .offset-sm-9 {
    margin-left: 75%; }
  *[dir="rtl"] .offset-sm-9 {
    margin-right: 75%; }
  html:not([dir="rtl"]) .offset-sm-10 {
    margin-left: 83.33333%; }
  *[dir="rtl"] .offset-sm-10 {
    margin-right: 83.33333%; }
  html:not([dir="rtl"]) .offset-sm-11 {
    margin-left: 91.66667%; }
  *[dir="rtl"] .offset-sm-11 {
    margin-right: 91.66667%; }
  .g-sm-0,
  .gx-sm-0 {
    --cui-gutter-x: 0; }
  .g-sm-0,
  .gy-sm-0 {
    --cui-gutter-y: 0; }
  .g-sm-1,
  .gx-sm-1 {
    --cui-gutter-x: 0.25rem; }
  .g-sm-1,
  .gy-sm-1 {
    --cui-gutter-y: 0.25rem; }
  .g-sm-2,
  .gx-sm-2 {
    --cui-gutter-x: 0.5rem; }
  .g-sm-2,
  .gy-sm-2 {
    --cui-gutter-y: 0.5rem; }
  .g-sm-3,
  .gx-sm-3 {
    --cui-gutter-x: 1rem; }
  .g-sm-3,
  .gy-sm-3 {
    --cui-gutter-y: 1rem; }
  .g-sm-4,
  .gx-sm-4 {
    --cui-gutter-x: 1.5rem; }
  .g-sm-4,
  .gy-sm-4 {
    --cui-gutter-y: 1.5rem; }
  .g-sm-5,
  .gx-sm-5 {
    --cui-gutter-x: 3rem; }
  .g-sm-5,
  .gy-sm-5 {
    --cui-gutter-y: 3rem; } }

@media (min-width: 768px) {
  .col-md {
    flex: 1 0; }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%; }
  html:not([dir="rtl"]) .offset-md-0 {
    margin-left: 0; }
  *[dir="rtl"] .offset-md-0 {
    margin-right: 0; }
  html:not([dir="rtl"]) .offset-md-1 {
    margin-left: 8.33333%; }
  *[dir="rtl"] .offset-md-1 {
    margin-right: 8.33333%; }
  html:not([dir="rtl"]) .offset-md-2 {
    margin-left: 16.66667%; }
  *[dir="rtl"] .offset-md-2 {
    margin-right: 16.66667%; }
  html:not([dir="rtl"]) .offset-md-3 {
    margin-left: 25%; }
  *[dir="rtl"] .offset-md-3 {
    margin-right: 25%; }
  html:not([dir="rtl"]) .offset-md-4 {
    margin-left: 33.33333%; }
  *[dir="rtl"] .offset-md-4 {
    margin-right: 33.33333%; }
  html:not([dir="rtl"]) .offset-md-5 {
    margin-left: 41.66667%; }
  *[dir="rtl"] .offset-md-5 {
    margin-right: 41.66667%; }
  html:not([dir="rtl"]) .offset-md-6 {
    margin-left: 50%; }
  *[dir="rtl"] .offset-md-6 {
    margin-right: 50%; }
  html:not([dir="rtl"]) .offset-md-7 {
    margin-left: 58.33333%; }
  *[dir="rtl"] .offset-md-7 {
    margin-right: 58.33333%; }
  html:not([dir="rtl"]) .offset-md-8 {
    margin-left: 66.66667%; }
  *[dir="rtl"] .offset-md-8 {
    margin-right: 66.66667%; }
  html:not([dir="rtl"]) .offset-md-9 {
    margin-left: 75%; }
  *[dir="rtl"] .offset-md-9 {
    margin-right: 75%; }
  html:not([dir="rtl"]) .offset-md-10 {
    margin-left: 83.33333%; }
  *[dir="rtl"] .offset-md-10 {
    margin-right: 83.33333%; }
  html:not([dir="rtl"]) .offset-md-11 {
    margin-left: 91.66667%; }
  *[dir="rtl"] .offset-md-11 {
    margin-right: 91.66667%; }
  .g-md-0,
  .gx-md-0 {
    --cui-gutter-x: 0; }
  .g-md-0,
  .gy-md-0 {
    --cui-gutter-y: 0; }
  .g-md-1,
  .gx-md-1 {
    --cui-gutter-x: 0.25rem; }
  .g-md-1,
  .gy-md-1 {
    --cui-gutter-y: 0.25rem; }
  .g-md-2,
  .gx-md-2 {
    --cui-gutter-x: 0.5rem; }
  .g-md-2,
  .gy-md-2 {
    --cui-gutter-y: 0.5rem; }
  .g-md-3,
  .gx-md-3 {
    --cui-gutter-x: 1rem; }
  .g-md-3,
  .gy-md-3 {
    --cui-gutter-y: 1rem; }
  .g-md-4,
  .gx-md-4 {
    --cui-gutter-x: 1.5rem; }
  .g-md-4,
  .gy-md-4 {
    --cui-gutter-y: 1.5rem; }
  .g-md-5,
  .gx-md-5 {
    --cui-gutter-x: 3rem; }
  .g-md-5,
  .gy-md-5 {
    --cui-gutter-y: 3rem; } }

@media (min-width: 992px) {
  .col-lg {
    flex: 1 0; }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%; }
  html:not([dir="rtl"]) .offset-lg-0 {
    margin-left: 0; }
  *[dir="rtl"] .offset-lg-0 {
    margin-right: 0; }
  html:not([dir="rtl"]) .offset-lg-1 {
    margin-left: 8.33333%; }
  *[dir="rtl"] .offset-lg-1 {
    margin-right: 8.33333%; }
  html:not([dir="rtl"]) .offset-lg-2 {
    margin-left: 16.66667%; }
  *[dir="rtl"] .offset-lg-2 {
    margin-right: 16.66667%; }
  html:not([dir="rtl"]) .offset-lg-3 {
    margin-left: 25%; }
  *[dir="rtl"] .offset-lg-3 {
    margin-right: 25%; }
  html:not([dir="rtl"]) .offset-lg-4 {
    margin-left: 33.33333%; }
  *[dir="rtl"] .offset-lg-4 {
    margin-right: 33.33333%; }
  html:not([dir="rtl"]) .offset-lg-5 {
    margin-left: 41.66667%; }
  *[dir="rtl"] .offset-lg-5 {
    margin-right: 41.66667%; }
  html:not([dir="rtl"]) .offset-lg-6 {
    margin-left: 50%; }
  *[dir="rtl"] .offset-lg-6 {
    margin-right: 50%; }
  html:not([dir="rtl"]) .offset-lg-7 {
    margin-left: 58.33333%; }
  *[dir="rtl"] .offset-lg-7 {
    margin-right: 58.33333%; }
  html:not([dir="rtl"]) .offset-lg-8 {
    margin-left: 66.66667%; }
  *[dir="rtl"] .offset-lg-8 {
    margin-right: 66.66667%; }
  html:not([dir="rtl"]) .offset-lg-9 {
    margin-left: 75%; }
  *[dir="rtl"] .offset-lg-9 {
    margin-right: 75%; }
  html:not([dir="rtl"]) .offset-lg-10 {
    margin-left: 83.33333%; }
  *[dir="rtl"] .offset-lg-10 {
    margin-right: 83.33333%; }
  html:not([dir="rtl"]) .offset-lg-11 {
    margin-left: 91.66667%; }
  *[dir="rtl"] .offset-lg-11 {
    margin-right: 91.66667%; }
  .g-lg-0,
  .gx-lg-0 {
    --cui-gutter-x: 0; }
  .g-lg-0,
  .gy-lg-0 {
    --cui-gutter-y: 0; }
  .g-lg-1,
  .gx-lg-1 {
    --cui-gutter-x: 0.25rem; }
  .g-lg-1,
  .gy-lg-1 {
    --cui-gutter-y: 0.25rem; }
  .g-lg-2,
  .gx-lg-2 {
    --cui-gutter-x: 0.5rem; }
  .g-lg-2,
  .gy-lg-2 {
    --cui-gutter-y: 0.5rem; }
  .g-lg-3,
  .gx-lg-3 {
    --cui-gutter-x: 1rem; }
  .g-lg-3,
  .gy-lg-3 {
    --cui-gutter-y: 1rem; }
  .g-lg-4,
  .gx-lg-4 {
    --cui-gutter-x: 1.5rem; }
  .g-lg-4,
  .gy-lg-4 {
    --cui-gutter-y: 1.5rem; }
  .g-lg-5,
  .gx-lg-5 {
    --cui-gutter-x: 3rem; }
  .g-lg-5,
  .gy-lg-5 {
    --cui-gutter-y: 3rem; } }

@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0; }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%; }
  html:not([dir="rtl"]) .offset-xl-0 {
    margin-left: 0; }
  *[dir="rtl"] .offset-xl-0 {
    margin-right: 0; }
  html:not([dir="rtl"]) .offset-xl-1 {
    margin-left: 8.33333%; }
  *[dir="rtl"] .offset-xl-1 {
    margin-right: 8.33333%; }
  html:not([dir="rtl"]) .offset-xl-2 {
    margin-left: 16.66667%; }
  *[dir="rtl"] .offset-xl-2 {
    margin-right: 16.66667%; }
  html:not([dir="rtl"]) .offset-xl-3 {
    margin-left: 25%; }
  *[dir="rtl"] .offset-xl-3 {
    margin-right: 25%; }
  html:not([dir="rtl"]) .offset-xl-4 {
    margin-left: 33.33333%; }
  *[dir="rtl"] .offset-xl-4 {
    margin-right: 33.33333%; }
  html:not([dir="rtl"]) .offset-xl-5 {
    margin-left: 41.66667%; }
  *[dir="rtl"] .offset-xl-5 {
    margin-right: 41.66667%; }
  html:not([dir="rtl"]) .offset-xl-6 {
    margin-left: 50%; }
  *[dir="rtl"] .offset-xl-6 {
    margin-right: 50%; }
  html:not([dir="rtl"]) .offset-xl-7 {
    margin-left: 58.33333%; }
  *[dir="rtl"] .offset-xl-7 {
    margin-right: 58.33333%; }
  html:not([dir="rtl"]) .offset-xl-8 {
    margin-left: 66.66667%; }
  *[dir="rtl"] .offset-xl-8 {
    margin-right: 66.66667%; }
  html:not([dir="rtl"]) .offset-xl-9 {
    margin-left: 75%; }
  *[dir="rtl"] .offset-xl-9 {
    margin-right: 75%; }
  html:not([dir="rtl"]) .offset-xl-10 {
    margin-left: 83.33333%; }
  *[dir="rtl"] .offset-xl-10 {
    margin-right: 83.33333%; }
  html:not([dir="rtl"]) .offset-xl-11 {
    margin-left: 91.66667%; }
  *[dir="rtl"] .offset-xl-11 {
    margin-right: 91.66667%; }
  .g-xl-0,
  .gx-xl-0 {
    --cui-gutter-x: 0; }
  .g-xl-0,
  .gy-xl-0 {
    --cui-gutter-y: 0; }
  .g-xl-1,
  .gx-xl-1 {
    --cui-gutter-x: 0.25rem; }
  .g-xl-1,
  .gy-xl-1 {
    --cui-gutter-y: 0.25rem; }
  .g-xl-2,
  .gx-xl-2 {
    --cui-gutter-x: 0.5rem; }
  .g-xl-2,
  .gy-xl-2 {
    --cui-gutter-y: 0.5rem; }
  .g-xl-3,
  .gx-xl-3 {
    --cui-gutter-x: 1rem; }
  .g-xl-3,
  .gy-xl-3 {
    --cui-gutter-y: 1rem; }
  .g-xl-4,
  .gx-xl-4 {
    --cui-gutter-x: 1.5rem; }
  .g-xl-4,
  .gy-xl-4 {
    --cui-gutter-y: 1.5rem; }
  .g-xl-5,
  .gx-xl-5 {
    --cui-gutter-x: 3rem; }
  .g-xl-5,
  .gy-xl-5 {
    --cui-gutter-y: 3rem; } }

@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0; }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%; }
  html:not([dir="rtl"]) .offset-xxl-0 {
    margin-left: 0; }
  *[dir="rtl"] .offset-xxl-0 {
    margin-right: 0; }
  html:not([dir="rtl"]) .offset-xxl-1 {
    margin-left: 8.33333%; }
  *[dir="rtl"] .offset-xxl-1 {
    margin-right: 8.33333%; }
  html:not([dir="rtl"]) .offset-xxl-2 {
    margin-left: 16.66667%; }
  *[dir="rtl"] .offset-xxl-2 {
    margin-right: 16.66667%; }
  html:not([dir="rtl"]) .offset-xxl-3 {
    margin-left: 25%; }
  *[dir="rtl"] .offset-xxl-3 {
    margin-right: 25%; }
  html:not([dir="rtl"]) .offset-xxl-4 {
    margin-left: 33.33333%; }
  *[dir="rtl"] .offset-xxl-4 {
    margin-right: 33.33333%; }
  html:not([dir="rtl"]) .offset-xxl-5 {
    margin-left: 41.66667%; }
  *[dir="rtl"] .offset-xxl-5 {
    margin-right: 41.66667%; }
  html:not([dir="rtl"]) .offset-xxl-6 {
    margin-left: 50%; }
  *[dir="rtl"] .offset-xxl-6 {
    margin-right: 50%; }
  html:not([dir="rtl"]) .offset-xxl-7 {
    margin-left: 58.33333%; }
  *[dir="rtl"] .offset-xxl-7 {
    margin-right: 58.33333%; }
  html:not([dir="rtl"]) .offset-xxl-8 {
    margin-left: 66.66667%; }
  *[dir="rtl"] .offset-xxl-8 {
    margin-right: 66.66667%; }
  html:not([dir="rtl"]) .offset-xxl-9 {
    margin-left: 75%; }
  *[dir="rtl"] .offset-xxl-9 {
    margin-right: 75%; }
  html:not([dir="rtl"]) .offset-xxl-10 {
    margin-left: 83.33333%; }
  *[dir="rtl"] .offset-xxl-10 {
    margin-right: 83.33333%; }
  html:not([dir="rtl"]) .offset-xxl-11 {
    margin-left: 91.66667%; }
  *[dir="rtl"] .offset-xxl-11 {
    margin-right: 91.66667%; }
  .g-xxl-0,
  .gx-xxl-0 {
    --cui-gutter-x: 0; }
  .g-xxl-0,
  .gy-xxl-0 {
    --cui-gutter-y: 0; }
  .g-xxl-1,
  .gx-xxl-1 {
    --cui-gutter-x: 0.25rem; }
  .g-xxl-1,
  .gy-xxl-1 {
    --cui-gutter-y: 0.25rem; }
  .g-xxl-2,
  .gx-xxl-2 {
    --cui-gutter-x: 0.5rem; }
  .g-xxl-2,
  .gy-xxl-2 {
    --cui-gutter-y: 0.5rem; }
  .g-xxl-3,
  .gx-xxl-3 {
    --cui-gutter-x: 1rem; }
  .g-xxl-3,
  .gy-xxl-3 {
    --cui-gutter-y: 1rem; }
  .g-xxl-4,
  .gx-xxl-4 {
    --cui-gutter-x: 1.5rem; }
  .g-xxl-4,
  .gy-xxl-4 {
    --cui-gutter-y: 1.5rem; }
  .g-xxl-5,
  .gx-xxl-5 {
    --cui-gutter-x: 3rem; }
  .g-xxl-5,
  .gy-xxl-5 {
    --cui-gutter-y: 3rem; } }

.table {
  --cui-table-color-type: initial;
  --cui-table-bg-type: initial;
  --cui-table-color-state: initial;
  --cui-table-bg-state: initial;
  --cui-table-color: var(--cui-body-color);
  --cui-table-bg: var(--cui-body-bg);
  --cui-table-border-color: var(--cui-border-color);
  --cui-table-accent-bg: transparent;
  --cui-table-striped-color: var(--cui-body-color);
  --cui-table-striped-bg: rgba(0, 0, 21, 0.05);
  --cui-table-active-color: var(--cui-body-color);
  --cui-table-active-bg: rgba(0, 0, 21, 0.1);
  --cui-table-hover-color: var(--cui-body-color);
  --cui-table-hover-bg: rgba(0, 0, 21, 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--cui-table-border-color); }
  .table > :not(caption) > * > * {
    padding: 0.5rem 0.5rem;
    color: var(--cui-table-color);
    color: var(--cui-table-color-state, var(--cui-table-color-type, var(--cui-table-color)));
    background-color: var(--cui-table-bg);
    border-bottom-width: 1px;
    border-bottom-width: var(--cui-border-width);
    box-shadow: inset 0 0 0 9999px var(--cui-table-accent-bg);
    box-shadow: inset 0 0 0 9999px var(--cui-table-bg-state, var(--cui-table-bg-type, var(--cui-table-accent-bg))); }
  .table > tbody {
    vertical-align: inherit; }
  .table > thead {
    vertical-align: bottom; }

.table-group-divider {
  border-top: calc(1px * 2) solid currentcolor;
  border-top: calc(var(--cui-border-width) * 2) solid currentcolor; }

.caption-top {
  caption-side: top; }

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem; }

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
  border-width: var(--cui-border-width) 0; }
  .table-bordered > :not(caption) > * > * {
    border-width: 0 1px;
    border-width: 0 var(--cui-border-width); }

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0; }

.table-borderless > :not(:first-child) {
  border-top-width: 0; }

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --cui-table-color-type: var(--cui-table-striped-color);
  --cui-table-bg-type: var(--cui-table-striped-bg); }

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --cui-table-color-type: var(--cui-table-striped-color);
  --cui-table-bg-type: var(--cui-table-striped-bg); }

.table-active {
  --cui-table-color-state: var(--cui-table-active-color);
  --cui-table-bg-state: var(--cui-table-active-bg); }

.table-hover > tbody > tr:hover > * {
  --cui-table-color-state: var(--cui-table-hover-color);
  --cui-table-bg-state: var(--cui-table-hover-bg); }

.table-primary {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #d6d2f8;
  --cui-table-border-color: rgba(198, 196, 232, 0.995);
  --cui-table-striped-bg: rgba(206, 203, 240, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(198, 196, 232, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(202, 199, 236, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color); }

.table-secondary {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #ebedef;
  --cui-table-border-color: rgba(218, 220, 224, 0.995);
  --cui-table-striped-bg: rgba(226, 229, 232, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(218, 220, 224, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(222, 225, 228, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color); }

.table-success {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #d5f1de;
  --cui-table-border-color: rgba(198, 224, 208, 0.995);
  --cui-table-striped-bg: rgba(205, 233, 215, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(198, 224, 208, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(201, 228, 212, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color); }

.table-info {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #d6ebff;
  --cui-table-border-color: rgba(198, 219, 238, 0.995);
  --cui-table-striped-bg: rgba(206, 227, 247, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(198, 219, 238, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(202, 223, 243, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color); }

.table-warning {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #feefd0;
  --cui-table-border-color: rgba(235, 222, 196, 0.995);
  --cui-table-striped-bg: rgba(244, 231, 202, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(235, 222, 196, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(240, 226, 199, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color); }

.table-danger {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #fadddd;
  --cui-table-border-color: rgba(231, 206, 208, 0.995);
  --cui-table-striped-bg: rgba(241, 214, 214, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(231, 206, 208, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(236, 210, 211, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color); }

.table-light {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #ebedef;
  --cui-table-border-color: rgba(218, 220, 224, 0.995);
  --cui-table-striped-bg: rgba(226, 229, 232, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(218, 220, 224, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(222, 225, 228, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color); }

.table-dark {
  --cui-table-color: rgba(255, 255, 255, 0.87);
  --cui-table-bg: #4f5d73;
  --cui-table-border-color: rgba(93, 106, 126, 0.987);
  --cui-table-striped-bg: rgba(86, 99, 120, 0.9935);
  --cui-table-striped-color: rgba(255, 255, 255, 0.87);
  --cui-table-active-bg: rgba(93, 106, 126, 0.987);
  --cui-table-active-color: rgba(255, 255, 255, 0.87);
  --cui-table-hover-bg: rgba(89, 103, 123, 0.99025);
  --cui-table-hover-color: rgba(255, 255, 255, 0.87);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color); }

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; }

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

.form-label {
  margin-bottom: 0.5rem;
  color: var(--cui-form-label-color, ); }

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-top: calc(0.375rem + var(--cui-border-width));
  padding-bottom: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + var(--cui-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
  color: var(--cui-form-label-color, ); }

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-top: calc(0.5rem + var(--cui-border-width));
  padding-bottom: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + var(--cui-border-width));
  font-size: 1.25rem; }

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-top: calc(0.25rem + var(--cui-border-width));
  padding-bottom: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + var(--cui-border-width));
  font-size: 0.875rem; }

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: rgba(44, 56, 74, 0.681);
  color: var(--cui-form-text-color, var(--cui-secondary-color)); }

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: rgba(44, 56, 74, 0.95);
  color: var(--cui-input-color, var(--cui-body-color));
  -webkit-appearance: none;
          appearance: none;
  background-color: #fff;
  background-color: var(--cui-input-bg, var(--cui-body-bg));
  background-clip: padding-box;
  border: 1px solid #d8dbe0;
  border: var(--cui-border-width) solid var(--cui-input-border-color, var(--cui-border-color));
  border-radius: 0.375rem;
  border-radius: var(--cui-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .form-control {
      transition: none; } }
  .form-control[type="file"] {
    overflow: hidden; }
    .form-control[type="file"]:not(:disabled):not([readonly]) {
      cursor: pointer; }
  .form-control:focus {
    color: rgba(44, 56, 74, 0.95);
    color: var(--cui-input-focus-color, var(--cui-body-color));
    background-color: #fff;
    background-color: var(--cui-input-focus-bg, var(--cui-body-bg));
    border-color: #998fed;
    border-color: var(--cui-input-focus-border-color, #998fed);
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25); }
  .form-control::-webkit-date-and-time-value {
    min-width: 85px;
    height: 1.5em;
    margin: 0; }
  .form-control::-webkit-datetime-edit {
    display: block;
    padding: 0; }
  .form-control::placeholder {
    color: rgba(44, 56, 74, 0.681);
    color: var(--cui-input-placeholder-color, var(--cui-secondary-color));
    opacity: 1; }
  .form-control:disabled {
    background-color: #d8dbe0;
    background-color: var(--cui-secondary-bg);
    opacity: 1; }
  .form-control::-webkit-file-upload-button {
    padding: 0.375rem 0.75rem;
    margin: -0.375rem -0.75rem;
    -webkit-margin-end: 0.75rem;
            margin-inline-end: 0.75rem;
    color: rgba(44, 56, 74, 0.95);
    color: var(--cui-form-file-button-color, var(--cui-body-color));
    background-color: #ebedef;
    background-color: var(--cui-form-file-button-bg, var(--cui-tertiary-bg));
    pointer-events: none;
    border-color: inherit;
    border-style: solid;
    border-width: 0;
    border-inline-end-width: 1px;
    border-inline-end-width: var(--cui-border-width);
    border-radius: 0;
    -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  .form-control::file-selector-button {
    padding: 0.375rem 0.75rem;
    margin: -0.375rem -0.75rem;
    -webkit-margin-end: 0.75rem;
            margin-inline-end: 0.75rem;
    color: rgba(44, 56, 74, 0.95);
    color: var(--cui-form-file-button-color, var(--cui-body-color));
    background-color: #ebedef;
    background-color: var(--cui-form-file-button-bg, var(--cui-tertiary-bg));
    pointer-events: none;
    border-color: inherit;
    border-style: solid;
    border-width: 0;
    border-inline-end-width: 1px;
    border-inline-end-width: var(--cui-border-width);
    border-radius: 0;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-control::-webkit-file-upload-button {
        -webkit-transition: none;
        transition: none; }
      .form-control::file-selector-button {
        transition: none; } }
  .form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {
    background-color: #d8dbe0;
    background-color: var(--cui-form-file-button-hover-bg, var(--cui-secondary-bg)); }
  .form-control:hover:not(:disabled):not([readonly])::file-selector-button {
    background-color: #d8dbe0;
    background-color: var(--cui-form-file-button-hover-bg, var(--cui-secondary-bg)); }

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: rgba(44, 56, 74, 0.95);
  color: var(--cui-input-plaintext-color, var(--cui-body-color));
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
  border-width: var(--cui-border-width) 0; }
  .form-control-plaintext:focus {
    outline: 0; }
  .form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
    padding-right: 0;
    padding-left: 0; }

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(1px * 2));
  min-height: calc(1.5em + 0.5rem + calc(var(--cui-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
  border-radius: var(--cui-border-radius-sm); }
  .form-control-sm::-webkit-file-upload-button {
    padding: 0.25rem 0.5rem;
    margin: -0.25rem -0.5rem;
    -webkit-margin-end: 0.5rem;
            margin-inline-end: 0.5rem; }
  .form-control-sm::file-selector-button {
    padding: 0.25rem 0.5rem;
    margin: -0.25rem -0.5rem;
    -webkit-margin-end: 0.5rem;
            margin-inline-end: 0.5rem; }

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(1px * 2));
  min-height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: 0.5rem;
  border-radius: var(--cui-border-radius-lg); }
  .form-control-lg::-webkit-file-upload-button {
    padding: 0.5rem 1rem;
    margin: -0.5rem -1rem;
    -webkit-margin-end: 1rem;
            margin-inline-end: 1rem; }
  .form-control-lg::file-selector-button {
    padding: 0.5rem 1rem;
    margin: -0.5rem -1rem;
    -webkit-margin-end: 1rem;
            margin-inline-end: 1rem; }

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(1px * 2));
  min-height: calc(1.5em + 0.75rem + calc(var(--cui-border-width) * 2)); }

textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(1px * 2));
  min-height: calc(1.5em + 0.5rem + calc(var(--cui-border-width) * 2)); }

textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(1px * 2));
  min-height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2)); }

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(1px * 2));
  height: calc(1.5em + 0.75rem + calc(var(--cui-border-width) * 2));
  padding: 0.375rem; }
  .form-control-color:not(:disabled):not([readonly]) {
    cursor: pointer; }
  .form-control-color::-moz-color-swatch {
    border: 0 !important;
    border-radius: 0.375rem;
    border-radius: var(--cui-border-radius); }
  .form-control-color::-webkit-color-swatch {
    border: 0 !important;
    border-radius: 0.375rem;
    border-radius: var(--cui-border-radius); }
  .form-control-color.form-control-sm {
    height: calc(1.5em + 0.5rem + calc(1px * 2));
    height: calc(1.5em + 0.5rem + calc(var(--cui-border-width) * 2)); }
  .form-control-color.form-control-lg {
    height: calc(1.5em + 1rem + calc(1px * 2));
    height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2)); }

.form-select {
  --cui-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: rgba(44, 56, 74, 0.95);
  color: var(--cui-form-select-color, var(--cui-body-color));
  -webkit-appearance: none;
          appearance: none;
  background-color: #fff;
  background-color: var(--cui-form-select-bg, var(--cui-body-bg));
  background-image: var(--cui-form-select-bg-img), none;
  background-image: var(--cui-form-select-bg-img), var(--cui-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-size: 16px 12px;
  border: 1px solid #d8dbe0;
  border: var(--cui-border-width) solid var(--cui-form-select-border-color, var(--cui-border-color));
  border-radius: 0.375rem;
  border-radius: var(--cui-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  html:not([dir="rtl"]) .form-select {
    padding: 0.375rem 2.25rem 0.375rem 0.75rem; }
  *[dir="rtl"] .form-select {
    padding: 0.375rem 0.75rem 0.375rem 2.25rem; }
  html:not([dir="rtl"]) .form-select {
    background-position: right 0.75rem center; }
  *[dir="rtl"] .form-select {
    background-position: left 0.75rem center; }
  @media (prefers-reduced-motion: reduce) {
    .form-select {
      transition: none; } }
  .form-select:focus {
    border-color: #998fed;
    border-color: var(--cui-form-select-focus-border-color, #998fed);
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25); }
  .form-select[multiple], .form-select[size]:not([size="1"]) {
    background-image: none; }
    html:not([dir="rtl"]) .form-select[multiple], html:not([dir="rtl"]) .form-select[size]:not([size="1"]) {
      padding-right: 0.75rem; }
    *[dir="rtl"] .form-select[multiple], *[dir="rtl"] .form-select[size]:not([size="1"]) {
      padding-left: 0.75rem; }
  .form-select:disabled {
    color: var(--cui-form-select-disabled-color, );
    background-color: #d8dbe0;
    background-color: var(--cui-form-select-disabled-bg, var(--cui-secondary-bg)); }
  .form-select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 rgba(44, 56, 74, 0.95);
    text-shadow: 0 0 0 var(--cui-form-select-color, var(--cui-body-color)); }

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
  border-radius: var(--cui-border-radius-sm); }
  html:not([dir="rtl"]) .form-select-sm {
    padding-left: 0.5rem; }
  *[dir="rtl"] .form-select-sm {
    padding-right: 0.5rem; }

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 1.25rem;
  border-radius: 0.5rem;
  border-radius: var(--cui-border-radius-lg); }
  html:not([dir="rtl"]) .form-select-lg {
    padding-left: 1rem; }
  *[dir="rtl"] .form-select-lg {
    padding-right: 1rem; }

.form-check {
  display: block;
  min-height: 1.5rem;
  margin-bottom: 0.125rem; }
  html:not([dir="rtl"]) .form-check {
    padding-left: 1.5em; }
  *[dir="rtl"] .form-check {
    padding-right: 1.5em; }
  html:not([dir="rtl"]) .form-check .form-check-input {
    float: left; }
  *[dir="rtl"] .form-check .form-check-input {
    float: right; }
  html:not([dir="rtl"]) .form-check .form-check-input {
    margin-left: -1.5em; }
  *[dir="rtl"] .form-check .form-check-input {
    margin-right: -1.5em; }

html:not([dir="rtl"]) .form-check-reverse {
  padding-right: 1.5em; }

*[dir="rtl"] .form-check-reverse {
  padding-left: 1.5em; }

html:not([dir="rtl"]) .form-check-reverse {
  padding-left: 0; }

*[dir="rtl"] .form-check-reverse {
  padding-right: 0; }

html:not([dir="rtl"]) .form-check-reverse {
  text-align: right; }

*[dir="rtl"] .form-check-reverse {
  text-align: left; }

html:not([dir="rtl"]) .form-check-reverse .form-check-input {
  float: right; }

*[dir="rtl"] .form-check-reverse .form-check-input {
  float: left; }

html:not([dir="rtl"]) .form-check-reverse .form-check-input {
  margin-right: -1.5em; }

*[dir="rtl"] .form-check-reverse .form-check-input {
  margin-left: -1.5em; }

html:not([dir="rtl"]) .form-check-reverse .form-check-input {
  margin-left: 0; }

*[dir="rtl"] .form-check-reverse .form-check-input {
  margin-right: 0; }

.form-check-input {
  --cui-form-check-bg: var(--cui-body-bg);
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  -webkit-appearance: none;
          appearance: none;
  background-color: var(--cui-form-check-bg);
  background-image: var(--cui-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid #d8dbe0;
  border: var(--cui-border-width) solid var(--cui-border-color);
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact; }
  .form-check-input[type="checkbox"] {
    border-radius: 0.25em; }
  .form-check-input[type="radio"] {
    border-radius: 50%; }
  .form-check-input:active {
    filter: brightness(90%); }
  .form-check-input:focus {
    border-color: #998fed;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25); }
  .form-check-input:checked {
    background-color: #321fdb;
    background-color: var(--cui-form-check-input-checked-bg-color, #321fdb);
    border-color: #321fdb;
    border-color: var(--cui-form-check-input-checked-border-color, #321fdb); }
    .form-check-input:checked[type="checkbox"] {
      --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); }
    .form-check-input:checked[type="radio"] {
      --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); }
  .form-check-input[type="checkbox"]:indeterminate {
    background-color: #321fdb;
    border-color: #321fdb;
    --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); }
  .form-check-input:disabled {
    pointer-events: none;
    filter: none;
    opacity: 0.5; }
  .form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
    cursor: default;
    opacity: 0.5; }

.form-check-label {
  color: var(--cui-form-check-label-color, ); }

html:not([dir="rtl"]) .form-switch {
  padding-left: 2.5em; }

*[dir="rtl"] .form-switch {
  padding-right: 2.5em; }

.form-switch .form-check-input {
  --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  width: 2em;
  background-image: var(--cui-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out; }
  html:not([dir="rtl"]) .form-switch .form-check-input {
    margin-left: -2.5em; }
  *[dir="rtl"] .form-switch .form-check-input {
    margin-right: -2.5em; }
  @media (prefers-reduced-motion: reduce) {
    .form-switch .form-check-input {
      transition: none; } }
  .form-switch .form-check-input:focus {
    --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___}); }
  .form-switch .form-check-input:checked {
    background-position: right center;
    --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); }

html:not([dir="rtl"]) .form-switch.form-check-reverse {
  padding-right: 1.5em; }

*[dir="rtl"] .form-switch.form-check-reverse {
  padding-left: 1.5em; }

html:not([dir="rtl"]) .form-switch.form-check-reverse {
  padding-left: 0; }

*[dir="rtl"] .form-switch.form-check-reverse {
  padding-right: 0; }

html:not([dir="rtl"]) .form-switch.form-check-reverse .form-check-input {
  margin-right: -1.5em; }

*[dir="rtl"] .form-switch.form-check-reverse .form-check-input {
  margin-left: -1.5em; }

html:not([dir="rtl"]) .form-switch.form-check-reverse .form-check-input {
  margin-left: 0; }

*[dir="rtl"] .form-switch.form-check-reverse .form-check-input {
  margin-right: 0; }

.form-switch-lg {
  min-height: 1.25em; }
  html:not([dir="rtl"]) .form-switch-lg {
    padding-left: 2.25em; }
  *[dir="rtl"] .form-switch-lg {
    padding-right: 2.25em; }
  .form-switch-lg .form-check-input {
    width: 1.75em;
    height: 1.25em; }
    html:not([dir="rtl"]) .form-switch-lg .form-check-input {
      margin-left: -2.25em; }
    *[dir="rtl"] .form-switch-lg .form-check-input {
      margin-right: -2.25em; }
  .form-switch-lg .form-check-label {
    padding-top: calc((1.25em - 1rem) / 2); }

.form-switch-xl {
  min-height: 1.5em; }
  html:not([dir="rtl"]) .form-switch-xl {
    padding-left: 2.5em; }
  *[dir="rtl"] .form-switch-xl {
    padding-right: 2.5em; }
  .form-switch-xl .form-check-input {
    width: 2em;
    height: 1.5em; }
    html:not([dir="rtl"]) .form-switch-xl .form-check-input {
      margin-left: -2.5em; }
    *[dir="rtl"] .form-switch-xl .form-check-input {
      margin-right: -2.5em; }
  .form-switch-xl .form-check-label {
    padding-top: calc((1.5em - 1rem) / 2); }

.form-check-inline {
  display: inline-block; }
  html:not([dir="rtl"]) .form-check-inline {
    margin-right: 1rem; }
  *[dir="rtl"] .form-check-inline {
    margin-left: 1rem; }

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none; }
  .btn-check[disabled] + .btn, .btn-check:disabled + .btn {
    pointer-events: none;
    filter: none;
    opacity: 0.65; }

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  -webkit-appearance: none;
          appearance: none;
  background-color: transparent; }
  .form-range:focus {
    outline: 0; }
    .form-range:focus::-webkit-slider-thumb {
      box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(50, 31, 219, 0.25); }
    .form-range:focus::-moz-range-thumb {
      box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(50, 31, 219, 0.25); }
  .form-range::-moz-focus-outer {
    border: 0; }
  .form-range::-webkit-slider-thumb {
    width: 1rem;
    height: 1rem;
    margin-top: -0.25rem;
    -webkit-appearance: none;
            appearance: none;
    background-color: #321fdb;
    background-color: var(--cui-form-range-thumb-bg, #321fdb);
    border: 0;
    border-radius: 1rem;
    -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-range::-webkit-slider-thumb {
        -webkit-transition: none;
        transition: none; } }
    .form-range::-webkit-slider-thumb:active {
      background-color: #c2bcf4;
      background-color: var(--cui-form-range-thumb-active-bg, #c2bcf4); }
  .form-range::-webkit-slider-runnable-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: #ebedef;
    background-color: var(--cui-form-range-track-bg, var(--cui-tertiary-bg));
    border-color: transparent;
    border-radius: 1rem; }
  .form-range::-moz-range-thumb {
    width: 1rem;
    height: 1rem;
    appearance: none;
    background-color: #321fdb;
    background-color: var(--cui-form-range-thumb-bg, #321fdb);
    border: 0;
    border-radius: 1rem;
    -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-range::-moz-range-thumb {
        -moz-transition: none;
        transition: none; } }
    .form-range::-moz-range-thumb:active {
      background-color: #c2bcf4;
      background-color: var(--cui-form-range-thumb-active-bg, #c2bcf4); }
  .form-range::-moz-range-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: #ebedef;
    background-color: var(--cui-form-range-track-bg, var(--cui-tertiary-bg));
    border-color: transparent;
    border-radius: 1rem; }
  .form-range:disabled {
    pointer-events: none; }
    .form-range:disabled::-webkit-slider-thumb {
      background-color: rgba(44, 56, 74, 0.681);
      background-color: var(--cui-form-range-thumb-disabled-bg, var(--cui-secondary-color)); }
    .form-range:disabled::-moz-range-thumb {
      background-color: rgba(44, 56, 74, 0.681);
      background-color: var(--cui-form-range-thumb-disabled-bg, var(--cui-secondary-color)); }

.form-floating {
  position: relative; }
  .form-floating > .form-control,
  .form-floating > .form-control-plaintext,
  .form-floating > .form-select {
    height: calc(3.5rem + calc(1px * 2));
    height: calc(3.5rem + calc(var(--cui-border-width) * 2));
    min-height: calc(3.5rem + calc(1px * 2));
    min-height: calc(3.5rem + calc(var(--cui-border-width) * 2));
    line-height: 1.25; }
  .form-floating > label {
    position: absolute;
    top: 0;
    z-index: 2;
    height: 100%;
    padding: 1rem 0.75rem;
    overflow: hidden;
    text-align: start;
    text-overflow: ellipsis;
    white-space: nowrap;
    pointer-events: none;
    border: 1px solid transparent;
    border: var(--cui-border-width) solid transparent;
    transform-origin: 0 0;
    transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out; }
    html:not([dir="rtl"]) .form-floating > label {
      left: 0; }
    *[dir="rtl"] .form-floating > label {
      right: 0; }
    @media (prefers-reduced-motion: reduce) {
      .form-floating > label {
        transition: none; } }
  .form-floating > .form-control,
  .form-floating > .form-control-plaintext {
    padding: 1rem 0.75rem; }
    .form-floating > .form-control::placeholder,
    .form-floating > .form-control-plaintext::placeholder {
      color: transparent; }
    .form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
    .form-floating > .form-control-plaintext:focus,
    .form-floating > .form-control-plaintext:not(:placeholder-shown) {
      padding-top: 1.625rem;
      padding-bottom: 0.625rem; }
    .form-floating > .form-control:-webkit-autofill,
    .form-floating > .form-control-plaintext:-webkit-autofill {
      padding-top: 1.625rem;
      padding-bottom: 0.625rem; }
  .form-floating > .form-select {
    padding-top: 1.625rem;
    padding-bottom: 0.625rem; }
  .form-floating > .form-control:focus ~ label,
  .form-floating > .form-control:not(:placeholder-shown) ~ label,
  .form-floating > .form-control-plaintext ~ label,
  .form-floating > .form-select ~ label {
    color: rgba(44, 56, 74, 0.65);
    color: rgba(var(--cui-body-color-rgb), 0.65);
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem); }
    .form-floating > .form-control:focus ~ label::after,
    .form-floating > .form-control:not(:placeholder-shown) ~ label::after,
    .form-floating > .form-control-plaintext ~ label::after,
    .form-floating > .form-select ~ label::after {
      position: absolute;
      inset: 1rem 0.375rem;
      z-index: -1;
      height: 1.5em;
      content: "";
      background-color: #fff;
      background-color: var(--cui-body-bg);
      border-radius: 0.375rem;
      border-radius: var(--cui-border-radius); }
  .form-floating > .form-control:-webkit-autofill ~ label {
    color: rgba(44, 56, 74, 0.65);
    color: rgba(var(--cui-body-color-rgb), 0.65);
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem); }
  .form-floating > .form-control-plaintext ~ label {
    border-width: 1px 0;
    border-width: var(--cui-border-width) 0; }
  .form-floating > :disabled ~ label,
  .form-floating > .form-control:disabled ~ label {
    color: #8a93a2; }
    .form-floating > :disabled ~ label::after,
    .form-floating > .form-control:disabled ~ label::after {
      background-color: #d8dbe0;
      background-color: var(--cui-secondary-bg); }

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%; }
  .input-group > .form-control,
  .input-group > .form-select,
  .input-group > .form-floating {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0; }
  .input-group > .form-control:focus,
  .input-group > .form-select:focus,
  .input-group > .form-floating:focus-within {
    z-index: 5; }
  .input-group .btn {
    position: relative;
    z-index: 2; }
    .input-group .btn:focus {
      z-index: 5; }

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: rgba(44, 56, 74, 0.95);
  color: var(--cui-input-group-addon-color, var(--cui-body-color));
  text-align: center;
  white-space: nowrap;
  background-color: #ebedef;
  background-color: var(--cui-input-group-addon-bg, var(--cui-tertiary-bg));
  border: 1px solid #d8dbe0;
  border: var(--cui-border-width) solid var(--cui-input-group-addon-border-color, var(--cui-border-color));
  border-radius: 0.375rem;
  border-radius: var(--cui-border-radius); }

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: 0.5rem;
  border-radius: var(--cui-border-radius-lg); }

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
  border-radius: var(--cui-border-radius-sm); }

html:not([dir="rtl"]) .input-group-lg > .form-select, html:not([dir="rtl"])
.input-group-sm > .form-select {
  padding-right: 3rem; }

*[dir="rtl"] .input-group-lg > .form-select, *[dir="rtl"]
.input-group-sm > .form-select {
  padding-left: 3rem; }

html:not([dir="rtl"]) .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating), html:not([dir="rtl"])
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n + 3), html:not([dir="rtl"])
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control, html:not([dir="rtl"])
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0; }

*[dir="rtl"] .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating), *[dir="rtl"]
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n + 3), *[dir="rtl"]
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control, *[dir="rtl"]
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-left-radius: 0; }

html:not([dir="rtl"]) .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating), html:not([dir="rtl"])
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n + 3), html:not([dir="rtl"])
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control, html:not([dir="rtl"])
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-bottom-right-radius: 0; }

*[dir="rtl"] .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating), *[dir="rtl"]
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n + 3), *[dir="rtl"]
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control, *[dir="rtl"]
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-bottom-left-radius: 0; }

html:not([dir="rtl"]) .input-group.has-validation > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating), html:not([dir="rtl"])
.input-group.has-validation > .dropdown-toggle:nth-last-child(n + 4), html:not([dir="rtl"])
.input-group.has-validation > .form-floating:nth-last-child(n + 3) > .form-control, html:not([dir="rtl"])
.input-group.has-validation > .form-floating:nth-last-child(n + 3) > .form-select {
  border-top-right-radius: 0; }

*[dir="rtl"] .input-group.has-validation > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating), *[dir="rtl"]
.input-group.has-validation > .dropdown-toggle:nth-last-child(n + 4), *[dir="rtl"]
.input-group.has-validation > .form-floating:nth-last-child(n + 3) > .form-control, *[dir="rtl"]
.input-group.has-validation > .form-floating:nth-last-child(n + 3) > .form-select {
  border-top-left-radius: 0; }

html:not([dir="rtl"]) .input-group.has-validation > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating), html:not([dir="rtl"])
.input-group.has-validation > .dropdown-toggle:nth-last-child(n + 4), html:not([dir="rtl"])
.input-group.has-validation > .form-floating:nth-last-child(n + 3) > .form-control, html:not([dir="rtl"])
.input-group.has-validation > .form-floating:nth-last-child(n + 3) > .form-select {
  border-bottom-right-radius: 0; }

*[dir="rtl"] .input-group.has-validation > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating), *[dir="rtl"]
.input-group.has-validation > .dropdown-toggle:nth-last-child(n + 4), *[dir="rtl"]
.input-group.has-validation > .form-floating:nth-last-child(n + 3) > .form-control, *[dir="rtl"]
.input-group.has-validation > .form-floating:nth-last-child(n + 3) > .form-select {
  border-bottom-left-radius: 0; }

html:not([dir="rtl"]) .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(1px * -1);
  margin-left: calc(var(--cui-border-width) * -1); }

*[dir="rtl"] .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-right: calc(1px * -1);
  margin-right: calc(var(--cui-border-width) * -1); }

html:not([dir="rtl"]) .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-top-left-radius: 0; }

*[dir="rtl"] .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-top-right-radius: 0; }

html:not([dir="rtl"]) .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-bottom-left-radius: 0; }

*[dir="rtl"] .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-bottom-right-radius: 0; }

html:not([dir="rtl"]) .input-group > .form-floating:not(:first-child) > .form-control, html:not([dir="rtl"])
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0; }

*[dir="rtl"] .input-group > .form-floating:not(:first-child) > .form-control, *[dir="rtl"]
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-right-radius: 0; }

html:not([dir="rtl"]) .input-group > .form-floating:not(:first-child) > .form-control, html:not([dir="rtl"])
.input-group > .form-floating:not(:first-child) > .form-select {
  border-bottom-left-radius: 0; }

*[dir="rtl"] .input-group > .form-floating:not(:first-child) > .form-control, *[dir="rtl"]
.input-group > .form-floating:not(:first-child) > .form-select {
  border-bottom-right-radius: 0; }

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #2eb85c;
  color: var(--cui-form-valid-color); }

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: .1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: #2eb85c;
  background-color: var(--cui-success);
  border-radius: 0.375rem;
  border-radius: var(--cui-border-radius); }

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block; }

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #2eb85c;
  border-color: var(--cui-form-valid-border-color);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }
  html:not([dir="rtl"]) .was-validated .form-control:valid, html:not([dir="rtl"]) .form-control.is-valid {
    padding-right: calc(1.5em + 0.75rem); }
  *[dir="rtl"] .was-validated .form-control:valid, *[dir="rtl"] .form-control.is-valid {
    padding-left: calc(1.5em + 0.75rem); }
  html:not([dir="rtl"]) .was-validated .form-control:valid, html:not([dir="rtl"]) .form-control.is-valid {
    background-position: right calc(0.375em + 0.1875rem) center; }
  *[dir="rtl"] .was-validated .form-control:valid, *[dir="rtl"] .form-control.is-valid {
    background-position: left calc(0.375em + 0.1875rem) center; }
  .was-validated .form-control:valid:focus, .form-control.is-valid:focus {
    border-color: #2eb85c;
    border-color: var(--cui-form-valid-border-color);
    box-shadow: 0 0 0 0.25rem rgba(46, 184, 92, 0.25);
    box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25); }

html:not([dir="rtl"]) .was-validated textarea.form-control:valid, html:not([dir="rtl"]) textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem); }

*[dir="rtl"] .was-validated textarea.form-control:valid, *[dir="rtl"] textarea.form-control.is-valid {
  padding-left: calc(1.5em + 0.75rem); }

html:not([dir="rtl"]) .was-validated textarea.form-control:valid, html:not([dir="rtl"]) textarea.form-control.is-valid {
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem); }

*[dir="rtl"] .was-validated textarea.form-control:valid, *[dir="rtl"] textarea.form-control.is-valid {
  background-position: top calc(0.375em + 0.1875rem) left calc(0.375em + 0.1875rem); }

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: #2eb85c;
  border-color: var(--cui-form-valid-border-color); }
  .was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
    --cui-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }
    html:not([dir="rtl"]) .was-validated .form-select:valid:not([multiple]):not([size]), html:not([dir="rtl"]) .was-validated .form-select:valid:not([multiple])[size="1"], html:not([dir="rtl"]) .form-select.is-valid:not([multiple]):not([size]), html:not([dir="rtl"]) .form-select.is-valid:not([multiple])[size="1"] {
      padding-right: 4.125rem; }
    *[dir="rtl"] .was-validated .form-select:valid:not([multiple]):not([size]), *[dir="rtl"] .was-validated .form-select:valid:not([multiple])[size="1"], *[dir="rtl"] .form-select.is-valid:not([multiple]):not([size]), *[dir="rtl"] .form-select.is-valid:not([multiple])[size="1"] {
      padding-left: 4.125rem; }
    html:not([dir="rtl"]) .was-validated .form-select:valid:not([multiple]):not([size]), html:not([dir="rtl"]) .was-validated .form-select:valid:not([multiple])[size="1"], html:not([dir="rtl"]) .form-select.is-valid:not([multiple]):not([size]), html:not([dir="rtl"]) .form-select.is-valid:not([multiple])[size="1"] {
      background-position: right 0.75rem center, center right 2.25rem; }
    *[dir="rtl"] .was-validated .form-select:valid:not([multiple]):not([size]), *[dir="rtl"] .was-validated .form-select:valid:not([multiple])[size="1"], *[dir="rtl"] .form-select.is-valid:not([multiple]):not([size]), *[dir="rtl"] .form-select.is-valid:not([multiple])[size="1"] {
      background-position: left 0.75rem center, center left 2.25rem; }
  .was-validated .form-select:valid:focus, .form-select.is-valid:focus {
    border-color: #2eb85c;
    border-color: var(--cui-form-valid-border-color);
    box-shadow: 0 0 0 0.25rem rgba(46, 184, 92, 0.25);
    box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25); }

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem)); }

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: #2eb85c;
  border-color: var(--cui-form-valid-border-color); }
  .was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
    background-color: #2eb85c;
    background-color: var(--cui-form-valid-color); }
  .was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
    box-shadow: 0 0 0 0.25rem rgba(46, 184, 92, 0.25);
    box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25); }
  .was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
    color: #2eb85c;
    color: var(--cui-form-valid-color); }

html:not([dir="rtl"]) .form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em; }

*[dir="rtl"] .form-check-inline .form-check-input ~ .valid-feedback {
  margin-right: 0.5em; }

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid, .was-validated
.input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid, .was-validated
.input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3; }

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #e55353;
  color: var(--cui-form-invalid-color); }

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: .1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: #e55353;
  background-color: var(--cui-danger);
  border-radius: 0.375rem;
  border-radius: var(--cui-border-radius); }

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block; }

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #e55353;
  border-color: var(--cui-form-invalid-border-color);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }
  html:not([dir="rtl"]) .was-validated .form-control:invalid, html:not([dir="rtl"]) .form-control.is-invalid {
    padding-right: calc(1.5em + 0.75rem); }
  *[dir="rtl"] .was-validated .form-control:invalid, *[dir="rtl"] .form-control.is-invalid {
    padding-left: calc(1.5em + 0.75rem); }
  html:not([dir="rtl"]) .was-validated .form-control:invalid, html:not([dir="rtl"]) .form-control.is-invalid {
    background-position: right calc(0.375em + 0.1875rem) center; }
  *[dir="rtl"] .was-validated .form-control:invalid, *[dir="rtl"] .form-control.is-invalid {
    background-position: left calc(0.375em + 0.1875rem) center; }
  .was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
    border-color: #e55353;
    border-color: var(--cui-form-invalid-border-color);
    box-shadow: 0 0 0 0.25rem rgba(229, 83, 83, 0.25);
    box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25); }

html:not([dir="rtl"]) .was-validated textarea.form-control:invalid, html:not([dir="rtl"]) textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem); }

*[dir="rtl"] .was-validated textarea.form-control:invalid, *[dir="rtl"] textarea.form-control.is-invalid {
  padding-left: calc(1.5em + 0.75rem); }

html:not([dir="rtl"]) .was-validated textarea.form-control:invalid, html:not([dir="rtl"]) textarea.form-control.is-invalid {
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem); }

*[dir="rtl"] .was-validated textarea.form-control:invalid, *[dir="rtl"] textarea.form-control.is-invalid {
  background-position: top calc(0.375em + 0.1875rem) left calc(0.375em + 0.1875rem); }

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: #e55353;
  border-color: var(--cui-form-invalid-border-color); }
  .was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
    --cui-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }
    html:not([dir="rtl"]) .was-validated .form-select:invalid:not([multiple]):not([size]), html:not([dir="rtl"]) .was-validated .form-select:invalid:not([multiple])[size="1"], html:not([dir="rtl"]) .form-select.is-invalid:not([multiple]):not([size]), html:not([dir="rtl"]) .form-select.is-invalid:not([multiple])[size="1"] {
      padding-right: 4.125rem; }
    *[dir="rtl"] .was-validated .form-select:invalid:not([multiple]):not([size]), *[dir="rtl"] .was-validated .form-select:invalid:not([multiple])[size="1"], *[dir="rtl"] .form-select.is-invalid:not([multiple]):not([size]), *[dir="rtl"] .form-select.is-invalid:not([multiple])[size="1"] {
      padding-left: 4.125rem; }
    html:not([dir="rtl"]) .was-validated .form-select:invalid:not([multiple]):not([size]), html:not([dir="rtl"]) .was-validated .form-select:invalid:not([multiple])[size="1"], html:not([dir="rtl"]) .form-select.is-invalid:not([multiple]):not([size]), html:not([dir="rtl"]) .form-select.is-invalid:not([multiple])[size="1"] {
      background-position: right 0.75rem center, center right 2.25rem; }
    *[dir="rtl"] .was-validated .form-select:invalid:not([multiple]):not([size]), *[dir="rtl"] .was-validated .form-select:invalid:not([multiple])[size="1"], *[dir="rtl"] .form-select.is-invalid:not([multiple]):not([size]), *[dir="rtl"] .form-select.is-invalid:not([multiple])[size="1"] {
      background-position: left 0.75rem center, center left 2.25rem; }
  .was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
    border-color: #e55353;
    border-color: var(--cui-form-invalid-border-color);
    box-shadow: 0 0 0 0.25rem rgba(229, 83, 83, 0.25);
    box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25); }

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem)); }

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: #e55353;
  border-color: var(--cui-form-invalid-border-color); }
  .was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
    background-color: #e55353;
    background-color: var(--cui-form-invalid-color); }
  .was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
    box-shadow: 0 0 0 0.25rem rgba(229, 83, 83, 0.25);
    box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25); }
  .was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
    color: #e55353;
    color: var(--cui-form-invalid-color); }

html:not([dir="rtl"]) .form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em; }

*[dir="rtl"] .form-check-inline .form-check-input ~ .invalid-feedback {
  margin-right: 0.5em; }

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid, .was-validated
.input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid, .was-validated
.input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4; }

.btn {
  --cui-btn-padding-x: 0.75rem;
  --cui-btn-padding-y: 0.375rem;
  --cui-btn-font-family: ;
  --cui-btn-font-size: 1rem;
  --cui-btn-font-weight: 400;
  --cui-btn-line-height: 1.5;
  --cui-btn-color: var(--cui-body-color);
  --cui-btn-bg: transparent;
  --cui-btn-border-width: var(--cui-border-width);
  --cui-btn-border-color: transparent;
  --cui-btn-border-radius: var(--cui-border-radius);
  --cui-btn-hover-border-color: transparent;
  --cui-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 21, 0.075);
  --cui-btn-disabled-opacity: 0.65;
  --cui-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--cui-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--cui-btn-padding-y) var(--cui-btn-padding-x);
  font-family: var(--cui-btn-font-family);
  font-size: var(--cui-btn-font-size);
  font-weight: var(--cui-btn-font-weight);
  line-height: var(--cui-btn-line-height);
  color: var(--cui-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--cui-btn-border-width) solid var(--cui-btn-border-color);
  border-radius: var(--cui-btn-border-radius);
  background-color: var(--cui-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .btn {
      transition: none; } }
  .btn:hover {
    color: var(--cui-btn-hover-color);
    background-color: var(--cui-btn-hover-bg);
    border-color: var(--cui-btn-hover-border-color); }
  .btn-check + .btn:hover {
    color: var(--cui-btn-color);
    background-color: var(--cui-btn-bg);
    border-color: var(--cui-btn-border-color); }
  .btn:focus-visible {
    color: var(--cui-btn-hover-color);
    background-color: var(--cui-btn-hover-bg);
    border-color: var(--cui-btn-hover-border-color);
    outline: 0;
    box-shadow: var(--cui-btn-focus-box-shadow); }
  .btn-check:focus-visible + .btn {
    border-color: var(--cui-btn-hover-border-color);
    outline: 0;
    box-shadow: var(--cui-btn-focus-box-shadow); }
  .btn-check:checked + .btn,
  :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
    color: var(--cui-btn-active-color);
    background-color: var(--cui-btn-active-bg);
    border-color: var(--cui-btn-active-border-color); }
    .btn-check:checked + .btn:focus-visible,
    :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
      box-shadow: var(--cui-btn-focus-box-shadow); }
  .btn:disabled, .btn.disabled,
  fieldset:disabled .btn {
    color: var(--cui-btn-disabled-color);
    pointer-events: none;
    background-color: var(--cui-btn-disabled-bg);
    border-color: var(--cui-btn-disabled-border-color);
    opacity: var(--cui-btn-disabled-opacity); }

.btn-transparent {
  --cui-btn-active-border-color: transparent;
  --cui-btn-disabled-border-color: transparent;
  --cui-btn-hover-border-color: transparent; }

.btn-primary {
  --cui-btn-color: rgba(255, 255, 255, 0.87);
  --cui-btn-bg: #321fdb;
  --cui-btn-border-color: #321fdb;
  --cui-btn-hover-color: rgba(255, 255, 255, 0.87);
  --cui-btn-hover-bg: #5141e0;
  --cui-btn-hover-border-color: #4735df;
  --cui-btn-focus-shadow-rgb: 75, 58, 223;
  --cui-btn-active-color: rgba(255, 255, 255, 0.87);
  --cui-btn-active-bg: #5b4ce2;
  --cui-btn-active-border-color: #4735df;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: rgba(255, 255, 255, 0.87);
  --cui-btn-disabled-bg: #321fdb;
  --cui-btn-disabled-border-color: #321fdb; }

.btn-secondary {
  --cui-btn-color: #000015;
  --cui-btn-bg: #9da5b1;
  --cui-btn-border-color: #9da5b1;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #acb3bd;
  --cui-btn-hover-border-color: #a7aeb9;
  --cui-btn-focus-shadow-rgb: 133, 140, 154;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #b1b7c1;
  --cui-btn-active-border-color: #a7aeb9;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #000015;
  --cui-btn-disabled-bg: #9da5b1;
  --cui-btn-disabled-border-color: #9da5b1; }

.btn-success {
  --cui-btn-color: #000015;
  --cui-btn-bg: #2eb85c;
  --cui-btn-border-color: #2eb85c;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #4dc374;
  --cui-btn-hover-border-color: #43bf6c;
  --cui-btn-focus-shadow-rgb: 39, 156, 81;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #58c67d;
  --cui-btn-active-border-color: #43bf6c;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #000015;
  --cui-btn-disabled-bg: #2eb85c;
  --cui-btn-disabled-border-color: #2eb85c; }

.btn-danger {
  --cui-btn-color: #000015;
  --cui-btn-bg: #e55353;
  --cui-btn-border-color: #e55353;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #e96d6d;
  --cui-btn-hover-border-color: #e86464;
  --cui-btn-focus-shadow-rgb: 195, 71, 74;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #ea7575;
  --cui-btn-active-border-color: #e86464;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #000015;
  --cui-btn-disabled-bg: #e55353;
  --cui-btn-disabled-border-color: #e55353; }

.btn-warning {
  --cui-btn-color: rgba(44, 56, 74, 0.95);
  --cui-btn-bg: #f9b115;
  --cui-btn-border-color: #f9b115;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #d49612;
  --cui-btn-hover-border-color: #c78e11;
  --cui-btn-focus-shadow-rgb: 221, 160, 28;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #c78e11;
  --cui-btn-active-border-color: #bb8510;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-bg: #f9b115;
  --cui-btn-disabled-border-color: #f9b115; }

.btn-info {
  --cui-btn-color: #000015;
  --cui-btn-bg: #39f;
  --cui-btn-border-color: #39f;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #52a8ff;
  --cui-btn-hover-border-color: #47a3ff;
  --cui-btn-focus-shadow-rgb: 43, 130, 220;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #5cadff;
  --cui-btn-active-border-color: #47a3ff;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #000015;
  --cui-btn-disabled-bg: #39f;
  --cui-btn-disabled-border-color: #39f; }

.btn-light {
  --cui-btn-color: rgba(44, 56, 74, 0.95);
  --cui-btn-bg: #ebedef;
  --cui-btn-border-color: #ebedef;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #c8c9cb;
  --cui-btn-hover-border-color: #bcbebf;
  --cui-btn-focus-shadow-rgb: 209, 212, 216;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #bcbebf;
  --cui-btn-active-border-color: #b0b2b3;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-bg: #ebedef;
  --cui-btn-disabled-border-color: #ebedef; }

.btn-dark {
  --cui-btn-color: rgba(255, 255, 255, 0.87);
  --cui-btn-bg: #4f5d73;
  --cui-btn-border-color: #4f5d73;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: #697588;
  --cui-btn-hover-border-color: #616d81;
  --cui-btn-focus-shadow-rgb: 100, 112, 132;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: #727d8f;
  --cui-btn-active-border-color: #616d81;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: rgba(255, 255, 255, 0.87);
  --cui-btn-disabled-bg: #4f5d73;
  --cui-btn-disabled-border-color: #4f5d73; }

.btn-outline-primary {
  --cui-btn-color: #321fdb;
  --cui-btn-border-color: #321fdb;
  --cui-btn-hover-color: rgba(255, 255, 255, 0.87);
  --cui-btn-hover-bg: #5b4ce2;
  --cui-btn-hover-border-color: #4735df;
  --cui-btn-focus-shadow-rgb: 50, 31, 219;
  --cui-btn-active-color: rgba(255, 255, 255, 0.87);
  --cui-btn-active-bg: #5b4ce2;
  --cui-btn-active-border-color: #4735df;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #321fdb;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none; }

.btn-outline-secondary {
  --cui-btn-color: #9da5b1;
  --cui-btn-border-color: #9da5b1;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #b1b7c1;
  --cui-btn-hover-border-color: #a7aeb9;
  --cui-btn-focus-shadow-rgb: 157, 165, 177;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #b1b7c1;
  --cui-btn-active-border-color: #a7aeb9;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #9da5b1;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none; }

.btn-outline-success {
  --cui-btn-color: #2eb85c;
  --cui-btn-border-color: #2eb85c;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #58c67d;
  --cui-btn-hover-border-color: #43bf6c;
  --cui-btn-focus-shadow-rgb: 46, 184, 92;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #58c67d;
  --cui-btn-active-border-color: #43bf6c;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #2eb85c;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none; }

.btn-outline-danger {
  --cui-btn-color: #e55353;
  --cui-btn-border-color: #e55353;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #ea7575;
  --cui-btn-hover-border-color: #e86464;
  --cui-btn-focus-shadow-rgb: 229, 83, 83;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #ea7575;
  --cui-btn-active-border-color: #e86464;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #e55353;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none; }

.btn-outline-warning {
  --cui-btn-color: #f9b115;
  --cui-btn-border-color: #f9b115;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #c78e11;
  --cui-btn-hover-border-color: #bb8510;
  --cui-btn-focus-shadow-rgb: 249, 177, 21;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #c78e11;
  --cui-btn-active-border-color: #bb8510;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #f9b115;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none; }

.btn-outline-info {
  --cui-btn-color: #39f;
  --cui-btn-border-color: #39f;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #5cadff;
  --cui-btn-hover-border-color: #47a3ff;
  --cui-btn-focus-shadow-rgb: 51, 153, 255;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #5cadff;
  --cui-btn-active-border-color: #47a3ff;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #39f;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none; }

.btn-outline-light {
  --cui-btn-color: #ebedef;
  --cui-btn-border-color: #ebedef;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #bcbebf;
  --cui-btn-hover-border-color: #b0b2b3;
  --cui-btn-focus-shadow-rgb: 235, 237, 239;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #bcbebf;
  --cui-btn-active-border-color: #b0b2b3;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #ebedef;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none; }

.btn-outline-dark {
  --cui-btn-color: #4f5d73;
  --cui-btn-border-color: #4f5d73;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: #727d8f;
  --cui-btn-hover-border-color: #616d81;
  --cui-btn-focus-shadow-rgb: 79, 93, 115;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: #727d8f;
  --cui-btn-active-border-color: #616d81;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #4f5d73;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none; }

.btn-ghost-primary {
  --cui-btn-color: #321fdb;
  --cui-btn-hover-bg: #5141e0;
  --cui-btn-hover-border-color: #4735df;
  --cui-btn-hover-color: rgba(255, 255, 255, 0.87);
  --cui-btn-active-bg: #5b4ce2;
  --cui-btn-active-border-color: #4735df;
  --cui-btn-active-color: rgba(255, 255, 255, 0.87);
  --cui-btn-disabled-color: #321fdb;
  --cui-btn-shadow: rgba(50, 31, 219, 0.5); }

.btn-ghost-secondary {
  --cui-btn-color: #9da5b1;
  --cui-btn-hover-bg: #acb3bd;
  --cui-btn-hover-border-color: #a7aeb9;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #b1b7c1;
  --cui-btn-active-border-color: #a7aeb9;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-color: #9da5b1;
  --cui-btn-shadow: rgba(157, 165, 177, 0.5); }

.btn-ghost-success {
  --cui-btn-color: #2eb85c;
  --cui-btn-hover-bg: #4dc374;
  --cui-btn-hover-border-color: #43bf6c;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #58c67d;
  --cui-btn-active-border-color: #43bf6c;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-color: #2eb85c;
  --cui-btn-shadow: rgba(46, 184, 92, 0.5); }

.btn-ghost-danger {
  --cui-btn-color: #e55353;
  --cui-btn-hover-bg: #e96d6d;
  --cui-btn-hover-border-color: #e86464;
  --cui-btn-hover-color: #000015;
  --cui-btn-active-bg: #ea7575;
  --cui-btn-active-border-color: #e86464;
  --cui-btn-active-color: #000015;
  --cui-btn-disabled-color: #e55353;
  --cui-btn-shadow: rgba(229, 83, 83, 0.5); }

.btn-ghost-warning {
  --cui-btn-color: #f9b115;
  --cui-btn-hover-bg: #d49612;
  --cui-btn-hover-border-color: #c78e11;
  --cui-btn-hover-color: #000015;
  --cui-btn-active-bg: #c78e11;
  --cui-btn-active-border-color: #bb8510;
  --cui-btn-active-color: #000015;
  --cui-btn-disabled-color: #f9b115;
  --cui-btn-shadow: rgba(249, 177, 21, 0.5); }

.btn-ghost-info {
  --cui-btn-color: #39f;
  --cui-btn-hover-bg: #52a8ff;
  --cui-btn-hover-border-color: #47a3ff;
  --cui-btn-hover-color: #000015;
  --cui-btn-active-bg: #5cadff;
  --cui-btn-active-border-color: #47a3ff;
  --cui-btn-active-color: #000015;
  --cui-btn-disabled-color: #39f;
  --cui-btn-shadow: rgba(51, 153, 255, 0.5); }

.btn-ghost-light {
  --cui-btn-color: #ebedef;
  --cui-btn-hover-bg: #c8c9cb;
  --cui-btn-hover-border-color: #bcbebf;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #bcbebf;
  --cui-btn-active-border-color: #b0b2b3;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-color: #ebedef;
  --cui-btn-shadow: rgba(235, 237, 239, 0.5); }

.btn-ghost-dark {
  --cui-btn-color: #4f5d73;
  --cui-btn-hover-bg: #697588;
  --cui-btn-hover-border-color: #616d81;
  --cui-btn-hover-color: #fff;
  --cui-btn-active-bg: #727d8f;
  --cui-btn-active-border-color: #616d81;
  --cui-btn-active-color: #fff;
  --cui-btn-disabled-color: #4f5d73;
  --cui-btn-shadow: rgba(79, 93, 115, 0.5); }

.btn-link {
  --cui-btn-font-weight: 400;
  --cui-btn-color: var(--cui-link-color);
  --cui-btn-bg: transparent;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-color: var(--cui-link-hover-color);
  --cui-btn-hover-border-color: transparent;
  --cui-btn-active-border-color: transparent;
  --cui-btn-disabled-color: #8a93a2;
  --cui-btn-disabled-border-color: transparent;
  --cui-btn-box-shadow: none;
  --cui-btn-focus-shadow-rgb: 75, 58, 223;
  text-decoration: underline; }
  .btn-link:focus-visible {
    color: var(--cui-btn-color); }

.btn-lg, .btn-group-lg > .btn {
  --cui-btn-padding-y: 0.5rem;
  --cui-btn-padding-x: 1rem;
  --cui-btn-font-size: 1.25rem;
  --cui-btn-border-radius: var(--cui-border-radius-lg); }

.btn-sm, .btn-group-sm > .btn {
  --cui-btn-padding-y: 0.25rem;
  --cui-btn-padding-x: 0.5rem;
  --cui-btn-font-size: 0.875rem;
  --cui-btn-border-radius: var(--cui-border-radius-sm); }

.fade {
  transition: opacity 0.15s linear; }
  @media (prefers-reduced-motion: reduce) {
    .fade {
      transition: none; } }
  .fade:not(.show) {
    opacity: 0; }

.collapse:not(.show) {
  display: none; }

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease; }
  @media (prefers-reduced-motion: reduce) {
    .collapsing {
      transition: none; } }
  .collapsing.collapse-horizontal {
    width: 0;
    height: auto;
    transition: width 0.35s ease; }
    @media (prefers-reduced-motion: reduce) {
      .collapsing.collapse-horizontal {
        transition: none; } }

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative; }

.dropdown-toggle {
  white-space: nowrap; }
  .dropdown-toggle::after {
    display: inline-block;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent; }
    html:not([dir="rtl"]) .dropdown-toggle::after {
      margin-left: 0.255em; }
    *[dir="rtl"] .dropdown-toggle::after {
      margin-right: 0.255em; }
  html:not([dir="rtl"]) .dropdown-toggle:empty::after {
    margin-left: 0; }
  *[dir="rtl"] .dropdown-toggle:empty::after {
    margin-right: 0; }

.dropdown-menu {
  --cui-dropdown-zindex: 1000;
  --cui-dropdown-min-width: 10rem;
  --cui-dropdown-padding-x: 0;
  --cui-dropdown-padding-y: 0.5rem;
  --cui-dropdown-spacer: 0.125rem;
  --cui-dropdown-font-size: 1rem;
  --cui-dropdown-color: var(--cui-body-color);
  --cui-dropdown-bg: var(--cui-body-bg);
  --cui-dropdown-border-color: var(--cui-border-color-translucent);
  --cui-dropdown-border-radius: var(--cui-border-radius);
  --cui-dropdown-border-width: var(--cui-border-width);
  --cui-dropdown-inner-border-radius: calc(var(--cui-border-radius) - var(--cui-border-width));
  --cui-dropdown-divider-bg: var(--cui-border-color-translucent);
  --cui-dropdown-divider-margin-y: 0.5rem;
  --cui-dropdown-box-shadow: 0 0.5rem 1rem rgba(0, 0, 21, 0.15);
  --cui-dropdown-link-color: var(--cui-body-color);
  --cui-dropdown-link-hover-color: var(--cui-body-color);
  --cui-dropdown-link-hover-bg: var(--cui-tertiary-bg);
  --cui-dropdown-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-dropdown-link-active-bg: #321fdb;
  --cui-dropdown-link-disabled-color: var(--cui-tertiary-color);
  --cui-dropdown-item-padding-x: 1rem;
  --cui-dropdown-item-padding-y: 0.25rem;
  --cui-dropdown-header-color: #8a93a2;
  --cui-dropdown-header-padding-x: 1rem;
  --cui-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--cui-dropdown-zindex);
  display: none;
  min-width: var(--cui-dropdown-min-width);
  padding: var(--cui-dropdown-padding-y) var(--cui-dropdown-padding-x);
  margin: 0;
  font-size: var(--cui-dropdown-font-size);
  color: var(--cui-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--cui-dropdown-bg);
  background-clip: padding-box;
  border: var(--cui-dropdown-border-width) solid var(--cui-dropdown-border-color);
  border-radius: var(--cui-dropdown-border-radius); }
  .dropdown-menu[data-coreui-popper] {
    top: 100%;
    margin-top: var(--cui-dropdown-spacer); }
    html:not([dir="rtl"]) .dropdown-menu[data-coreui-popper] {
      left: 0; }
    *[dir="rtl"] .dropdown-menu[data-coreui-popper] {
      right: 0; }

.dropdown-menu-start {
  --cui-position: start; }
  html:not([dir="rtl"]) .dropdown-menu-start[data-coreui-popper] {
    right: auto; }
  *[dir="rtl"] .dropdown-menu-start[data-coreui-popper] {
    left: auto; }
  html:not([dir="rtl"]) .dropdown-menu-start[data-coreui-popper] {
    left: 0; }
  *[dir="rtl"] .dropdown-menu-start[data-coreui-popper] {
    right: 0; }

.dropdown-menu-end {
  --cui-position: end; }
  html:not([dir="rtl"]) .dropdown-menu-end[data-coreui-popper] {
    right: 0; }
  *[dir="rtl"] .dropdown-menu-end[data-coreui-popper] {
    left: 0; }
  html:not([dir="rtl"]) .dropdown-menu-end[data-coreui-popper] {
    left: auto; }
  *[dir="rtl"] .dropdown-menu-end[data-coreui-popper] {
    right: auto; }

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --cui-position: start; }
    html:not([dir="rtl"]) .dropdown-menu-sm-start[data-coreui-popper] {
      right: auto; }
    *[dir="rtl"] .dropdown-menu-sm-start[data-coreui-popper] {
      left: auto; }
    html:not([dir="rtl"]) .dropdown-menu-sm-start[data-coreui-popper] {
      left: 0; }
    *[dir="rtl"] .dropdown-menu-sm-start[data-coreui-popper] {
      right: 0; }
  .dropdown-menu-sm-end {
    --cui-position: end; }
    html:not([dir="rtl"]) .dropdown-menu-sm-end[data-coreui-popper] {
      right: 0; }
    *[dir="rtl"] .dropdown-menu-sm-end[data-coreui-popper] {
      left: 0; }
    html:not([dir="rtl"]) .dropdown-menu-sm-end[data-coreui-popper] {
      left: auto; }
    *[dir="rtl"] .dropdown-menu-sm-end[data-coreui-popper] {
      right: auto; } }

@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --cui-position: start; }
    html:not([dir="rtl"]) .dropdown-menu-md-start[data-coreui-popper] {
      right: auto; }
    *[dir="rtl"] .dropdown-menu-md-start[data-coreui-popper] {
      left: auto; }
    html:not([dir="rtl"]) .dropdown-menu-md-start[data-coreui-popper] {
      left: 0; }
    *[dir="rtl"] .dropdown-menu-md-start[data-coreui-popper] {
      right: 0; }
  .dropdown-menu-md-end {
    --cui-position: end; }
    html:not([dir="rtl"]) .dropdown-menu-md-end[data-coreui-popper] {
      right: 0; }
    *[dir="rtl"] .dropdown-menu-md-end[data-coreui-popper] {
      left: 0; }
    html:not([dir="rtl"]) .dropdown-menu-md-end[data-coreui-popper] {
      left: auto; }
    *[dir="rtl"] .dropdown-menu-md-end[data-coreui-popper] {
      right: auto; } }

@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --cui-position: start; }
    html:not([dir="rtl"]) .dropdown-menu-lg-start[data-coreui-popper] {
      right: auto; }
    *[dir="rtl"] .dropdown-menu-lg-start[data-coreui-popper] {
      left: auto; }
    html:not([dir="rtl"]) .dropdown-menu-lg-start[data-coreui-popper] {
      left: 0; }
    *[dir="rtl"] .dropdown-menu-lg-start[data-coreui-popper] {
      right: 0; }
  .dropdown-menu-lg-end {
    --cui-position: end; }
    html:not([dir="rtl"]) .dropdown-menu-lg-end[data-coreui-popper] {
      right: 0; }
    *[dir="rtl"] .dropdown-menu-lg-end[data-coreui-popper] {
      left: 0; }
    html:not([dir="rtl"]) .dropdown-menu-lg-end[data-coreui-popper] {
      left: auto; }
    *[dir="rtl"] .dropdown-menu-lg-end[data-coreui-popper] {
      right: auto; } }

@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --cui-position: start; }
    html:not([dir="rtl"]) .dropdown-menu-xl-start[data-coreui-popper] {
      right: auto; }
    *[dir="rtl"] .dropdown-menu-xl-start[data-coreui-popper] {
      left: auto; }
    html:not([dir="rtl"]) .dropdown-menu-xl-start[data-coreui-popper] {
      left: 0; }
    *[dir="rtl"] .dropdown-menu-xl-start[data-coreui-popper] {
      right: 0; }
  .dropdown-menu-xl-end {
    --cui-position: end; }
    html:not([dir="rtl"]) .dropdown-menu-xl-end[data-coreui-popper] {
      right: 0; }
    *[dir="rtl"] .dropdown-menu-xl-end[data-coreui-popper] {
      left: 0; }
    html:not([dir="rtl"]) .dropdown-menu-xl-end[data-coreui-popper] {
      left: auto; }
    *[dir="rtl"] .dropdown-menu-xl-end[data-coreui-popper] {
      right: auto; } }

@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --cui-position: start; }
    html:not([dir="rtl"]) .dropdown-menu-xxl-start[data-coreui-popper] {
      right: auto; }
    *[dir="rtl"] .dropdown-menu-xxl-start[data-coreui-popper] {
      left: auto; }
    html:not([dir="rtl"]) .dropdown-menu-xxl-start[data-coreui-popper] {
      left: 0; }
    *[dir="rtl"] .dropdown-menu-xxl-start[data-coreui-popper] {
      right: 0; }
  .dropdown-menu-xxl-end {
    --cui-position: end; }
    html:not([dir="rtl"]) .dropdown-menu-xxl-end[data-coreui-popper] {
      right: 0; }
    *[dir="rtl"] .dropdown-menu-xxl-end[data-coreui-popper] {
      left: 0; }
    html:not([dir="rtl"]) .dropdown-menu-xxl-end[data-coreui-popper] {
      left: auto; }
    *[dir="rtl"] .dropdown-menu-xxl-end[data-coreui-popper] {
      right: auto; } }

.dropup .dropdown-menu[data-coreui-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--cui-dropdown-spacer); }

.dropup .dropdown-toggle::after {
  display: inline-block;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent; }
  html:not([dir="rtl"]) .dropup .dropdown-toggle::after {
    margin-left: 0.255em; }
  *[dir="rtl"] .dropup .dropdown-toggle::after {
    margin-right: 0.255em; }

html:not([dir="rtl"]) .dropup .dropdown-toggle:empty::after {
  margin-left: 0; }

*[dir="rtl"] .dropup .dropdown-toggle:empty::after {
  margin-right: 0; }

.dropend .dropdown-menu[data-coreui-popper] {
  top: 0;
  margin-top: 0; }
  html:not([dir="rtl"]) .dropend .dropdown-menu[data-coreui-popper] {
    right: auto; }
  *[dir="rtl"] .dropend .dropdown-menu[data-coreui-popper] {
    left: auto; }
  html:not([dir="rtl"]) .dropend .dropdown-menu[data-coreui-popper] {
    left: 100%; }
  *[dir="rtl"] .dropend .dropdown-menu[data-coreui-popper] {
    right: 100%; }
  html:not([dir="rtl"]) .dropend .dropdown-menu[data-coreui-popper] {
    margin-left: var(--cui-dropdown-spacer); }
  *[dir="rtl"] .dropend .dropdown-menu[data-coreui-popper] {
    margin-right: var(--cui-dropdown-spacer); }

.dropend .dropdown-toggle::after {
  display: inline-block;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid; }
  html:not([dir="rtl"]) .dropend .dropdown-toggle::after {
    margin-left: 0.255em; }
  *[dir="rtl"] .dropend .dropdown-toggle::after {
    margin-right: 0.255em; }

html:not([dir="rtl"]) .dropend .dropdown-toggle:empty::after {
  margin-left: 0; }

*[dir="rtl"] .dropend .dropdown-toggle:empty::after {
  margin-right: 0; }

.dropend .dropdown-toggle::after {
  vertical-align: 0; }

.dropstart .dropdown-menu[data-coreui-popper] {
  top: 0;
  margin-top: 0; }
  html:not([dir="rtl"]) .dropstart .dropdown-menu[data-coreui-popper] {
    right: 100%; }
  *[dir="rtl"] .dropstart .dropdown-menu[data-coreui-popper] {
    left: 100%; }
  html:not([dir="rtl"]) .dropstart .dropdown-menu[data-coreui-popper] {
    left: auto; }
  *[dir="rtl"] .dropstart .dropdown-menu[data-coreui-popper] {
    right: auto; }
  html:not([dir="rtl"]) .dropstart .dropdown-menu[data-coreui-popper] {
    margin-right: var(--cui-dropdown-spacer); }
  *[dir="rtl"] .dropstart .dropdown-menu[data-coreui-popper] {
    margin-left: var(--cui-dropdown-spacer); }

.dropstart .dropdown-toggle::after {
  display: inline-block;
  vertical-align: 0.255em;
  content: ""; }
  html:not([dir="rtl"]) .dropstart .dropdown-toggle::after {
    margin-left: 0.255em; }
  *[dir="rtl"] .dropstart .dropdown-toggle::after {
    margin-right: 0.255em; }

.dropstart .dropdown-toggle::after {
  display: none; }

.dropstart .dropdown-toggle::before {
  display: inline-block;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent; }
  html:not([dir="rtl"]) .dropstart .dropdown-toggle::before {
    margin-right: 0.255em; }
  *[dir="rtl"] .dropstart .dropdown-toggle::before {
    margin-left: 0.255em; }

html:not([dir="rtl"]) .dropstart .dropdown-toggle:empty::after {
  margin-left: 0; }

*[dir="rtl"] .dropstart .dropdown-toggle:empty::after {
  margin-right: 0; }

.dropstart .dropdown-toggle::before {
  vertical-align: 0; }

.dropdown-divider {
  height: 0;
  margin: var(--cui-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--cui-dropdown-divider-bg);
  opacity: 1; }

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--cui-dropdown-item-padding-y) var(--cui-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--cui-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: 0;
  border-radius: var(--cui-dropdown-item-border-radius, 0); }
  .dropdown-item:hover, .dropdown-item:focus {
    color: var(--cui-dropdown-link-hover-color);
    background-color: var(--cui-dropdown-link-hover-bg); }
  .dropdown-item.active, .dropdown-item:active {
    color: var(--cui-dropdown-link-active-color);
    text-decoration: none;
    background-color: var(--cui-dropdown-link-active-bg); }
  .dropdown-item.disabled, .dropdown-item:disabled {
    color: var(--cui-dropdown-link-disabled-color);
    pointer-events: none;
    background-color: transparent; }

.dropdown-menu.show {
  display: block; }

.dropdown-header {
  display: block;
  padding: var(--cui-dropdown-header-padding-y) var(--cui-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--cui-dropdown-header-color);
  white-space: nowrap; }

.dropdown-item-text {
  display: block;
  padding: var(--cui-dropdown-item-padding-y) var(--cui-dropdown-item-padding-x);
  color: var(--cui-dropdown-link-color); }

.dropdown-menu-dark {
  --cui-dropdown-color: #c4c9d0;
  --cui-dropdown-bg: #636f83;
  --cui-dropdown-border-color: var(--cui-border-color-translucent);
  --cui-dropdown-box-shadow: ;
  --cui-dropdown-link-color: #c4c9d0;
  --cui-dropdown-link-hover-color: rgba(255, 255, 255, 0.87);
  --cui-dropdown-divider-bg: var(--cui-border-color-translucent);
  --cui-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --cui-dropdown-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-dropdown-link-active-bg: #321fdb;
  --cui-dropdown-link-disabled-color: #9da5b1;
  --cui-dropdown-header-color: #9da5b1; }

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle; }
  .btn-group > .btn,
  .btn-group-vertical > .btn {
    position: relative;
    flex: 1 1 auto; }
  .btn-group > .btn-check:checked + .btn,
  .btn-group > .btn-check:focus + .btn,
  .btn-group > .btn:hover,
  .btn-group > .btn:focus,
  .btn-group > .btn:active,
  .btn-group > .btn.active,
  .btn-group-vertical > .btn-check:checked + .btn,
  .btn-group-vertical > .btn-check:focus + .btn,
  .btn-group-vertical > .btn:hover,
  .btn-group-vertical > .btn:focus,
  .btn-group-vertical > .btn:active,
  .btn-group-vertical > .btn.active {
    z-index: 1; }

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; }
  .btn-toolbar .input-group {
    width: auto; }

.btn-group {
  border-radius: 0.375rem;
  border-radius: var(--cui-border-radius); }
  html:not([dir="rtl"]) .btn-group > :not(.btn-check:first-child) + .btn, html:not([dir="rtl"])
  .btn-group > .btn-group:not(:first-child) {
    margin-left: calc(1px * -1);
    margin-left: calc(var(--cui-border-width) * -1); }
  *[dir="rtl"] .btn-group > :not(.btn-check:first-child) + .btn, *[dir="rtl"]
  .btn-group > .btn-group:not(:first-child) {
    margin-right: calc(1px * -1);
    margin-right: calc(var(--cui-border-width) * -1); }
  html:not([dir="rtl"]) .btn-group > .btn:not(:last-child):not(.dropdown-toggle), html:not([dir="rtl"])
  .btn-group > .btn.dropdown-toggle-split:first-child, html:not([dir="rtl"])
  .btn-group > .btn-group:not(:last-child) > .btn {
    border-top-right-radius: 0; }
  *[dir="rtl"] .btn-group > .btn:not(:last-child):not(.dropdown-toggle), *[dir="rtl"]
  .btn-group > .btn.dropdown-toggle-split:first-child, *[dir="rtl"]
  .btn-group > .btn-group:not(:last-child) > .btn {
    border-top-left-radius: 0; }
  html:not([dir="rtl"]) .btn-group > .btn:not(:last-child):not(.dropdown-toggle), html:not([dir="rtl"])
  .btn-group > .btn.dropdown-toggle-split:first-child, html:not([dir="rtl"])
  .btn-group > .btn-group:not(:last-child) > .btn {
    border-bottom-right-radius: 0; }
  *[dir="rtl"] .btn-group > .btn:not(:last-child):not(.dropdown-toggle), *[dir="rtl"]
  .btn-group > .btn.dropdown-toggle-split:first-child, *[dir="rtl"]
  .btn-group > .btn-group:not(:last-child) > .btn {
    border-bottom-left-radius: 0; }
  html:not([dir="rtl"]) .btn-group > .btn:nth-child(n + 3), html:not([dir="rtl"])
  .btn-group > :not(.btn-check) + .btn, html:not([dir="rtl"])
  .btn-group > .btn-group:not(:first-child) > .btn {
    border-top-left-radius: 0; }
  *[dir="rtl"] .btn-group > .btn:nth-child(n + 3), *[dir="rtl"]
  .btn-group > :not(.btn-check) + .btn, *[dir="rtl"]
  .btn-group > .btn-group:not(:first-child) > .btn {
    border-top-right-radius: 0; }
  html:not([dir="rtl"]) .btn-group > .btn:nth-child(n + 3), html:not([dir="rtl"])
  .btn-group > :not(.btn-check) + .btn, html:not([dir="rtl"])
  .btn-group > .btn-group:not(:first-child) > .btn {
    border-bottom-left-radius: 0; }
  *[dir="rtl"] .btn-group > .btn:nth-child(n + 3), *[dir="rtl"]
  .btn-group > :not(.btn-check) + .btn, *[dir="rtl"]
  .btn-group > .btn-group:not(:first-child) > .btn {
    border-bottom-right-radius: 0; }

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem; }
  html:not([dir="rtl"]) .dropdown-toggle-split::after, html:not([dir="rtl"])
  .dropup .dropdown-toggle-split::after, html:not([dir="rtl"])
  .dropend .dropdown-toggle-split::after {
    margin-left: 0; }
  *[dir="rtl"] .dropdown-toggle-split::after, *[dir="rtl"]
  .dropup .dropdown-toggle-split::after, *[dir="rtl"]
  .dropend .dropdown-toggle-split::after {
    margin-right: 0; }
  html:not([dir="rtl"]) .dropstart .dropdown-toggle-split::before {
    margin-right: 0; }
  *[dir="rtl"] .dropstart .dropdown-toggle-split::before {
    margin-left: 0; }

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem; }

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem; }

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center; }
  .btn-group-vertical > .btn,
  .btn-group-vertical > .btn-group {
    width: 100%; }
  .btn-group-vertical > .btn:not(:first-child),
  .btn-group-vertical > .btn-group:not(:first-child) {
    margin-top: calc(1px * -1);
    margin-top: calc(var(--cui-border-width) * -1); }
  .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
  .btn-group-vertical > .btn-group:not(:last-child) > .btn {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0; }
  .btn-group-vertical > .btn ~ .btn,
  .btn-group-vertical > .btn-group:not(:first-child) > .btn {
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.nav {
  --cui-nav-link-padding-x: 1rem;
  --cui-nav-link-padding-y: 0.5rem;
  --cui-nav-link-font-weight: ;
  --cui-nav-link-color: var(--cui-link-color);
  --cui-nav-link-hover-color: var(--cui-link-hover-color);
  --cui-nav-link-disabled-color: var(--cui-secondary-color);
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0;
  list-style: none; }
  html:not([dir="rtl"]) .nav {
    padding-left: 0; }
  *[dir="rtl"] .nav {
    padding-right: 0; }

.nav-link {
  display: block;
  padding: var(--cui-nav-link-padding-y) var(--cui-nav-link-padding-x);
  font-size: var(--cui-nav-link-font-size);
  font-weight: var(--cui-nav-link-font-weight);
  color: var(--cui-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .nav-link {
      transition: none; } }
  .nav-link:hover, .nav-link:focus {
    color: var(--cui-nav-link-hover-color); }
  .nav-link:focus-visible {
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25); }
  .nav-link.disabled, .nav-link:disabled {
    color: var(--cui-nav-link-disabled-color);
    pointer-events: none;
    cursor: default; }

.nav-tabs {
  --cui-nav-tabs-border-width: var(--cui-border-width);
  --cui-nav-tabs-border-color: var(--cui-border-color);
  --cui-nav-tabs-border-radius: var(--cui-border-radius);
  --cui-nav-tabs-link-hover-border-color: var(--cui-secondary-bg) var(--cui-secondary-bg) var(--cui-border-color);
  --cui-nav-tabs-link-active-color: var(--cui-emphasis-color);
  --cui-nav-tabs-link-active-bg: var(--cui-body-bg);
  --cui-nav-tabs-link-active-border-color: var(--cui-border-color) var(--cui-border-color) var(--cui-body-bg);
  border-bottom: var(--cui-nav-tabs-border-width) solid var(--cui-nav-tabs-border-color); }
  .nav-tabs .nav-link {
    margin-bottom: calc(-1 * var(--cui-nav-tabs-border-width));
    border: var(--cui-nav-tabs-border-width) solid transparent;
    border-top-left-radius: var(--cui-nav-tabs-border-radius);
    border-top-right-radius: var(--cui-nav-tabs-border-radius); }
    .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
      isolation: isolate;
      border-color: var(--cui-nav-tabs-link-hover-border-color); }
  .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    color: var(--cui-nav-tabs-link-active-color);
    background-color: var(--cui-nav-tabs-link-active-bg);
    border-color: var(--cui-nav-tabs-link-active-border-color); }
  .nav-tabs .dropdown-menu {
    margin-top: calc(-1 * var(--cui-nav-tabs-border-width));
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.nav-pills {
  --cui-nav-pills-border-radius: var(--cui-border-radius);
  --cui-nav-pills-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-nav-pills-link-active-bg: #321fdb; }
  .nav-pills .nav-link {
    border-radius: var(--cui-nav-pills-border-radius); }
  .nav-pills .nav-link.active,
  .nav-pills .show > .nav-link {
    color: var(--cui-nav-pills-link-active-color);
    background-color: var(--cui-nav-pills-link-active-bg); }

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center; }

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center; }

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%; }

.tab-content > .tab-pane {
  display: none; }

.tab-content > .active {
  display: block; }

.navbar {
  --cui-navbar-padding-x: 0;
  --cui-navbar-padding-y: 0.5rem;
  --cui-navbar-color: rgba(var(--cui-emphasis-color-rgb), 0.65);
  --cui-navbar-hover-color: rgba(var(--cui-emphasis-color-rgb), 0.8);
  --cui-navbar-disabled-color: rgba(var(--cui-emphasis-color-rgb), 0.3);
  --cui-navbar-active-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-brand-padding-y: 0.3125rem;
  --cui-navbar-brand-margin-end: 1rem;
  --cui-navbar-brand-font-size: 1.25rem;
  --cui-navbar-brand-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-brand-hover-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-nav-link-padding-x: 0.5rem;
  --cui-navbar-toggler-padding-y: 0.25rem;
  --cui-navbar-toggler-padding-x: 0.75rem;
  --cui-navbar-toggler-font-size: 1.25rem;
  --cui-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  --cui-navbar-toggler-border-color: rgba(var(--cui-emphasis-color-rgb), 0.15);
  --cui-navbar-toggler-border-radius: var(--cui-border-radius);
  --cui-navbar-toggler-focus-width: 0.25rem;
  --cui-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-navbar-padding-y) var(--cui-navbar-padding-x); }
  .navbar > .container,
  .navbar > .container-fluid, .navbar > .container-sm, .navbar > .container-md, .navbar > .container-lg, .navbar > .container-xl, .navbar > .container-xxl, .navbar .header > .container,
  .navbar .header > .container-fluid, .navbar .header > .container-sm, .navbar .header > .container-md, .navbar .header > .container-lg, .navbar .header > .container-xl, .navbar .header > .container-xxl {
    display: flex;
    flex-wrap: inherit;
    align-items: center;
    justify-content: space-between; }

.navbar-brand {
  padding-top: var(--cui-navbar-brand-padding-y);
  padding-bottom: var(--cui-navbar-brand-padding-y);
  font-size: var(--cui-navbar-brand-font-size);
  color: var(--cui-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap; }
  html:not([dir="rtl"]) .navbar-brand {
    margin-right: var(--cui-navbar-brand-margin-end); }
  *[dir="rtl"] .navbar-brand {
    margin-left: var(--cui-navbar-brand-margin-end); }
  .navbar-brand:hover, .navbar-brand:focus {
    color: var(--cui-navbar-brand-hover-color); }

.navbar-nav {
  --cui-nav-link-padding-x: 0;
  --cui-nav-link-padding-y: 0.5rem;
  --cui-nav-link-font-weight: ;
  --cui-nav-link-color: var(--cui-navbar-color);
  --cui-nav-link-hover-color: var(--cui-navbar-hover-color);
  --cui-nav-link-disabled-color: var(--cui-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  list-style: none; }
  html:not([dir="rtl"]) .navbar-nav {
    padding-left: 0; }
  *[dir="rtl"] .navbar-nav {
    padding-right: 0; }
  .navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
    color: var(--cui-navbar-active-color); }
  .navbar-nav .dropdown-menu {
    position: static; }

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--cui-navbar-color); }
  .navbar-text a,
  .navbar-text a:hover,
  .navbar-text a:focus {
    color: var(--cui-navbar-active-color); }

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center; }

.navbar-toggler {
  padding: var(--cui-navbar-toggler-padding-y) var(--cui-navbar-toggler-padding-x);
  font-size: var(--cui-navbar-toggler-font-size);
  line-height: 1;
  color: var(--cui-navbar-color);
  background-color: transparent;
  border: 1px solid var(--cui-navbar-toggler-border-color);
  border: var(--cui-border-width) solid var(--cui-navbar-toggler-border-color);
  border-radius: var(--cui-navbar-toggler-border-radius);
  transition: var(--cui-navbar-toggler-transition); }
  @media (prefers-reduced-motion: reduce) {
    .navbar-toggler {
      transition: none; } }
  .navbar-toggler:hover {
    text-decoration: none; }
  .navbar-toggler:focus {
    text-decoration: none;
    outline: 0;
    box-shadow: 0 0 0 var(--cui-navbar-toggler-focus-width); }

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--cui-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%; }

.navbar-nav-scroll {
  max-height: 75vh;
  max-height: var(--cui-scroll-height, 75vh);
  overflow-y: auto; }

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-sm .navbar-nav {
      flex-direction: row; }
      .navbar-expand-sm .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-sm .navbar-nav .nav-link {
        padding-right: var(--cui-navbar-nav-link-padding-x);
        padding-left: var(--cui-navbar-nav-link-padding-x); }
    .navbar-expand-sm .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-sm .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-sm .navbar-toggler {
      display: none; }
    .navbar-expand-sm .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-sm .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-sm .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-md .navbar-nav {
      flex-direction: row; }
      .navbar-expand-md .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-md .navbar-nav .nav-link {
        padding-right: var(--cui-navbar-nav-link-padding-x);
        padding-left: var(--cui-navbar-nav-link-padding-x); }
    .navbar-expand-md .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-md .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-md .navbar-toggler {
      display: none; }
    .navbar-expand-md .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-md .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-md .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-lg .navbar-nav {
      flex-direction: row; }
      .navbar-expand-lg .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: var(--cui-navbar-nav-link-padding-x);
        padding-left: var(--cui-navbar-nav-link-padding-x); }
    .navbar-expand-lg .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-lg .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-lg .navbar-toggler {
      display: none; }
    .navbar-expand-lg .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-lg .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-lg .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-xl .navbar-nav {
      flex-direction: row; }
      .navbar-expand-xl .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-xl .navbar-nav .nav-link {
        padding-right: var(--cui-navbar-nav-link-padding-x);
        padding-left: var(--cui-navbar-nav-link-padding-x); }
    .navbar-expand-xl .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-xl .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-xl .navbar-toggler {
      display: none; }
    .navbar-expand-xl .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-xl .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-xl .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-xxl .navbar-nav {
      flex-direction: row; }
      .navbar-expand-xxl .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-xxl .navbar-nav .nav-link {
        padding-right: var(--cui-navbar-nav-link-padding-x);
        padding-left: var(--cui-navbar-nav-link-padding-x); }
    .navbar-expand-xxl .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-xxl .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-xxl .navbar-toggler {
      display: none; }
    .navbar-expand-xxl .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-xxl .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-xxl .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start; }
  .navbar-expand .navbar-nav {
    flex-direction: row; }
    .navbar-expand .navbar-nav .dropdown-menu {
      position: absolute; }
    .navbar-expand .navbar-nav .nav-link {
      padding-right: var(--cui-navbar-nav-link-padding-x);
      padding-left: var(--cui-navbar-nav-link-padding-x); }
  .navbar-expand .navbar-nav-scroll {
    overflow: visible; }
  .navbar-expand .navbar-collapse {
    display: flex !important;
    flex-basis: auto; }
  .navbar-expand .navbar-toggler {
    display: none; }
  .navbar-expand .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none; }
    .navbar-expand .offcanvas .offcanvas-header {
      display: none; }
    .navbar-expand .offcanvas .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible; }

.navbar-dark {
  --cui-navbar-color: rgba(255, 255, 255, 0.55);
  --cui-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --cui-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --cui-navbar-active-color: #fff;
  --cui-navbar-brand-color: #fff;
  --cui-navbar-brand-hover-color: #fff;
  --cui-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --cui-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_10___}); }

.card {
  --cui-card-spacer-y: 1rem;
  --cui-card-spacer-x: 1rem;
  --cui-card-title-spacer-y: 0.5rem;
  --cui-card-title-color: ;
  --cui-card-subtitle-color: ;
  --cui-card-border-width: var(--cui-border-width);
  --cui-card-border-color: var(--cui-border-color-translucent);
  --cui-card-border-radius: var(--cui-border-radius);
  --cui-card-box-shadow: ;
  --cui-card-inner-border-radius: calc(var(--cui-border-radius) - (var(--cui-border-width)));
  --cui-card-cap-padding-y: 0.5rem;
  --cui-card-cap-padding-x: 1rem;
  --cui-card-cap-bg: rgba(var(--cui-body-color-rgb), 0.03);
  --cui-card-cap-color: ;
  --cui-card-height: ;
  --cui-card-color: ;
  --cui-card-bg: var(--cui-body-bg);
  --cui-card-img-overlay-padding: 1rem;
  --cui-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--cui-card-height);
  color: rgba(44, 56, 74, 0.95);
  color: var(--cui-body-color);
  word-wrap: break-word;
  background-color: var(--cui-card-bg);
  background-clip: border-box;
  border: var(--cui-card-border-width) solid var(--cui-card-border-color);
  border-radius: var(--cui-card-border-radius); }
  .card > hr {
    margin-right: 0;
    margin-left: 0; }
  .card > .list-group {
    border-top: inherit;
    border-bottom: inherit; }
    .card > .list-group:first-child {
      border-top-width: 0;
      border-top-left-radius: var(--cui-card-inner-border-radius);
      border-top-right-radius: var(--cui-card-inner-border-radius); }
    .card > .list-group:last-child {
      border-bottom-width: 0;
      border-bottom-right-radius: var(--cui-card-inner-border-radius);
      border-bottom-left-radius: var(--cui-card-inner-border-radius); }
  .card > .card-header + .list-group,
  .card > .list-group + .card-footer {
    border-top: 0; }

.card-body {
  flex: 1 1 auto;
  padding: var(--cui-card-spacer-y) var(--cui-card-spacer-x);
  color: var(--cui-card-color); }

.card-title {
  margin-bottom: var(--cui-card-title-spacer-y);
  color: var(--cui-card-title-color); }

.card-subtitle {
  margin-top: calc(-.5 * var(--cui-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--cui-card-subtitle-color); }

.card-text:last-child {
  margin-bottom: 0; }

html:not([dir="rtl"]) .card-link + .card-link {
  margin-left: var(--cui-card-spacer-x); }

*[dir="rtl"] .card-link + .card-link {
  margin-right: var(--cui-card-spacer-x); }

.card-header {
  padding: var(--cui-card-cap-padding-y) var(--cui-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--cui-card-cap-color);
  background-color: var(--cui-card-cap-bg);
  border-bottom: var(--cui-card-border-width) solid var(--cui-card-border-color); }
  .card-header:first-child {
    border-radius: var(--cui-card-inner-border-radius) var(--cui-card-inner-border-radius) 0 0; }

.card-footer {
  padding: var(--cui-card-cap-padding-y) var(--cui-card-cap-padding-x);
  color: var(--cui-card-cap-color);
  background-color: var(--cui-card-cap-bg);
  border-top: var(--cui-card-border-width) solid var(--cui-card-border-color); }
  .card-footer:last-child {
    border-radius: 0 0 var(--cui-card-inner-border-radius) var(--cui-card-inner-border-radius); }

.card-header-tabs {
  margin-right: calc(-.5 * var(--cui-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--cui-card-cap-padding-y));
  margin-left: calc(-.5 * var(--cui-card-cap-padding-x));
  border-bottom: 0; }
  .card-header-tabs .nav-link.active {
    background-color: var(--cui-card-bg);
    border-bottom-color: var(--cui-card-bg); }

.card-header-pills {
  margin-right: calc(-.5 * var(--cui-card-cap-padding-x));
  margin-left: calc(-.5 * var(--cui-card-cap-padding-x)); }

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--cui-card-img-overlay-padding);
  border-radius: var(--cui-card-inner-border-radius); }

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%; }

.card-img,
.card-img-top {
  border-top-left-radius: var(--cui-card-inner-border-radius);
  border-top-right-radius: var(--cui-card-inner-border-radius); }

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--cui-card-inner-border-radius);
  border-bottom-left-radius: var(--cui-card-inner-border-radius); }

.card-group > .card {
  margin-bottom: var(--cui-card-group-margin); }

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap; }
    .card-group > .card {
      flex: 1 0;
      margin-bottom: 0; }
      html:not([dir="rtl"]) .card-group > .card + .card {
        margin-left: 0; }
      *[dir="rtl"] .card-group > .card + .card {
        margin-right: 0; }
      html:not([dir="rtl"]) .card-group > .card + .card {
        border-left: 0; }
      *[dir="rtl"] .card-group > .card + .card {
        border-right: 0; }
      html:not([dir="rtl"]) .card-group > .card:not(:last-child) {
        border-top-right-radius: 0; }
      *[dir="rtl"] .card-group > .card:not(:last-child) {
        border-top-left-radius: 0; }
      html:not([dir="rtl"]) .card-group > .card:not(:last-child) {
        border-bottom-right-radius: 0; }
      *[dir="rtl"] .card-group > .card:not(:last-child) {
        border-bottom-left-radius: 0; }
      .card-group > .card:not(:last-child) .card-img-top,
      .card-group > .card:not(:last-child) .card-header {
        border-top-right-radius: 0; }
      .card-group > .card:not(:last-child) .card-img-bottom,
      .card-group > .card:not(:last-child) .card-footer {
        border-bottom-right-radius: 0; }
      html:not([dir="rtl"]) .card-group > .card:not(:first-child) {
        border-top-left-radius: 0; }
      *[dir="rtl"] .card-group > .card:not(:first-child) {
        border-top-right-radius: 0; }
      html:not([dir="rtl"]) .card-group > .card:not(:first-child) {
        border-bottom-left-radius: 0; }
      *[dir="rtl"] .card-group > .card:not(:first-child) {
        border-bottom-right-radius: 0; }
      .card-group > .card:not(:first-child) .card-img-top,
      .card-group > .card:not(:first-child) .card-header {
        border-top-left-radius: 0; }
      .card-group > .card:not(:first-child) .card-img-bottom,
      .card-group > .card:not(:first-child) .card-footer {
        border-bottom-left-radius: 0; } }

.accordion {
  --cui-accordion-color: var(--cui-body-color);
  --cui-accordion-bg: var(--cui-body-bg);
  --cui-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --cui-accordion-border-color: var(--cui-border-color);
  --cui-accordion-border-width: var(--cui-border-width);
  --cui-accordion-border-radius: var(--cui-border-radius);
  --cui-accordion-inner-border-radius: calc(var(--cui-border-radius) - (var(--cui-border-width)));
  --cui-accordion-btn-padding-x: 1.25rem;
  --cui-accordion-btn-padding-y: 1rem;
  --cui-accordion-btn-color: var(--cui-body-color);
  --cui-accordion-btn-bg: var(--cui-accordion-bg);
  --cui-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --cui-accordion-btn-icon-width: 1.25rem;
  --cui-accordion-btn-icon-transform: rotate(-180deg);
  --cui-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --cui-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  --cui-accordion-btn-focus-border-color: #998fed;
  --cui-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
  --cui-accordion-body-padding-x: 1.25rem;
  --cui-accordion-body-padding-y: 1rem;
  --cui-accordion-active-color: #2d1cc5;
  --cui-accordion-active-bg: #ebe9fb; }

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--cui-accordion-btn-padding-y) var(--cui-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--cui-accordion-btn-color);
  text-align: left;
  background-color: var(--cui-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--cui-accordion-transition); }
  @media (prefers-reduced-motion: reduce) {
    .accordion-button {
      transition: none; } }
  .accordion-button:not(.collapsed) {
    color: var(--cui-accordion-active-color);
    background-color: var(--cui-accordion-active-bg);
    box-shadow: inset 0 calc(-1 * var(--cui-accordion-border-width)) 0 var(--cui-accordion-border-color); }
    .accordion-button:not(.collapsed)::after {
      background-image: var(--cui-accordion-btn-active-icon);
      transform: var(--cui-accordion-btn-icon-transform); }
  .accordion-button::after {
    flex-shrink: 0;
    width: var(--cui-accordion-btn-icon-width);
    height: var(--cui-accordion-btn-icon-width);
    margin-left: auto;
    content: "";
    background-image: var(--cui-accordion-btn-icon);
    background-repeat: no-repeat;
    background-size: var(--cui-accordion-btn-icon-width);
    transition: var(--cui-accordion-btn-icon-transition); }
    @media (prefers-reduced-motion: reduce) {
      .accordion-button::after {
        transition: none; } }
  .accordion-button:hover {
    z-index: 2; }
  .accordion-button:focus {
    z-index: 3;
    border-color: var(--cui-accordion-btn-focus-border-color);
    outline: 0;
    box-shadow: var(--cui-accordion-btn-focus-box-shadow); }

.accordion-header {
  margin-bottom: 0; }

.accordion-item {
  color: var(--cui-accordion-color);
  background-color: var(--cui-accordion-bg);
  border: var(--cui-accordion-border-width) solid var(--cui-accordion-border-color); }
  .accordion-item:first-of-type {
    border-top-left-radius: var(--cui-accordion-border-radius);
    border-top-right-radius: var(--cui-accordion-border-radius); }
    .accordion-item:first-of-type .accordion-button {
      border-top-left-radius: var(--cui-accordion-inner-border-radius);
      border-top-right-radius: var(--cui-accordion-inner-border-radius); }
  .accordion-item:not(:first-of-type) {
    border-top: 0; }
  .accordion-item:last-of-type {
    border-bottom-right-radius: var(--cui-accordion-border-radius);
    border-bottom-left-radius: var(--cui-accordion-border-radius); }
    .accordion-item:last-of-type .accordion-button.collapsed {
      border-bottom-right-radius: var(--cui-accordion-inner-border-radius);
      border-bottom-left-radius: var(--cui-accordion-inner-border-radius); }
    .accordion-item:last-of-type .accordion-collapse {
      border-bottom-right-radius: var(--cui-accordion-border-radius);
      border-bottom-left-radius: var(--cui-accordion-border-radius); }

.accordion-body {
  padding: var(--cui-accordion-body-padding-y) var(--cui-accordion-body-padding-x); }

.accordion-flush .accordion-collapse {
  border-width: 0; }

.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0; }
  .accordion-flush .accordion-item:first-child {
    border-top: 0; }
  .accordion-flush .accordion-item:last-child {
    border-bottom: 0; }
  .accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
    border-radius: 0; }

.breadcrumb {
  --cui-breadcrumb-padding-x: 0;
  --cui-breadcrumb-padding-y: 0;
  --cui-breadcrumb-margin-bottom: 1rem;
  --cui-breadcrumb-bg: ;
  --cui-breadcrumb-border-radius: ;
  --cui-breadcrumb-divider-color: var(--cui-secondary-color);
  --cui-breadcrumb-item-padding-x: 0.5rem;
  --cui-breadcrumb-item-active-color: var(--cui-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--cui-breadcrumb-padding-y) var(--cui-breadcrumb-padding-x);
  margin-bottom: var(--cui-breadcrumb-margin-bottom);
  font-size: var(--cui-breadcrumb-font-size);
  list-style: none;
  background-color: var(--cui-breadcrumb-bg);
  border-radius: var(--cui-breadcrumb-border-radius); }

html:not([dir="rtl"]) .breadcrumb-item + .breadcrumb-item {
  padding-left: var(--cui-breadcrumb-item-padding-x); }

*[dir="rtl"] .breadcrumb-item + .breadcrumb-item {
  padding-right: var(--cui-breadcrumb-item-padding-x); }

.breadcrumb-item + .breadcrumb-item::before {
  color: var(--cui-breadcrumb-divider-color); }
  html:not([dir="rtl"]) .breadcrumb-item + .breadcrumb-item::before {
    float: left; }
  *[dir="rtl"] .breadcrumb-item + .breadcrumb-item::before {
    float: right; }
  html:not([dir="rtl"]) .breadcrumb-item + .breadcrumb-item::before {
    padding-right: var(--cui-breadcrumb-item-padding-x); }
  *[dir="rtl"] .breadcrumb-item + .breadcrumb-item::before {
    padding-left: var(--cui-breadcrumb-item-padding-x); }
  html:not([dir="rtl"]) .breadcrumb-item + .breadcrumb-item::before {
    content: "/";
    content: var(--cui-breadcrumb-divider, "/"); }
  *[dir="rtl"] .breadcrumb-item + .breadcrumb-item::before {
    content: "/";
    content: var(--cui-breadcrumb-divider-flipped, "/"); }

.breadcrumb-item.active {
  color: var(--cui-breadcrumb-item-active-color); }

.pagination {
  --cui-pagination-padding-x: 0.75rem;
  --cui-pagination-padding-y: 0.375rem;
  --cui-pagination-font-size: 1rem;
  --cui-pagination-color: var(--cui-link-color);
  --cui-pagination-bg: var(--cui-body-bg);
  --cui-pagination-border-width: var(--cui-border-width);
  --cui-pagination-border-color: var(--cui-border-color);
  --cui-pagination-border-radius: var(--cui-border-radius);
  --cui-pagination-hover-color: var(--cui-link-hover-color);
  --cui-pagination-hover-bg: var(--cui-tertiary-bg);
  --cui-pagination-hover-border-color: var(--cui-border-color);
  --cui-pagination-focus-color: var(--cui-link-hover-color);
  --cui-pagination-focus-bg: var(--cui-secondary-bg);
  --cui-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
  --cui-pagination-active-color: rgba(255, 255, 255, 0.87);
  --cui-pagination-active-bg: #321fdb;
  --cui-pagination-active-border-color: #321fdb;
  --cui-pagination-disabled-color: var(--cui-secondary-color);
  --cui-pagination-disabled-bg: var(--cui-secondary-bg);
  --cui-pagination-disabled-border-color: var(--cui-border-color);
  display: flex;
  list-style: none; }
  html:not([dir="rtl"]) .pagination {
    padding-left: 0; }
  *[dir="rtl"] .pagination {
    padding-right: 0; }

.page-link {
  position: relative;
  display: block;
  padding: var(--cui-pagination-padding-y) var(--cui-pagination-padding-x);
  font-size: var(--cui-pagination-font-size);
  color: var(--cui-pagination-color);
  text-decoration: none;
  background-color: var(--cui-pagination-bg);
  border: var(--cui-pagination-border-width) solid var(--cui-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .page-link {
      transition: none; } }
  .page-link:hover {
    z-index: 2;
    color: var(--cui-pagination-hover-color);
    background-color: var(--cui-pagination-hover-bg);
    border-color: var(--cui-pagination-hover-border-color); }
  .page-link:focus {
    z-index: 3;
    color: var(--cui-pagination-focus-color);
    background-color: var(--cui-pagination-focus-bg);
    outline: 0;
    box-shadow: var(--cui-pagination-focus-box-shadow); }
  .page-link.active,
  .active > .page-link {
    z-index: 3;
    color: var(--cui-pagination-active-color);
    background-color: var(--cui-pagination-active-bg);
    border-color: var(--cui-pagination-active-border-color); }
  .page-link.disabled,
  .disabled > .page-link {
    color: var(--cui-pagination-disabled-color);
    pointer-events: none;
    background-color: var(--cui-pagination-disabled-bg);
    border-color: var(--cui-pagination-disabled-border-color); }

html:not([dir="rtl"]) .page-item:not(:first-child) .page-link {
  margin-left: calc(1px * -1);
  margin-left: calc(var(--cui-border-width) * -1); }

*[dir="rtl"] .page-item:not(:first-child) .page-link {
  margin-right: calc(1px * -1);
  margin-right: calc(var(--cui-border-width) * -1); }

html:not([dir="rtl"]) .page-item:first-child .page-link {
  border-top-left-radius: var(--cui-pagination-border-radius); }

*[dir="rtl"] .page-item:first-child .page-link {
  border-top-right-radius: var(--cui-pagination-border-radius); }

html:not([dir="rtl"]) .page-item:first-child .page-link {
  border-bottom-left-radius: var(--cui-pagination-border-radius); }

*[dir="rtl"] .page-item:first-child .page-link {
  border-bottom-right-radius: var(--cui-pagination-border-radius); }

html:not([dir="rtl"]) .page-item:last-child .page-link {
  border-top-right-radius: var(--cui-pagination-border-radius); }

*[dir="rtl"] .page-item:last-child .page-link {
  border-top-left-radius: var(--cui-pagination-border-radius); }

html:not([dir="rtl"]) .page-item:last-child .page-link {
  border-bottom-right-radius: var(--cui-pagination-border-radius); }

*[dir="rtl"] .page-item:last-child .page-link {
  border-bottom-left-radius: var(--cui-pagination-border-radius); }

.pagination-lg {
  --cui-pagination-padding-x: 1.5rem;
  --cui-pagination-padding-y: 0.75rem;
  --cui-pagination-font-size: 1.25rem;
  --cui-pagination-border-radius: var(--cui-border-radius-lg); }

.pagination-sm {
  --cui-pagination-padding-x: 0.5rem;
  --cui-pagination-padding-y: 0.25rem;
  --cui-pagination-font-size: 0.875rem;
  --cui-pagination-border-radius: var(--cui-border-radius-sm); }

.badge {
  --cui-badge-padding-x: 0.65em;
  --cui-badge-padding-y: 0.35em;
  --cui-badge-font-size: 0.75em;
  --cui-badge-font-weight: 700;
  --cui-badge-color: rgba(255, 255, 255, 0.87);
  --cui-badge-border-radius: var(--cui-border-radius);
  display: inline-block;
  padding: var(--cui-badge-padding-y) var(--cui-badge-padding-x);
  font-size: var(--cui-badge-font-size);
  font-weight: var(--cui-badge-font-weight);
  line-height: 1;
  color: var(--cui-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0;
  border-radius: var(--cui-badge-border-radius, 0); }
  .badge:empty {
    display: none; }

.btn .badge {
  position: relative;
  top: -1px; }

.badge-sm {
  --cui-badge-padding-x: 0.5em;
  --cui-badge-padding-y: 0.3em;
  font-size: 0.65em; }

.alert {
  --cui-alert-bg: transparent;
  --cui-alert-padding-x: 1rem;
  --cui-alert-padding-y: 1rem;
  --cui-alert-margin-bottom: 1rem;
  --cui-alert-color: inherit;
  --cui-alert-border-color: transparent;
  --cui-alert-border: var(--cui-border-width) solid var(--cui-alert-border-color);
  --cui-alert-border-radius: var(--cui-border-radius);
  --cui-alert-link-color: inherit;
  position: relative;
  padding: var(--cui-alert-padding-y) var(--cui-alert-padding-x);
  margin-bottom: var(--cui-alert-margin-bottom);
  color: var(--cui-alert-color);
  background-color: var(--cui-alert-bg);
  border: var(--cui-alert-border);
  border-radius: var(--cui-alert-border-radius); }

.alert-heading {
  color: inherit; }

.alert-link {
  font-weight: 700;
  color: var(--cui-alert-link-color); }

html:not([dir="rtl"]) .alert-dismissible {
  padding-right: 3rem; }

*[dir="rtl"] .alert-dismissible {
  padding-left: 3rem; }

.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  z-index: 2;
  padding: 1.25rem 1rem; }
  html:not([dir="rtl"]) .alert-dismissible .btn-close {
    right: 0; }
  *[dir="rtl"] .alert-dismissible .btn-close {
    left: 0; }

.alert-primary {
  --cui-alert-color: #1e1383;
  --cui-alert-bg: #d6d2f8;
  --cui-alert-border-color: #c2bcf4;
  --cui-alert-link-color: #180f69; }

.alert-secondary {
  --cui-alert-color: #5e636a;
  --cui-alert-bg: #ebedef;
  --cui-alert-border-color: #e2e4e8;
  --cui-alert-link-color: #4b4f55; }

.alert-success {
  --cui-alert-color: #1c6e37;
  --cui-alert-bg: #d5f1de;
  --cui-alert-border-color: #c0eace;
  --cui-alert-link-color: #16582c; }

.alert-info {
  --cui-alert-color: #1f5c99;
  --cui-alert-bg: #d6ebff;
  --cui-alert-border-color: #c2e0ff;
  --cui-alert-link-color: #194a7a; }

.alert-warning {
  --cui-alert-color: #956a0d;
  --cui-alert-bg: #feefd0;
  --cui-alert-border-color: #fde8b9;
  --cui-alert-link-color: #77550a; }

.alert-danger {
  --cui-alert-color: #893232;
  --cui-alert-bg: #fadddd;
  --cui-alert-border-color: #f7cbcb;
  --cui-alert-link-color: #6e2828; }

.alert-light {
  --cui-alert-color: #8d8e8f;
  --cui-alert-bg: #fbfbfc;
  --cui-alert-border-color: #f9fafa;
  --cui-alert-link-color: #717272; }

.alert-dark {
  --cui-alert-color: #2f3845;
  --cui-alert-bg: #dcdfe3;
  --cui-alert-border-color: #caced5;
  --cui-alert-link-color: #262d37; }

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem; } }

.progress,
.progress-stacked {
  --cui-progress-height: 1rem;
  --cui-progress-font-size: 0.75rem;
  --cui-progress-bg: var(--cui-secondary-bg);
  --cui-progress-border-radius: var(--cui-border-radius);
  --cui-progress-box-shadow: var(--cui-box-shadow-inset);
  --cui-progress-bar-color: rgba(255, 255, 255, 0.87);
  --cui-progress-bar-bg: var(--cui-primary);
  --cui-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--cui-progress-height);
  overflow: hidden;
  font-size: var(--cui-progress-font-size);
  background-color: var(--cui-progress-bg);
  border-radius: var(--cui-progress-border-radius); }

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--cui-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--cui-progress-bar-bg);
  transition: var(--cui-progress-bar-transition); }
  @media (prefers-reduced-motion: reduce) {
    .progress-bar {
      transition: none; } }

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--cui-progress-height) var(--cui-progress-height); }

.progress-stacked > .progress {
  overflow: visible; }

.progress-stacked > .progress > .progress-bar {
  width: 100%; }

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes; }
  @media (prefers-reduced-motion: reduce) {
    .progress-bar-animated {
      animation: none; } }

.progress-thin {
  height: 4px; }

.progress.progress-white {
  background-color: rgba(255, 255, 255, 0.2); }
  .progress.progress-white .progress-bar {
    background-color: #fff; }

.progress-group {
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 1rem; }

.progress-group-prepend {
  flex: 0 0 100px;
  align-self: center; }

.progress-group-header {
  display: flex;
  flex-basis: 100%;
  align-items: center;
  margin-bottom: 0.25rem; }

.progress-group-bars {
  flex-grow: 1;
  align-self: center; }
  .progress-group-bars .progress:not(:last-child) {
    margin-bottom: 2px; }

.progress-group-header + .progress-group-bars {
  flex-basis: 100%; }

.list-group {
  --cui-list-group-color: var(--cui-body-color);
  --cui-list-group-bg: var(--cui-body-bg);
  --cui-list-group-border-color: var(--cui-border-color);
  --cui-list-group-border-width: var(--cui-border-width);
  --cui-list-group-border-radius: var(--cui-border-radius);
  --cui-list-group-item-padding-x: 1rem;
  --cui-list-group-item-padding-y: 0.5rem;
  --cui-list-group-action-color: var(--cui-secondary-color);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-tertiary-bg);
  --cui-list-group-action-active-color: var(--cui-body-color);
  --cui-list-group-action-active-bg: var(--cui-secondary-bg);
  --cui-list-group-disabled-color: var(--cui-secondary-color);
  --cui-list-group-disabled-bg: var(--cui-body-bg);
  --cui-list-group-active-color: rgba(255, 255, 255, 0.87);
  --cui-list-group-active-bg: #321fdb;
  --cui-list-group-active-border-color: #321fdb;
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  border-radius: var(--cui-list-group-border-radius); }
  html:not([dir="rtl"]) .list-group {
    padding-left: 0; }
  *[dir="rtl"] .list-group {
    padding-right: 0; }

.list-group-numbered {
  list-style-type: none;
  counter-reset: section; }
  .list-group-numbered > .list-group-item::before {
    content: counters(section, ".") ". ";
    counter-increment: section; }

.list-group-item-action {
  width: 100%;
  color: var(--cui-list-group-action-color);
  text-align: inherit; }
  .list-group-item-action:hover, .list-group-item-action:focus {
    z-index: 1;
    color: var(--cui-list-group-action-hover-color);
    text-decoration: none;
    background-color: var(--cui-list-group-action-hover-bg); }
  .list-group-item-action:active {
    color: var(--cui-list-group-action-active-color);
    background-color: var(--cui-list-group-action-active-bg); }

.list-group-item {
  position: relative;
  display: block;
  padding: var(--cui-list-group-item-padding-y) var(--cui-list-group-item-padding-x);
  color: var(--cui-list-group-color);
  text-decoration: none;
  background-color: var(--cui-list-group-bg);
  border: var(--cui-list-group-border-width) solid var(--cui-list-group-border-color); }
  .list-group-item:first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit; }
  .list-group-item:last-child {
    border-bottom-right-radius: inherit;
    border-bottom-left-radius: inherit; }
  .list-group-item.disabled, .list-group-item:disabled {
    color: var(--cui-list-group-disabled-color);
    pointer-events: none;
    background-color: var(--cui-list-group-disabled-bg); }
  .list-group-item.active {
    z-index: 2;
    color: var(--cui-list-group-active-color);
    background-color: var(--cui-list-group-active-bg);
    border-color: var(--cui-list-group-active-border-color); }
  .list-group-item + .list-group-item {
    border-top-width: 0; }
    .list-group-item + .list-group-item.active {
      margin-top: calc(-1 * var(--cui-list-group-border-width));
      border-top-width: var(--cui-list-group-border-width); }

.list-group-horizontal {
  flex-direction: row; }
  html:not([dir="rtl"]) .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius); }
  *[dir="rtl"] .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--cui-list-group-border-radius); }
  html:not([dir="rtl"]) .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
    border-top-right-radius: 0; }
  *[dir="rtl"] .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
    border-top-left-radius: 0; }
  html:not([dir="rtl"]) .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius); }
  *[dir="rtl"] .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--cui-list-group-border-radius); }
  html:not([dir="rtl"]) .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
    border-bottom-left-radius: 0; }
  *[dir="rtl"] .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
    border-bottom-right-radius: 0; }
  .list-group-horizontal > .list-group-item.active {
    margin-top: 0; }
  .list-group-horizontal > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width); }
    html:not([dir="rtl"]) .list-group-horizontal > .list-group-item + .list-group-item {
      border-left-width: 0; }
    *[dir="rtl"] .list-group-horizontal > .list-group-item + .list-group-item {
      border-right-width: 0; }
    html:not([dir="rtl"]) .list-group-horizontal > .list-group-item + .list-group-item.active {
      margin-left: calc(-1 * var(--cui-list-group-border-width)); }
    *[dir="rtl"] .list-group-horizontal > .list-group-item + .list-group-item.active {
      margin-right: calc(-1 * var(--cui-list-group-border-width)); }
    html:not([dir="rtl"]) .list-group-horizontal > .list-group-item + .list-group-item.active {
      border-left-width: var(--cui-list-group-border-width); }
    *[dir="rtl"] .list-group-horizontal > .list-group-item + .list-group-item.active {
      border-right-width: var(--cui-list-group-border-width); }

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row; }
    html:not([dir="rtl"]) .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--cui-list-group-border-radius); }
    *[dir="rtl"] .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
      border-bottom-right-radius: var(--cui-list-group-border-radius); }
    html:not([dir="rtl"]) .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
      border-top-right-radius: 0; }
    *[dir="rtl"] .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
      border-top-left-radius: 0; }
    html:not([dir="rtl"]) .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--cui-list-group-border-radius); }
    *[dir="rtl"] .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
      border-top-left-radius: var(--cui-list-group-border-radius); }
    html:not([dir="rtl"]) .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
      border-bottom-left-radius: 0; }
    *[dir="rtl"] .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
      border-bottom-right-radius: 0; }
    .list-group-horizontal-sm > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-sm > .list-group-item + .list-group-item {
      border-top-width: var(--cui-list-group-border-width); }
      html:not([dir="rtl"]) .list-group-horizontal-sm > .list-group-item + .list-group-item {
        border-left-width: 0; }
      *[dir="rtl"] .list-group-horizontal-sm > .list-group-item + .list-group-item {
        border-right-width: 0; }
      html:not([dir="rtl"]) .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--cui-list-group-border-width)); }
      *[dir="rtl"] .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
        margin-right: calc(-1 * var(--cui-list-group-border-width)); }
      html:not([dir="rtl"]) .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
        border-left-width: var(--cui-list-group-border-width); }
      *[dir="rtl"] .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
        border-right-width: var(--cui-list-group-border-width); } }

@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row; }
    html:not([dir="rtl"]) .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--cui-list-group-border-radius); }
    *[dir="rtl"] .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
      border-bottom-right-radius: var(--cui-list-group-border-radius); }
    html:not([dir="rtl"]) .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
      border-top-right-radius: 0; }
    *[dir="rtl"] .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
      border-top-left-radius: 0; }
    html:not([dir="rtl"]) .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--cui-list-group-border-radius); }
    *[dir="rtl"] .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
      border-top-left-radius: var(--cui-list-group-border-radius); }
    html:not([dir="rtl"]) .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
      border-bottom-left-radius: 0; }
    *[dir="rtl"] .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
      border-bottom-right-radius: 0; }
    .list-group-horizontal-md > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-md > .list-group-item + .list-group-item {
      border-top-width: var(--cui-list-group-border-width); }
      html:not([dir="rtl"]) .list-group-horizontal-md > .list-group-item + .list-group-item {
        border-left-width: 0; }
      *[dir="rtl"] .list-group-horizontal-md > .list-group-item + .list-group-item {
        border-right-width: 0; }
      html:not([dir="rtl"]) .list-group-horizontal-md > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--cui-list-group-border-width)); }
      *[dir="rtl"] .list-group-horizontal-md > .list-group-item + .list-group-item.active {
        margin-right: calc(-1 * var(--cui-list-group-border-width)); }
      html:not([dir="rtl"]) .list-group-horizontal-md > .list-group-item + .list-group-item.active {
        border-left-width: var(--cui-list-group-border-width); }
      *[dir="rtl"] .list-group-horizontal-md > .list-group-item + .list-group-item.active {
        border-right-width: var(--cui-list-group-border-width); } }

@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row; }
    html:not([dir="rtl"]) .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--cui-list-group-border-radius); }
    *[dir="rtl"] .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
      border-bottom-right-radius: var(--cui-list-group-border-radius); }
    html:not([dir="rtl"]) .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
      border-top-right-radius: 0; }
    *[dir="rtl"] .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
      border-top-left-radius: 0; }
    html:not([dir="rtl"]) .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--cui-list-group-border-radius); }
    *[dir="rtl"] .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
      border-top-left-radius: var(--cui-list-group-border-radius); }
    html:not([dir="rtl"]) .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
      border-bottom-left-radius: 0; }
    *[dir="rtl"] .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
      border-bottom-right-radius: 0; }
    .list-group-horizontal-lg > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-lg > .list-group-item + .list-group-item {
      border-top-width: var(--cui-list-group-border-width); }
      html:not([dir="rtl"]) .list-group-horizontal-lg > .list-group-item + .list-group-item {
        border-left-width: 0; }
      *[dir="rtl"] .list-group-horizontal-lg > .list-group-item + .list-group-item {
        border-right-width: 0; }
      html:not([dir="rtl"]) .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--cui-list-group-border-width)); }
      *[dir="rtl"] .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
        margin-right: calc(-1 * var(--cui-list-group-border-width)); }
      html:not([dir="rtl"]) .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
        border-left-width: var(--cui-list-group-border-width); }
      *[dir="rtl"] .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
        border-right-width: var(--cui-list-group-border-width); } }

@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row; }
    html:not([dir="rtl"]) .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--cui-list-group-border-radius); }
    *[dir="rtl"] .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
      border-bottom-right-radius: var(--cui-list-group-border-radius); }
    html:not([dir="rtl"]) .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
      border-top-right-radius: 0; }
    *[dir="rtl"] .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
      border-top-left-radius: 0; }
    html:not([dir="rtl"]) .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--cui-list-group-border-radius); }
    *[dir="rtl"] .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
      border-top-left-radius: var(--cui-list-group-border-radius); }
    html:not([dir="rtl"]) .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
      border-bottom-left-radius: 0; }
    *[dir="rtl"] .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
      border-bottom-right-radius: 0; }
    .list-group-horizontal-xl > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-xl > .list-group-item + .list-group-item {
      border-top-width: var(--cui-list-group-border-width); }
      html:not([dir="rtl"]) .list-group-horizontal-xl > .list-group-item + .list-group-item {
        border-left-width: 0; }
      *[dir="rtl"] .list-group-horizontal-xl > .list-group-item + .list-group-item {
        border-right-width: 0; }
      html:not([dir="rtl"]) .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--cui-list-group-border-width)); }
      *[dir="rtl"] .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
        margin-right: calc(-1 * var(--cui-list-group-border-width)); }
      html:not([dir="rtl"]) .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
        border-left-width: var(--cui-list-group-border-width); }
      *[dir="rtl"] .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
        border-right-width: var(--cui-list-group-border-width); } }

@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row; }
    html:not([dir="rtl"]) .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--cui-list-group-border-radius); }
    *[dir="rtl"] .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
      border-bottom-right-radius: var(--cui-list-group-border-radius); }
    html:not([dir="rtl"]) .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
      border-top-right-radius: 0; }
    *[dir="rtl"] .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
      border-top-left-radius: 0; }
    html:not([dir="rtl"]) .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--cui-list-group-border-radius); }
    *[dir="rtl"] .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
      border-top-left-radius: var(--cui-list-group-border-radius); }
    html:not([dir="rtl"]) .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
      border-bottom-left-radius: 0; }
    *[dir="rtl"] .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
      border-bottom-right-radius: 0; }
    .list-group-horizontal-xxl > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-xxl > .list-group-item + .list-group-item {
      border-top-width: var(--cui-list-group-border-width); }
      html:not([dir="rtl"]) .list-group-horizontal-xxl > .list-group-item + .list-group-item {
        border-left-width: 0; }
      *[dir="rtl"] .list-group-horizontal-xxl > .list-group-item + .list-group-item {
        border-right-width: 0; }
      html:not([dir="rtl"]) .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--cui-list-group-border-width)); }
      *[dir="rtl"] .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
        margin-right: calc(-1 * var(--cui-list-group-border-width)); }
      html:not([dir="rtl"]) .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
        border-left-width: var(--cui-list-group-border-width); }
      *[dir="rtl"] .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
        border-right-width: var(--cui-list-group-border-width); } }

.list-group-flush {
  border-radius: 0; }
  .list-group-flush > .list-group-item {
    border-width: 0 0 var(--cui-list-group-border-width); }
    .list-group-flush > .list-group-item:last-child {
      border-bottom-width: 0; }

.list-group-item-primary {
  --cui-list-group-color: contrast-ratio-correction(#1e1383, #d6d2f8, 40%, "primary");
  --cui-list-group-bg: #d6d2f8;
  --cui-list-group-hover-bg: #2d1cc5;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#1e1383, #d6d2f8, 40%, "primary");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#1e1383, #d6d2f8, 40%, "primary");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#1e1383, #d6d2f8, 40%, "primary"); }

.list-group-item-secondary {
  --cui-list-group-color: contrast-ratio-correction(#5e636a, #ebedef, 40%, "secondary");
  --cui-list-group-bg: #ebedef;
  --cui-list-group-hover-bg: #8d959f;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#5e636a, #ebedef, 40%, "secondary");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#5e636a, #ebedef, 40%, "secondary");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#5e636a, #ebedef, 40%, "secondary"); }

.list-group-item-success {
  --cui-list-group-color: contrast-ratio-correction(#1c6e37, #d5f1de, 40%, "success");
  --cui-list-group-bg: #d5f1de;
  --cui-list-group-hover-bg: #29a653;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#1c6e37, #d5f1de, 40%, "success");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#1c6e37, #d5f1de, 40%, "success");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#1c6e37, #d5f1de, 40%, "success"); }

.list-group-item-danger {
  --cui-list-group-color: contrast-ratio-correction(#893232, #fadddd, 40%, "danger");
  --cui-list-group-bg: #fadddd;
  --cui-list-group-hover-bg: #ce4b4b;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#893232, #fadddd, 40%, "danger");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#893232, #fadddd, 40%, "danger");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#893232, #fadddd, 40%, "danger"); }

.list-group-item-warning {
  --cui-list-group-color: contrast-ratio-correction(#956a0d, #feefd0, 40%, "warning");
  --cui-list-group-bg: #feefd0;
  --cui-list-group-hover-bg: #e09f13;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#956a0d, #feefd0, 40%, "warning");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#956a0d, #feefd0, 40%, "warning");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#956a0d, #feefd0, 40%, "warning"); }

.list-group-item-info {
  --cui-list-group-color: contrast-ratio-correction(#1f5c99, #d6ebff, 40%, "info");
  --cui-list-group-bg: #d6ebff;
  --cui-list-group-hover-bg: #2e8ae6;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#1f5c99, #d6ebff, 40%, "info");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#1f5c99, #d6ebff, 40%, "info");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#1f5c99, #d6ebff, 40%, "info"); }

.list-group-item-light {
  --cui-list-group-color: contrast-ratio-correction(#8d8e8f, #fbfbfc, 40%, "light");
  --cui-list-group-bg: #fbfbfc;
  --cui-list-group-hover-bg: #d4d5d7;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#8d8e8f, #fbfbfc, 40%, "light");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#8d8e8f, #fbfbfc, 40%, "light");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#8d8e8f, #fbfbfc, 40%, "light"); }

.list-group-item-dark {
  --cui-list-group-color: contrast-ratio-correction(#2f3845, #dcdfe3, 40%, "dark");
  --cui-list-group-bg: #dcdfe3;
  --cui-list-group-hover-bg: #475468;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#2f3845, #dcdfe3, 40%, "dark");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#2f3845, #dcdfe3, 40%, "dark");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#2f3845, #dcdfe3, 40%, "dark"); }

.btn-close {
  --cui-btn-close-color: rgba(44, 56, 74, 0.95);
  --cui-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --cui-btn-close-opacity: 0.5;
  --cui-btn-close-hover-opacity: 0.75;
  --cui-btn-close-focus-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
  --cui-btn-close-focus-opacity: 1;
  --cui-btn-close-disabled-opacity: 0.25;
  --cui-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--cui-btn-close-color);
  background: transparent var(--cui-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--cui-btn-close-opacity); }
  .btn-close:hover {
    color: var(--cui-btn-close-color);
    text-decoration: none;
    opacity: var(--cui-btn-close-hover-opacity); }
  .btn-close:focus {
    outline: 0;
    box-shadow: var(--cui-btn-close-focus-shadow);
    opacity: var(--cui-btn-close-focus-opacity); }
  .btn-close:disabled, .btn-close.disabled {
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
    opacity: var(--cui-btn-close-disabled-opacity); }

.btn-close-white {
  filter: var(--cui-btn-close-white-filter); }

.toast {
  --cui-toast-zindex: 1090;
  --cui-toast-padding-x: 0.75rem;
  --cui-toast-padding-y: 0.5rem;
  --cui-toast-spacing: 1.5rem;
  --cui-toast-max-width: 350px;
  --cui-toast-font-size: 0.875rem;
  --cui-toast-color: ;
  --cui-toast-bg: rgba(var(--cui-body-bg-rgb), 0.85);
  --cui-toast-border-width: var(--cui-border-width);
  --cui-toast-border-color: var(--cui-border-color-translucent);
  --cui-toast-border-radius: var(--cui-border-radius);
  --cui-toast-box-shadow: var(--cui-box-shadow);
  --cui-toast-header-color: var(--cui-secondary-color);
  --cui-toast-header-bg: rgba(var(--cui-body-bg-rgb), 0.85);
  --cui-toast-header-border-color: var(--cui-border-color-translucent);
  width: var(--cui-toast-max-width);
  max-width: 100%;
  font-size: var(--cui-toast-font-size);
  color: var(--cui-toast-color);
  pointer-events: auto;
  background-color: var(--cui-toast-bg);
  background-clip: padding-box;
  border: var(--cui-toast-border-width) solid var(--cui-toast-border-color);
  box-shadow: var(--cui-toast-box-shadow);
  border-radius: var(--cui-toast-border-radius); }
  .toast.showing {
    opacity: 0; }
  .toast:not(.show) {
    display: none; }

.toast-container {
  --cui-toast-zindex: 1090;
  position: absolute;
  z-index: var(--cui-toast-zindex);
  width: -webkit-max-content;
  width: max-content;
  max-width: 100%;
  pointer-events: none; }
  .toast-container > :not(:last-child) {
    margin-bottom: var(--cui-toast-spacing); }

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--cui-toast-padding-y) var(--cui-toast-padding-x);
  color: var(--cui-toast-header-color);
  background-color: var(--cui-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--cui-toast-border-width) solid var(--cui-toast-header-border-color);
  border-top-left-radius: calc(var(--cui-toast-border-radius) - var(--cui-toast-border-width));
  border-top-right-radius: calc(var(--cui-toast-border-radius) - var(--cui-toast-border-width)); }
  html:not([dir="rtl"]) .toast-header .btn-close {
    margin-right: calc(-.5 * var(--cui-toast-padding-x)); }
  *[dir="rtl"] .toast-header .btn-close {
    margin-left: calc(-.5 * var(--cui-toast-padding-x)); }
  html:not([dir="rtl"]) .toast-header .btn-close {
    margin-left: var(--cui-toast-padding-x); }
  *[dir="rtl"] .toast-header .btn-close {
    margin-right: var(--cui-toast-padding-x); }

.toast-body {
  padding: var(--cui-toast-padding-x);
  word-wrap: break-word; }

.modal {
  --cui-modal-zindex: 1055;
  --cui-modal-width: 500px;
  --cui-modal-padding: 1rem;
  --cui-modal-margin: 0.5rem;
  --cui-modal-color: ;
  --cui-modal-bg: var(--cui-body-bg);
  --cui-modal-border-color: var(--cui-border-color-translucent);
  --cui-modal-border-width: var(--cui-border-width);
  --cui-modal-border-radius: var(--cui-border-radius-lg);
  --cui-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 21, 0.075);
  --cui-modal-inner-border-radius: calc(var(--cui-border-radius-lg) - (var(--cui-border-width)));
  --cui-modal-header-padding-x: 1rem;
  --cui-modal-header-padding-y: 1rem;
  --cui-modal-header-padding: 1rem 1rem;
  --cui-modal-header-border-color: var(--cui-border-color);
  --cui-modal-header-border-width: var(--cui-border-width);
  --cui-modal-title-line-height: 1.5;
  --cui-modal-footer-gap: 0.5rem;
  --cui-modal-footer-bg: ;
  --cui-modal-footer-border-color: var(--cui-border-color);
  --cui-modal-footer-border-width: var(--cui-border-width);
  position: fixed;
  top: 0;
  z-index: var(--cui-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0; }
  html:not([dir="rtl"]) .modal {
    left: 0; }
  *[dir="rtl"] .modal {
    right: 0; }

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--cui-modal-margin);
  pointer-events: none; }
  .modal.fade .modal-dialog {
    transition: transform 0.3s ease-out;
    transform: translate(0, -50px); }
    @media (prefers-reduced-motion: reduce) {
      .modal.fade .modal-dialog {
        transition: none; } }
  .modal.show .modal-dialog {
    transform: none; }
  .modal.modal-static .modal-dialog {
    transform: scale(1.02); }

.modal-dialog-scrollable {
  height: calc(100% - var(--cui-modal-margin) * 2); }
  .modal-dialog-scrollable .modal-content {
    max-height: 100%;
    overflow: hidden; }
  .modal-dialog-scrollable .modal-body {
    overflow-y: auto; }

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--cui-modal-margin) * 2); }

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--cui-modal-color);
  pointer-events: auto;
  background-color: var(--cui-modal-bg);
  background-clip: padding-box;
  border: var(--cui-modal-border-width) solid var(--cui-modal-border-color);
  border-radius: var(--cui-modal-border-radius);
  outline: 0; }

.modal-backdrop {
  --cui-backdrop-zindex: 1050;
  --cui-backdrop-bg: #000015;
  --cui-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--cui-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--cui-backdrop-bg); }
  .modal-backdrop.fade {
    opacity: 0; }
  .modal-backdrop.show {
    opacity: var(--cui-backdrop-opacity); }

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-modal-header-padding);
  border-bottom: var(--cui-modal-header-border-width) solid var(--cui-modal-header-border-color);
  border-top-left-radius: var(--cui-modal-inner-border-radius);
  border-top-right-radius: var(--cui-modal-inner-border-radius); }
  .modal-header .btn-close {
    padding: calc(var(--cui-modal-header-padding-y) * .5) calc(var(--cui-modal-header-padding-x) * .5); }
    html:not([dir="rtl"]) .modal-header .btn-close {
      margin: calc(-.5 * var(--cui-modal-header-padding-y)) calc(-.5 * var(--cui-modal-header-padding-x)) calc(-.5 * var(--cui-modal-header-padding-y)) auto; }
    *[dir="rtl"] .modal-header .btn-close {
      margin: calc(-.5 * var(--cui-modal-header-padding-y)) auto calc(-.5 * var(--cui-modal-header-padding-y)) calc(-.5 * var(--cui-modal-header-padding-x)); }

.modal-title {
  margin-bottom: 0;
  line-height: var(--cui-modal-title-line-height); }

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--cui-modal-padding); }

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--cui-modal-padding) - var(--cui-modal-footer-gap) * .5);
  background-color: var(--cui-modal-footer-bg);
  border-top: var(--cui-modal-footer-border-width) solid var(--cui-modal-footer-border-color);
  border-bottom-right-radius: var(--cui-modal-inner-border-radius);
  border-bottom-left-radius: var(--cui-modal-inner-border-radius); }
  .modal-footer > * {
    margin: calc(var(--cui-modal-footer-gap) * .5); }

@media (min-width: 576px) {
  .modal {
    --cui-modal-margin: 1.75rem;
    --cui-modal-box-shadow: 0 0.5rem 1rem rgba(0, 0, 21, 0.15); }
  .modal-dialog {
    max-width: var(--cui-modal-width);
    margin-right: auto;
    margin-left: auto; }
  .modal-sm {
    --cui-modal-width: 300px; } }

@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --cui-modal-width: 800px; } }

@media (min-width: 1200px) {
  .modal-xl {
    --cui-modal-width: 1140px; } }

.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0; }
  .modal-fullscreen .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0; }
  .modal-fullscreen .modal-header,
  .modal-fullscreen .modal-footer {
    border-radius: 0; }
  .modal-fullscreen .modal-body {
    overflow-y: auto; }

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-sm-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-sm-down .modal-header,
    .modal-fullscreen-sm-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-sm-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-md-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-md-down .modal-header,
    .modal-fullscreen-md-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-md-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-lg-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-lg-down .modal-header,
    .modal-fullscreen-lg-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-lg-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-xl-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-xl-down .modal-header,
    .modal-fullscreen-xl-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-xl-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-xxl-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-xxl-down .modal-header,
    .modal-fullscreen-xxl-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-xxl-down .modal-body {
      overflow-y: auto; } }

.tooltip {
  --cui-tooltip-zindex: 1080;
  --cui-tooltip-max-width: 200px;
  --cui-tooltip-padding-x: 0.5rem;
  --cui-tooltip-padding-y: 0.25rem;
  --cui-tooltip-margin: ;
  --cui-tooltip-font-size: 0.875rem;
  --cui-tooltip-color: var(--cui-body-bg);
  --cui-tooltip-bg: var(--cui-emphasis-color);
  --cui-tooltip-border-radius: var(--cui-border-radius);
  --cui-tooltip-opacity: 0.9;
  --cui-tooltip-arrow-width: 0.8rem;
  --cui-tooltip-arrow-height: 0.4rem;
  z-index: var(--cui-tooltip-zindex);
  display: block;
  margin: var(--cui-tooltip-margin);
  font-family: "Aldrich", "Helvetica Neue", Arial, sans-serif;
  font-family: var(--cui-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--cui-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0; }
  .tooltip.show {
    opacity: var(--cui-tooltip-opacity); }
  .tooltip .tooltip-arrow {
    display: block;
    width: var(--cui-tooltip-arrow-width);
    height: var(--cui-tooltip-arrow-height); }
    .tooltip .tooltip-arrow::before {
      position: absolute;
      content: "";
      border-color: transparent;
      border-style: solid; }

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="top"] .tooltip-arrow {
  bottom: calc(-1 * var(--cui-tooltip-arrow-height)); }
  .bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="top"] .tooltip-arrow::before {
    top: -1px;
    border-width: var(--cui-tooltip-arrow-height) calc(var(--cui-tooltip-arrow-width) * .5) 0;
    border-top-color: var(--cui-tooltip-bg); }

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="right"] .tooltip-arrow {
  left: calc(-1 * var(--cui-tooltip-arrow-height));
  width: var(--cui-tooltip-arrow-height);
  height: var(--cui-tooltip-arrow-width); }
  .bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="right"] .tooltip-arrow::before {
    right: -1px;
    border-width: calc(var(--cui-tooltip-arrow-width) * .5) var(--cui-tooltip-arrow-height) calc(var(--cui-tooltip-arrow-width) * .5) 0;
    border-right-color: var(--cui-tooltip-bg); }

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="bottom"] .tooltip-arrow {
  top: calc(-1 * var(--cui-tooltip-arrow-height)); }
  .bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="bottom"] .tooltip-arrow::before {
    bottom: -1px;
    border-width: 0 calc(var(--cui-tooltip-arrow-width) * .5) var(--cui-tooltip-arrow-height);
    border-bottom-color: var(--cui-tooltip-bg); }

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="left"] .tooltip-arrow {
  right: calc(-1 * var(--cui-tooltip-arrow-height));
  width: var(--cui-tooltip-arrow-height);
  height: var(--cui-tooltip-arrow-width); }
  .bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="left"] .tooltip-arrow::before {
    left: -1px;
    border-width: calc(var(--cui-tooltip-arrow-width) * .5) 0 calc(var(--cui-tooltip-arrow-width) * .5) var(--cui-tooltip-arrow-height);
    border-left-color: var(--cui-tooltip-bg); }

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--cui-tooltip-max-width);
  padding: var(--cui-tooltip-padding-y) var(--cui-tooltip-padding-x);
  color: var(--cui-tooltip-color);
  text-align: center;
  background-color: var(--cui-tooltip-bg);
  border-radius: var(--cui-tooltip-border-radius); }

.popover {
  --cui-popover-zindex: 1070;
  --cui-popover-max-width: 276px;
  --cui-popover-font-size: 0.875rem;
  --cui-popover-bg: var(--cui-body-bg);
  --cui-popover-border-width: var(--cui-border-width);
  --cui-popover-border-color: var(--cui-border-color-translucent);
  --cui-popover-border-radius: var(--cui-border-radius-lg);
  --cui-popover-inner-border-radius: calc(var(--cui-border-radius-lg) - var(--cui-border-width));
  --cui-popover-box-shadow: 0 0.5rem 1rem rgba(0, 0, 21, 0.15);
  --cui-popover-header-padding-x: 1rem;
  --cui-popover-header-padding-y: 0.5rem;
  --cui-popover-header-font-size: 1rem;
  --cui-popover-header-color: inherit;
  --cui-popover-header-bg: var(--cui-secondary-bg);
  --cui-popover-body-padding-x: 1rem;
  --cui-popover-body-padding-y: 1rem;
  --cui-popover-body-color: var(--cui-body-color);
  --cui-popover-arrow-width: 1rem;
  --cui-popover-arrow-height: 0.5rem;
  --cui-popover-arrow-border: var(--cui-popover-border-color);
  z-index: var(--cui-popover-zindex);
  display: block;
  max-width: var(--cui-popover-max-width);
  font-family: "Aldrich", "Helvetica Neue", Arial, sans-serif;
  font-family: var(--cui-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--cui-popover-font-size);
  word-wrap: break-word;
  background-color: var(--cui-popover-bg);
  background-clip: padding-box;
  border: var(--cui-popover-border-width) solid var(--cui-popover-border-color);
  border-radius: var(--cui-popover-border-radius); }
  .popover .popover-arrow {
    display: block;
    width: var(--cui-popover-arrow-width);
    height: var(--cui-popover-arrow-height); }
    .popover .popover-arrow::before, .popover .popover-arrow::after {
      position: absolute;
      display: block;
      content: "";
      border-color: transparent;
      border-style: solid;
      border-width: 0; }

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow {
  bottom: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width)); }
  .bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::after {
    border-width: var(--cui-popover-arrow-height) calc(var(--cui-popover-arrow-width) * .5) 0; }
  .bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::before {
    bottom: 0;
    border-top-color: var(--cui-popover-arrow-border); }
  .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::after {
    bottom: var(--cui-popover-border-width);
    border-top-color: var(--cui-popover-bg); }

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow {
  left: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
  width: var(--cui-popover-arrow-height);
  height: var(--cui-popover-arrow-width); }
  .bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::after {
    border-width: calc(var(--cui-popover-arrow-width) * .5) var(--cui-popover-arrow-height) calc(var(--cui-popover-arrow-width) * .5) 0; }
  .bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::before {
    left: 0;
    border-right-color: var(--cui-popover-arrow-border); }
  .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::after {
    left: var(--cui-popover-border-width);
    border-right-color: var(--cui-popover-bg); }

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow {
  top: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width)); }
  .bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::after {
    border-width: 0 calc(var(--cui-popover-arrow-width) * .5) var(--cui-popover-arrow-height); }
  .bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::before {
    top: 0;
    border-bottom-color: var(--cui-popover-arrow-border); }
  .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::after {
    top: var(--cui-popover-border-width);
    border-bottom-color: var(--cui-popover-bg); }

.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^="bottom"] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--cui-popover-arrow-width);
  margin-left: calc(-.5 * var(--cui-popover-arrow-width));
  content: "";
  border-bottom: var(--cui-popover-border-width) solid var(--cui-popover-header-bg); }

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow {
  right: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
  width: var(--cui-popover-arrow-height);
  height: var(--cui-popover-arrow-width); }
  .bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::after {
    border-width: calc(var(--cui-popover-arrow-width) * .5) 0 calc(var(--cui-popover-arrow-width) * .5) var(--cui-popover-arrow-height); }
  .bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::before {
    right: 0;
    border-left-color: var(--cui-popover-arrow-border); }
  .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::after {
    right: var(--cui-popover-border-width);
    border-left-color: var(--cui-popover-bg); }

/* rtl:end:ignore */
.popover-header {
  padding: var(--cui-popover-header-padding-y) var(--cui-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--cui-popover-header-font-size);
  color: var(--cui-popover-header-color);
  background-color: var(--cui-popover-header-bg);
  border-bottom: var(--cui-popover-border-width) solid var(--cui-popover-border-color);
  border-top-left-radius: var(--cui-popover-inner-border-radius);
  border-top-right-radius: var(--cui-popover-inner-border-radius); }
  .popover-header:empty {
    display: none; }

.popover-body {
  padding: var(--cui-popover-body-padding-y) var(--cui-popover-body-padding-x);
  color: var(--cui-popover-body-color); }

.carousel {
  position: relative; }

.carousel.pointer-event {
  touch-action: pan-y; }

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden; }
  .carousel-inner::after {
    display: block;
    clear: both;
    content: ""; }

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  transition: transform 0.6s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-item {
      transition: none; } }

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block; }

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%); }

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%); }

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none; }

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1; }

.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-fade .active.carousel-item-start,
    .carousel-fade .active.carousel-item-end {
      transition: none; } }

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: rgba(255, 255, 255, 0.87);
  color: var(--cui-carousel-control-color, rgba(255, 255, 255, 0.87));
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-control-prev,
    .carousel-control-next {
      transition: none; } }
  .carousel-control-prev:hover, .carousel-control-prev:focus,
  .carousel-control-next:hover,
  .carousel-control-next:focus {
    color: rgba(255, 255, 255, 0.87);
    color: var(--cui-carousel-control-color, rgba(255, 255, 255, 0.87));
    text-decoration: none;
    outline: 0;
    opacity: 0.9; }

.carousel-control-prev {
  left: 0; }

.carousel-control-next {
  right: 0; }

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%; }

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___}); }

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___}); }

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none; }
  .carousel-indicators [data-coreui-target] {
    box-sizing: content-box;
    flex: 0 1 auto;
    width: 30px;
    height: 3px;
    padding: 0;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    cursor: pointer;
    background-color: #fff;
    background-color: var(--cui-carousel-indicator-active-bg, #fff);
    background-clip: padding-box;
    border: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    opacity: 0.5;
    transition: opacity 0.6s ease; }
    @media (prefers-reduced-motion: reduce) {
      .carousel-indicators [data-coreui-target] {
        transition: none; } }
  .carousel-indicators .active {
    opacity: 1; }

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: rgba(255, 255, 255, 0.87);
  color: var(--cui-carousel-caption-color, rgba(255, 255, 255, 0.87));
  text-align: center; }

.carousel-dark {
  --cui-carousel-indicator-active-bg: #000015;
  --cui-carousel-caption-color: rgba(44, 56, 74, 0.95); }
  .carousel-dark .carousel-control-prev-icon,
  .carousel-dark .carousel-control-next-icon {
    filter: invert(1) grayscale(100); }
  .carousel-dark .carousel-indicators [data-coreui-target] {
    background-color: #000015; }
  .carousel-dark .carousel-caption {
    color: rgba(44, 56, 74, 0.95); }

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--cui-spinner-width);
  height: var(--cui-spinner-height);
  vertical-align: var(--cui-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--cui-spinner-animation-speed) linear infinite var(--cui-spinner-animation-name); }

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */; } }

.spinner-border {
  --cui-spinner-width: 2rem;
  --cui-spinner-height: 2rem;
  --cui-spinner-vertical-align: -0.125em;
  --cui-spinner-border-width: 0.25em;
  --cui-spinner-animation-speed: 0.75s;
  --cui-spinner-animation-name: spinner-border;
  border: var(--cui-spinner-border-width) solid currentcolor;
  border-right-color: transparent; }

.spinner-border-sm {
  --cui-spinner-width: 1rem;
  --cui-spinner-height: 1rem;
  --cui-spinner-border-width: 0.2em; }

@keyframes spinner-grow {
  0% {
    transform: scale(0); }
  50% {
    opacity: 1;
    transform: none; } }

.spinner-grow {
  --cui-spinner-width: 2rem;
  --cui-spinner-height: 2rem;
  --cui-spinner-vertical-align: -0.125em;
  --cui-spinner-animation-speed: 0.75s;
  --cui-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0; }

.spinner-grow-sm {
  --cui-spinner-width: 1rem;
  --cui-spinner-height: 1rem; }

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --cui-spinner-animation-speed: 1.5s; } }

.offcanvas-sm, .offcanvas-md, .offcanvas-lg, .offcanvas-xl, .offcanvas-xxl, .offcanvas {
  --cui-offcanvas-zindex: 1045;
  --cui-offcanvas-width: 400px;
  --cui-offcanvas-height: 30vh;
  --cui-offcanvas-padding-x: 1rem;
  --cui-offcanvas-padding-y: 1rem;
  --cui-offcanvas-color: var(--cui-body-color);
  --cui-offcanvas-bg: var(--cui-body-bg);
  --cui-offcanvas-border-width: var(--cui-border-width);
  --cui-offcanvas-border-color: var(--cui-border-color-translucent);
  --cui-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 21, 0.075);
  --cui-offcanvas-transition: transform 0.3s ease-in-out;
  --cui-offcanvas-title-line-height: 1.5; }

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition); } }
  @media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-sm {
      transition: none; } }

@media (max-width: 575.98px) {
    .offcanvas-sm.offcanvas-start {
      top: 0;
      width: var(--cui-offcanvas-width); }
      html:not([dir="rtl"]) .offcanvas-sm.offcanvas-start {
        left: 0; }
      *[dir="rtl"] .offcanvas-sm.offcanvas-start {
        right: 0; }
      html:not([dir="rtl"]) .offcanvas-sm.offcanvas-start {
        border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
      *[dir="rtl"] .offcanvas-sm.offcanvas-start {
        border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
      html:not([dir="rtl"]) .offcanvas-sm.offcanvas-start {
        transform: translateX(-100%); }
      *[dir="rtl"] .offcanvas-sm.offcanvas-start {
        transform: translateX(100%); }
    .offcanvas-sm.offcanvas-end {
      top: 0;
      width: var(--cui-offcanvas-width);
      transform: translateX(100%); }
      html:not([dir="rtl"]) .offcanvas-sm.offcanvas-end {
        right: 0; }
      *[dir="rtl"] .offcanvas-sm.offcanvas-end {
        left: 0; }
      html:not([dir="rtl"]) .offcanvas-sm.offcanvas-end {
        border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
      *[dir="rtl"] .offcanvas-sm.offcanvas-end {
        border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
    .offcanvas-sm.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--cui-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-sm.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--cui-offcanvas-height);
      max-height: 100%;
      border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
      transform: none !important; }
    .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
      visibility: visible; } }

@media (min-width: 576px) {
  .offcanvas-sm {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-sm .offcanvas-header {
      display: none; }
    .offcanvas-sm .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition); } }
  @media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-md {
      transition: none; } }

@media (max-width: 767.98px) {
    .offcanvas-md.offcanvas-start {
      top: 0;
      width: var(--cui-offcanvas-width); }
      html:not([dir="rtl"]) .offcanvas-md.offcanvas-start {
        left: 0; }
      *[dir="rtl"] .offcanvas-md.offcanvas-start {
        right: 0; }
      html:not([dir="rtl"]) .offcanvas-md.offcanvas-start {
        border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
      *[dir="rtl"] .offcanvas-md.offcanvas-start {
        border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
      html:not([dir="rtl"]) .offcanvas-md.offcanvas-start {
        transform: translateX(-100%); }
      *[dir="rtl"] .offcanvas-md.offcanvas-start {
        transform: translateX(100%); }
    .offcanvas-md.offcanvas-end {
      top: 0;
      width: var(--cui-offcanvas-width);
      transform: translateX(100%); }
      html:not([dir="rtl"]) .offcanvas-md.offcanvas-end {
        right: 0; }
      *[dir="rtl"] .offcanvas-md.offcanvas-end {
        left: 0; }
      html:not([dir="rtl"]) .offcanvas-md.offcanvas-end {
        border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
      *[dir="rtl"] .offcanvas-md.offcanvas-end {
        border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
    .offcanvas-md.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--cui-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-md.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--cui-offcanvas-height);
      max-height: 100%;
      border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
      transform: none !important; }
    .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
      visibility: visible; } }

@media (min-width: 768px) {
  .offcanvas-md {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-md .offcanvas-header {
      display: none; }
    .offcanvas-md .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition); } }
  @media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-lg {
      transition: none; } }

@media (max-width: 991.98px) {
    .offcanvas-lg.offcanvas-start {
      top: 0;
      width: var(--cui-offcanvas-width); }
      html:not([dir="rtl"]) .offcanvas-lg.offcanvas-start {
        left: 0; }
      *[dir="rtl"] .offcanvas-lg.offcanvas-start {
        right: 0; }
      html:not([dir="rtl"]) .offcanvas-lg.offcanvas-start {
        border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
      *[dir="rtl"] .offcanvas-lg.offcanvas-start {
        border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
      html:not([dir="rtl"]) .offcanvas-lg.offcanvas-start {
        transform: translateX(-100%); }
      *[dir="rtl"] .offcanvas-lg.offcanvas-start {
        transform: translateX(100%); }
    .offcanvas-lg.offcanvas-end {
      top: 0;
      width: var(--cui-offcanvas-width);
      transform: translateX(100%); }
      html:not([dir="rtl"]) .offcanvas-lg.offcanvas-end {
        right: 0; }
      *[dir="rtl"] .offcanvas-lg.offcanvas-end {
        left: 0; }
      html:not([dir="rtl"]) .offcanvas-lg.offcanvas-end {
        border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
      *[dir="rtl"] .offcanvas-lg.offcanvas-end {
        border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
    .offcanvas-lg.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--cui-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-lg.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--cui-offcanvas-height);
      max-height: 100%;
      border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
      transform: none !important; }
    .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
      visibility: visible; } }

@media (min-width: 992px) {
  .offcanvas-lg {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-lg .offcanvas-header {
      display: none; }
    .offcanvas-lg .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition); } }
  @media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-xl {
      transition: none; } }

@media (max-width: 1199.98px) {
    .offcanvas-xl.offcanvas-start {
      top: 0;
      width: var(--cui-offcanvas-width); }
      html:not([dir="rtl"]) .offcanvas-xl.offcanvas-start {
        left: 0; }
      *[dir="rtl"] .offcanvas-xl.offcanvas-start {
        right: 0; }
      html:not([dir="rtl"]) .offcanvas-xl.offcanvas-start {
        border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
      *[dir="rtl"] .offcanvas-xl.offcanvas-start {
        border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
      html:not([dir="rtl"]) .offcanvas-xl.offcanvas-start {
        transform: translateX(-100%); }
      *[dir="rtl"] .offcanvas-xl.offcanvas-start {
        transform: translateX(100%); }
    .offcanvas-xl.offcanvas-end {
      top: 0;
      width: var(--cui-offcanvas-width);
      transform: translateX(100%); }
      html:not([dir="rtl"]) .offcanvas-xl.offcanvas-end {
        right: 0; }
      *[dir="rtl"] .offcanvas-xl.offcanvas-end {
        left: 0; }
      html:not([dir="rtl"]) .offcanvas-xl.offcanvas-end {
        border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
      *[dir="rtl"] .offcanvas-xl.offcanvas-end {
        border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
    .offcanvas-xl.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--cui-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-xl.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--cui-offcanvas-height);
      max-height: 100%;
      border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
      transform: none !important; }
    .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
      visibility: visible; } }

@media (min-width: 1200px) {
  .offcanvas-xl {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-xl .offcanvas-header {
      display: none; }
    .offcanvas-xl .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition); } }
  @media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-xxl {
      transition: none; } }

@media (max-width: 1399.98px) {
    .offcanvas-xxl.offcanvas-start {
      top: 0;
      width: var(--cui-offcanvas-width); }
      html:not([dir="rtl"]) .offcanvas-xxl.offcanvas-start {
        left: 0; }
      *[dir="rtl"] .offcanvas-xxl.offcanvas-start {
        right: 0; }
      html:not([dir="rtl"]) .offcanvas-xxl.offcanvas-start {
        border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
      *[dir="rtl"] .offcanvas-xxl.offcanvas-start {
        border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
      html:not([dir="rtl"]) .offcanvas-xxl.offcanvas-start {
        transform: translateX(-100%); }
      *[dir="rtl"] .offcanvas-xxl.offcanvas-start {
        transform: translateX(100%); }
    .offcanvas-xxl.offcanvas-end {
      top: 0;
      width: var(--cui-offcanvas-width);
      transform: translateX(100%); }
      html:not([dir="rtl"]) .offcanvas-xxl.offcanvas-end {
        right: 0; }
      *[dir="rtl"] .offcanvas-xxl.offcanvas-end {
        left: 0; }
      html:not([dir="rtl"]) .offcanvas-xxl.offcanvas-end {
        border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
      *[dir="rtl"] .offcanvas-xxl.offcanvas-end {
        border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
    .offcanvas-xxl.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--cui-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-xxl.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--cui-offcanvas-height);
      max-height: 100%;
      border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
      transform: none !important; }
    .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
      visibility: visible; } }

@media (min-width: 1400px) {
  .offcanvas-xxl {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-xxl .offcanvas-header {
      display: none; }
    .offcanvas-xxl .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--cui-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--cui-offcanvas-color);
  visibility: hidden;
  background-color: var(--cui-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--cui-offcanvas-transition); }
  @media (prefers-reduced-motion: reduce) {
    .offcanvas {
      transition: none; } }
  .offcanvas.offcanvas-start {
    top: 0;
    width: var(--cui-offcanvas-width); }
    html:not([dir="rtl"]) .offcanvas.offcanvas-start {
      left: 0; }
    *[dir="rtl"] .offcanvas.offcanvas-start {
      right: 0; }
    html:not([dir="rtl"]) .offcanvas.offcanvas-start {
      border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
    *[dir="rtl"] .offcanvas.offcanvas-start {
      border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
    html:not([dir="rtl"]) .offcanvas.offcanvas-start {
      transform: translateX(-100%); }
    *[dir="rtl"] .offcanvas.offcanvas-start {
      transform: translateX(100%); }
  .offcanvas.offcanvas-end {
    top: 0;
    width: var(--cui-offcanvas-width);
    transform: translateX(100%); }
    html:not([dir="rtl"]) .offcanvas.offcanvas-end {
      right: 0; }
    *[dir="rtl"] .offcanvas.offcanvas-end {
      left: 0; }
    html:not([dir="rtl"]) .offcanvas.offcanvas-end {
      border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
    *[dir="rtl"] .offcanvas.offcanvas-end {
      border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color); }
  .offcanvas.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%); }
  .offcanvas.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%); }
  .offcanvas.showing, .offcanvas.show:not(.hiding) {
    transform: none !important; }
  .offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
    visibility: visible; }

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000015;
  background-color: var(--cui-offcanvas-backdrop-bg, #000015); }
  .offcanvas-backdrop.fade {
    opacity: 0; }
  .offcanvas-backdrop.show {
    opacity: 0.5; }

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-offcanvas-padding-y) var(--cui-offcanvas-padding-x); }
  .offcanvas-header .btn-close {
    padding: calc(var(--cui-offcanvas-padding-y) * .5) calc(var(--cui-offcanvas-padding-x) * .5);
    margin-top: calc(-.5 * var(--cui-offcanvas-padding-y));
    margin-bottom: calc(-.5 * var(--cui-offcanvas-padding-y)); }
    html:not([dir="rtl"]) .offcanvas-header .btn-close {
      margin-right: calc(-.5 * var(--cui-offcanvas-padding-x)); }
    *[dir="rtl"] .offcanvas-header .btn-close {
      margin-left: calc(-.5 * var(--cui-offcanvas-padding-x)); }

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--cui-offcanvas-title-line-height); }

.offcanvas-body {
  flex-grow: 1;
  padding: var(--cui-offcanvas-padding-y) var(--cui-offcanvas-padding-x);
  overflow-y: auto; }

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5; }
  .placeholder.btn::before {
    display: inline-block;
    content: ""; }

.placeholder-xs {
  min-height: .6em; }

.placeholder-sm {
  min-height: .8em; }

.placeholder-lg {
  min-height: 1.2em; }

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite; }

@keyframes placeholder-glow {
  50% {
    opacity: 0.2; } }

.placeholder-wave {
  -webkit-mask-image: linear-gradient(130deg, #000015 55%, rgba(0, 0, 0, 0.8) 75%, #000015 95%);
          mask-image: linear-gradient(130deg, #000015 55%, rgba(0, 0, 0, 0.8) 75%, #000015 95%);
  -webkit-mask-size: 200% 100%;
          mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite; }

@keyframes placeholder-wave {
  100% {
    -webkit-mask-position: -200% 0%;
            mask-position: -200% 0%; } }

.avatar {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  border-radius: 50em;
  transition: margin 0.15s;
  width: 2rem;
  height: 2rem;
  font-size: 0.8rem; }
  @media (prefers-reduced-motion: reduce) {
    .avatar {
      transition: none; } }
  .avatar .avatar-status {
    width: 0.53333rem;
    height: 0.53333rem; }

.avatar-img {
  width: 100%;
  height: auto;
  border-radius: 50em; }

.avatar-status {
  position: absolute;
  bottom: 0;
  display: block;
  border: 1px solid #fff;
  border-radius: 50em; }
  html:not([dir="rtl"]) .avatar-status {
    right: 0; }
  *[dir="rtl"] .avatar-status {
    left: 0; }

.avatar-sm {
  width: 1.5rem;
  height: 1.5rem;
  font-size: 0.6rem; }
  .avatar-sm .avatar-status {
    width: 0.4rem;
    height: 0.4rem; }

.avatar-md {
  width: 2.5rem;
  height: 2.5rem;
  font-size: 1rem; }
  .avatar-md .avatar-status {
    width: 0.66667rem;
    height: 0.66667rem; }

.avatar-lg {
  width: 3rem;
  height: 3rem;
  font-size: 1.2rem; }
  .avatar-lg .avatar-status {
    width: 0.8rem;
    height: 0.8rem; }

.avatar-xl {
  width: 4rem;
  height: 4rem;
  font-size: 1.6rem; }
  .avatar-xl .avatar-status {
    width: 1.06667rem;
    height: 1.06667rem; }

.avatars-stack {
  display: flex; }
  html:not([dir="rtl"]) .avatars-stack .avatar {
    margin-right: -0.8rem; }
  *[dir="rtl"] .avatars-stack .avatar {
    margin-left: -0.8rem; }
  html:not([dir="rtl"]) .avatars-stack .avatar:hover {
    margin-right: 0; }
  *[dir="rtl"] .avatars-stack .avatar:hover {
    margin-left: 0; }
  html:not([dir="rtl"]) .avatars-stack .avatar-sm {
    margin-right: -0.6rem; }
  *[dir="rtl"] .avatars-stack .avatar-sm {
    margin-left: -0.6rem; }
  html:not([dir="rtl"]) .avatars-stack .avatar-md {
    margin-right: -1rem; }
  *[dir="rtl"] .avatars-stack .avatar-md {
    margin-left: -1rem; }
  html:not([dir="rtl"]) .avatars-stack .avatar-lg {
    margin-right: -1.2rem; }
  *[dir="rtl"] .avatars-stack .avatar-lg {
    margin-left: -1.2rem; }
  html:not([dir="rtl"]) .avatars-stack .avatar-xl {
    margin-right: -1.6rem; }
  *[dir="rtl"] .avatars-stack .avatar-xl {
    margin-left: -1.6rem; }

.callout {
  --cui-callout-padding-x: 1rem;
  --cui-callout-padding-y: 1rem;
  --cui-callout-margin-x: 0;
  --cui-callout-margin-y: 1rem;
  --cui-callout-border-width: var(--cui-border-width);
  --cui-callout-border-color: var(--cui-border-color);
  --cui-callout-border-left-width: calc(\$callout-border-width * 4);
  --cui-callout-border-radius: var(--cui-border-radius);
  padding: var(--cui-callout-padding-y) var(--cui-callout-padding-x);
  margin: var(--cui-callout-margin-y) var(--cui-callout-margin-x);
  border: var(--cui-callout-border-width) solid var(--cui-callout-border-color);
  border-radius: var(--cui-callout-border-radius); }
  html:not([dir="rtl"]) .callout {
    border-left-width: var(--cui-callout-border-left-width); }
  *[dir="rtl"] .callout {
    border-right-width: var(--cui-callout-border-right-width); }
  html:not([dir="rtl"]) .callout {
    border-left-color: var(--cui-callout-border-left-color); }
  *[dir="rtl"] .callout {
    border-right-color: var(--cui-callout-border-right-color); }

.callout-primary {
  --cui-callout-border-left-color: #321fdb; }

.callout-secondary {
  --cui-callout-border-left-color: #9da5b1; }

.callout-success {
  --cui-callout-border-left-color: #2eb85c; }

.callout-danger {
  --cui-callout-border-left-color: #e55353; }

.callout-warning {
  --cui-callout-border-left-color: #f9b115; }

.callout-info {
  --cui-callout-border-left-color: #39f; }

.callout-light {
  --cui-callout-border-left-color: #ebedef; }

.callout-dark {
  --cui-callout-border-left-color: #4f5d73; }

.footer {
  --cui-footer-min-height: 3rem;
  --cui-footer-padding-x: 1rem;
  --cui-footer-padding-y: 0.5rem;
  --cui-footer-color: var(--cui-body-color);
  --cui-footer-bg: var(--cui-tertiary-bg);
  --cui-footer-border-color: var(--cui-border-color);
  --cui-footer-border: var(--cui-border-width) solid var(--cui-footer-border-color);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  min-height: var(--cui-footer-min-height);
  padding: var(--cui-footer-padding-y) var(--cui-footer-padding-x);
  color: var(--cui-footer-color);
  background: var(--cui-footer-bg);
  border-top: var(--cui-footer-border); }

.footer-fixed {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030; }

.footer-sticky {
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  z-index: 1030; }

.header {
  --cui-header-min-height: 4rem;
  --cui-header-padding-x: 0.5rem;
  --cui-header-padding-y: 0.5rem;
  --cui-header-bg: var(--cui-body-bg);
  --cui-header-color: rgba(var(--cui-emphasis-color-rgb), 0.65);
  --cui-header-border-color: var(--cui-border-color);
  --cui-header-border: var(--cui-border-width) solid var(--cui-header-border-color);
  --cui-header-hover-color: rgba(var(--cui-emphasis-color-rgb), 0.8);
  --cui-header-disabled-color: rgba(var(--cui-emphasis-color-rgb), 0.3);
  --cui-header-active-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-header-brand-padding-y: 0.3125rem;
  --cui-header-brand-color: #4f5d73;
  --cui-header-brand-hover-color: #475468;
  --cui-header-toggler-padding-x: 0.75rem;
  --cui-header-toggler-padding-y: 0.25rem;
  --cui-header-toggler-bg: transparent;
  --cui-header-toggler-color: rgba(var(--cui-emphasis-color-rgb), 0.65);
  --cui-header-toggler-border-radius: var(--cui-border-radius);
  --cui-header-toggler-hover-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-header-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --cui-header-toggler-hover-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --cui-header-nav-link-padding-x: 0.5rem;
  --cui-header-nav-link-padding-y: 0.5rem;
  --cui-header-divider-border-color: var(--cui-border-color);
  --cui-header-divider-border: var(--cui-border-width) solid var(--cui-header-divider-border-color);
  --cui-subheader-min-height: 3rem;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  min-height: var(--cui-header-min-height);
  padding: var(--cui-header-padding-y) var(--cui-header-padding-x);
  background: var(--cui-header-bg);
  border-bottom: var(--cui-header-border); }
  .header .navbar > .container,
  .header .navbar > .container-fluid, .header .navbar > .container-sm, .header .navbar > .container-md, .header .navbar > .container-lg, .header .navbar > .container-xl, .header .navbar > .container-xxl, .header > .container,
  .header > .container-fluid, .header > .container-sm, .header > .container-md, .header > .container-lg, .header > .container-xl, .header > .container-xxl {
    display: flex;
    flex-wrap: inherit;
    align-items: center;
    justify-content: space-between; }
  .header .container:first-child,
  .header .container-fluid:first-child,
  .header .container-sm:first-child,
  .header .container-md:first-child,
  .header .container-lg:first-child,
  .header .container-xl:first-child,
  .header .container-xxl:first-child {
    min-height: calc(var(--cui-header-min-height) - (2 * var(--cui-header-padding-y))); }
  .header .container:nth-child(n+2),
  .header .container-fluid:nth-child(n+2),
  .header .container-sm:nth-child(n+2),
  .header .container-md:nth-child(n+2),
  .header .container-lg:nth-child(n+2),
  .header .container-xl:nth-child(n+2),
  .header .container-xxl:nth-child(n+2) {
    min-height: calc(var(--cui-subheader-min-height) - (2 * var(--cui-header-padding-y))); }
  .header.header-sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1029; }

.header-divider {
  flex-basis: calc(100% + (2 * var(--cui-header-padding-x)));
  height: 0;
  margin: var(--cui-header-padding-y) calc(var(--cui-header-padding-x) * -1);
  border-top: var(--cui-header-divider-border); }

.header-brand {
  padding-top: var(--cui-header-brand-padding-y);
  padding-bottom: var(--cui-header-brand-padding-y);
  font-size: 1.25rem;
  color: var(--cui-header-brand-color);
  text-decoration: none;
  white-space: nowrap; }
  html:not([dir="rtl"]) .header-brand {
    margin-right: 1rem; }
  *[dir="rtl"] .header-brand {
    margin-left: 1rem; }
  .header-brand:hover, .header-brand:focus {
    color: var(--cui-header-brand-hover-color); }

.header-nav {
  display: flex;
  flex-direction: row;
  margin-bottom: 0;
  list-style: none; }
  html:not([dir="rtl"]) .header-nav {
    padding-left: 0; }
  *[dir="rtl"] .header-nav {
    padding-right: 0; }
  .header-nav .nav-link {
    padding: var(--cui-header-nav-link-padding-y) var(--cui-header-nav-link-padding-x);
    color: var(--cui-header-color); }
    .header-nav .nav-link:hover, .header-nav .nav-link:focus {
      color: var(--cui-header-hover-color); }
    .header-nav .nav-link.disabled {
      color: var(--cui-header-disabled-color); }
  .header-nav .show > .nav-link,
  .header-nav .nav-link.active {
    color: var(--cui-header-active-color); }
  .header-nav .dropdown-menu {
    position: absolute; }

.header-text {
  padding-top: var(--cui-header-nav-link-padding-y);
  padding-bottom: var(--cui-header-nav-link-padding-y);
  color: var(--cui-header-color); }
  .header-text a {
    color: var(--cui-header-active-color); }
    .header-text a:hover, .header-text a:focus {
      color: var(--cui-header-active-color); }

.header-toggler {
  padding: var(--cui-header-toggler-padding-y) var(--cui-header-toggler-padding-x);
  font-size: 1.25rem;
  color: var(--cui-header-toggler-color);
  background-color: var(--cui-header-toggler-bg);
  border: 0;
  border-radius: var(--cui-header-toggler-border-radius); }
  .header-toggler:hover {
    color: var(--cui-header-toggler-hover-color);
    text-decoration: none; }
  .header-toggler:focus {
    outline: 0; }
  .header-toggler:not(:disabled) {
    cursor: pointer; }

.header-toggler-icon {
  display: block;
  height: 1.5625rem;
  background-image: var(--cui-header-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%; }
  .header-toggler-icon:hover {
    background-image: var(--cui-header-toggler-hover-icon-bg); }

.icon {
  display: inline-block;
  color: inherit;
  text-align: center;
  vertical-align: -.125rem;
  fill: currentcolor; }
  .icon:not(.icon-c-s):not(.icon-custom-size) {
    width: 1rem;
    height: 1rem;
    font-size: 1rem; }
    .icon:not(.icon-c-s):not(.icon-custom-size).icon-xxl {
      width: 2rem;
      height: 2rem;
      font-size: 2rem; }
    .icon:not(.icon-c-s):not(.icon-custom-size).icon-xl {
      width: 1.5rem;
      height: 1.5rem;
      font-size: 1.5rem; }
    .icon:not(.icon-c-s):not(.icon-custom-size).icon-lg {
      width: 1.25rem;
      height: 1.25rem;
      font-size: 1.25rem; }
    .icon:not(.icon-c-s):not(.icon-custom-size).icon-sm {
      width: 0.875rem;
      height: 0.875rem;
      font-size: 0.875rem; }
    .icon:not(.icon-c-s):not(.icon-custom-size).icon-3xl {
      width: 3rem;
      height: 3rem;
      font-size: 3rem; }
    .icon:not(.icon-c-s):not(.icon-custom-size).icon-4xl {
      width: 4rem;
      height: 4rem;
      font-size: 4rem; }
    .icon:not(.icon-c-s):not(.icon-custom-size).icon-5xl {
      width: 5rem;
      height: 5rem;
      font-size: 5rem; }
    .icon:not(.icon-c-s):not(.icon-custom-size).icon-6xl {
      width: 6rem;
      height: 6rem;
      font-size: 6rem; }
    .icon:not(.icon-c-s):not(.icon-custom-size).icon-7xl {
      width: 7rem;
      height: 7rem;
      font-size: 7rem; }
    .icon:not(.icon-c-s):not(.icon-custom-size).icon-8xl {
      width: 8rem;
      height: 8rem;
      font-size: 8rem; }
    .icon:not(.icon-c-s):not(.icon-custom-size).icon-9xl {
      width: 9rem;
      height: 9rem;
      font-size: 9rem; }

.sidebar {
  --cui-sidebar-width: 16rem;
  --cui-sidebar-bg: #3c4b64;
  --cui-sidebar-padding-x: 0;
  --cui-sidebar-padding-y: 0;
  --cui-sidebar-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-border-width: 0;
  --cui-sidebar-border-color: transparent;
  --cui-sidebar-brand-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-brand-height: 4rem;
  --cui-sidebar-brand-bg: rgba(0, 0, 21, 0.2);
  --cui-sidebar-header-height: 4rem;
  --cui-sidebar-header-bg: rgba(0, 0, 21, 0.2);
  --cui-sidebar-header-padding-x: 1rem;
  --cui-sidebar-header-padding-y: 0.75rem;
  --cui-sidebar-footer-bg: rgba(0, 0, 21, 0.2);
  --cui-sidebar-footer-height: auto;
  --cui-sidebar-footer-padding-x: 1rem;
  --cui-sidebar-footer-padding-y: 0.75rem;
  --cui-sidebar-toggler-bg: rgba(0, 0, 21, 0.2);
  --cui-sidebar-toggler-height: 3rem;
  --cui-sidebar-toggler-indicator: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  --cui-sidebar-toggler-indicator-width: 4rem;
  --cui-sidebar-toggler-indicator-height: 3rem;
  --cui-sidebar-toggler-hover-bg: rgba(0, 0, 0, 0.3);
  --cui-sidebar-toggler-indicator-hover: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  --cui-sidebar-narrow-width: 4rem;
  --cui-sidebar-nav-title-padding-x: 1rem;
  --cui-sidebar-nav-title-padding-y: 0.75rem;
  --cui-sidebar-nav-title-margin-top: 1rem;
  --cui-sidebar-nav-title-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-link-padding-x: 1rem;
  --cui-sidebar-nav-link-padding-y: 0.8445rem;
  --cui-sidebar-nav-link-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-link-bg: transparent;
  --cui-sidebar-nav-link-border-color: transparent;
  --cui-sidebar-nav-link-border: 0 solid var(--cui-sidebar-nav-link-border-color);
  --cui-sidebar-nav-link-border-radius: 0;
  --cui-sidebar-nav-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-link-active-bg: rgba(255, 255, 255, 0.05);
  --cui-sidebar-nav-link-active-icon-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-link-disabled-color: rgba(255, 255, 255, 0.38);
  --cui-sidebar-nav-link-disabled-icon-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-link-hover-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-link-hover-bg: rgba(255, 255, 255, 0.05);
  --cui-sidebar-nav-link-hover-icon-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-icon-width: 4rem;
  --cui-sidebar-nav-icon-height: 1.25rem;
  --cui-sidebar-nav-icon-font-size: 1.25rem;
  --cui-sidebar-nav-link-icon-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-group-bg: rgba(0, 0, 0, 0.2);
  --cui-sidebar-nav-group-items-padding-y: 0;
  --cui-sidebar-nav-group-items-padding-x: 0;
  --cui-sidebar-nav-group-indicator: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  --cui-sidebar-nav-group-indicator-hover: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  --cui-sidebar-nav-group-toggle-show-color: rgba(255, 255, 255, 0.6);
  position: relative;
  display: flex;
  flex: 0 0 var(--cui-sidebar-width);
  flex-direction: column;
  order: -1;
  width: var(--cui-sidebar-width);
  padding: var(--cui-sidebar-padding-y) var(--cui-sidebar-padding-x);
  color: var(--cui-sidebar-color);
  background: var(--cui-sidebar-bg);
  box-shadow: none;
  transition: margin-left 0.15s, margin-right 0.15s, box-shadow 0.075s, transform 0.15s, width 0.15s, z-index 0s ease 0.15s; }
  html:not([dir="rtl"]) .sidebar {
    border-right: var(--cui-sidebar-border-width) solid var(--cui-sidebar-border-color); }
  *[dir="rtl"] .sidebar {
    border-left: var(--cui-sidebar-border-width) solid var(--cui-sidebar-border-color); }
  @media (prefers-reduced-motion: reduce) {
    .sidebar {
      transition: none; } }
  html:not([dir="rtl"]) .sidebar:not(.sidebar-end) {
    margin-left: 0; }
  *[dir="rtl"] .sidebar:not(.sidebar-end) {
    margin-right: 0; }
  .sidebar:not(.sidebar-end) ~ * {
    --cui-sidebar-occupy-start: 16rem; }
  .sidebar.sidebar-end {
    order: 99; }
    html:not([dir="rtl"]) .sidebar.sidebar-end {
      margin-right: 0; }
    *[dir="rtl"] .sidebar.sidebar-end {
      margin-left: 0; }
    .sidebar.sidebar-end ~ * {
      --cui-sidebar-occupy-end: 16rem; }
  .sidebar[class*="bg-"] {
    border-color: rgba(0, 0, 21, 0.1); }
  .sidebar.sidebar-sm {
    --cui-sidebar-width: 12rem; }
    @media (min-width: 768px) {
      .sidebar.sidebar-sm:not(.sidebar-end):not(.hide) ~ * {
        --cui-sidebar-occupy-start: 12rem; }
      .sidebar.sidebar-sm.sidebar-end:not(.hide) ~ * {
        --cui-sidebar-occupy-end: 12rem; } }
  .sidebar.sidebar-lg {
    --cui-sidebar-width: 20rem; }
    @media (min-width: 768px) {
      .sidebar.sidebar-lg:not(.sidebar-end):not(.hide) ~ * {
        --cui-sidebar-occupy-start: 20rem; }
      .sidebar.sidebar-lg.sidebar-end:not(.hide) ~ * {
        --cui-sidebar-occupy-end: 20rem; } }
  .sidebar.sidebar-xl {
    --cui-sidebar-width: 24rem; }
    @media (min-width: 768px) {
      .sidebar.sidebar-xl:not(.sidebar-end):not(.hide) ~ * {
        --cui-sidebar-occupy-start: 24rem; }
      .sidebar.sidebar-xl.sidebar-end:not(.hide) ~ * {
        --cui-sidebar-occupy-end: 24rem; } }
  @media (min-width: 768px) {
    html:not([dir="rtl"]) .sidebar.hide:not(.sidebar-end) {
      margin-left: calc(-1 * var(--cui-sidebar-width)); }
    *[dir="rtl"] .sidebar.hide:not(.sidebar-end) {
      margin-right: calc(-1 * var(--cui-sidebar-width)); }
    .sidebar.hide:not(.sidebar-end) ~ * {
      --cui-sidebar-occupy-start: 0; }
    html:not([dir="rtl"]) .sidebar.hide.sidebar-end {
      margin-right: calc(-1 * var(--cui-sidebar-width)); }
    *[dir="rtl"] .sidebar.hide.sidebar-end {
      margin-left: calc(-1 * var(--cui-sidebar-width)); }
    .sidebar.hide.sidebar-end ~ * {
      --cui-sidebar-occupy-end: 0; } }
  @media (min-width: 768px) {
    .sidebar.sidebar-fixed {
      position: fixed;
      top: 0;
      bottom: 0;
      z-index: 1030; }
      html:not([dir="rtl"]) .sidebar.sidebar-fixed:not(.sidebar-end) {
        left: 0; }
      *[dir="rtl"] .sidebar.sidebar-fixed:not(.sidebar-end) {
        right: 0; }
      html:not([dir="rtl"]) .sidebar.sidebar-fixed.sidebar-end {
        right: 0; }
      *[dir="rtl"] .sidebar.sidebar-fixed.sidebar-end {
        left: 0; } }
  @media (min-width: 768px) {
    .sidebar.sidebar-sticky {
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      height: 100vh; } }
  .sidebar.sidebar-overlaid {
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 1032; }
    html:not([dir="rtl"]) .sidebar.sidebar-overlaid:not(.sidebar-end) {
      left: 0; }
    *[dir="rtl"] .sidebar.sidebar-overlaid:not(.sidebar-end) {
      right: 0; }
    .sidebar.sidebar-overlaid:not(.sidebar-end) ~ * {
      --cui-sidebar-occupy-start: 0; }
    html:not([dir="rtl"]) .sidebar.sidebar-overlaid.sidebar-end {
      right: 0; }
    *[dir="rtl"] .sidebar.sidebar-overlaid.sidebar-end {
      left: 0; }
    .sidebar.sidebar-overlaid.sidebar-end ~ * {
      --cui-sidebar-occupy-end: 0; }
  @media (max-width: 767.98px) {
    .sidebar {
      --cui-is-mobile: true;
      position: fixed;
      top: 0;
      bottom: 0;
      z-index: 1031; }
      html:not([dir="rtl"]) .sidebar:not(.sidebar-end) {
        left: 0; }
      *[dir="rtl"] .sidebar:not(.sidebar-end) {
        right: 0; }
      .sidebar:not(.sidebar-end) ~ * {
        --cui-sidebar-occupy-start: 0 !important; }
      html:not([dir="rtl"]) .sidebar:not(.sidebar-end):not(.show) {
        margin-left: calc(-1 * var(--cui-sidebar-width)); }
      *[dir="rtl"] .sidebar:not(.sidebar-end):not(.show) {
        margin-right: calc(-1 * var(--cui-sidebar-width)); }
      html:not([dir="rtl"]) .sidebar.sidebar-end {
        right: 0; }
      *[dir="rtl"] .sidebar.sidebar-end {
        left: 0; }
      .sidebar.sidebar-end ~ * {
        --cui-sidebar-occupy-end: 0 !important; }
      html:not([dir="rtl"]) .sidebar.sidebar-end:not(.show) {
        margin-right: calc(-1 * var(--cui-sidebar-width)); }
      *[dir="rtl"] .sidebar.sidebar-end:not(.show) {
        margin-left: calc(-1 * var(--cui-sidebar-width)); } }

.sidebar-close {
  position: absolute;
  top: 0;
  width: var(--cui-sidebar-width);
  height: var(--cui-sidebar-header-height);
  color: var(--cui-sidebar-color);
  background: transparent;
  border: 0; }
  html:not([dir="rtl"]) .sidebar-close {
    right: 0; }
  *[dir="rtl"] .sidebar-close {
    left: 0; }
  .sidebar-close:hover {
    text-decoration: none; }
  .sidebar-close:focus {
    outline: 0; }

.sidebar-brand {
  display: flex;
  flex: 0 0 var(--cui-sidebar-brand-height);
  align-items: center;
  justify-content: center;
  color: var(--cui-sidebar-brand-color);
  background: var(--cui-sidebar-brand-bg); }
  .sidebar-brand .sidebar-brand-narrow {
    display: none; }

.sidebar-header {
  flex: 0 0 var(--cui-sidebar-header-height);
  padding: var(--cui-sidebar-header-padding-y) var(--cui-sidebar-header-padding-x);
  text-align: center;
  background: var(--cui-sidebar-header-bg);
  transition: height 0.15s, padding 0.15s; }
  @media (prefers-reduced-motion: reduce) {
    .sidebar-header {
      transition: none; } }
  .sidebar-header .nav-link {
    display: flex;
    align-items: center;
    min-height: var(--cui-sidebar-header-height); }

.sidebar-footer {
  flex: 0 0 var(--cui-sidebar-footer-height);
  padding: var(--cui-sidebar-footer-padding-y) var(--cui-sidebar-footer-padding-x);
  background: var(--cui-sidebar-footer-bg);
  transition: height 0.15s, padding 0.15s; }
  @media (prefers-reduced-motion: reduce) {
    .sidebar-footer {
      transition: none; } }

.sidebar-toggler {
  display: flex;
  flex: 0 0 var(--cui-sidebar-toggler-height);
  justify-content: flex-end;
  width: inherit;
  padding: 0;
  cursor: pointer;
  background-color: var(--cui-sidebar-toggler-bg);
  border: 0; }
  @media (max-width: 767.98px) {
    .sidebar-toggler {
      display: none; } }
  .sidebar-toggler::before {
    display: block;
    width: var(--cui-sidebar-toggler-indicator-width);
    height: var(--cui-sidebar-toggler-indicator-height);
    content: "";
    background-image: var(--cui-sidebar-toggler-indicator);
    background-repeat: no-repeat;
    background-position: center;
    background-size: calc(var(--cui-sidebar-toggler-indicator-height) * .25);
    transition: transform 0.15s; }
    @media (prefers-reduced-motion: reduce) {
      .sidebar-toggler::before {
        transition: none; } }
    *[dir="rtl"] .sidebar-toggler::before {
      transform: rotate(-180deg); }
  .sidebar-toggler:focus {
    outline: 0; }
  .sidebar-toggler:hover {
    background-color: var(--cui-sidebar-toggler-hover-bg); }
    .sidebar-toggler:hover::before {
      background-image: var(--cui-sidebar-toggler-indicator-hover); }
  .sidebar-end .sidebar-toggler {
    justify-content: flex-start; }
    .sidebar-end .sidebar-toggler::before {
      transform: rotate(-180deg); }

.sidebar-backdrop {
  --cui-backdrop-zindex: 1030;
  --cui-backdrop-bg: #000015;
  --cui-backdrop-opacity: 0.5; }
  @media (max-width: 767.98px) {
    .sidebar-backdrop {
      position: fixed;
      top: 0;
      left: 0;
      z-index: var(--cui-backdrop-zindex);
      width: 100vw;
      height: 100vh;
      background-color: var(--cui-backdrop-bg); }
      .sidebar-backdrop.fade {
        opacity: 0; }
      .sidebar-backdrop.show {
        opacity: var(--cui-backdrop-opacity); } }

.sidebar-nav {
  position: relative;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  padding: 0;
  margin-bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  list-style: none; }
  .sidebar-nav .nav-title {
    padding: var(--cui-sidebar-nav-title-padding-y) var(--cui-sidebar-nav-title-padding-x);
    margin-top: var(--cui-sidebar-nav-title-margin-top);
    font-size: 80%;
    font-weight: 700;
    color: var(--cui-sidebar-nav-title-color);
    text-transform: uppercase;
    transition: height 0.15s, margin 0.15s; }
    @media (prefers-reduced-motion: reduce) {
      .sidebar-nav .nav-title {
        transition: none; } }
  .sidebar-nav .nav-link {
    display: flex;
    flex: 1 1;
    align-items: center;
    padding: var(--cui-sidebar-nav-link-padding-y) var(--cui-sidebar-nav-link-padding-x);
    color: var(--cui-sidebar-nav-link-color);
    text-decoration: none;
    white-space: nowrap;
    background: var(--cui-sidebar-nav-link-bg);
    border: var(--cui-sidebar-nav-link-border);
    border-radius: var(--cui-sidebar-nav-link-border-radius);
    transition: background 0.15s ease, color 0.15s ease; }
    @media (prefers-reduced-motion: reduce) {
      .sidebar-nav .nav-link {
        transition: none; } }
    .sidebar-nav .nav-link.active {
      color: var(--cui-sidebar-nav-link-active-color);
      background: var(--cui-sidebar-nav-link-active-bg); }
      .sidebar-nav .nav-link.active .nav-icon {
        color: var(--cui-sidebar-nav-link-active-icon-color); }
    .sidebar-nav .nav-link.disabled {
      color: var(--cui-sidebar-nav-link-disabled-color);
      pointer-events: none;
      cursor: not-allowed;
      background: transparent; }
      .sidebar-nav .nav-link.disabled .nav-icon {
        color: var(--cui-sidebar-nav-link-disabled-icon-color); }
      .sidebar-nav .nav-link.disabled:hover {
        color: var(--cui-sidebar-nav-link-disabled-color); }
        .sidebar-nav .nav-link.disabled:hover .nav-icon {
          color: var(--cui-sidebar-nav-link-disabled-icon-color); }
        .sidebar-nav .nav-link.disabled:hover.nav-dropdown-toggle::after {
          background-image: var(--cui-sidebar-nav-group-indicator-hover); }
    @media (hover: hover), (-ms-high-contrast: none) {
      .sidebar-nav .nav-link:hover {
        color: var(--cui-sidebar-nav-link-hover-color);
        text-decoration: none;
        background: var(--cui-sidebar-nav-link-hover-bg); }
        .sidebar-nav .nav-link:hover .nav-icon {
          color: var(--cui-sidebar-nav-link-hover-icon-color); }
        .sidebar-nav .nav-link:hover.nav-group-toggle::after {
          background-image: var(--cui-sidebar-nav-group-indicator-hover); } }
  .sidebar-nav .nav-icon {
    flex: 0 0 var(--cui-sidebar-nav-icon-width);
    height: var(--cui-sidebar-nav-icon-height);
    font-size: var(--cui-sidebar-nav-icon-font-size);
    color: var(--cui-sidebar-nav-link-icon-color);
    text-align: center;
    pointer-events: none;
    fill: currentcolor;
    transition: inherit; }
    @media (prefers-reduced-motion: reduce) {
      .sidebar-nav .nav-icon {
        transition: none; } }
    html:not([dir="rtl"]) .sidebar-nav .nav-icon:first-child {
      margin-left: calc(var(--cui-sidebar-nav-link-padding-x) * -1); }
    *[dir="rtl"] .sidebar-nav .nav-icon:first-child {
      margin-right: calc(var(--cui-sidebar-nav-link-padding-x) * -1); }
  .sidebar-nav svg.nav-icon {
    overflow: hidden; }
  .sidebar-nav .nav-group {
    position: relative;
    transition: background 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .sidebar-nav .nav-group {
        transition: none; } }
    .sidebar-nav .nav-group .nav-group-items {
      padding: var(--cui-sidebar-nav-group-items-padding-y) var(--cui-sidebar-nav-group-items-padding-x);
      overflow: hidden;
      transition: height 0.15s ease; }
      @media (prefers-reduced-motion: reduce) {
        .sidebar-nav .nav-group .nav-group-items {
          transition: none; } }
    .sidebar-nav .nav-group:not(.show) .nav-group-items {
      display: none; }
    .sidebar-nav .nav-group.show {
      background: var(--cui-sidebar-nav-group-bg); }
      .sidebar-nav .nav-group.show .nav-group-toggle {
        color: var(--cui-sidebar-nav-group-toggle-show-color); }
      .sidebar-nav .nav-group.show > .nav-group-toggle::after {
        transform: rotate(180deg); }
      .sidebar-nav .nav-group.show + .show {
        margin-top: 1px; }
  .sidebar-nav .nav-group-toggle {
    cursor: pointer; }
    .sidebar-nav .nav-group-toggle::after {
      display: block;
      flex: 0 1 12px;
      height: 12px;
      content: "";
      background-image: var(--cui-sidebar-nav-group-indicator);
      background-repeat: no-repeat;
      background-position: center;
      transition: transform 0.15s; }
      html:not([dir="rtl"]) .sidebar-nav .nav-group-toggle::after {
        margin-left: auto; }
      *[dir="rtl"] .sidebar-nav .nav-group-toggle::after {
        margin-right: auto; }
      @media (prefers-reduced-motion: reduce) {
        .sidebar-nav .nav-group-toggle::after {
          transition: none; } }
  .sidebar-nav .nav-group-items {
    padding: 0;
    list-style: none; }
    html:not([dir="rtl"]) .sidebar-nav .nav-group-items .nav-link {
      padding-left: var(--cui-sidebar-nav-icon-width); }
    *[dir="rtl"] .sidebar-nav .nav-group-items .nav-link {
      padding-right: var(--cui-sidebar-nav-icon-width); }
    html:not([dir="rtl"]) .sidebar-nav .nav-group-items .nav-link .nav-icon {
      margin-left: calc(var(--cui-sidebar-nav-icon-width) * -1); }
    *[dir="rtl"] .sidebar-nav .nav-group-items .nav-link .nav-icon {
      margin-right: calc(var(--cui-sidebar-nav-icon-width) * -1); }
  .sidebar-nav.compact .nav-link,
  .sidebar-nav .compact .nav-link {
    padding-top: calc(var(--cui-sidebar-nav-link-padding-y) * .5);
    padding-bottom: calc(var(--cui-sidebar-nav-link-padding-y) * .5); }

@media (min-width: 768px) {
  .sidebar-narrow, .sidebar-narrow-unfoldable:not(:hover) {
    z-index: 1031;
    flex: 0 0 var(--cui-sidebar-narrow-width);
    width: var(--cui-sidebar-narrow-width);
    padding-bottom: var(--cui-sidebar-toggler-height);
    overflow: visible; }
    .sidebar-fixed.sidebar-narrow, .sidebar-fixed.sidebar-narrow-unfoldable:not(:hover) {
      z-index: 1031;
      width: var(--cui-sidebar-narrow-width); }
    .sidebar-narrow .sidebar-brand-full, .sidebar-narrow-unfoldable:not(:hover) .sidebar-brand-full {
      display: none; }
    .sidebar-narrow .sidebar-brand-narrow, .sidebar-narrow-unfoldable:not(:hover) .sidebar-brand-narrow {
      display: block; }
    .sidebar-narrow .d-narrow-none, .sidebar-narrow-unfoldable:not(:hover) .d-narrow-none,
    .sidebar-narrow .nav-label,
    .sidebar-narrow-unfoldable:not(:hover) .nav-label,
    .sidebar-narrow .nav-title,
    .sidebar-narrow-unfoldable:not(:hover) .nav-title,
    .sidebar-narrow .nav-group-items,
    .sidebar-narrow-unfoldable:not(:hover) .nav-group-items,
    .sidebar-narrow .nav-group.show .nav-group-items,
    .sidebar-narrow-unfoldable:not(:hover) .nav-group.show .nav-group-items,
    .sidebar-narrow .sidebar-footer,
    .sidebar-narrow-unfoldable:not(:hover) .sidebar-footer,
    .sidebar-narrow .sidebar-form,
    .sidebar-narrow-unfoldable:not(:hover) .sidebar-form,
    .sidebar-narrow .sidebar-header,
    .sidebar-narrow-unfoldable:not(:hover) .sidebar-header {
      height: 0 !important;
      padding: 0;
      margin: 0;
      visibility: hidden;
      opacity: 0; }
    .sidebar-narrow .sidebar-toggler, .sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler {
      position: fixed;
      bottom: 0; }
      html:not([dir="rtl"]) .sidebar-narrow .sidebar-toggler::before, html:not([dir="rtl"]) .sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler::before {
        transform: rotate(-180deg); }
      *[dir="rtl"] .sidebar-narrow .sidebar-toggler::before, *[dir="rtl"] .sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler::before {
        transform: rotate(0deg); }
    .sidebar-end.sidebar-narrow .sidebar-toggler::before, .sidebar-end.sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler::before {
      transform: rotate(0deg); } }

.sidebar-narrow:not(.sidebar-end) ~ * {
  --cui-sidebar-occupy-start: 4rem; }

.sidebar-narrow.sidebar-end ~ * {
  --cui-sidebar-occupy-end: 4rem; }

.sidebar-narrow-unfoldable {
  position: fixed;
  z-index: 1031; }
  .sidebar-narrow-unfoldable:not(.sidebar-end) ~ * {
    --cui-sidebar-occupy-start: 4rem; }
  .sidebar-narrow-unfoldable.sidebar-end ~ * {
    --cui-sidebar-occupy-end: 4rem; }
  html:not([dir="rtl"]) .sidebar-narrow-unfoldable:hover .sidebar-toggler::before {
    transform: rotate(-180deg); }
  *[dir="rtl"] .sidebar-narrow-unfoldable:hover .sidebar-toggler::before {
    transform: rotate(0deg); }
  .sidebar-narrow-unfoldable:hover.sidebar-end .sidebar-toggler::before {
    transform: rotate(0deg); }

html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow:not(.sidebar-end), html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow-unfoldable:not(.sidebar-end) {
  margin-left: calc(var(--cui-sidebar-narrow-width) * -1); }

*[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow:not(.sidebar-end), *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow-unfoldable:not(.sidebar-end) {
  margin-right: calc(var(--cui-sidebar-narrow-width) * -1); }

html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow.sidebar-end, html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow-unfoldable.sidebar-end {
  margin-right: calc(var(--cui-sidebar-narrow-width) * -1); }

*[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow.sidebar-end, *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow-unfoldable.sidebar-end {
  margin-left: calc(var(--cui-sidebar-narrow-width) * -1); }

@media (max-width: 575.98px) {
  html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow:not(.sidebar-end), html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1); }
  *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow:not(.sidebar-end), *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1); }
  html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow.sidebar-end, html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1); }
  *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow.sidebar-end, *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow-unfoldable.sidebar-end {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1); } }

@media (max-width: 767.98px) {
  html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow:not(.sidebar-end), html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1); }
  *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow:not(.sidebar-end), *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1); }
  html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow.sidebar-end, html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1); }
  *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow.sidebar-end, *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow-unfoldable.sidebar-end {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1); } }

@media (max-width: 991.98px) {
  html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow:not(.sidebar-end), html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1); }
  *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow:not(.sidebar-end), *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1); }
  html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow.sidebar-end, html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1); }
  *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow.sidebar-end, *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow-unfoldable.sidebar-end {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1); } }

@media (max-width: 1199.98px) {
  html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow:not(.sidebar-end), html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1); }
  *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow:not(.sidebar-end), *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1); }
  html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow.sidebar-end, html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1); }
  *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow.sidebar-end, *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow-unfoldable.sidebar-end {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1); } }

@media (max-width: 1399.98px) {
  html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow:not(.sidebar-end), html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1); }
  *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow:not(.sidebar-end), *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1); }
  html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow.sidebar-end, html:not([dir="rtl"]) .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1); }
  *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow.sidebar-end, *[dir="rtl"] .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow-unfoldable.sidebar-end {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1); } }

.subheader {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  min-height: 3rem;
  padding: 0.5rem 1rem;
  background: #fff;
  background: var(--cui-subheader-bg, #fff);
  border-bottom: 1px solid #d8dbe0;
  border-bottom: var(--cui-subheader-border-width, var(--cui-border-width)) solid var(--cui-subheader-border-color, var(--cui-border-color)); }

.subheader-sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1029; }

.subheader-nav {
  display: flex;
  flex-direction: row;
  margin-bottom: 0;
  list-style: none; }
  html:not([dir="rtl"]) .subheader-nav {
    padding-left: 0; }
  *[dir="rtl"] .subheader-nav {
    padding-right: 0; }
  .subheader-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    color: rgba(44, 56, 74, 0.681);
    color: var(--cui-subheader-color, var(--cui-secondary-color)); }
    .subheader-nav .nav-link:hover, .subheader-nav .nav-link:focus {
      color: rgba(44, 56, 74, 0.95);
      color: var(--cui-subheader-hover-color, var(--cui-body-color)); }
    .subheader-nav .nav-link.disabled {
      color: rgba(44, 56, 74, 0.38);
      color: var(--cui-subheader-disabled-color, rgba(44, 56, 74, 0.38)); }
  .subheader-nav .show > .nav-link,
  .subheader-nav .nav-link.active {
    color: rgba(44, 56, 74, 0.95);
    color: var(--cui-subheader-active-color, var(--cui-body-color)); }
  .subheader-nav .dropdown-menu {
    position: absolute; }

.subheader-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: rgba(44, 56, 74, 0.681);
  color: var(--cui-subheader-color, var(--cui-secondary-color)); }
  .subheader-text a {
    color: rgba(44, 56, 74, 0.95);
    color: var(--cui-subheader-active-color, var(--cui-body-color)); }
    .subheader-text a:hover, .subheader-text a:focus {
      color: rgba(44, 56, 74, 0.95);
      color: var(--cui-subheader-active-color, var(--cui-body-color)); }

.clearfix::after {
  display: block;
  clear: both;
  content: ""; }

.text-bg-primary {
  color: rgba(255, 255, 255, 0.87) !important;
  background-color: RGBA(50, 31, 219, 1) !important;
  background-color: RGBA(var(--cui-primary-rgb), var(--cui-bg-opacity, 1)) !important; }

.text-bg-secondary {
  color: #000015 !important;
  background-color: RGBA(157, 165, 177, 1) !important;
  background-color: RGBA(var(--cui-secondary-rgb), var(--cui-bg-opacity, 1)) !important; }

.text-bg-success {
  color: #000015 !important;
  background-color: RGBA(46, 184, 92, 1) !important;
  background-color: RGBA(var(--cui-success-rgb), var(--cui-bg-opacity, 1)) !important; }

.text-bg-info {
  color: #000015 !important;
  background-color: RGBA(51, 153, 255, 1) !important;
  background-color: RGBA(var(--cui-info-rgb), var(--cui-bg-opacity, 1)) !important; }

.text-bg-warning {
  color: rgba(44, 56, 74, 0.95) !important;
  background-color: RGBA(249, 177, 21, 1) !important;
  background-color: RGBA(var(--cui-warning-rgb), var(--cui-bg-opacity, 1)) !important; }

.text-bg-danger {
  color: #000015 !important;
  background-color: RGBA(229, 83, 83, 1) !important;
  background-color: RGBA(var(--cui-danger-rgb), var(--cui-bg-opacity, 1)) !important; }

.text-bg-light {
  color: rgba(44, 56, 74, 0.95) !important;
  background-color: RGBA(235, 237, 239, 1) !important;
  background-color: RGBA(var(--cui-light-rgb), var(--cui-bg-opacity, 1)) !important; }

.text-bg-dark {
  color: rgba(255, 255, 255, 0.87) !important;
  background-color: RGBA(79, 93, 115, 1) !important;
  background-color: RGBA(var(--cui-dark-rgb), var(--cui-bg-opacity, 1)) !important; }

.link-primary {
  color: RGBA(50, 31, 219, 1) !important;
  color: RGBA(var(--cui-primary-rgb), var(--cui-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(50, 31, 219, 1) !important;
          text-decoration-color: RGBA(50, 31, 219, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--cui-primary-rgb), var(--cui-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--cui-primary-rgb), var(--cui-link-underline-opacity, 1)) !important; }
  .link-primary:hover, .link-primary:focus {
    color: RGBA(91, 76, 226, 1) !important;
    color: RGBA(91, 76, 226, var(--cui-link-opacity, 1)) !important;
    -webkit-text-decoration-color: RGBA(91, 76, 226, 1) !important;
            text-decoration-color: RGBA(91, 76, 226, 1) !important;
    -webkit-text-decoration-color: RGBA(91, 76, 226, var(--cui-link-underline-opacity, 1)) !important;
            text-decoration-color: RGBA(91, 76, 226, var(--cui-link-underline-opacity, 1)) !important; }

.link-secondary {
  color: RGBA(157, 165, 177, 1) !important;
  color: RGBA(var(--cui-secondary-rgb), var(--cui-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(157, 165, 177, 1) !important;
          text-decoration-color: RGBA(157, 165, 177, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--cui-secondary-rgb), var(--cui-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--cui-secondary-rgb), var(--cui-link-underline-opacity, 1)) !important; }
  .link-secondary:hover, .link-secondary:focus {
    color: RGBA(177, 183, 193, 1) !important;
    color: RGBA(177, 183, 193, var(--cui-link-opacity, 1)) !important;
    -webkit-text-decoration-color: RGBA(177, 183, 193, 1) !important;
            text-decoration-color: RGBA(177, 183, 193, 1) !important;
    -webkit-text-decoration-color: RGBA(177, 183, 193, var(--cui-link-underline-opacity, 1)) !important;
            text-decoration-color: RGBA(177, 183, 193, var(--cui-link-underline-opacity, 1)) !important; }

.link-success {
  color: RGBA(46, 184, 92, 1) !important;
  color: RGBA(var(--cui-success-rgb), var(--cui-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(46, 184, 92, 1) !important;
          text-decoration-color: RGBA(46, 184, 92, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--cui-success-rgb), var(--cui-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--cui-success-rgb), var(--cui-link-underline-opacity, 1)) !important; }
  .link-success:hover, .link-success:focus {
    color: RGBA(88, 198, 125, 1) !important;
    color: RGBA(88, 198, 125, var(--cui-link-opacity, 1)) !important;
    -webkit-text-decoration-color: RGBA(88, 198, 125, 1) !important;
            text-decoration-color: RGBA(88, 198, 125, 1) !important;
    -webkit-text-decoration-color: RGBA(88, 198, 125, var(--cui-link-underline-opacity, 1)) !important;
            text-decoration-color: RGBA(88, 198, 125, var(--cui-link-underline-opacity, 1)) !important; }

.link-info {
  color: RGBA(51, 153, 255, 1) !important;
  color: RGBA(var(--cui-info-rgb), var(--cui-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(51, 153, 255, 1) !important;
          text-decoration-color: RGBA(51, 153, 255, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--cui-info-rgb), var(--cui-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--cui-info-rgb), var(--cui-link-underline-opacity, 1)) !important; }
  .link-info:hover, .link-info:focus {
    color: RGBA(92, 173, 255, 1) !important;
    color: RGBA(92, 173, 255, var(--cui-link-opacity, 1)) !important;
    -webkit-text-decoration-color: RGBA(92, 173, 255, 1) !important;
            text-decoration-color: RGBA(92, 173, 255, 1) !important;
    -webkit-text-decoration-color: RGBA(92, 173, 255, var(--cui-link-underline-opacity, 1)) !important;
            text-decoration-color: RGBA(92, 173, 255, var(--cui-link-underline-opacity, 1)) !important; }

.link-warning {
  color: RGBA(249, 177, 21, 1) !important;
  color: RGBA(var(--cui-warning-rgb), var(--cui-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(249, 177, 21, 1) !important;
          text-decoration-color: RGBA(249, 177, 21, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--cui-warning-rgb), var(--cui-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--cui-warning-rgb), var(--cui-link-underline-opacity, 1)) !important; }
  .link-warning:hover, .link-warning:focus {
    color: RGBA(199, 142, 17, 1) !important;
    color: RGBA(199, 142, 17, var(--cui-link-opacity, 1)) !important;
    -webkit-text-decoration-color: RGBA(199, 142, 17, 1) !important;
            text-decoration-color: RGBA(199, 142, 17, 1) !important;
    -webkit-text-decoration-color: RGBA(199, 142, 17, var(--cui-link-underline-opacity, 1)) !important;
            text-decoration-color: RGBA(199, 142, 17, var(--cui-link-underline-opacity, 1)) !important; }

.link-danger {
  color: RGBA(229, 83, 83, 1) !important;
  color: RGBA(var(--cui-danger-rgb), var(--cui-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(229, 83, 83, 1) !important;
          text-decoration-color: RGBA(229, 83, 83, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--cui-danger-rgb), var(--cui-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--cui-danger-rgb), var(--cui-link-underline-opacity, 1)) !important; }
  .link-danger:hover, .link-danger:focus {
    color: RGBA(234, 117, 117, 1) !important;
    color: RGBA(234, 117, 117, var(--cui-link-opacity, 1)) !important;
    -webkit-text-decoration-color: RGBA(234, 117, 117, 1) !important;
            text-decoration-color: RGBA(234, 117, 117, 1) !important;
    -webkit-text-decoration-color: RGBA(234, 117, 117, var(--cui-link-underline-opacity, 1)) !important;
            text-decoration-color: RGBA(234, 117, 117, var(--cui-link-underline-opacity, 1)) !important; }

.link-light {
  color: RGBA(235, 237, 239, 1) !important;
  color: RGBA(var(--cui-light-rgb), var(--cui-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(235, 237, 239, 1) !important;
          text-decoration-color: RGBA(235, 237, 239, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--cui-light-rgb), var(--cui-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--cui-light-rgb), var(--cui-link-underline-opacity, 1)) !important; }
  .link-light:hover, .link-light:focus {
    color: RGBA(188, 190, 191, 1) !important;
    color: RGBA(188, 190, 191, var(--cui-link-opacity, 1)) !important;
    -webkit-text-decoration-color: RGBA(188, 190, 191, 1) !important;
            text-decoration-color: RGBA(188, 190, 191, 1) !important;
    -webkit-text-decoration-color: RGBA(188, 190, 191, var(--cui-link-underline-opacity, 1)) !important;
            text-decoration-color: RGBA(188, 190, 191, var(--cui-link-underline-opacity, 1)) !important; }

.link-dark {
  color: RGBA(79, 93, 115, 1) !important;
  color: RGBA(var(--cui-dark-rgb), var(--cui-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(79, 93, 115, 1) !important;
          text-decoration-color: RGBA(79, 93, 115, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--cui-dark-rgb), var(--cui-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--cui-dark-rgb), var(--cui-link-underline-opacity, 1)) !important; }
  .link-dark:hover, .link-dark:focus {
    color: RGBA(114, 125, 143, 1) !important;
    color: RGBA(114, 125, 143, var(--cui-link-opacity, 1)) !important;
    -webkit-text-decoration-color: RGBA(114, 125, 143, 1) !important;
            text-decoration-color: RGBA(114, 125, 143, 1) !important;
    -webkit-text-decoration-color: RGBA(114, 125, 143, var(--cui-link-underline-opacity, 1)) !important;
            text-decoration-color: RGBA(114, 125, 143, var(--cui-link-underline-opacity, 1)) !important; }

.link-body-emphasis {
  color: RGBA(0, 0, 21, 1) !important;
  color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(0, 0, 21, 1) !important;
          text-decoration-color: RGBA(0, 0, 21, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-underline-opacity, 1)) !important; }
  .link-body-emphasis:hover, .link-body-emphasis:focus {
    color: RGBA(0, 0, 21, 0.75) !important;
    color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-opacity, 0.75)) !important;
    -webkit-text-decoration-color: RGBA(0, 0, 21, 0.75) !important;
            text-decoration-color: RGBA(0, 0, 21, 0.75) !important;
    -webkit-text-decoration-color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-underline-opacity, 0.75)) !important;
            text-decoration-color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-underline-opacity, 0.75)) !important; }

.focus-ring:focus {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
  box-shadow: var(--cui-focus-ring-x, 0) var(--cui-focus-ring-y, 0) var(--cui-focus-ring-blur, 0) var(--cui-focus-ring-width) var(--cui-focus-ring-color); }

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  -webkit-text-decoration-color: rgba(50, 31, 219, 0.5);
          text-decoration-color: rgba(50, 31, 219, 0.5);
  -webkit-text-decoration-color: rgba(var(--cui-link-color-rgb), var(--cui-link-opacity, 0.5));
          text-decoration-color: rgba(var(--cui-link-color-rgb), var(--cui-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden; }
  .icon-link > .bi {
    flex-shrink: 0;
    width: 1em;
    height: 1em;
    fill: currentcolor;
    transition: 0.2s ease-in-out transform; }
    @media (prefers-reduced-motion: reduce) {
      .icon-link > .bi {
        transition: none; } }

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: translate3d(0.25em, 0, 0);
  transform: var(--cui-icon-link-transform, translate3d(0.25em, 0, 0)); }

.ratio {
  position: relative;
  width: 100%; }
  .ratio::before {
    display: block;
    padding-top: var(--cui-aspect-ratio);
    content: ""; }
  .ratio > * {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%; }
    html:not([dir="rtl"]) .ratio > * {
      left: 0; }
    *[dir="rtl"] .ratio > * {
      right: 0; }

.ratio-1x1 {
  --cui-aspect-ratio: 100%; }

.ratio-4x3 {
  --cui-aspect-ratio: calc(3 / 4 * 100%); }

.ratio-16x9 {
  --cui-aspect-ratio: calc(9 / 16 * 100%); }

.ratio-21x9 {
  --cui-aspect-ratio: calc(9 / 21 * 100%); }

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030; }

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030; }

.sticky-top {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1020; }

.sticky-bottom {
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  z-index: 1020; }

@media (min-width: 576px) {
  .sticky-sm-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-sm-bottom {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 768px) {
  .sticky-md-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-md-bottom {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 992px) {
  .sticky-lg-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-lg-bottom {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 1200px) {
  .sticky-xl-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-xl-bottom {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-xxl-bottom {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch; }

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch; }

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important; }
  .visually-hidden:not(caption),
  .visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
    position: absolute !important; }

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: ""; }

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.vr {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  width: var(--cui-border-width);
  min-height: 1em;
  padding: 0;
  background-color: currentcolor;
  opacity: 0.25; }

.align-baseline {
  vertical-align: baseline !important; }

.align-top {
  vertical-align: top !important; }

.align-middle {
  vertical-align: middle !important; }

.align-bottom {
  vertical-align: bottom !important; }

.align-text-bottom {
  vertical-align: text-bottom !important; }

.align-text-top {
  vertical-align: text-top !important; }

html:not([dir="rtl"]) .float-start {
  float: left !important; }

*[dir="rtl"] .float-start {
  float: right !important; }

html:not([dir="rtl"]) .float-end {
  float: right !important; }

*[dir="rtl"] .float-end {
  float: left !important; }

html:not([dir="rtl"]) .float-none {
  float: none !important; }

*[dir="rtl"] .float-none {
  float: none !important; }

.object-fit-contain {
  object-fit: contain !important; }

.object-fit-cover {
  object-fit: cover !important; }

.object-fit-fill {
  object-fit: fill !important; }

.object-fit-scale {
  object-fit: scale-down !important; }

.object-fit-none {
  object-fit: none !important; }

.opacity-0 {
  opacity: 0 !important; }

.opacity-25 {
  opacity: 0.25 !important; }

.opacity-50 {
  opacity: 0.5 !important; }

.opacity-75 {
  opacity: 0.75 !important; }

.opacity-100 {
  opacity: 1 !important; }

.overflow-auto {
  overflow: auto !important; }

.overflow-hidden {
  overflow: hidden !important; }

.overflow-visible {
  overflow: visible !important; }

.overflow-scroll {
  overflow: scroll !important; }

.overflow-x-auto {
  overflow-x: auto !important; }

.overflow-x-hidden {
  overflow-x: hidden !important; }

.overflow-x-visible {
  overflow-x: visible !important; }

.overflow-x-scroll {
  overflow-x: scroll !important; }

.overflow-y-auto {
  overflow-y: auto !important; }

.overflow-y-hidden {
  overflow-y: hidden !important; }

.overflow-y-visible {
  overflow-y: visible !important; }

.overflow-y-scroll {
  overflow-y: scroll !important; }

.d-inline {
  display: inline !important; }

.d-inline-block {
  display: inline-block !important; }

.d-block {
  display: block !important; }

.d-grid {
  display: grid !important; }

.d-inline-grid {
  display: inline-grid !important; }

.d-table {
  display: table !important; }

.d-table-row {
  display: table-row !important; }

.d-table-cell {
  display: table-cell !important; }

.d-flex {
  display: flex !important; }

.d-inline-flex {
  display: inline-flex !important; }

.d-none {
  display: none !important; }

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 21, 0.15) !important; }

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 21, 0.075) !important; }

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 21, 0.175) !important; }

.shadow-none {
  box-shadow: none !important; }

.focus-ring-primary {
  --cui-focus-ring-color: rgba(var(--cui-primary-rgb), var(--cui-focus-ring-opacity)); }

.focus-ring-secondary {
  --cui-focus-ring-color: rgba(var(--cui-secondary-rgb), var(--cui-focus-ring-opacity)); }

.focus-ring-success {
  --cui-focus-ring-color: rgba(var(--cui-success-rgb), var(--cui-focus-ring-opacity)); }

.focus-ring-info {
  --cui-focus-ring-color: rgba(var(--cui-info-rgb), var(--cui-focus-ring-opacity)); }

.focus-ring-warning {
  --cui-focus-ring-color: rgba(var(--cui-warning-rgb), var(--cui-focus-ring-opacity)); }

.focus-ring-danger {
  --cui-focus-ring-color: rgba(var(--cui-danger-rgb), var(--cui-focus-ring-opacity)); }

.focus-ring-light {
  --cui-focus-ring-color: rgba(var(--cui-light-rgb), var(--cui-focus-ring-opacity)); }

.focus-ring-dark {
  --cui-focus-ring-color: rgba(var(--cui-dark-rgb), var(--cui-focus-ring-opacity)); }

.position-static {
  position: static !important; }

.position-relative {
  position: relative !important; }

.position-absolute {
  position: absolute !important; }

.position-fixed {
  position: fixed !important; }

.position-sticky {
  position: -webkit-sticky !important;
  position: sticky !important; }

.top-0 {
  top: 0 !important; }

.top-50 {
  top: 50% !important; }

.top-100 {
  top: 100% !important; }

.bottom-0 {
  bottom: 0 !important; }

.bottom-50 {
  bottom: 50% !important; }

.bottom-100 {
  bottom: 100% !important; }

.start-0 {
  left: 0 !important; }

.start-50 {
  left: 50% !important; }

.start-100 {
  left: 100% !important; }

.end-0 {
  right: 0 !important; }

.end-50 {
  right: 50% !important; }

.end-100 {
  right: 100% !important; }

.translate-middle {
  transform: translate(-50%, -50%) !important; }

.translate-middle-x {
  transform: translateX(-50%) !important; }

.translate-middle-y {
  transform: translateY(-50%) !important; }

.border {
  border: 1px solid #d8dbe0 !important;
  border: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important; }

.border-0 {
  border: 0 !important; }

.border-top {
  border-top: 1px solid #d8dbe0 !important;
  border-top: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important; }

.border-top-0 {
  border-top: 0 !important; }

html:not([dir="rtl"]) .border-end {
  border-right: 1px solid #d8dbe0 !important;
  border-right: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important; }

*[dir="rtl"] .border-end {
  border-left: 1px solid #d8dbe0 !important;
  border-left: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important; }

html:not([dir="rtl"]) .border-end-0 {
  border-right: 0 !important; }

*[dir="rtl"] .border-end-0 {
  border-left: 0 !important; }

.border-bottom {
  border-bottom: 1px solid #d8dbe0 !important;
  border-bottom: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important; }

.border-bottom-0 {
  border-bottom: 0 !important; }

html:not([dir="rtl"]) .border-start {
  border-left: 1px solid #d8dbe0 !important;
  border-left: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important; }

*[dir="rtl"] .border-start {
  border-right: 1px solid #d8dbe0 !important;
  border-right: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important; }

html:not([dir="rtl"]) .border-start-0 {
  border-left: 0 !important; }

*[dir="rtl"] .border-start-0 {
  border-right: 0 !important; }

.border-primary {
  --cui-border-opacity: 1;
  border-color: rgba(50, 31, 219, var(--cui-border-opacity)) !important;
  border-color: rgba(var(--cui-primary-rgb), var(--cui-border-opacity)) !important; }

.border-secondary {
  --cui-border-opacity: 1;
  border-color: rgba(157, 165, 177, var(--cui-border-opacity)) !important;
  border-color: rgba(var(--cui-secondary-rgb), var(--cui-border-opacity)) !important; }

.border-success {
  --cui-border-opacity: 1;
  border-color: rgba(46, 184, 92, var(--cui-border-opacity)) !important;
  border-color: rgba(var(--cui-success-rgb), var(--cui-border-opacity)) !important; }

.border-info {
  --cui-border-opacity: 1;
  border-color: rgba(51, 153, 255, var(--cui-border-opacity)) !important;
  border-color: rgba(var(--cui-info-rgb), var(--cui-border-opacity)) !important; }

.border-warning {
  --cui-border-opacity: 1;
  border-color: rgba(249, 177, 21, var(--cui-border-opacity)) !important;
  border-color: rgba(var(--cui-warning-rgb), var(--cui-border-opacity)) !important; }

.border-danger {
  --cui-border-opacity: 1;
  border-color: rgba(229, 83, 83, var(--cui-border-opacity)) !important;
  border-color: rgba(var(--cui-danger-rgb), var(--cui-border-opacity)) !important; }

.border-light {
  --cui-border-opacity: 1;
  border-color: rgba(235, 237, 239, var(--cui-border-opacity)) !important;
  border-color: rgba(var(--cui-light-rgb), var(--cui-border-opacity)) !important; }

.border-dark {
  --cui-border-opacity: 1;
  border-color: rgba(79, 93, 115, var(--cui-border-opacity)) !important;
  border-color: rgba(var(--cui-dark-rgb), var(--cui-border-opacity)) !important; }

.border-white {
  --cui-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--cui-border-opacity)) !important;
  border-color: rgba(var(--cui-white-rgb), var(--cui-border-opacity)) !important; }

.border-top-primary {
  border-top-color: #321fdb !important; }

.border-top-secondary {
  border-top-color: #9da5b1 !important; }

.border-top-success {
  border-top-color: #2eb85c !important; }

.border-top-info {
  border-top-color: #39f !important; }

.border-top-warning {
  border-top-color: #f9b115 !important; }

.border-top-danger {
  border-top-color: #e55353 !important; }

.border-top-light {
  border-top-color: #ebedef !important; }

.border-top-dark {
  border-top-color: #4f5d73 !important; }

.border-top-white {
  border-top-color: #fff !important; }

html:not([dir="rtl"]) .border-end-primary {
  border-right-color: #321fdb !important; }

*[dir="rtl"] .border-end-primary {
  border-left-color: #321fdb !important; }

html:not([dir="rtl"]) .border-end-secondary {
  border-right-color: #9da5b1 !important; }

*[dir="rtl"] .border-end-secondary {
  border-left-color: #9da5b1 !important; }

html:not([dir="rtl"]) .border-end-success {
  border-right-color: #2eb85c !important; }

*[dir="rtl"] .border-end-success {
  border-left-color: #2eb85c !important; }

html:not([dir="rtl"]) .border-end-info {
  border-right-color: #39f !important; }

*[dir="rtl"] .border-end-info {
  border-left-color: #39f !important; }

html:not([dir="rtl"]) .border-end-warning {
  border-right-color: #f9b115 !important; }

*[dir="rtl"] .border-end-warning {
  border-left-color: #f9b115 !important; }

html:not([dir="rtl"]) .border-end-danger {
  border-right-color: #e55353 !important; }

*[dir="rtl"] .border-end-danger {
  border-left-color: #e55353 !important; }

html:not([dir="rtl"]) .border-end-light {
  border-right-color: #ebedef !important; }

*[dir="rtl"] .border-end-light {
  border-left-color: #ebedef !important; }

html:not([dir="rtl"]) .border-end-dark {
  border-right-color: #4f5d73 !important; }

*[dir="rtl"] .border-end-dark {
  border-left-color: #4f5d73 !important; }

html:not([dir="rtl"]) .border-end-white {
  border-right-color: #fff !important; }

*[dir="rtl"] .border-end-white {
  border-left-color: #fff !important; }

.border-bottom-primary {
  border-bottom-color: #321fdb !important; }

.border-bottom-secondary {
  border-bottom-color: #9da5b1 !important; }

.border-bottom-success {
  border-bottom-color: #2eb85c !important; }

.border-bottom-info {
  border-bottom-color: #39f !important; }

.border-bottom-warning {
  border-bottom-color: #f9b115 !important; }

.border-bottom-danger {
  border-bottom-color: #e55353 !important; }

.border-bottom-light {
  border-bottom-color: #ebedef !important; }

.border-bottom-dark {
  border-bottom-color: #4f5d73 !important; }

.border-bottom-white {
  border-bottom-color: #fff !important; }

html:not([dir="rtl"]) .border-start-primary {
  border-left-color: #321fdb !important; }

*[dir="rtl"] .border-start-primary {
  border-right-color: #321fdb !important; }

html:not([dir="rtl"]) .border-start-secondary {
  border-left-color: #9da5b1 !important; }

*[dir="rtl"] .border-start-secondary {
  border-right-color: #9da5b1 !important; }

html:not([dir="rtl"]) .border-start-success {
  border-left-color: #2eb85c !important; }

*[dir="rtl"] .border-start-success {
  border-right-color: #2eb85c !important; }

html:not([dir="rtl"]) .border-start-info {
  border-left-color: #39f !important; }

*[dir="rtl"] .border-start-info {
  border-right-color: #39f !important; }

html:not([dir="rtl"]) .border-start-warning {
  border-left-color: #f9b115 !important; }

*[dir="rtl"] .border-start-warning {
  border-right-color: #f9b115 !important; }

html:not([dir="rtl"]) .border-start-danger {
  border-left-color: #e55353 !important; }

*[dir="rtl"] .border-start-danger {
  border-right-color: #e55353 !important; }

html:not([dir="rtl"]) .border-start-light {
  border-left-color: #ebedef !important; }

*[dir="rtl"] .border-start-light {
  border-right-color: #ebedef !important; }

html:not([dir="rtl"]) .border-start-dark {
  border-left-color: #4f5d73 !important; }

*[dir="rtl"] .border-start-dark {
  border-right-color: #4f5d73 !important; }

html:not([dir="rtl"]) .border-start-white {
  border-left-color: #fff !important; }

*[dir="rtl"] .border-start-white {
  border-right-color: #fff !important; }

.border-1 {
  border-width: 1px !important; }

.border-2 {
  border-width: 2px !important; }

.border-3 {
  border-width: 3px !important; }

.border-4 {
  border-width: 4px !important; }

.border-5 {
  border-width: 5px !important; }

.border-top-1 {
  border-top-width: 1px !important; }

.border-top-2 {
  border-top-width: 2px !important; }

.border-top-3 {
  border-top-width: 3px !important; }

.border-top-4 {
  border-top-width: 4px !important; }

.border-top-5 {
  border-top-width: 5px !important; }

html:not([dir="rtl"]) .border-end-1 {
  border-right-width: 1px !important; }

*[dir="rtl"] .border-end-1 {
  border-left-width: 1px !important; }

html:not([dir="rtl"]) .border-end-2 {
  border-right-width: 2px !important; }

*[dir="rtl"] .border-end-2 {
  border-left-width: 2px !important; }

html:not([dir="rtl"]) .border-end-3 {
  border-right-width: 3px !important; }

*[dir="rtl"] .border-end-3 {
  border-left-width: 3px !important; }

html:not([dir="rtl"]) .border-end-4 {
  border-right-width: 4px !important; }

*[dir="rtl"] .border-end-4 {
  border-left-width: 4px !important; }

html:not([dir="rtl"]) .border-end-5 {
  border-right-width: 5px !important; }

*[dir="rtl"] .border-end-5 {
  border-left-width: 5px !important; }

.border-bottom-1 {
  border-bottom-width: 1px !important; }

.border-bottom-2 {
  border-bottom-width: 2px !important; }

.border-bottom-3 {
  border-bottom-width: 3px !important; }

.border-bottom-4 {
  border-bottom-width: 4px !important; }

.border-bottom-5 {
  border-bottom-width: 5px !important; }

html:not([dir="rtl"]) .border-start-1 {
  border-left-width: 1px !important; }

*[dir="rtl"] .border-start-1 {
  border-right-width: 1px !important; }

html:not([dir="rtl"]) .border-start-2 {
  border-left-width: 2px !important; }

*[dir="rtl"] .border-start-2 {
  border-right-width: 2px !important; }

html:not([dir="rtl"]) .border-start-3 {
  border-left-width: 3px !important; }

*[dir="rtl"] .border-start-3 {
  border-right-width: 3px !important; }

html:not([dir="rtl"]) .border-start-4 {
  border-left-width: 4px !important; }

*[dir="rtl"] .border-start-4 {
  border-right-width: 4px !important; }

html:not([dir="rtl"]) .border-start-5 {
  border-left-width: 5px !important; }

*[dir="rtl"] .border-start-5 {
  border-right-width: 5px !important; }

.border-opacity-10 {
  --cui-border-opacity: 0.1; }

.border-opacity-25 {
  --cui-border-opacity: 0.25; }

.border-opacity-50 {
  --cui-border-opacity: 0.5; }

.border-opacity-75 {
  --cui-border-opacity: 0.75; }

.border-opacity-100 {
  --cui-border-opacity: 1; }

.w-25 {
  width: 25% !important; }

.w-50 {
  width: 50% !important; }

.w-75 {
  width: 75% !important; }

.w-100 {
  width: 100% !important; }

.w-auto {
  width: auto !important; }

.mw-100 {
  max-width: 100% !important; }

.vw-100 {
  width: 100vw !important; }

.min-vw-100 {
  min-width: 100vw !important; }

.h-25 {
  height: 25% !important; }

.h-50 {
  height: 50% !important; }

.h-75 {
  height: 75% !important; }

.h-100 {
  height: 100% !important; }

.h-auto {
  height: auto !important; }

.mh-100 {
  max-height: 100% !important; }

.vh-100 {
  height: 100vh !important; }

.min-vh-100 {
  min-height: 100vh !important; }

.flex-fill {
  flex: 1 1 auto !important; }

.flex-row {
  flex-direction: row !important; }

.flex-column {
  flex-direction: column !important; }

.flex-row-reverse {
  flex-direction: row-reverse !important; }

.flex-column-reverse {
  flex-direction: column-reverse !important; }

.flex-grow-0 {
  flex-grow: 0 !important; }

.flex-grow-1 {
  flex-grow: 1 !important; }

.flex-shrink-0 {
  flex-shrink: 0 !important; }

.flex-shrink-1 {
  flex-shrink: 1 !important; }

.flex-wrap {
  flex-wrap: wrap !important; }

.flex-nowrap {
  flex-wrap: nowrap !important; }

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important; }

.justify-content-start {
  justify-content: flex-start !important; }

.justify-content-end {
  justify-content: flex-end !important; }

.justify-content-center {
  justify-content: center !important; }

.justify-content-between {
  justify-content: space-between !important; }

.justify-content-around {
  justify-content: space-around !important; }

.justify-content-evenly {
  justify-content: space-evenly !important; }

.align-items-start {
  align-items: flex-start !important; }

.align-items-end {
  align-items: flex-end !important; }

.align-items-center {
  align-items: center !important; }

.align-items-baseline {
  align-items: baseline !important; }

.align-items-stretch {
  align-items: stretch !important; }

.align-content-start {
  align-content: flex-start !important; }

.align-content-end {
  align-content: flex-end !important; }

.align-content-center {
  align-content: center !important; }

.align-content-between {
  align-content: space-between !important; }

.align-content-around {
  align-content: space-around !important; }

.align-content-stretch {
  align-content: stretch !important; }

.align-self-auto {
  align-self: auto !important; }

.align-self-start {
  align-self: flex-start !important; }

.align-self-end {
  align-self: flex-end !important; }

.align-self-center {
  align-self: center !important; }

.align-self-baseline {
  align-self: baseline !important; }

.align-self-stretch {
  align-self: stretch !important; }

.order-first {
  order: -1 !important; }

.order-0 {
  order: 0 !important; }

.order-1 {
  order: 1 !important; }

.order-2 {
  order: 2 !important; }

.order-3 {
  order: 3 !important; }

.order-4 {
  order: 4 !important; }

.order-5 {
  order: 5 !important; }

.order-last {
  order: 6 !important; }

.m-0 {
  margin: 0 !important; }

.m-1 {
  margin: 0.25rem !important; }

.m-2 {
  margin: 0.5rem !important; }

.m-3 {
  margin: 1rem !important; }

.m-4 {
  margin: 1.5rem !important; }

.m-5 {
  margin: 3rem !important; }

.m-auto {
  margin: auto !important; }

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important; }

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important; }

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important; }

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important; }

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important; }

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important; }

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important; }

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important; }

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important; }

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important; }

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important; }

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important; }

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important; }

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important; }

.mt-0 {
  margin-top: 0 !important; }

.mt-1 {
  margin-top: 0.25rem !important; }

.mt-2 {
  margin-top: 0.5rem !important; }

.mt-3 {
  margin-top: 1rem !important; }

.mt-4 {
  margin-top: 1.5rem !important; }

.mt-5 {
  margin-top: 3rem !important; }

.mt-auto {
  margin-top: auto !important; }

html:not([dir="rtl"]) .me-0 {
  margin-right: 0 !important; }

*[dir="rtl"] .me-0 {
  margin-left: 0 !important; }

html:not([dir="rtl"]) .me-1 {
  margin-right: 0.25rem !important; }

*[dir="rtl"] .me-1 {
  margin-left: 0.25rem !important; }

html:not([dir="rtl"]) .me-2 {
  margin-right: 0.5rem !important; }

*[dir="rtl"] .me-2 {
  margin-left: 0.5rem !important; }

html:not([dir="rtl"]) .me-3 {
  margin-right: 1rem !important; }

*[dir="rtl"] .me-3 {
  margin-left: 1rem !important; }

html:not([dir="rtl"]) .me-4 {
  margin-right: 1.5rem !important; }

*[dir="rtl"] .me-4 {
  margin-left: 1.5rem !important; }

html:not([dir="rtl"]) .me-5 {
  margin-right: 3rem !important; }

*[dir="rtl"] .me-5 {
  margin-left: 3rem !important; }

html:not([dir="rtl"]) .me-auto {
  margin-right: auto !important; }

*[dir="rtl"] .me-auto {
  margin-left: auto !important; }

.mb-0 {
  margin-bottom: 0 !important; }

.mb-1 {
  margin-bottom: 0.25rem !important; }

.mb-2 {
  margin-bottom: 0.5rem !important; }

.mb-3 {
  margin-bottom: 1rem !important; }

.mb-4 {
  margin-bottom: 1.5rem !important; }

.mb-5 {
  margin-bottom: 3rem !important; }

.mb-auto {
  margin-bottom: auto !important; }

html:not([dir="rtl"]) .ms-0 {
  margin-left: 0 !important; }

*[dir="rtl"] .ms-0 {
  margin-right: 0 !important; }

html:not([dir="rtl"]) .ms-1 {
  margin-left: 0.25rem !important; }

*[dir="rtl"] .ms-1 {
  margin-right: 0.25rem !important; }

html:not([dir="rtl"]) .ms-2 {
  margin-left: 0.5rem !important; }

*[dir="rtl"] .ms-2 {
  margin-right: 0.5rem !important; }

html:not([dir="rtl"]) .ms-3 {
  margin-left: 1rem !important; }

*[dir="rtl"] .ms-3 {
  margin-right: 1rem !important; }

html:not([dir="rtl"]) .ms-4 {
  margin-left: 1.5rem !important; }

*[dir="rtl"] .ms-4 {
  margin-right: 1.5rem !important; }

html:not([dir="rtl"]) .ms-5 {
  margin-left: 3rem !important; }

*[dir="rtl"] .ms-5 {
  margin-right: 3rem !important; }

html:not([dir="rtl"]) .ms-auto {
  margin-left: auto !important; }

*[dir="rtl"] .ms-auto {
  margin-right: auto !important; }

.p-0 {
  padding: 0 !important; }

.p-1 {
  padding: 0.25rem !important; }

.p-2 {
  padding: 0.5rem !important; }

.p-3 {
  padding: 1rem !important; }

.p-4 {
  padding: 1.5rem !important; }

.p-5 {
  padding: 3rem !important; }

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important; }

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important; }

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important; }

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important; }

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important; }

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important; }

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important; }

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important; }

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important; }

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important; }

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important; }

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important; }

.pt-0 {
  padding-top: 0 !important; }

.pt-1 {
  padding-top: 0.25rem !important; }

.pt-2 {
  padding-top: 0.5rem !important; }

.pt-3 {
  padding-top: 1rem !important; }

.pt-4 {
  padding-top: 1.5rem !important; }

.pt-5 {
  padding-top: 3rem !important; }

html:not([dir="rtl"]) .pe-0 {
  padding-right: 0 !important; }

*[dir="rtl"] .pe-0 {
  padding-left: 0 !important; }

html:not([dir="rtl"]) .pe-1 {
  padding-right: 0.25rem !important; }

*[dir="rtl"] .pe-1 {
  padding-left: 0.25rem !important; }

html:not([dir="rtl"]) .pe-2 {
  padding-right: 0.5rem !important; }

*[dir="rtl"] .pe-2 {
  padding-left: 0.5rem !important; }

html:not([dir="rtl"]) .pe-3 {
  padding-right: 1rem !important; }

*[dir="rtl"] .pe-3 {
  padding-left: 1rem !important; }

html:not([dir="rtl"]) .pe-4 {
  padding-right: 1.5rem !important; }

*[dir="rtl"] .pe-4 {
  padding-left: 1.5rem !important; }

html:not([dir="rtl"]) .pe-5 {
  padding-right: 3rem !important; }

*[dir="rtl"] .pe-5 {
  padding-left: 3rem !important; }

.pb-0 {
  padding-bottom: 0 !important; }

.pb-1 {
  padding-bottom: 0.25rem !important; }

.pb-2 {
  padding-bottom: 0.5rem !important; }

.pb-3 {
  padding-bottom: 1rem !important; }

.pb-4 {
  padding-bottom: 1.5rem !important; }

.pb-5 {
  padding-bottom: 3rem !important; }

html:not([dir="rtl"]) .ps-0 {
  padding-left: 0 !important; }

*[dir="rtl"] .ps-0 {
  padding-right: 0 !important; }

html:not([dir="rtl"]) .ps-1 {
  padding-left: 0.25rem !important; }

*[dir="rtl"] .ps-1 {
  padding-right: 0.25rem !important; }

html:not([dir="rtl"]) .ps-2 {
  padding-left: 0.5rem !important; }

*[dir="rtl"] .ps-2 {
  padding-right: 0.5rem !important; }

html:not([dir="rtl"]) .ps-3 {
  padding-left: 1rem !important; }

*[dir="rtl"] .ps-3 {
  padding-right: 1rem !important; }

html:not([dir="rtl"]) .ps-4 {
  padding-left: 1.5rem !important; }

*[dir="rtl"] .ps-4 {
  padding-right: 1.5rem !important; }

html:not([dir="rtl"]) .ps-5 {
  padding-left: 3rem !important; }

*[dir="rtl"] .ps-5 {
  padding-right: 3rem !important; }

.gap-0 {
  gap: 0 !important; }

.gap-1 {
  gap: 0.25rem !important; }

.gap-2 {
  gap: 0.5rem !important; }

.gap-3 {
  gap: 1rem !important; }

.gap-4 {
  gap: 1.5rem !important; }

.gap-5 {
  gap: 3rem !important; }

.row-gap-0 {
  row-gap: 0 !important; }

.row-gap-1 {
  row-gap: 0.25rem !important; }

.row-gap-2 {
  row-gap: 0.5rem !important; }

.row-gap-3 {
  row-gap: 1rem !important; }

.row-gap-4 {
  row-gap: 1.5rem !important; }

.row-gap-5 {
  row-gap: 3rem !important; }

.column-gap-0 {
  column-gap: 0 !important; }

.column-gap-1 {
  column-gap: 0.25rem !important; }

.column-gap-2 {
  column-gap: 0.5rem !important; }

.column-gap-3 {
  column-gap: 1rem !important; }

.column-gap-4 {
  column-gap: 1.5rem !important; }

.column-gap-5 {
  column-gap: 3rem !important; }

.font-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
  font-family: var(--cui-font-monospace) !important; }

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important; }

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important; }

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important; }

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important; }

.fs-5 {
  font-size: 1.25rem !important; }

.fs-6 {
  font-size: 1rem !important; }

.fst-italic {
  font-style: italic !important; }

.fst-normal {
  font-style: normal !important; }

.fw-lighter {
  font-weight: lighter !important; }

.fw-light {
  font-weight: 300 !important; }

.fw-normal {
  font-weight: 400 !important; }

.fw-medium {
  font-weight: 500 !important; }

.fw-semibold {
  font-weight: 600 !important; }

.fw-bold {
  font-weight: 700 !important; }

.fw-bolder {
  font-weight: bolder !important; }

.lh-1 {
  line-height: 1 !important; }

.lh-sm {
  line-height: 1.25 !important; }

.lh-base {
  line-height: 1.5 !important; }

.lh-lg {
  line-height: 2 !important; }

html:not([dir="rtl"]) .text-start {
  text-align: left !important; }

*[dir="rtl"] .text-start {
  text-align: right !important; }

html:not([dir="rtl"]) .text-end {
  text-align: right !important; }

*[dir="rtl"] .text-end {
  text-align: left !important; }

html:not([dir="rtl"]) .text-center {
  text-align: center !important; }

*[dir="rtl"] .text-center {
  text-align: center !important; }

.text-decoration-none {
  text-decoration: none !important; }

.text-decoration-underline {
  text-decoration: underline !important; }

.text-decoration-line-through {
  text-decoration: line-through !important; }

.text-lowercase {
  text-transform: lowercase !important; }

.text-uppercase {
  text-transform: uppercase !important; }

.text-capitalize {
  text-transform: capitalize !important; }

.text-wrap {
  white-space: normal !important; }

.text-nowrap {
  white-space: nowrap !important; }

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important; }

/* rtl:end:remove */
.text-primary {
  --cui-text-opacity: 1;
  color: rgba(50, 31, 219, var(--cui-text-opacity)) !important;
  color: rgba(var(--cui-primary-rgb), var(--cui-text-opacity)) !important; }

.text-secondary {
  --cui-text-opacity: 1;
  color: rgba(157, 165, 177, var(--cui-text-opacity)) !important;
  color: rgba(var(--cui-secondary-rgb), var(--cui-text-opacity)) !important; }

.text-success {
  --cui-text-opacity: 1;
  color: rgba(46, 184, 92, var(--cui-text-opacity)) !important;
  color: rgba(var(--cui-success-rgb), var(--cui-text-opacity)) !important; }

.text-info {
  --cui-text-opacity: 1;
  color: rgba(51, 153, 255, var(--cui-text-opacity)) !important;
  color: rgba(var(--cui-info-rgb), var(--cui-text-opacity)) !important; }

.text-warning {
  --cui-text-opacity: 1;
  color: rgba(249, 177, 21, var(--cui-text-opacity)) !important;
  color: rgba(var(--cui-warning-rgb), var(--cui-text-opacity)) !important; }

.text-danger {
  --cui-text-opacity: 1;
  color: rgba(229, 83, 83, var(--cui-text-opacity)) !important;
  color: rgba(var(--cui-danger-rgb), var(--cui-text-opacity)) !important; }

.text-light {
  --cui-text-opacity: 1;
  color: rgba(235, 237, 239, var(--cui-text-opacity)) !important;
  color: rgba(var(--cui-light-rgb), var(--cui-text-opacity)) !important; }

.text-dark {
  --cui-text-opacity: 1;
  color: rgba(79, 93, 115, var(--cui-text-opacity)) !important;
  color: rgba(var(--cui-dark-rgb), var(--cui-text-opacity)) !important; }

.text-black {
  --cui-text-opacity: 1;
  color: rgba(0, 0, 21, var(--cui-text-opacity)) !important;
  color: rgba(var(--cui-black-rgb), var(--cui-text-opacity)) !important; }

.text-white {
  --cui-text-opacity: 1;
  color: rgba(255, 255, 255, var(--cui-text-opacity)) !important;
  color: rgba(var(--cui-white-rgb), var(--cui-text-opacity)) !important; }

.text-body {
  --cui-text-opacity: 1;
  color: rgba(44, 56, 74, var(--cui-text-opacity)) !important;
  color: rgba(var(--cui-body-color-rgb), var(--cui-text-opacity)) !important; }

.text-muted {
  --cui-text-opacity: 1;
  color: rgba(44, 56, 74, 0.681) !important;
  color: var(--cui-secondary-color) !important; }

.text-black-50 {
  --cui-text-opacity: 1;
  color: rgba(0, 0, 21, 0.5) !important; }

.text-white-50 {
  --cui-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important; }

.text-body-secondary {
  --cui-text-opacity: 1;
  color: rgba(44, 56, 74, 0.681) !important;
  color: var(--cui-secondary-color) !important; }

.text-body-tertiary {
  --cui-text-opacity: 1;
  color: rgba(44, 56, 74, 0.38) !important;
  color: var(--cui-tertiary-color) !important; }

.text-body-emphasis {
  --cui-text-opacity: 1;
  color: #000015 !important;
  color: var(--cui-emphasis-color) !important; }

.text-reset {
  --cui-text-opacity: 1;
  color: inherit !important; }

.text-high-emphasis-inverse {
  --cui-text-opacity: 1;
  color: rgba(255, 255, 255, 0.87) !important;
  color: var(--cui-high-emphasis-inverse) !important; }

.text-medium-emphasis-inverse {
  --cui-text-opacity: 1;
  color: rgba(255, 255, 255, 0.6) !important;
  color: var(--cui-medium-emphasis-inverse) !important; }

.text-disabled-inverse {
  --cui-text-opacity: 1;
  color: rgba(255, 255, 255, 0.38) !important;
  color: var(--cui-disabled-inverse) !important; }

.text-high-emphasis {
  --cui-text-opacity: 1;
  color: rgba(44, 56, 74, 0.95) !important;
  color: var(--cui-high-emphasis) !important; }

.text-medium-emphasis {
  --cui-text-opacity: 1;
  color: rgba(44, 56, 74, 0.681) !important;
  color: var(--cui-medium-emphasis) !important; }

.text-disabled {
  --cui-text-opacity: 1;
  color: rgba(44, 56, 74, 0.38) !important;
  color: var(--cui-disabled) !important; }

.text-opacity-25 {
  --cui-text-opacity: 0.25; }

.text-opacity-50 {
  --cui-text-opacity: 0.5; }

.text-opacity-75 {
  --cui-text-opacity: 0.75; }

.text-opacity-100 {
  --cui-text-opacity: 1; }

.link-opacity-10 {
  --cui-link-opacity: 0.1; }

.link-opacity-10-hover:hover {
  --cui-link-opacity: 0.1; }

.link-opacity-25 {
  --cui-link-opacity: 0.25; }

.link-opacity-25-hover:hover {
  --cui-link-opacity: 0.25; }

.link-opacity-50 {
  --cui-link-opacity: 0.5; }

.link-opacity-50-hover:hover {
  --cui-link-opacity: 0.5; }

.link-opacity-75 {
  --cui-link-opacity: 0.75; }

.link-opacity-75-hover:hover {
  --cui-link-opacity: 0.75; }

.link-opacity-100 {
  --cui-link-opacity: 1; }

.link-opacity-100-hover:hover {
  --cui-link-opacity: 1; }

.link-offset-1 {
  text-underline-offset: 0.125em !important; }

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important; }

.link-offset-2 {
  text-underline-offset: 0.25em !important; }

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important; }

.link-offset-3 {
  text-underline-offset: 0.375em !important; }

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important; }

.link-underline-primary {
  --cui-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(50, 31, 219, var(--cui-link-underline-opacity)) !important;
          text-decoration-color: rgba(50, 31, 219, var(--cui-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--cui-primary-rgb), var(--cui-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--cui-primary-rgb), var(--cui-link-underline-opacity)) !important; }

.link-underline-secondary {
  --cui-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(157, 165, 177, var(--cui-link-underline-opacity)) !important;
          text-decoration-color: rgba(157, 165, 177, var(--cui-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--cui-secondary-rgb), var(--cui-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--cui-secondary-rgb), var(--cui-link-underline-opacity)) !important; }

.link-underline-success {
  --cui-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(46, 184, 92, var(--cui-link-underline-opacity)) !important;
          text-decoration-color: rgba(46, 184, 92, var(--cui-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--cui-success-rgb), var(--cui-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--cui-success-rgb), var(--cui-link-underline-opacity)) !important; }

.link-underline-info {
  --cui-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(51, 153, 255, var(--cui-link-underline-opacity)) !important;
          text-decoration-color: rgba(51, 153, 255, var(--cui-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--cui-info-rgb), var(--cui-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--cui-info-rgb), var(--cui-link-underline-opacity)) !important; }

.link-underline-warning {
  --cui-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(249, 177, 21, var(--cui-link-underline-opacity)) !important;
          text-decoration-color: rgba(249, 177, 21, var(--cui-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--cui-warning-rgb), var(--cui-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--cui-warning-rgb), var(--cui-link-underline-opacity)) !important; }

.link-underline-danger {
  --cui-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(229, 83, 83, var(--cui-link-underline-opacity)) !important;
          text-decoration-color: rgba(229, 83, 83, var(--cui-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--cui-danger-rgb), var(--cui-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--cui-danger-rgb), var(--cui-link-underline-opacity)) !important; }

.link-underline-light {
  --cui-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(235, 237, 239, var(--cui-link-underline-opacity)) !important;
          text-decoration-color: rgba(235, 237, 239, var(--cui-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--cui-light-rgb), var(--cui-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--cui-light-rgb), var(--cui-link-underline-opacity)) !important; }

.link-underline-dark {
  --cui-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(79, 93, 115, var(--cui-link-underline-opacity)) !important;
          text-decoration-color: rgba(79, 93, 115, var(--cui-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--cui-dark-rgb), var(--cui-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--cui-dark-rgb), var(--cui-link-underline-opacity)) !important; }

.link-underline {
  --cui-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(50, 31, 219, 1) !important;
          text-decoration-color: rgba(50, 31, 219, 1) !important;
  -webkit-text-decoration-color: rgba(var(--cui-link-color-rgb), var(--cui-link-underline-opacity, 1)) !important;
          text-decoration-color: rgba(var(--cui-link-color-rgb), var(--cui-link-underline-opacity, 1)) !important; }

.link-underline-opacity-0 {
  --cui-link-underline-opacity: 0; }

.link-underline-opacity-0-hover:hover {
  --cui-link-underline-opacity: 0; }

.link-underline-opacity-10 {
  --cui-link-underline-opacity: 0.1; }

.link-underline-opacity-10-hover:hover {
  --cui-link-underline-opacity: 0.1; }

.link-underline-opacity-25 {
  --cui-link-underline-opacity: 0.25; }

.link-underline-opacity-25-hover:hover {
  --cui-link-underline-opacity: 0.25; }

.link-underline-opacity-50 {
  --cui-link-underline-opacity: 0.5; }

.link-underline-opacity-50-hover:hover {
  --cui-link-underline-opacity: 0.5; }

.link-underline-opacity-75 {
  --cui-link-underline-opacity: 0.75; }

.link-underline-opacity-75-hover:hover {
  --cui-link-underline-opacity: 0.75; }

.link-underline-opacity-100 {
  --cui-link-underline-opacity: 1; }

.link-underline-opacity-100-hover:hover {
  --cui-link-underline-opacity: 1; }

.bg-primary {
  --cui-bg-opacity: 1;
  background-color: rgba(50, 31, 219, var(--cui-bg-opacity)) !important;
  background-color: rgba(var(--cui-primary-rgb), var(--cui-bg-opacity)) !important; }

.bg-secondary {
  --cui-bg-opacity: 1;
  background-color: rgba(157, 165, 177, var(--cui-bg-opacity)) !important;
  background-color: rgba(var(--cui-secondary-rgb), var(--cui-bg-opacity)) !important; }

.bg-success {
  --cui-bg-opacity: 1;
  background-color: rgba(46, 184, 92, var(--cui-bg-opacity)) !important;
  background-color: rgba(var(--cui-success-rgb), var(--cui-bg-opacity)) !important; }

.bg-info {
  --cui-bg-opacity: 1;
  background-color: rgba(51, 153, 255, var(--cui-bg-opacity)) !important;
  background-color: rgba(var(--cui-info-rgb), var(--cui-bg-opacity)) !important; }

.bg-warning {
  --cui-bg-opacity: 1;
  background-color: rgba(249, 177, 21, var(--cui-bg-opacity)) !important;
  background-color: rgba(var(--cui-warning-rgb), var(--cui-bg-opacity)) !important; }

.bg-danger {
  --cui-bg-opacity: 1;
  background-color: rgba(229, 83, 83, var(--cui-bg-opacity)) !important;
  background-color: rgba(var(--cui-danger-rgb), var(--cui-bg-opacity)) !important; }

.bg-light {
  --cui-bg-opacity: 1;
  background-color: rgba(235, 237, 239, var(--cui-bg-opacity)) !important;
  background-color: rgba(var(--cui-light-rgb), var(--cui-bg-opacity)) !important; }

.bg-dark {
  --cui-bg-opacity: 1;
  background-color: rgba(79, 93, 115, var(--cui-bg-opacity)) !important;
  background-color: rgba(var(--cui-dark-rgb), var(--cui-bg-opacity)) !important; }

.bg-black {
  --cui-bg-opacity: 1;
  background-color: rgba(0, 0, 21, var(--cui-bg-opacity)) !important;
  background-color: rgba(var(--cui-black-rgb), var(--cui-bg-opacity)) !important; }

.bg-white {
  --cui-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--cui-bg-opacity)) !important;
  background-color: rgba(var(--cui-white-rgb), var(--cui-bg-opacity)) !important; }

.bg-body {
  --cui-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--cui-bg-opacity)) !important;
  background-color: rgba(var(--cui-body-bg-rgb), var(--cui-bg-opacity)) !important; }

.bg-transparent {
  --cui-bg-opacity: 1;
  background-color: transparent !important; }

.bg-body-secondary {
  --cui-bg-opacity: 1;
  background-color: rgba(216, 219, 224, var(--cui-bg-opacity)) !important;
  background-color: rgba(var(--cui-secondary-bg-rgb), var(--cui-bg-opacity)) !important; }

.bg-body-tertiary {
  --cui-bg-opacity: 1;
  background-color: rgba(235, 237, 239, var(--cui-bg-opacity)) !important;
  background-color: rgba(var(--cui-tertiary-bg-rgb), var(--cui-bg-opacity)) !important; }

.bg-opacity-10 {
  --cui-bg-opacity: 0.1; }

.bg-opacity-25 {
  --cui-bg-opacity: 0.25; }

.bg-opacity-50 {
  --cui-bg-opacity: 0.5; }

.bg-opacity-75 {
  --cui-bg-opacity: 0.75; }

.bg-opacity-100 {
  --cui-bg-opacity: 1; }

.bg-gradient {
  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0)) !important;
  background-image: var(--cui-gradient) !important; }

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important; }

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important; }

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important; }

.pe-none {
  pointer-events: none !important; }

.pe-auto {
  pointer-events: auto !important; }

.rounded {
  border-radius: 0.375rem !important;
  border-radius: var(--cui-border-radius) !important; }

.rounded-0 {
  border-radius: 0 !important; }

.rounded-1 {
  border-radius: 0.25rem !important;
  border-radius: var(--cui-border-radius-sm) !important; }

.rounded-2 {
  border-radius: 0.375rem !important;
  border-radius: var(--cui-border-radius) !important; }

.rounded-3 {
  border-radius: 0.5rem !important;
  border-radius: var(--cui-border-radius-lg) !important; }

.rounded-4 {
  border-radius: 1rem !important;
  border-radius: var(--cui-border-radius-xl) !important; }

.rounded-5 {
  border-radius: 2rem !important;
  border-radius: var(--cui-border-radius-xxl) !important; }

.rounded-circle {
  border-radius: 50% !important; }

.rounded-pill {
  border-radius: 50rem !important;
  border-radius: var(--cui-border-radius-pill) !important; }

.rounded-top {
  border-top-left-radius: 0.375rem !important;
  border-top-left-radius: var(--cui-border-radius) !important;
  border-top-right-radius: 0.375rem !important;
  border-top-right-radius: var(--cui-border-radius) !important; }

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important; }

.rounded-top-1 {
  border-top-left-radius: 0.25rem !important;
  border-top-left-radius: var(--cui-border-radius-sm) !important;
  border-top-right-radius: 0.25rem !important;
  border-top-right-radius: var(--cui-border-radius-sm) !important; }

.rounded-top-2 {
  border-top-left-radius: 0.375rem !important;
  border-top-left-radius: var(--cui-border-radius) !important;
  border-top-right-radius: 0.375rem !important;
  border-top-right-radius: var(--cui-border-radius) !important; }

.rounded-top-3 {
  border-top-left-radius: 0.5rem !important;
  border-top-left-radius: var(--cui-border-radius-lg) !important;
  border-top-right-radius: 0.5rem !important;
  border-top-right-radius: var(--cui-border-radius-lg) !important; }

.rounded-top-4 {
  border-top-left-radius: 1rem !important;
  border-top-left-radius: var(--cui-border-radius-xl) !important;
  border-top-right-radius: 1rem !important;
  border-top-right-radius: var(--cui-border-radius-xl) !important; }

.rounded-top-5 {
  border-top-left-radius: 2rem !important;
  border-top-left-radius: var(--cui-border-radius-xxl) !important;
  border-top-right-radius: 2rem !important;
  border-top-right-radius: var(--cui-border-radius-xxl) !important; }

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important; }

.rounded-top-pill {
  border-top-left-radius: 50rem !important;
  border-top-left-radius: var(--cui-border-radius-pill) !important;
  border-top-right-radius: 50rem !important;
  border-top-right-radius: var(--cui-border-radius-pill) !important; }

html:not([dir="rtl"]) .rounded-end {
  border-top-right-radius: 0.375rem !important;
  border-top-right-radius: var(--cui-border-radius) !important; }

*[dir="rtl"] .rounded-end {
  border-top-left-radius: 0.375rem !important;
  border-top-left-radius: var(--cui-border-radius) !important; }

html:not([dir="rtl"]) .rounded-end {
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-right-radius: var(--cui-border-radius) !important; }

*[dir="rtl"] .rounded-end {
  border-bottom-left-radius: 0.375rem !important;
  border-bottom-left-radius: var(--cui-border-radius) !important; }

html:not([dir="rtl"]) .rounded-end-0 {
  border-top-right-radius: 0 !important; }

*[dir="rtl"] .rounded-end-0 {
  border-top-left-radius: 0 !important; }

html:not([dir="rtl"]) .rounded-end-0 {
  border-bottom-right-radius: 0 !important; }

*[dir="rtl"] .rounded-end-0 {
  border-bottom-left-radius: 0 !important; }

html:not([dir="rtl"]) .rounded-end-1 {
  border-top-right-radius: 0.25rem !important;
  border-top-right-radius: var(--cui-border-radius-sm) !important; }

*[dir="rtl"] .rounded-end-1 {
  border-top-left-radius: 0.25rem !important;
  border-top-left-radius: var(--cui-border-radius-sm) !important; }

html:not([dir="rtl"]) .rounded-end-1 {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-right-radius: var(--cui-border-radius-sm) !important; }

*[dir="rtl"] .rounded-end-1 {
  border-bottom-left-radius: 0.25rem !important;
  border-bottom-left-radius: var(--cui-border-radius-sm) !important; }

html:not([dir="rtl"]) .rounded-end-2 {
  border-top-right-radius: 0.375rem !important;
  border-top-right-radius: var(--cui-border-radius) !important; }

*[dir="rtl"] .rounded-end-2 {
  border-top-left-radius: 0.375rem !important;
  border-top-left-radius: var(--cui-border-radius) !important; }

html:not([dir="rtl"]) .rounded-end-2 {
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-right-radius: var(--cui-border-radius) !important; }

*[dir="rtl"] .rounded-end-2 {
  border-bottom-left-radius: 0.375rem !important;
  border-bottom-left-radius: var(--cui-border-radius) !important; }

html:not([dir="rtl"]) .rounded-end-3 {
  border-top-right-radius: 0.5rem !important;
  border-top-right-radius: var(--cui-border-radius-lg) !important; }

*[dir="rtl"] .rounded-end-3 {
  border-top-left-radius: 0.5rem !important;
  border-top-left-radius: var(--cui-border-radius-lg) !important; }

html:not([dir="rtl"]) .rounded-end-3 {
  border-bottom-right-radius: 0.5rem !important;
  border-bottom-right-radius: var(--cui-border-radius-lg) !important; }

*[dir="rtl"] .rounded-end-3 {
  border-bottom-left-radius: 0.5rem !important;
  border-bottom-left-radius: var(--cui-border-radius-lg) !important; }

html:not([dir="rtl"]) .rounded-end-4 {
  border-top-right-radius: 1rem !important;
  border-top-right-radius: var(--cui-border-radius-xl) !important; }

*[dir="rtl"] .rounded-end-4 {
  border-top-left-radius: 1rem !important;
  border-top-left-radius: var(--cui-border-radius-xl) !important; }

html:not([dir="rtl"]) .rounded-end-4 {
  border-bottom-right-radius: 1rem !important;
  border-bottom-right-radius: var(--cui-border-radius-xl) !important; }

*[dir="rtl"] .rounded-end-4 {
  border-bottom-left-radius: 1rem !important;
  border-bottom-left-radius: var(--cui-border-radius-xl) !important; }

html:not([dir="rtl"]) .rounded-end-5 {
  border-top-right-radius: 2rem !important;
  border-top-right-radius: var(--cui-border-radius-xxl) !important; }

*[dir="rtl"] .rounded-end-5 {
  border-top-left-radius: 2rem !important;
  border-top-left-radius: var(--cui-border-radius-xxl) !important; }

html:not([dir="rtl"]) .rounded-end-5 {
  border-bottom-right-radius: 2rem !important;
  border-bottom-right-radius: var(--cui-border-radius-xxl) !important; }

*[dir="rtl"] .rounded-end-5 {
  border-bottom-left-radius: 2rem !important;
  border-bottom-left-radius: var(--cui-border-radius-xxl) !important; }

html:not([dir="rtl"]) .rounded-end-circle {
  border-top-right-radius: 50% !important; }

*[dir="rtl"] .rounded-end-circle {
  border-top-left-radius: 50% !important; }

html:not([dir="rtl"]) .rounded-end-circle {
  border-bottom-right-radius: 50% !important; }

*[dir="rtl"] .rounded-end-circle {
  border-bottom-left-radius: 50% !important; }

html:not([dir="rtl"]) .rounded-end-pill {
  border-top-right-radius: 50rem !important;
  border-top-right-radius: var(--cui-border-radius-pill) !important; }

*[dir="rtl"] .rounded-end-pill {
  border-top-left-radius: 50rem !important;
  border-top-left-radius: var(--cui-border-radius-pill) !important; }

html:not([dir="rtl"]) .rounded-end-pill {
  border-bottom-right-radius: 50rem !important;
  border-bottom-right-radius: var(--cui-border-radius-pill) !important; }

*[dir="rtl"] .rounded-end-pill {
  border-bottom-left-radius: 50rem !important;
  border-bottom-left-radius: var(--cui-border-radius-pill) !important; }

.rounded-bottom {
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-right-radius: var(--cui-border-radius) !important;
  border-bottom-left-radius: 0.375rem !important;
  border-bottom-left-radius: var(--cui-border-radius) !important; }

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important; }

.rounded-bottom-1 {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-right-radius: var(--cui-border-radius-sm) !important;
  border-bottom-left-radius: 0.25rem !important;
  border-bottom-left-radius: var(--cui-border-radius-sm) !important; }

.rounded-bottom-2 {
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-right-radius: var(--cui-border-radius) !important;
  border-bottom-left-radius: 0.375rem !important;
  border-bottom-left-radius: var(--cui-border-radius) !important; }

.rounded-bottom-3 {
  border-bottom-right-radius: 0.5rem !important;
  border-bottom-right-radius: var(--cui-border-radius-lg) !important;
  border-bottom-left-radius: 0.5rem !important;
  border-bottom-left-radius: var(--cui-border-radius-lg) !important; }

.rounded-bottom-4 {
  border-bottom-right-radius: 1rem !important;
  border-bottom-right-radius: var(--cui-border-radius-xl) !important;
  border-bottom-left-radius: 1rem !important;
  border-bottom-left-radius: var(--cui-border-radius-xl) !important; }

.rounded-bottom-5 {
  border-bottom-right-radius: 2rem !important;
  border-bottom-right-radius: var(--cui-border-radius-xxl) !important;
  border-bottom-left-radius: 2rem !important;
  border-bottom-left-radius: var(--cui-border-radius-xxl) !important; }

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important; }

.rounded-bottom-pill {
  border-bottom-right-radius: 50rem !important;
  border-bottom-right-radius: var(--cui-border-radius-pill) !important;
  border-bottom-left-radius: 50rem !important;
  border-bottom-left-radius: var(--cui-border-radius-pill) !important; }

html:not([dir="rtl"]) .rounded-start {
  border-bottom-left-radius: 0.375rem !important;
  border-bottom-left-radius: var(--cui-border-radius) !important; }

*[dir="rtl"] .rounded-start {
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-right-radius: var(--cui-border-radius) !important; }

html:not([dir="rtl"]) .rounded-start {
  border-top-left-radius: 0.375rem !important;
  border-top-left-radius: var(--cui-border-radius) !important; }

*[dir="rtl"] .rounded-start {
  border-top-right-radius: 0.375rem !important;
  border-top-right-radius: var(--cui-border-radius) !important; }

html:not([dir="rtl"]) .rounded-start-0 {
  border-bottom-left-radius: 0 !important; }

*[dir="rtl"] .rounded-start-0 {
  border-bottom-right-radius: 0 !important; }

html:not([dir="rtl"]) .rounded-start-0 {
  border-top-left-radius: 0 !important; }

*[dir="rtl"] .rounded-start-0 {
  border-top-right-radius: 0 !important; }

html:not([dir="rtl"]) .rounded-start-1 {
  border-bottom-left-radius: 0.25rem !important;
  border-bottom-left-radius: var(--cui-border-radius-sm) !important; }

*[dir="rtl"] .rounded-start-1 {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-right-radius: var(--cui-border-radius-sm) !important; }

html:not([dir="rtl"]) .rounded-start-1 {
  border-top-left-radius: 0.25rem !important;
  border-top-left-radius: var(--cui-border-radius-sm) !important; }

*[dir="rtl"] .rounded-start-1 {
  border-top-right-radius: 0.25rem !important;
  border-top-right-radius: var(--cui-border-radius-sm) !important; }

html:not([dir="rtl"]) .rounded-start-2 {
  border-bottom-left-radius: 0.375rem !important;
  border-bottom-left-radius: var(--cui-border-radius) !important; }

*[dir="rtl"] .rounded-start-2 {
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-right-radius: var(--cui-border-radius) !important; }

html:not([dir="rtl"]) .rounded-start-2 {
  border-top-left-radius: 0.375rem !important;
  border-top-left-radius: var(--cui-border-radius) !important; }

*[dir="rtl"] .rounded-start-2 {
  border-top-right-radius: 0.375rem !important;
  border-top-right-radius: var(--cui-border-radius) !important; }

html:not([dir="rtl"]) .rounded-start-3 {
  border-bottom-left-radius: 0.5rem !important;
  border-bottom-left-radius: var(--cui-border-radius-lg) !important; }

*[dir="rtl"] .rounded-start-3 {
  border-bottom-right-radius: 0.5rem !important;
  border-bottom-right-radius: var(--cui-border-radius-lg) !important; }

html:not([dir="rtl"]) .rounded-start-3 {
  border-top-left-radius: 0.5rem !important;
  border-top-left-radius: var(--cui-border-radius-lg) !important; }

*[dir="rtl"] .rounded-start-3 {
  border-top-right-radius: 0.5rem !important;
  border-top-right-radius: var(--cui-border-radius-lg) !important; }

html:not([dir="rtl"]) .rounded-start-4 {
  border-bottom-left-radius: 1rem !important;
  border-bottom-left-radius: var(--cui-border-radius-xl) !important; }

*[dir="rtl"] .rounded-start-4 {
  border-bottom-right-radius: 1rem !important;
  border-bottom-right-radius: var(--cui-border-radius-xl) !important; }

html:not([dir="rtl"]) .rounded-start-4 {
  border-top-left-radius: 1rem !important;
  border-top-left-radius: var(--cui-border-radius-xl) !important; }

*[dir="rtl"] .rounded-start-4 {
  border-top-right-radius: 1rem !important;
  border-top-right-radius: var(--cui-border-radius-xl) !important; }

html:not([dir="rtl"]) .rounded-start-5 {
  border-bottom-left-radius: 2rem !important;
  border-bottom-left-radius: var(--cui-border-radius-xxl) !important; }

*[dir="rtl"] .rounded-start-5 {
  border-bottom-right-radius: 2rem !important;
  border-bottom-right-radius: var(--cui-border-radius-xxl) !important; }

html:not([dir="rtl"]) .rounded-start-5 {
  border-top-left-radius: 2rem !important;
  border-top-left-radius: var(--cui-border-radius-xxl) !important; }

*[dir="rtl"] .rounded-start-5 {
  border-top-right-radius: 2rem !important;
  border-top-right-radius: var(--cui-border-radius-xxl) !important; }

html:not([dir="rtl"]) .rounded-start-circle {
  border-bottom-left-radius: 50% !important; }

*[dir="rtl"] .rounded-start-circle {
  border-bottom-right-radius: 50% !important; }

html:not([dir="rtl"]) .rounded-start-circle {
  border-top-left-radius: 50% !important; }

*[dir="rtl"] .rounded-start-circle {
  border-top-right-radius: 50% !important; }

html:not([dir="rtl"]) .rounded-start-pill {
  border-bottom-left-radius: 50rem !important;
  border-bottom-left-radius: var(--cui-border-radius-pill) !important; }

*[dir="rtl"] .rounded-start-pill {
  border-bottom-right-radius: 50rem !important;
  border-bottom-right-radius: var(--cui-border-radius-pill) !important; }

html:not([dir="rtl"]) .rounded-start-pill {
  border-top-left-radius: 50rem !important;
  border-top-left-radius: var(--cui-border-radius-pill) !important; }

*[dir="rtl"] .rounded-start-pill {
  border-top-right-radius: 50rem !important;
  border-top-right-radius: var(--cui-border-radius-pill) !important; }

.visible {
  visibility: visible !important; }

.invisible {
  visibility: hidden !important; }

.z-n1 {
  z-index: -1 !important; }

.z-0 {
  z-index: 0 !important; }

.z-1 {
  z-index: 1 !important; }

.z-2 {
  z-index: 2 !important; }

.z-3 {
  z-index: 3 !important; }

@media (min-width: 576px) {
  html:not([dir="rtl"]) .float-sm-start {
    float: left !important; }
  *[dir="rtl"] .float-sm-start {
    float: right !important; }
  html:not([dir="rtl"]) .float-sm-end {
    float: right !important; }
  *[dir="rtl"] .float-sm-end {
    float: left !important; }
  html:not([dir="rtl"]) .float-sm-none {
    float: none !important; }
  *[dir="rtl"] .float-sm-none {
    float: none !important; }
  .object-fit-sm-contain {
    object-fit: contain !important; }
  .object-fit-sm-cover {
    object-fit: cover !important; }
  .object-fit-sm-fill {
    object-fit: fill !important; }
  .object-fit-sm-scale {
    object-fit: scale-down !important; }
  .object-fit-sm-none {
    object-fit: none !important; }
  .d-sm-inline {
    display: inline !important; }
  .d-sm-inline-block {
    display: inline-block !important; }
  .d-sm-block {
    display: block !important; }
  .d-sm-grid {
    display: grid !important; }
  .d-sm-inline-grid {
    display: inline-grid !important; }
  .d-sm-table {
    display: table !important; }
  .d-sm-table-row {
    display: table-row !important; }
  .d-sm-table-cell {
    display: table-cell !important; }
  .d-sm-flex {
    display: flex !important; }
  .d-sm-inline-flex {
    display: inline-flex !important; }
  .d-sm-none {
    display: none !important; }
  .flex-sm-fill {
    flex: 1 1 auto !important; }
  .flex-sm-row {
    flex-direction: row !important; }
  .flex-sm-column {
    flex-direction: column !important; }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-sm-grow-0 {
    flex-grow: 0 !important; }
  .flex-sm-grow-1 {
    flex-grow: 1 !important; }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-sm-wrap {
    flex-wrap: wrap !important; }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important; }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-sm-start {
    justify-content: flex-start !important; }
  .justify-content-sm-end {
    justify-content: flex-end !important; }
  .justify-content-sm-center {
    justify-content: center !important; }
  .justify-content-sm-between {
    justify-content: space-between !important; }
  .justify-content-sm-around {
    justify-content: space-around !important; }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important; }
  .align-items-sm-start {
    align-items: flex-start !important; }
  .align-items-sm-end {
    align-items: flex-end !important; }
  .align-items-sm-center {
    align-items: center !important; }
  .align-items-sm-baseline {
    align-items: baseline !important; }
  .align-items-sm-stretch {
    align-items: stretch !important; }
  .align-content-sm-start {
    align-content: flex-start !important; }
  .align-content-sm-end {
    align-content: flex-end !important; }
  .align-content-sm-center {
    align-content: center !important; }
  .align-content-sm-between {
    align-content: space-between !important; }
  .align-content-sm-around {
    align-content: space-around !important; }
  .align-content-sm-stretch {
    align-content: stretch !important; }
  .align-self-sm-auto {
    align-self: auto !important; }
  .align-self-sm-start {
    align-self: flex-start !important; }
  .align-self-sm-end {
    align-self: flex-end !important; }
  .align-self-sm-center {
    align-self: center !important; }
  .align-self-sm-baseline {
    align-self: baseline !important; }
  .align-self-sm-stretch {
    align-self: stretch !important; }
  .order-sm-first {
    order: -1 !important; }
  .order-sm-0 {
    order: 0 !important; }
  .order-sm-1 {
    order: 1 !important; }
  .order-sm-2 {
    order: 2 !important; }
  .order-sm-3 {
    order: 3 !important; }
  .order-sm-4 {
    order: 4 !important; }
  .order-sm-5 {
    order: 5 !important; }
  .order-sm-last {
    order: 6 !important; }
  .m-sm-0 {
    margin: 0 !important; }
  .m-sm-1 {
    margin: 0.25rem !important; }
  .m-sm-2 {
    margin: 0.5rem !important; }
  .m-sm-3 {
    margin: 1rem !important; }
  .m-sm-4 {
    margin: 1.5rem !important; }
  .m-sm-5 {
    margin: 3rem !important; }
  .m-sm-auto {
    margin: auto !important; }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-sm-0 {
    margin-top: 0 !important; }
  .mt-sm-1 {
    margin-top: 0.25rem !important; }
  .mt-sm-2 {
    margin-top: 0.5rem !important; }
  .mt-sm-3 {
    margin-top: 1rem !important; }
  .mt-sm-4 {
    margin-top: 1.5rem !important; }
  .mt-sm-5 {
    margin-top: 3rem !important; }
  .mt-sm-auto {
    margin-top: auto !important; }
  html:not([dir="rtl"]) .me-sm-0 {
    margin-right: 0 !important; }
  *[dir="rtl"] .me-sm-0 {
    margin-left: 0 !important; }
  html:not([dir="rtl"]) .me-sm-1 {
    margin-right: 0.25rem !important; }
  *[dir="rtl"] .me-sm-1 {
    margin-left: 0.25rem !important; }
  html:not([dir="rtl"]) .me-sm-2 {
    margin-right: 0.5rem !important; }
  *[dir="rtl"] .me-sm-2 {
    margin-left: 0.5rem !important; }
  html:not([dir="rtl"]) .me-sm-3 {
    margin-right: 1rem !important; }
  *[dir="rtl"] .me-sm-3 {
    margin-left: 1rem !important; }
  html:not([dir="rtl"]) .me-sm-4 {
    margin-right: 1.5rem !important; }
  *[dir="rtl"] .me-sm-4 {
    margin-left: 1.5rem !important; }
  html:not([dir="rtl"]) .me-sm-5 {
    margin-right: 3rem !important; }
  *[dir="rtl"] .me-sm-5 {
    margin-left: 3rem !important; }
  html:not([dir="rtl"]) .me-sm-auto {
    margin-right: auto !important; }
  *[dir="rtl"] .me-sm-auto {
    margin-left: auto !important; }
  .mb-sm-0 {
    margin-bottom: 0 !important; }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important; }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important; }
  .mb-sm-3 {
    margin-bottom: 1rem !important; }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important; }
  .mb-sm-5 {
    margin-bottom: 3rem !important; }
  .mb-sm-auto {
    margin-bottom: auto !important; }
  html:not([dir="rtl"]) .ms-sm-0 {
    margin-left: 0 !important; }
  *[dir="rtl"] .ms-sm-0 {
    margin-right: 0 !important; }
  html:not([dir="rtl"]) .ms-sm-1 {
    margin-left: 0.25rem !important; }
  *[dir="rtl"] .ms-sm-1 {
    margin-right: 0.25rem !important; }
  html:not([dir="rtl"]) .ms-sm-2 {
    margin-left: 0.5rem !important; }
  *[dir="rtl"] .ms-sm-2 {
    margin-right: 0.5rem !important; }
  html:not([dir="rtl"]) .ms-sm-3 {
    margin-left: 1rem !important; }
  *[dir="rtl"] .ms-sm-3 {
    margin-right: 1rem !important; }
  html:not([dir="rtl"]) .ms-sm-4 {
    margin-left: 1.5rem !important; }
  *[dir="rtl"] .ms-sm-4 {
    margin-right: 1.5rem !important; }
  html:not([dir="rtl"]) .ms-sm-5 {
    margin-left: 3rem !important; }
  *[dir="rtl"] .ms-sm-5 {
    margin-right: 3rem !important; }
  html:not([dir="rtl"]) .ms-sm-auto {
    margin-left: auto !important; }
  *[dir="rtl"] .ms-sm-auto {
    margin-right: auto !important; }
  .p-sm-0 {
    padding: 0 !important; }
  .p-sm-1 {
    padding: 0.25rem !important; }
  .p-sm-2 {
    padding: 0.5rem !important; }
  .p-sm-3 {
    padding: 1rem !important; }
  .p-sm-4 {
    padding: 1.5rem !important; }
  .p-sm-5 {
    padding: 3rem !important; }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-sm-0 {
    padding-top: 0 !important; }
  .pt-sm-1 {
    padding-top: 0.25rem !important; }
  .pt-sm-2 {
    padding-top: 0.5rem !important; }
  .pt-sm-3 {
    padding-top: 1rem !important; }
  .pt-sm-4 {
    padding-top: 1.5rem !important; }
  .pt-sm-5 {
    padding-top: 3rem !important; }
  html:not([dir="rtl"]) .pe-sm-0 {
    padding-right: 0 !important; }
  *[dir="rtl"] .pe-sm-0 {
    padding-left: 0 !important; }
  html:not([dir="rtl"]) .pe-sm-1 {
    padding-right: 0.25rem !important; }
  *[dir="rtl"] .pe-sm-1 {
    padding-left: 0.25rem !important; }
  html:not([dir="rtl"]) .pe-sm-2 {
    padding-right: 0.5rem !important; }
  *[dir="rtl"] .pe-sm-2 {
    padding-left: 0.5rem !important; }
  html:not([dir="rtl"]) .pe-sm-3 {
    padding-right: 1rem !important; }
  *[dir="rtl"] .pe-sm-3 {
    padding-left: 1rem !important; }
  html:not([dir="rtl"]) .pe-sm-4 {
    padding-right: 1.5rem !important; }
  *[dir="rtl"] .pe-sm-4 {
    padding-left: 1.5rem !important; }
  html:not([dir="rtl"]) .pe-sm-5 {
    padding-right: 3rem !important; }
  *[dir="rtl"] .pe-sm-5 {
    padding-left: 3rem !important; }
  .pb-sm-0 {
    padding-bottom: 0 !important; }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important; }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important; }
  .pb-sm-3 {
    padding-bottom: 1rem !important; }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important; }
  .pb-sm-5 {
    padding-bottom: 3rem !important; }
  html:not([dir="rtl"]) .ps-sm-0 {
    padding-left: 0 !important; }
  *[dir="rtl"] .ps-sm-0 {
    padding-right: 0 !important; }
  html:not([dir="rtl"]) .ps-sm-1 {
    padding-left: 0.25rem !important; }
  *[dir="rtl"] .ps-sm-1 {
    padding-right: 0.25rem !important; }
  html:not([dir="rtl"]) .ps-sm-2 {
    padding-left: 0.5rem !important; }
  *[dir="rtl"] .ps-sm-2 {
    padding-right: 0.5rem !important; }
  html:not([dir="rtl"]) .ps-sm-3 {
    padding-left: 1rem !important; }
  *[dir="rtl"] .ps-sm-3 {
    padding-right: 1rem !important; }
  html:not([dir="rtl"]) .ps-sm-4 {
    padding-left: 1.5rem !important; }
  *[dir="rtl"] .ps-sm-4 {
    padding-right: 1.5rem !important; }
  html:not([dir="rtl"]) .ps-sm-5 {
    padding-left: 3rem !important; }
  *[dir="rtl"] .ps-sm-5 {
    padding-right: 3rem !important; }
  .gap-sm-0 {
    gap: 0 !important; }
  .gap-sm-1 {
    gap: 0.25rem !important; }
  .gap-sm-2 {
    gap: 0.5rem !important; }
  .gap-sm-3 {
    gap: 1rem !important; }
  .gap-sm-4 {
    gap: 1.5rem !important; }
  .gap-sm-5 {
    gap: 3rem !important; }
  .row-gap-sm-0 {
    row-gap: 0 !important; }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important; }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important; }
  .row-gap-sm-3 {
    row-gap: 1rem !important; }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important; }
  .row-gap-sm-5 {
    row-gap: 3rem !important; }
  .column-gap-sm-0 {
    column-gap: 0 !important; }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important; }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important; }
  .column-gap-sm-3 {
    column-gap: 1rem !important; }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important; }
  .column-gap-sm-5 {
    column-gap: 3rem !important; }
  html:not([dir="rtl"]) .text-sm-start {
    text-align: left !important; }
  *[dir="rtl"] .text-sm-start {
    text-align: right !important; }
  html:not([dir="rtl"]) .text-sm-end {
    text-align: right !important; }
  *[dir="rtl"] .text-sm-end {
    text-align: left !important; }
  html:not([dir="rtl"]) .text-sm-center {
    text-align: center !important; }
  *[dir="rtl"] .text-sm-center {
    text-align: center !important; } }

@media (min-width: 768px) {
  html:not([dir="rtl"]) .float-md-start {
    float: left !important; }
  *[dir="rtl"] .float-md-start {
    float: right !important; }
  html:not([dir="rtl"]) .float-md-end {
    float: right !important; }
  *[dir="rtl"] .float-md-end {
    float: left !important; }
  html:not([dir="rtl"]) .float-md-none {
    float: none !important; }
  *[dir="rtl"] .float-md-none {
    float: none !important; }
  .object-fit-md-contain {
    object-fit: contain !important; }
  .object-fit-md-cover {
    object-fit: cover !important; }
  .object-fit-md-fill {
    object-fit: fill !important; }
  .object-fit-md-scale {
    object-fit: scale-down !important; }
  .object-fit-md-none {
    object-fit: none !important; }
  .d-md-inline {
    display: inline !important; }
  .d-md-inline-block {
    display: inline-block !important; }
  .d-md-block {
    display: block !important; }
  .d-md-grid {
    display: grid !important; }
  .d-md-inline-grid {
    display: inline-grid !important; }
  .d-md-table {
    display: table !important; }
  .d-md-table-row {
    display: table-row !important; }
  .d-md-table-cell {
    display: table-cell !important; }
  .d-md-flex {
    display: flex !important; }
  .d-md-inline-flex {
    display: inline-flex !important; }
  .d-md-none {
    display: none !important; }
  .flex-md-fill {
    flex: 1 1 auto !important; }
  .flex-md-row {
    flex-direction: row !important; }
  .flex-md-column {
    flex-direction: column !important; }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-md-grow-0 {
    flex-grow: 0 !important; }
  .flex-md-grow-1 {
    flex-grow: 1 !important; }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-md-wrap {
    flex-wrap: wrap !important; }
  .flex-md-nowrap {
    flex-wrap: nowrap !important; }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-md-start {
    justify-content: flex-start !important; }
  .justify-content-md-end {
    justify-content: flex-end !important; }
  .justify-content-md-center {
    justify-content: center !important; }
  .justify-content-md-between {
    justify-content: space-between !important; }
  .justify-content-md-around {
    justify-content: space-around !important; }
  .justify-content-md-evenly {
    justify-content: space-evenly !important; }
  .align-items-md-start {
    align-items: flex-start !important; }
  .align-items-md-end {
    align-items: flex-end !important; }
  .align-items-md-center {
    align-items: center !important; }
  .align-items-md-baseline {
    align-items: baseline !important; }
  .align-items-md-stretch {
    align-items: stretch !important; }
  .align-content-md-start {
    align-content: flex-start !important; }
  .align-content-md-end {
    align-content: flex-end !important; }
  .align-content-md-center {
    align-content: center !important; }
  .align-content-md-between {
    align-content: space-between !important; }
  .align-content-md-around {
    align-content: space-around !important; }
  .align-content-md-stretch {
    align-content: stretch !important; }
  .align-self-md-auto {
    align-self: auto !important; }
  .align-self-md-start {
    align-self: flex-start !important; }
  .align-self-md-end {
    align-self: flex-end !important; }
  .align-self-md-center {
    align-self: center !important; }
  .align-self-md-baseline {
    align-self: baseline !important; }
  .align-self-md-stretch {
    align-self: stretch !important; }
  .order-md-first {
    order: -1 !important; }
  .order-md-0 {
    order: 0 !important; }
  .order-md-1 {
    order: 1 !important; }
  .order-md-2 {
    order: 2 !important; }
  .order-md-3 {
    order: 3 !important; }
  .order-md-4 {
    order: 4 !important; }
  .order-md-5 {
    order: 5 !important; }
  .order-md-last {
    order: 6 !important; }
  .m-md-0 {
    margin: 0 !important; }
  .m-md-1 {
    margin: 0.25rem !important; }
  .m-md-2 {
    margin: 0.5rem !important; }
  .m-md-3 {
    margin: 1rem !important; }
  .m-md-4 {
    margin: 1.5rem !important; }
  .m-md-5 {
    margin: 3rem !important; }
  .m-md-auto {
    margin: auto !important; }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-md-0 {
    margin-top: 0 !important; }
  .mt-md-1 {
    margin-top: 0.25rem !important; }
  .mt-md-2 {
    margin-top: 0.5rem !important; }
  .mt-md-3 {
    margin-top: 1rem !important; }
  .mt-md-4 {
    margin-top: 1.5rem !important; }
  .mt-md-5 {
    margin-top: 3rem !important; }
  .mt-md-auto {
    margin-top: auto !important; }
  html:not([dir="rtl"]) .me-md-0 {
    margin-right: 0 !important; }
  *[dir="rtl"] .me-md-0 {
    margin-left: 0 !important; }
  html:not([dir="rtl"]) .me-md-1 {
    margin-right: 0.25rem !important; }
  *[dir="rtl"] .me-md-1 {
    margin-left: 0.25rem !important; }
  html:not([dir="rtl"]) .me-md-2 {
    margin-right: 0.5rem !important; }
  *[dir="rtl"] .me-md-2 {
    margin-left: 0.5rem !important; }
  html:not([dir="rtl"]) .me-md-3 {
    margin-right: 1rem !important; }
  *[dir="rtl"] .me-md-3 {
    margin-left: 1rem !important; }
  html:not([dir="rtl"]) .me-md-4 {
    margin-right: 1.5rem !important; }
  *[dir="rtl"] .me-md-4 {
    margin-left: 1.5rem !important; }
  html:not([dir="rtl"]) .me-md-5 {
    margin-right: 3rem !important; }
  *[dir="rtl"] .me-md-5 {
    margin-left: 3rem !important; }
  html:not([dir="rtl"]) .me-md-auto {
    margin-right: auto !important; }
  *[dir="rtl"] .me-md-auto {
    margin-left: auto !important; }
  .mb-md-0 {
    margin-bottom: 0 !important; }
  .mb-md-1 {
    margin-bottom: 0.25rem !important; }
  .mb-md-2 {
    margin-bottom: 0.5rem !important; }
  .mb-md-3 {
    margin-bottom: 1rem !important; }
  .mb-md-4 {
    margin-bottom: 1.5rem !important; }
  .mb-md-5 {
    margin-bottom: 3rem !important; }
  .mb-md-auto {
    margin-bottom: auto !important; }
  html:not([dir="rtl"]) .ms-md-0 {
    margin-left: 0 !important; }
  *[dir="rtl"] .ms-md-0 {
    margin-right: 0 !important; }
  html:not([dir="rtl"]) .ms-md-1 {
    margin-left: 0.25rem !important; }
  *[dir="rtl"] .ms-md-1 {
    margin-right: 0.25rem !important; }
  html:not([dir="rtl"]) .ms-md-2 {
    margin-left: 0.5rem !important; }
  *[dir="rtl"] .ms-md-2 {
    margin-right: 0.5rem !important; }
  html:not([dir="rtl"]) .ms-md-3 {
    margin-left: 1rem !important; }
  *[dir="rtl"] .ms-md-3 {
    margin-right: 1rem !important; }
  html:not([dir="rtl"]) .ms-md-4 {
    margin-left: 1.5rem !important; }
  *[dir="rtl"] .ms-md-4 {
    margin-right: 1.5rem !important; }
  html:not([dir="rtl"]) .ms-md-5 {
    margin-left: 3rem !important; }
  *[dir="rtl"] .ms-md-5 {
    margin-right: 3rem !important; }
  html:not([dir="rtl"]) .ms-md-auto {
    margin-left: auto !important; }
  *[dir="rtl"] .ms-md-auto {
    margin-right: auto !important; }
  .p-md-0 {
    padding: 0 !important; }
  .p-md-1 {
    padding: 0.25rem !important; }
  .p-md-2 {
    padding: 0.5rem !important; }
  .p-md-3 {
    padding: 1rem !important; }
  .p-md-4 {
    padding: 1.5rem !important; }
  .p-md-5 {
    padding: 3rem !important; }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-md-0 {
    padding-top: 0 !important; }
  .pt-md-1 {
    padding-top: 0.25rem !important; }
  .pt-md-2 {
    padding-top: 0.5rem !important; }
  .pt-md-3 {
    padding-top: 1rem !important; }
  .pt-md-4 {
    padding-top: 1.5rem !important; }
  .pt-md-5 {
    padding-top: 3rem !important; }
  html:not([dir="rtl"]) .pe-md-0 {
    padding-right: 0 !important; }
  *[dir="rtl"] .pe-md-0 {
    padding-left: 0 !important; }
  html:not([dir="rtl"]) .pe-md-1 {
    padding-right: 0.25rem !important; }
  *[dir="rtl"] .pe-md-1 {
    padding-left: 0.25rem !important; }
  html:not([dir="rtl"]) .pe-md-2 {
    padding-right: 0.5rem !important; }
  *[dir="rtl"] .pe-md-2 {
    padding-left: 0.5rem !important; }
  html:not([dir="rtl"]) .pe-md-3 {
    padding-right: 1rem !important; }
  *[dir="rtl"] .pe-md-3 {
    padding-left: 1rem !important; }
  html:not([dir="rtl"]) .pe-md-4 {
    padding-right: 1.5rem !important; }
  *[dir="rtl"] .pe-md-4 {
    padding-left: 1.5rem !important; }
  html:not([dir="rtl"]) .pe-md-5 {
    padding-right: 3rem !important; }
  *[dir="rtl"] .pe-md-5 {
    padding-left: 3rem !important; }
  .pb-md-0 {
    padding-bottom: 0 !important; }
  .pb-md-1 {
    padding-bottom: 0.25rem !important; }
  .pb-md-2 {
    padding-bottom: 0.5rem !important; }
  .pb-md-3 {
    padding-bottom: 1rem !important; }
  .pb-md-4 {
    padding-bottom: 1.5rem !important; }
  .pb-md-5 {
    padding-bottom: 3rem !important; }
  html:not([dir="rtl"]) .ps-md-0 {
    padding-left: 0 !important; }
  *[dir="rtl"] .ps-md-0 {
    padding-right: 0 !important; }
  html:not([dir="rtl"]) .ps-md-1 {
    padding-left: 0.25rem !important; }
  *[dir="rtl"] .ps-md-1 {
    padding-right: 0.25rem !important; }
  html:not([dir="rtl"]) .ps-md-2 {
    padding-left: 0.5rem !important; }
  *[dir="rtl"] .ps-md-2 {
    padding-right: 0.5rem !important; }
  html:not([dir="rtl"]) .ps-md-3 {
    padding-left: 1rem !important; }
  *[dir="rtl"] .ps-md-3 {
    padding-right: 1rem !important; }
  html:not([dir="rtl"]) .ps-md-4 {
    padding-left: 1.5rem !important; }
  *[dir="rtl"] .ps-md-4 {
    padding-right: 1.5rem !important; }
  html:not([dir="rtl"]) .ps-md-5 {
    padding-left: 3rem !important; }
  *[dir="rtl"] .ps-md-5 {
    padding-right: 3rem !important; }
  .gap-md-0 {
    gap: 0 !important; }
  .gap-md-1 {
    gap: 0.25rem !important; }
  .gap-md-2 {
    gap: 0.5rem !important; }
  .gap-md-3 {
    gap: 1rem !important; }
  .gap-md-4 {
    gap: 1.5rem !important; }
  .gap-md-5 {
    gap: 3rem !important; }
  .row-gap-md-0 {
    row-gap: 0 !important; }
  .row-gap-md-1 {
    row-gap: 0.25rem !important; }
  .row-gap-md-2 {
    row-gap: 0.5rem !important; }
  .row-gap-md-3 {
    row-gap: 1rem !important; }
  .row-gap-md-4 {
    row-gap: 1.5rem !important; }
  .row-gap-md-5 {
    row-gap: 3rem !important; }
  .column-gap-md-0 {
    column-gap: 0 !important; }
  .column-gap-md-1 {
    column-gap: 0.25rem !important; }
  .column-gap-md-2 {
    column-gap: 0.5rem !important; }
  .column-gap-md-3 {
    column-gap: 1rem !important; }
  .column-gap-md-4 {
    column-gap: 1.5rem !important; }
  .column-gap-md-5 {
    column-gap: 3rem !important; }
  html:not([dir="rtl"]) .text-md-start {
    text-align: left !important; }
  *[dir="rtl"] .text-md-start {
    text-align: right !important; }
  html:not([dir="rtl"]) .text-md-end {
    text-align: right !important; }
  *[dir="rtl"] .text-md-end {
    text-align: left !important; }
  html:not([dir="rtl"]) .text-md-center {
    text-align: center !important; }
  *[dir="rtl"] .text-md-center {
    text-align: center !important; } }

@media (min-width: 992px) {
  html:not([dir="rtl"]) .float-lg-start {
    float: left !important; }
  *[dir="rtl"] .float-lg-start {
    float: right !important; }
  html:not([dir="rtl"]) .float-lg-end {
    float: right !important; }
  *[dir="rtl"] .float-lg-end {
    float: left !important; }
  html:not([dir="rtl"]) .float-lg-none {
    float: none !important; }
  *[dir="rtl"] .float-lg-none {
    float: none !important; }
  .object-fit-lg-contain {
    object-fit: contain !important; }
  .object-fit-lg-cover {
    object-fit: cover !important; }
  .object-fit-lg-fill {
    object-fit: fill !important; }
  .object-fit-lg-scale {
    object-fit: scale-down !important; }
  .object-fit-lg-none {
    object-fit: none !important; }
  .d-lg-inline {
    display: inline !important; }
  .d-lg-inline-block {
    display: inline-block !important; }
  .d-lg-block {
    display: block !important; }
  .d-lg-grid {
    display: grid !important; }
  .d-lg-inline-grid {
    display: inline-grid !important; }
  .d-lg-table {
    display: table !important; }
  .d-lg-table-row {
    display: table-row !important; }
  .d-lg-table-cell {
    display: table-cell !important; }
  .d-lg-flex {
    display: flex !important; }
  .d-lg-inline-flex {
    display: inline-flex !important; }
  .d-lg-none {
    display: none !important; }
  .flex-lg-fill {
    flex: 1 1 auto !important; }
  .flex-lg-row {
    flex-direction: row !important; }
  .flex-lg-column {
    flex-direction: column !important; }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-lg-grow-0 {
    flex-grow: 0 !important; }
  .flex-lg-grow-1 {
    flex-grow: 1 !important; }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-lg-wrap {
    flex-wrap: wrap !important; }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important; }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-lg-start {
    justify-content: flex-start !important; }
  .justify-content-lg-end {
    justify-content: flex-end !important; }
  .justify-content-lg-center {
    justify-content: center !important; }
  .justify-content-lg-between {
    justify-content: space-between !important; }
  .justify-content-lg-around {
    justify-content: space-around !important; }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important; }
  .align-items-lg-start {
    align-items: flex-start !important; }
  .align-items-lg-end {
    align-items: flex-end !important; }
  .align-items-lg-center {
    align-items: center !important; }
  .align-items-lg-baseline {
    align-items: baseline !important; }
  .align-items-lg-stretch {
    align-items: stretch !important; }
  .align-content-lg-start {
    align-content: flex-start !important; }
  .align-content-lg-end {
    align-content: flex-end !important; }
  .align-content-lg-center {
    align-content: center !important; }
  .align-content-lg-between {
    align-content: space-between !important; }
  .align-content-lg-around {
    align-content: space-around !important; }
  .align-content-lg-stretch {
    align-content: stretch !important; }
  .align-self-lg-auto {
    align-self: auto !important; }
  .align-self-lg-start {
    align-self: flex-start !important; }
  .align-self-lg-end {
    align-self: flex-end !important; }
  .align-self-lg-center {
    align-self: center !important; }
  .align-self-lg-baseline {
    align-self: baseline !important; }
  .align-self-lg-stretch {
    align-self: stretch !important; }
  .order-lg-first {
    order: -1 !important; }
  .order-lg-0 {
    order: 0 !important; }
  .order-lg-1 {
    order: 1 !important; }
  .order-lg-2 {
    order: 2 !important; }
  .order-lg-3 {
    order: 3 !important; }
  .order-lg-4 {
    order: 4 !important; }
  .order-lg-5 {
    order: 5 !important; }
  .order-lg-last {
    order: 6 !important; }
  .m-lg-0 {
    margin: 0 !important; }
  .m-lg-1 {
    margin: 0.25rem !important; }
  .m-lg-2 {
    margin: 0.5rem !important; }
  .m-lg-3 {
    margin: 1rem !important; }
  .m-lg-4 {
    margin: 1.5rem !important; }
  .m-lg-5 {
    margin: 3rem !important; }
  .m-lg-auto {
    margin: auto !important; }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-lg-0 {
    margin-top: 0 !important; }
  .mt-lg-1 {
    margin-top: 0.25rem !important; }
  .mt-lg-2 {
    margin-top: 0.5rem !important; }
  .mt-lg-3 {
    margin-top: 1rem !important; }
  .mt-lg-4 {
    margin-top: 1.5rem !important; }
  .mt-lg-5 {
    margin-top: 3rem !important; }
  .mt-lg-auto {
    margin-top: auto !important; }
  html:not([dir="rtl"]) .me-lg-0 {
    margin-right: 0 !important; }
  *[dir="rtl"] .me-lg-0 {
    margin-left: 0 !important; }
  html:not([dir="rtl"]) .me-lg-1 {
    margin-right: 0.25rem !important; }
  *[dir="rtl"] .me-lg-1 {
    margin-left: 0.25rem !important; }
  html:not([dir="rtl"]) .me-lg-2 {
    margin-right: 0.5rem !important; }
  *[dir="rtl"] .me-lg-2 {
    margin-left: 0.5rem !important; }
  html:not([dir="rtl"]) .me-lg-3 {
    margin-right: 1rem !important; }
  *[dir="rtl"] .me-lg-3 {
    margin-left: 1rem !important; }
  html:not([dir="rtl"]) .me-lg-4 {
    margin-right: 1.5rem !important; }
  *[dir="rtl"] .me-lg-4 {
    margin-left: 1.5rem !important; }
  html:not([dir="rtl"]) .me-lg-5 {
    margin-right: 3rem !important; }
  *[dir="rtl"] .me-lg-5 {
    margin-left: 3rem !important; }
  html:not([dir="rtl"]) .me-lg-auto {
    margin-right: auto !important; }
  *[dir="rtl"] .me-lg-auto {
    margin-left: auto !important; }
  .mb-lg-0 {
    margin-bottom: 0 !important; }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important; }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important; }
  .mb-lg-3 {
    margin-bottom: 1rem !important; }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important; }
  .mb-lg-5 {
    margin-bottom: 3rem !important; }
  .mb-lg-auto {
    margin-bottom: auto !important; }
  html:not([dir="rtl"]) .ms-lg-0 {
    margin-left: 0 !important; }
  *[dir="rtl"] .ms-lg-0 {
    margin-right: 0 !important; }
  html:not([dir="rtl"]) .ms-lg-1 {
    margin-left: 0.25rem !important; }
  *[dir="rtl"] .ms-lg-1 {
    margin-right: 0.25rem !important; }
  html:not([dir="rtl"]) .ms-lg-2 {
    margin-left: 0.5rem !important; }
  *[dir="rtl"] .ms-lg-2 {
    margin-right: 0.5rem !important; }
  html:not([dir="rtl"]) .ms-lg-3 {
    margin-left: 1rem !important; }
  *[dir="rtl"] .ms-lg-3 {
    margin-right: 1rem !important; }
  html:not([dir="rtl"]) .ms-lg-4 {
    margin-left: 1.5rem !important; }
  *[dir="rtl"] .ms-lg-4 {
    margin-right: 1.5rem !important; }
  html:not([dir="rtl"]) .ms-lg-5 {
    margin-left: 3rem !important; }
  *[dir="rtl"] .ms-lg-5 {
    margin-right: 3rem !important; }
  html:not([dir="rtl"]) .ms-lg-auto {
    margin-left: auto !important; }
  *[dir="rtl"] .ms-lg-auto {
    margin-right: auto !important; }
  .p-lg-0 {
    padding: 0 !important; }
  .p-lg-1 {
    padding: 0.25rem !important; }
  .p-lg-2 {
    padding: 0.5rem !important; }
  .p-lg-3 {
    padding: 1rem !important; }
  .p-lg-4 {
    padding: 1.5rem !important; }
  .p-lg-5 {
    padding: 3rem !important; }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-lg-0 {
    padding-top: 0 !important; }
  .pt-lg-1 {
    padding-top: 0.25rem !important; }
  .pt-lg-2 {
    padding-top: 0.5rem !important; }
  .pt-lg-3 {
    padding-top: 1rem !important; }
  .pt-lg-4 {
    padding-top: 1.5rem !important; }
  .pt-lg-5 {
    padding-top: 3rem !important; }
  html:not([dir="rtl"]) .pe-lg-0 {
    padding-right: 0 !important; }
  *[dir="rtl"] .pe-lg-0 {
    padding-left: 0 !important; }
  html:not([dir="rtl"]) .pe-lg-1 {
    padding-right: 0.25rem !important; }
  *[dir="rtl"] .pe-lg-1 {
    padding-left: 0.25rem !important; }
  html:not([dir="rtl"]) .pe-lg-2 {
    padding-right: 0.5rem !important; }
  *[dir="rtl"] .pe-lg-2 {
    padding-left: 0.5rem !important; }
  html:not([dir="rtl"]) .pe-lg-3 {
    padding-right: 1rem !important; }
  *[dir="rtl"] .pe-lg-3 {
    padding-left: 1rem !important; }
  html:not([dir="rtl"]) .pe-lg-4 {
    padding-right: 1.5rem !important; }
  *[dir="rtl"] .pe-lg-4 {
    padding-left: 1.5rem !important; }
  html:not([dir="rtl"]) .pe-lg-5 {
    padding-right: 3rem !important; }
  *[dir="rtl"] .pe-lg-5 {
    padding-left: 3rem !important; }
  .pb-lg-0 {
    padding-bottom: 0 !important; }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important; }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important; }
  .pb-lg-3 {
    padding-bottom: 1rem !important; }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important; }
  .pb-lg-5 {
    padding-bottom: 3rem !important; }
  html:not([dir="rtl"]) .ps-lg-0 {
    padding-left: 0 !important; }
  *[dir="rtl"] .ps-lg-0 {
    padding-right: 0 !important; }
  html:not([dir="rtl"]) .ps-lg-1 {
    padding-left: 0.25rem !important; }
  *[dir="rtl"] .ps-lg-1 {
    padding-right: 0.25rem !important; }
  html:not([dir="rtl"]) .ps-lg-2 {
    padding-left: 0.5rem !important; }
  *[dir="rtl"] .ps-lg-2 {
    padding-right: 0.5rem !important; }
  html:not([dir="rtl"]) .ps-lg-3 {
    padding-left: 1rem !important; }
  *[dir="rtl"] .ps-lg-3 {
    padding-right: 1rem !important; }
  html:not([dir="rtl"]) .ps-lg-4 {
    padding-left: 1.5rem !important; }
  *[dir="rtl"] .ps-lg-4 {
    padding-right: 1.5rem !important; }
  html:not([dir="rtl"]) .ps-lg-5 {
    padding-left: 3rem !important; }
  *[dir="rtl"] .ps-lg-5 {
    padding-right: 3rem !important; }
  .gap-lg-0 {
    gap: 0 !important; }
  .gap-lg-1 {
    gap: 0.25rem !important; }
  .gap-lg-2 {
    gap: 0.5rem !important; }
  .gap-lg-3 {
    gap: 1rem !important; }
  .gap-lg-4 {
    gap: 1.5rem !important; }
  .gap-lg-5 {
    gap: 3rem !important; }
  .row-gap-lg-0 {
    row-gap: 0 !important; }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important; }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important; }
  .row-gap-lg-3 {
    row-gap: 1rem !important; }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important; }
  .row-gap-lg-5 {
    row-gap: 3rem !important; }
  .column-gap-lg-0 {
    column-gap: 0 !important; }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important; }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important; }
  .column-gap-lg-3 {
    column-gap: 1rem !important; }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important; }
  .column-gap-lg-5 {
    column-gap: 3rem !important; }
  html:not([dir="rtl"]) .text-lg-start {
    text-align: left !important; }
  *[dir="rtl"] .text-lg-start {
    text-align: right !important; }
  html:not([dir="rtl"]) .text-lg-end {
    text-align: right !important; }
  *[dir="rtl"] .text-lg-end {
    text-align: left !important; }
  html:not([dir="rtl"]) .text-lg-center {
    text-align: center !important; }
  *[dir="rtl"] .text-lg-center {
    text-align: center !important; } }

@media (min-width: 1200px) {
  html:not([dir="rtl"]) .float-xl-start {
    float: left !important; }
  *[dir="rtl"] .float-xl-start {
    float: right !important; }
  html:not([dir="rtl"]) .float-xl-end {
    float: right !important; }
  *[dir="rtl"] .float-xl-end {
    float: left !important; }
  html:not([dir="rtl"]) .float-xl-none {
    float: none !important; }
  *[dir="rtl"] .float-xl-none {
    float: none !important; }
  .object-fit-xl-contain {
    object-fit: contain !important; }
  .object-fit-xl-cover {
    object-fit: cover !important; }
  .object-fit-xl-fill {
    object-fit: fill !important; }
  .object-fit-xl-scale {
    object-fit: scale-down !important; }
  .object-fit-xl-none {
    object-fit: none !important; }
  .d-xl-inline {
    display: inline !important; }
  .d-xl-inline-block {
    display: inline-block !important; }
  .d-xl-block {
    display: block !important; }
  .d-xl-grid {
    display: grid !important; }
  .d-xl-inline-grid {
    display: inline-grid !important; }
  .d-xl-table {
    display: table !important; }
  .d-xl-table-row {
    display: table-row !important; }
  .d-xl-table-cell {
    display: table-cell !important; }
  .d-xl-flex {
    display: flex !important; }
  .d-xl-inline-flex {
    display: inline-flex !important; }
  .d-xl-none {
    display: none !important; }
  .flex-xl-fill {
    flex: 1 1 auto !important; }
  .flex-xl-row {
    flex-direction: row !important; }
  .flex-xl-column {
    flex-direction: column !important; }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-xl-grow-0 {
    flex-grow: 0 !important; }
  .flex-xl-grow-1 {
    flex-grow: 1 !important; }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-xl-wrap {
    flex-wrap: wrap !important; }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important; }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-xl-start {
    justify-content: flex-start !important; }
  .justify-content-xl-end {
    justify-content: flex-end !important; }
  .justify-content-xl-center {
    justify-content: center !important; }
  .justify-content-xl-between {
    justify-content: space-between !important; }
  .justify-content-xl-around {
    justify-content: space-around !important; }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important; }
  .align-items-xl-start {
    align-items: flex-start !important; }
  .align-items-xl-end {
    align-items: flex-end !important; }
  .align-items-xl-center {
    align-items: center !important; }
  .align-items-xl-baseline {
    align-items: baseline !important; }
  .align-items-xl-stretch {
    align-items: stretch !important; }
  .align-content-xl-start {
    align-content: flex-start !important; }
  .align-content-xl-end {
    align-content: flex-end !important; }
  .align-content-xl-center {
    align-content: center !important; }
  .align-content-xl-between {
    align-content: space-between !important; }
  .align-content-xl-around {
    align-content: space-around !important; }
  .align-content-xl-stretch {
    align-content: stretch !important; }
  .align-self-xl-auto {
    align-self: auto !important; }
  .align-self-xl-start {
    align-self: flex-start !important; }
  .align-self-xl-end {
    align-self: flex-end !important; }
  .align-self-xl-center {
    align-self: center !important; }
  .align-self-xl-baseline {
    align-self: baseline !important; }
  .align-self-xl-stretch {
    align-self: stretch !important; }
  .order-xl-first {
    order: -1 !important; }
  .order-xl-0 {
    order: 0 !important; }
  .order-xl-1 {
    order: 1 !important; }
  .order-xl-2 {
    order: 2 !important; }
  .order-xl-3 {
    order: 3 !important; }
  .order-xl-4 {
    order: 4 !important; }
  .order-xl-5 {
    order: 5 !important; }
  .order-xl-last {
    order: 6 !important; }
  .m-xl-0 {
    margin: 0 !important; }
  .m-xl-1 {
    margin: 0.25rem !important; }
  .m-xl-2 {
    margin: 0.5rem !important; }
  .m-xl-3 {
    margin: 1rem !important; }
  .m-xl-4 {
    margin: 1.5rem !important; }
  .m-xl-5 {
    margin: 3rem !important; }
  .m-xl-auto {
    margin: auto !important; }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-xl-0 {
    margin-top: 0 !important; }
  .mt-xl-1 {
    margin-top: 0.25rem !important; }
  .mt-xl-2 {
    margin-top: 0.5rem !important; }
  .mt-xl-3 {
    margin-top: 1rem !important; }
  .mt-xl-4 {
    margin-top: 1.5rem !important; }
  .mt-xl-5 {
    margin-top: 3rem !important; }
  .mt-xl-auto {
    margin-top: auto !important; }
  html:not([dir="rtl"]) .me-xl-0 {
    margin-right: 0 !important; }
  *[dir="rtl"] .me-xl-0 {
    margin-left: 0 !important; }
  html:not([dir="rtl"]) .me-xl-1 {
    margin-right: 0.25rem !important; }
  *[dir="rtl"] .me-xl-1 {
    margin-left: 0.25rem !important; }
  html:not([dir="rtl"]) .me-xl-2 {
    margin-right: 0.5rem !important; }
  *[dir="rtl"] .me-xl-2 {
    margin-left: 0.5rem !important; }
  html:not([dir="rtl"]) .me-xl-3 {
    margin-right: 1rem !important; }
  *[dir="rtl"] .me-xl-3 {
    margin-left: 1rem !important; }
  html:not([dir="rtl"]) .me-xl-4 {
    margin-right: 1.5rem !important; }
  *[dir="rtl"] .me-xl-4 {
    margin-left: 1.5rem !important; }
  html:not([dir="rtl"]) .me-xl-5 {
    margin-right: 3rem !important; }
  *[dir="rtl"] .me-xl-5 {
    margin-left: 3rem !important; }
  html:not([dir="rtl"]) .me-xl-auto {
    margin-right: auto !important; }
  *[dir="rtl"] .me-xl-auto {
    margin-left: auto !important; }
  .mb-xl-0 {
    margin-bottom: 0 !important; }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important; }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important; }
  .mb-xl-3 {
    margin-bottom: 1rem !important; }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important; }
  .mb-xl-5 {
    margin-bottom: 3rem !important; }
  .mb-xl-auto {
    margin-bottom: auto !important; }
  html:not([dir="rtl"]) .ms-xl-0 {
    margin-left: 0 !important; }
  *[dir="rtl"] .ms-xl-0 {
    margin-right: 0 !important; }
  html:not([dir="rtl"]) .ms-xl-1 {
    margin-left: 0.25rem !important; }
  *[dir="rtl"] .ms-xl-1 {
    margin-right: 0.25rem !important; }
  html:not([dir="rtl"]) .ms-xl-2 {
    margin-left: 0.5rem !important; }
  *[dir="rtl"] .ms-xl-2 {
    margin-right: 0.5rem !important; }
  html:not([dir="rtl"]) .ms-xl-3 {
    margin-left: 1rem !important; }
  *[dir="rtl"] .ms-xl-3 {
    margin-right: 1rem !important; }
  html:not([dir="rtl"]) .ms-xl-4 {
    margin-left: 1.5rem !important; }
  *[dir="rtl"] .ms-xl-4 {
    margin-right: 1.5rem !important; }
  html:not([dir="rtl"]) .ms-xl-5 {
    margin-left: 3rem !important; }
  *[dir="rtl"] .ms-xl-5 {
    margin-right: 3rem !important; }
  html:not([dir="rtl"]) .ms-xl-auto {
    margin-left: auto !important; }
  *[dir="rtl"] .ms-xl-auto {
    margin-right: auto !important; }
  .p-xl-0 {
    padding: 0 !important; }
  .p-xl-1 {
    padding: 0.25rem !important; }
  .p-xl-2 {
    padding: 0.5rem !important; }
  .p-xl-3 {
    padding: 1rem !important; }
  .p-xl-4 {
    padding: 1.5rem !important; }
  .p-xl-5 {
    padding: 3rem !important; }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-xl-0 {
    padding-top: 0 !important; }
  .pt-xl-1 {
    padding-top: 0.25rem !important; }
  .pt-xl-2 {
    padding-top: 0.5rem !important; }
  .pt-xl-3 {
    padding-top: 1rem !important; }
  .pt-xl-4 {
    padding-top: 1.5rem !important; }
  .pt-xl-5 {
    padding-top: 3rem !important; }
  html:not([dir="rtl"]) .pe-xl-0 {
    padding-right: 0 !important; }
  *[dir="rtl"] .pe-xl-0 {
    padding-left: 0 !important; }
  html:not([dir="rtl"]) .pe-xl-1 {
    padding-right: 0.25rem !important; }
  *[dir="rtl"] .pe-xl-1 {
    padding-left: 0.25rem !important; }
  html:not([dir="rtl"]) .pe-xl-2 {
    padding-right: 0.5rem !important; }
  *[dir="rtl"] .pe-xl-2 {
    padding-left: 0.5rem !important; }
  html:not([dir="rtl"]) .pe-xl-3 {
    padding-right: 1rem !important; }
  *[dir="rtl"] .pe-xl-3 {
    padding-left: 1rem !important; }
  html:not([dir="rtl"]) .pe-xl-4 {
    padding-right: 1.5rem !important; }
  *[dir="rtl"] .pe-xl-4 {
    padding-left: 1.5rem !important; }
  html:not([dir="rtl"]) .pe-xl-5 {
    padding-right: 3rem !important; }
  *[dir="rtl"] .pe-xl-5 {
    padding-left: 3rem !important; }
  .pb-xl-0 {
    padding-bottom: 0 !important; }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important; }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important; }
  .pb-xl-3 {
    padding-bottom: 1rem !important; }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important; }
  .pb-xl-5 {
    padding-bottom: 3rem !important; }
  html:not([dir="rtl"]) .ps-xl-0 {
    padding-left: 0 !important; }
  *[dir="rtl"] .ps-xl-0 {
    padding-right: 0 !important; }
  html:not([dir="rtl"]) .ps-xl-1 {
    padding-left: 0.25rem !important; }
  *[dir="rtl"] .ps-xl-1 {
    padding-right: 0.25rem !important; }
  html:not([dir="rtl"]) .ps-xl-2 {
    padding-left: 0.5rem !important; }
  *[dir="rtl"] .ps-xl-2 {
    padding-right: 0.5rem !important; }
  html:not([dir="rtl"]) .ps-xl-3 {
    padding-left: 1rem !important; }
  *[dir="rtl"] .ps-xl-3 {
    padding-right: 1rem !important; }
  html:not([dir="rtl"]) .ps-xl-4 {
    padding-left: 1.5rem !important; }
  *[dir="rtl"] .ps-xl-4 {
    padding-right: 1.5rem !important; }
  html:not([dir="rtl"]) .ps-xl-5 {
    padding-left: 3rem !important; }
  *[dir="rtl"] .ps-xl-5 {
    padding-right: 3rem !important; }
  .gap-xl-0 {
    gap: 0 !important; }
  .gap-xl-1 {
    gap: 0.25rem !important; }
  .gap-xl-2 {
    gap: 0.5rem !important; }
  .gap-xl-3 {
    gap: 1rem !important; }
  .gap-xl-4 {
    gap: 1.5rem !important; }
  .gap-xl-5 {
    gap: 3rem !important; }
  .row-gap-xl-0 {
    row-gap: 0 !important; }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important; }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important; }
  .row-gap-xl-3 {
    row-gap: 1rem !important; }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important; }
  .row-gap-xl-5 {
    row-gap: 3rem !important; }
  .column-gap-xl-0 {
    column-gap: 0 !important; }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important; }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important; }
  .column-gap-xl-3 {
    column-gap: 1rem !important; }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important; }
  .column-gap-xl-5 {
    column-gap: 3rem !important; }
  html:not([dir="rtl"]) .text-xl-start {
    text-align: left !important; }
  *[dir="rtl"] .text-xl-start {
    text-align: right !important; }
  html:not([dir="rtl"]) .text-xl-end {
    text-align: right !important; }
  *[dir="rtl"] .text-xl-end {
    text-align: left !important; }
  html:not([dir="rtl"]) .text-xl-center {
    text-align: center !important; }
  *[dir="rtl"] .text-xl-center {
    text-align: center !important; } }

@media (min-width: 1400px) {
  html:not([dir="rtl"]) .float-xxl-start {
    float: left !important; }
  *[dir="rtl"] .float-xxl-start {
    float: right !important; }
  html:not([dir="rtl"]) .float-xxl-end {
    float: right !important; }
  *[dir="rtl"] .float-xxl-end {
    float: left !important; }
  html:not([dir="rtl"]) .float-xxl-none {
    float: none !important; }
  *[dir="rtl"] .float-xxl-none {
    float: none !important; }
  .object-fit-xxl-contain {
    object-fit: contain !important; }
  .object-fit-xxl-cover {
    object-fit: cover !important; }
  .object-fit-xxl-fill {
    object-fit: fill !important; }
  .object-fit-xxl-scale {
    object-fit: scale-down !important; }
  .object-fit-xxl-none {
    object-fit: none !important; }
  .d-xxl-inline {
    display: inline !important; }
  .d-xxl-inline-block {
    display: inline-block !important; }
  .d-xxl-block {
    display: block !important; }
  .d-xxl-grid {
    display: grid !important; }
  .d-xxl-inline-grid {
    display: inline-grid !important; }
  .d-xxl-table {
    display: table !important; }
  .d-xxl-table-row {
    display: table-row !important; }
  .d-xxl-table-cell {
    display: table-cell !important; }
  .d-xxl-flex {
    display: flex !important; }
  .d-xxl-inline-flex {
    display: inline-flex !important; }
  .d-xxl-none {
    display: none !important; }
  .flex-xxl-fill {
    flex: 1 1 auto !important; }
  .flex-xxl-row {
    flex-direction: row !important; }
  .flex-xxl-column {
    flex-direction: column !important; }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important; }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important; }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-xxl-wrap {
    flex-wrap: wrap !important; }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important; }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-xxl-start {
    justify-content: flex-start !important; }
  .justify-content-xxl-end {
    justify-content: flex-end !important; }
  .justify-content-xxl-center {
    justify-content: center !important; }
  .justify-content-xxl-between {
    justify-content: space-between !important; }
  .justify-content-xxl-around {
    justify-content: space-around !important; }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important; }
  .align-items-xxl-start {
    align-items: flex-start !important; }
  .align-items-xxl-end {
    align-items: flex-end !important; }
  .align-items-xxl-center {
    align-items: center !important; }
  .align-items-xxl-baseline {
    align-items: baseline !important; }
  .align-items-xxl-stretch {
    align-items: stretch !important; }
  .align-content-xxl-start {
    align-content: flex-start !important; }
  .align-content-xxl-end {
    align-content: flex-end !important; }
  .align-content-xxl-center {
    align-content: center !important; }
  .align-content-xxl-between {
    align-content: space-between !important; }
  .align-content-xxl-around {
    align-content: space-around !important; }
  .align-content-xxl-stretch {
    align-content: stretch !important; }
  .align-self-xxl-auto {
    align-self: auto !important; }
  .align-self-xxl-start {
    align-self: flex-start !important; }
  .align-self-xxl-end {
    align-self: flex-end !important; }
  .align-self-xxl-center {
    align-self: center !important; }
  .align-self-xxl-baseline {
    align-self: baseline !important; }
  .align-self-xxl-stretch {
    align-self: stretch !important; }
  .order-xxl-first {
    order: -1 !important; }
  .order-xxl-0 {
    order: 0 !important; }
  .order-xxl-1 {
    order: 1 !important; }
  .order-xxl-2 {
    order: 2 !important; }
  .order-xxl-3 {
    order: 3 !important; }
  .order-xxl-4 {
    order: 4 !important; }
  .order-xxl-5 {
    order: 5 !important; }
  .order-xxl-last {
    order: 6 !important; }
  .m-xxl-0 {
    margin: 0 !important; }
  .m-xxl-1 {
    margin: 0.25rem !important; }
  .m-xxl-2 {
    margin: 0.5rem !important; }
  .m-xxl-3 {
    margin: 1rem !important; }
  .m-xxl-4 {
    margin: 1.5rem !important; }
  .m-xxl-5 {
    margin: 3rem !important; }
  .m-xxl-auto {
    margin: auto !important; }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-xxl-0 {
    margin-top: 0 !important; }
  .mt-xxl-1 {
    margin-top: 0.25rem !important; }
  .mt-xxl-2 {
    margin-top: 0.5rem !important; }
  .mt-xxl-3 {
    margin-top: 1rem !important; }
  .mt-xxl-4 {
    margin-top: 1.5rem !important; }
  .mt-xxl-5 {
    margin-top: 3rem !important; }
  .mt-xxl-auto {
    margin-top: auto !important; }
  html:not([dir="rtl"]) .me-xxl-0 {
    margin-right: 0 !important; }
  *[dir="rtl"] .me-xxl-0 {
    margin-left: 0 !important; }
  html:not([dir="rtl"]) .me-xxl-1 {
    margin-right: 0.25rem !important; }
  *[dir="rtl"] .me-xxl-1 {
    margin-left: 0.25rem !important; }
  html:not([dir="rtl"]) .me-xxl-2 {
    margin-right: 0.5rem !important; }
  *[dir="rtl"] .me-xxl-2 {
    margin-left: 0.5rem !important; }
  html:not([dir="rtl"]) .me-xxl-3 {
    margin-right: 1rem !important; }
  *[dir="rtl"] .me-xxl-3 {
    margin-left: 1rem !important; }
  html:not([dir="rtl"]) .me-xxl-4 {
    margin-right: 1.5rem !important; }
  *[dir="rtl"] .me-xxl-4 {
    margin-left: 1.5rem !important; }
  html:not([dir="rtl"]) .me-xxl-5 {
    margin-right: 3rem !important; }
  *[dir="rtl"] .me-xxl-5 {
    margin-left: 3rem !important; }
  html:not([dir="rtl"]) .me-xxl-auto {
    margin-right: auto !important; }
  *[dir="rtl"] .me-xxl-auto {
    margin-left: auto !important; }
  .mb-xxl-0 {
    margin-bottom: 0 !important; }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important; }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important; }
  .mb-xxl-3 {
    margin-bottom: 1rem !important; }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important; }
  .mb-xxl-5 {
    margin-bottom: 3rem !important; }
  .mb-xxl-auto {
    margin-bottom: auto !important; }
  html:not([dir="rtl"]) .ms-xxl-0 {
    margin-left: 0 !important; }
  *[dir="rtl"] .ms-xxl-0 {
    margin-right: 0 !important; }
  html:not([dir="rtl"]) .ms-xxl-1 {
    margin-left: 0.25rem !important; }
  *[dir="rtl"] .ms-xxl-1 {
    margin-right: 0.25rem !important; }
  html:not([dir="rtl"]) .ms-xxl-2 {
    margin-left: 0.5rem !important; }
  *[dir="rtl"] .ms-xxl-2 {
    margin-right: 0.5rem !important; }
  html:not([dir="rtl"]) .ms-xxl-3 {
    margin-left: 1rem !important; }
  *[dir="rtl"] .ms-xxl-3 {
    margin-right: 1rem !important; }
  html:not([dir="rtl"]) .ms-xxl-4 {
    margin-left: 1.5rem !important; }
  *[dir="rtl"] .ms-xxl-4 {
    margin-right: 1.5rem !important; }
  html:not([dir="rtl"]) .ms-xxl-5 {
    margin-left: 3rem !important; }
  *[dir="rtl"] .ms-xxl-5 {
    margin-right: 3rem !important; }
  html:not([dir="rtl"]) .ms-xxl-auto {
    margin-left: auto !important; }
  *[dir="rtl"] .ms-xxl-auto {
    margin-right: auto !important; }
  .p-xxl-0 {
    padding: 0 !important; }
  .p-xxl-1 {
    padding: 0.25rem !important; }
  .p-xxl-2 {
    padding: 0.5rem !important; }
  .p-xxl-3 {
    padding: 1rem !important; }
  .p-xxl-4 {
    padding: 1.5rem !important; }
  .p-xxl-5 {
    padding: 3rem !important; }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-xxl-0 {
    padding-top: 0 !important; }
  .pt-xxl-1 {
    padding-top: 0.25rem !important; }
  .pt-xxl-2 {
    padding-top: 0.5rem !important; }
  .pt-xxl-3 {
    padding-top: 1rem !important; }
  .pt-xxl-4 {
    padding-top: 1.5rem !important; }
  .pt-xxl-5 {
    padding-top: 3rem !important; }
  html:not([dir="rtl"]) .pe-xxl-0 {
    padding-right: 0 !important; }
  *[dir="rtl"] .pe-xxl-0 {
    padding-left: 0 !important; }
  html:not([dir="rtl"]) .pe-xxl-1 {
    padding-right: 0.25rem !important; }
  *[dir="rtl"] .pe-xxl-1 {
    padding-left: 0.25rem !important; }
  html:not([dir="rtl"]) .pe-xxl-2 {
    padding-right: 0.5rem !important; }
  *[dir="rtl"] .pe-xxl-2 {
    padding-left: 0.5rem !important; }
  html:not([dir="rtl"]) .pe-xxl-3 {
    padding-right: 1rem !important; }
  *[dir="rtl"] .pe-xxl-3 {
    padding-left: 1rem !important; }
  html:not([dir="rtl"]) .pe-xxl-4 {
    padding-right: 1.5rem !important; }
  *[dir="rtl"] .pe-xxl-4 {
    padding-left: 1.5rem !important; }
  html:not([dir="rtl"]) .pe-xxl-5 {
    padding-right: 3rem !important; }
  *[dir="rtl"] .pe-xxl-5 {
    padding-left: 3rem !important; }
  .pb-xxl-0 {
    padding-bottom: 0 !important; }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important; }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important; }
  .pb-xxl-3 {
    padding-bottom: 1rem !important; }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important; }
  .pb-xxl-5 {
    padding-bottom: 3rem !important; }
  html:not([dir="rtl"]) .ps-xxl-0 {
    padding-left: 0 !important; }
  *[dir="rtl"] .ps-xxl-0 {
    padding-right: 0 !important; }
  html:not([dir="rtl"]) .ps-xxl-1 {
    padding-left: 0.25rem !important; }
  *[dir="rtl"] .ps-xxl-1 {
    padding-right: 0.25rem !important; }
  html:not([dir="rtl"]) .ps-xxl-2 {
    padding-left: 0.5rem !important; }
  *[dir="rtl"] .ps-xxl-2 {
    padding-right: 0.5rem !important; }
  html:not([dir="rtl"]) .ps-xxl-3 {
    padding-left: 1rem !important; }
  *[dir="rtl"] .ps-xxl-3 {
    padding-right: 1rem !important; }
  html:not([dir="rtl"]) .ps-xxl-4 {
    padding-left: 1.5rem !important; }
  *[dir="rtl"] .ps-xxl-4 {
    padding-right: 1.5rem !important; }
  html:not([dir="rtl"]) .ps-xxl-5 {
    padding-left: 3rem !important; }
  *[dir="rtl"] .ps-xxl-5 {
    padding-right: 3rem !important; }
  .gap-xxl-0 {
    gap: 0 !important; }
  .gap-xxl-1 {
    gap: 0.25rem !important; }
  .gap-xxl-2 {
    gap: 0.5rem !important; }
  .gap-xxl-3 {
    gap: 1rem !important; }
  .gap-xxl-4 {
    gap: 1.5rem !important; }
  .gap-xxl-5 {
    gap: 3rem !important; }
  .row-gap-xxl-0 {
    row-gap: 0 !important; }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important; }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important; }
  .row-gap-xxl-3 {
    row-gap: 1rem !important; }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important; }
  .row-gap-xxl-5 {
    row-gap: 3rem !important; }
  .column-gap-xxl-0 {
    column-gap: 0 !important; }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important; }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important; }
  .column-gap-xxl-3 {
    column-gap: 1rem !important; }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important; }
  .column-gap-xxl-5 {
    column-gap: 3rem !important; }
  html:not([dir="rtl"]) .text-xxl-start {
    text-align: left !important; }
  *[dir="rtl"] .text-xxl-start {
    text-align: right !important; }
  html:not([dir="rtl"]) .text-xxl-end {
    text-align: right !important; }
  *[dir="rtl"] .text-xxl-end {
    text-align: left !important; }
  html:not([dir="rtl"]) .text-xxl-center {
    text-align: center !important; }
  *[dir="rtl"] .text-xxl-center {
    text-align: center !important; } }

@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important; }
  .fs-2 {
    font-size: 2rem !important; }
  .fs-3 {
    font-size: 1.75rem !important; }
  .fs-4 {
    font-size: 1.5rem !important; } }

@media print {
  .d-print-inline {
    display: inline !important; }
  .d-print-inline-block {
    display: inline-block !important; }
  .d-print-block {
    display: block !important; }
  .d-print-grid {
    display: grid !important; }
  .d-print-inline-grid {
    display: inline-grid !important; }
  .d-print-table {
    display: table !important; }
  .d-print-table-row {
    display: table-row !important; }
  .d-print-table-cell {
    display: table-cell !important; }
  .d-print-flex {
    display: flex !important; }
  .d-print-inline-flex {
    display: inline-flex !important; }
  .d-print-none {
    display: none !important; } }

/*!
 * CoreUI Plugins - Chart.js for CoreUI 3
 * @version v3.1.2
 * @link https://coreui.io
 * Copyright (c) 2021 creativeLabs Łukasz Holeczek
 * Licensed under MIT (https://github.com/coreui/coreui-chartjs/blob/main/LICENSE)
 */
.chartjs-tooltip {
  position: absolute;
  z-index: 1021;
  padding: 0.25rem 0.5rem;
  color: #fff;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.7);
  opacity: 0;
  transition: all 0.15s ease;
  transform: translate(-50%, 0);
  border-radius: 0.375rem; }
  @media (prefers-reduced-motion: reduce) {
    .chartjs-tooltip {
      transition: none; } }

.chartjs-tooltip-header {
  margin-bottom: 0.5rem; }

.chartjs-tooltip-header-item {
  font-size: 0.875rem;
  font-weight: 700; }

.chartjs-tooltip-body-item {
  align-items: center;
  font-size: 0.875rem;
  white-space: nowrap; }

.wrapper {
  width: 100%;
  will-change: auto;
  transition: padding 0.15s; }
  html:not([dir="rtl"]) .wrapper {
    padding-left: 0;
    padding-left: var(--cui-sidebar-occupy-start, 0); }
  *[dir="rtl"] .wrapper {
    padding-right: 0;
    padding-right: var(--cui-sidebar-occupy-start, 0); }
  @media (prefers-reduced-motion: reduce) {
    .wrapper {
      transition: none; } }

.example:not(:first-child) {
  margin-top: 1.5rem; }

.example .tab-content {
  background-color: #f9fafa !important; }
  .dark-theme .example .tab-content {
    background-color: rgba(255, 255, 255, 0.1) !important; }

.example code[class*="language-"],
.example pre[class*="language-"] {
  font-size: .875rem !important; }

.example :not(pre) > code[class*="language-"],
.example pre[class*="language-"] {
  background: transparent; }

.example + p {
  margin-top: 1.5rem; }

.example .preview + p,
.example .preview .col + p {
  margin-top: 2rem; }

.example .preview > .form-control + .form-control,
.example .preview .col > .form-control + .form-control {
  margin-top: .5rem; }

.example .preview > .nav + .nav,
.example .preview > .alert + .alert,
.example .preview > .navbar + .navbar,
.example .preview > .progress + .progress,
.example .preview .col > .nav + .nav,
.example .preview .col > .alert + .alert,
.example .preview .col > .navbar + .navbar,
.example .preview .col > .progress + .progress {
  margin-top: 1rem; }

.example .preview > .dropdown-menu,
.example .preview .col > .dropdown-menu {
  position: static;
  display: block; }

.example .preview > :last-child,
.example .preview .col > :last-child {
  margin-bottom: 0; }

.example .preview > svg + svg,
.example .preview > img + img,
.example .preview .col > svg + svg,
.example .preview .col > img + img {
  margin-left: .5rem; }

.example .preview > .btn,
.example .preview > .btn-group,
.example .preview .col > .btn,
.example .preview .col > .btn-group {
  margin: .25rem .125rem; }

.example .preview > .btn-toolbar + .btn-toolbar,
.example .preview .col > .btn-toolbar + .btn-toolbar {
  margin-top: .5rem; }

.example .preview > .list-group,
.example .preview .col > .list-group {
  max-width: 400px; }

.example .preview > [class*="list-group-horizontal"],
.example .preview .col > [class*="list-group-horizontal"] {
  max-width: 100%; }

.example .preview .fixed-top,
.example .preview .sticky-top,
.example .preview .col .fixed-top,
.example .preview .col .sticky-top {
  position: static;
  margin: -1rem -1rem 1rem; }

.example .preview .fixed-bottom,
.example .preview .col .fixed-bottom {
  position: static;
  margin: 1rem -1rem -1rem; }

@media (min-width: 576px) {
  .example .preview .fixed-top,
  .example .preview .sticky-top,
  .example .preview .col .fixed-top,
  .example .preview .col .sticky-top {
    margin: -1.5rem -1.5rem 1rem; }
  .example .preview .fixed-bottom,
  .example .preview .col .fixed-bottom {
    margin: 1rem -1.5rem -1.5rem; } }

.example .preview .pagination,
.example .preview .col .pagination {
  margin-top: .5rem;
  margin-bottom: .5rem; }

/*Legend specific*/
.legend {
  padding: 6px 8px;
  font: 14px Arial, Helvetica, sans-serif;
  background: white;
  background: rgba(255, 255, 255, 0.8);
  /*box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);*/
  /*border-radius: 5px;*/
  line-height: 24px;
  color: #555; }

.legend h4, .legend .h4 {
  text-align: center;
  font-size: 16px;
  margin: 2px 12px 8px;
  color: #777; }

.legend span {
  position: relative;
  bottom: 3px; }

.legend i {
  width: 18px;
  height: 18px;
  float: left;
  margin: 0 8px 0 0;
  opacity: 0.7; }

.legend i.icon {
  background-size: 18px;
  background-color: white; }

.icon-Disponible {
  color: #22ac11 !important; }

.icon-NoDisponible {
  color: #DC3545 !important; }

.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  border-bottom: 5px solid #007BFF;
  background: #E1F4FF;
  font-size: 1.2rem !important;
  color: #007BFF !important; }

.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link {
  font-size: 1.2rem !important;
  color: #9A9A9A !important; }

.loading {
  font-size: 1.2rem !important;
  color: #DC3545 !important;
  text-align: center !important; }

.MuiTableCell-alignLeft {
  text-align: left !important; }

.CIconColor {
  color: #007BFF; }

.logo-empresaBpsystem {
  width: 70%; }

.img_carrucelPerfil {
  width: 100% !important; }

.img_carrucel {
  width: 100% !important;
  height: 100% !important; }

.textoMenu {
  font-size: 1.0rem !important; }

.textoMenuOFF {
  font-size: 1.0rem !important; }

.textoTabla {
  font-size: 0.8rem !important; }

.textoOption {
  font-size: 0.8rem !important; }

.textoTurno {
  font-size: 1.0rem !important; }

.sidebar-nav .nav-icon {
  flex: 0 0 3rem !important;
  height: 2rem !important;
  color: rgba(255, 255, 255, 0.6);
  color: var(--cui-sidebar-nav-link-icon-color, rgba(255, 255, 255, 0.6));
  text-align: center;
  fill: currentColor;
  transition: inherit; }

.nav-icon {
  width: 30px !important;
  height: 30px !important; }

.sidebar {
  --cui-sidebar-width: 17rem !important; }

.Row-leaflet-containerDenGrab {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #eeeeee !important;
  background-color: #fff !important;
  border-radius: 5px !important;
  box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;
  margin-bottom: 10px !important;
  height: 60vh !important; }

.col-titulo-login {
  border: 1px solid #eeeeee !important;
  background-color: #fff !important;
  border-radius: 5px !important;
  box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;
  margin-bottom: 10px !important;
  padding: 10px !important;
  margin-top: 3%;
  margin-right: auto;
  margin-left: auto;
  height: 100%;
  width: 30vw;
  min-height: 2.5rem;
  min-width: 2.5rem; }

.um_data-login-row {
  padding: 10px  !important;
  margin-top: 10px !important; }

.btn {
  margin-top: 10px !important;
  padding-left: 1.22rem;
  padding-right: 1.22rem; }

.btn1 {
  margin-top: 0px !important;
  padding-left: 1.22rem;
  padding-right: 1.22rem; }

.um_data-login-row {
  padding: 10px  !important;
  margin-top: 10px !important; }

.container2 {
  margin-left: 0px !important;
  transition: margin-left .2s ease-in !important;
  padding: 10px !important;
  box-sizing: border-box !important;
  background: #ffff !important; }

.container1 {
  text-align: center;
  margin-left: auto;
  margin-right: auto; }

.container3 {
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important; }

.texto-label-login-U {
  font-size: 0.7rem !important;
  justify-content: center;
  align-items: center; }

.center-texto {
  margin-top: 30px !important;
  display: flex;
  justify-content: center;
  align-items: center; }

.center-texto-SinTop {
  display: flex;
  justify-content: center;
  align-items: center; }

.left-texto {
  display: flex;
  justify-content: left;
  align-items: left; }

.leaflet-tooltip-own {
  position: absolute;
  padding: 4px;
  background-color: rgba(255, 255, 255, 0.4);
  border: 0px solid #000;
  color: #FFFFFF;
  white-space: nowrap;
  -webkit-user-select: none;
  user-select: none;
  pointer-events: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  color: #15438b !important;
  font-size: 0.6rem !important; }

.leaflet-tooltip-ownRojo {
  position: absolute;
  padding: 4px;
  background-color: rgba(255, 255, 255, 0.4);
  border: 0px solid #000;
  color: #FFFFFF;
  white-space: nowrap;
  -webkit-user-select: none;
  user-select: none;
  pointer-events: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  color: #fe0000 !important;
  font-size: 0.6rem !important; }

.leaflet-tooltip-ownVerde {
  position: absolute;
  padding: 4px;
  background-color: rgba(255, 255, 255, 0.4);
  border: 0px solid #000;
  color: #FFFFFF;
  white-space: nowrap;
  -webkit-user-select: none;
  user-select: none;
  pointer-events: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  color: #05b002 !important;
  font-size: 0.6rem !important; }

.logo-empresa {
  width: 40%;
  background: #FFFFFF !important;
  border-radius: 5px !important;
  margin-top: 2px !important; }

.logo-empresaT {
  width: 100%;
  background: #FFFFFF !important;
  border-radius: 5px !important;
  margin-top: 2px !important; }

.logo-empresaT_MAHO {
  width: 50%;
  background: #FFFFFF !important;
  border-radius: 5px !important;
  margin-top: 2px !important; }

.logo-empresaR {
  text-align: center !important;
  justify-content: center !important;
  width: 50% !important;
  background: #FFFFFF !important;
  border-radius: 5px !important;
  margin-top: 10px !important; }

.icon-Bpsystem {
  color: #e67e22 !important; }

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%; }

.centerPie {
  display: block;
  margin-left: auto;
  margin-right: auto;
  font-size: 1rem !important; }

.center {
  display: flex;
  justify-content: center;
  align-items: center; }

.centerT {
  margin-top: 0px !important;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 60%; }

.centerT_MAHO {
  margin-top: 0px !important;
  justify-content: center;
  align-items: center;
  display: flex; }

.reloj1 {
  color: #15438b !important;
  font-size: 1rem !important;
  text-align: center !important;
  justify-content: center !important; }

.logo-empresa1 {
  text-align: center !important;
  justify-content: center !important;
  width: 85% !important;
  background: #FFFFFF !important;
  border-radius: 5px !important;
  margin-top: 10px !important; }

.errorMsg {
  width: 100% !important;
  color: #f21e08 !important;
  padding: 1px 0;
  margin-top: 1%;
  font-size: 0.8rem;
  font-weight: bold; }

.text-SOS, .text-SOS:hover {
  color: #9368E9 !important; }

.text-EME, .text-EME:hover {
  color: #DC3545 !important; }

.text-URG, .text-URG:hover {
  color: #FFC107 !important; }

.text-DEN, .text-DEN:hover {
  color: #007BFF !important; }

.text-PLA, .text-PLA:hover {
  color: #afb6c0 !important; }

.stats {
  color: #a9a9a9;
  font-size: 0.7rem !important; }

.card-category,
label {
  font-size: 1rem;
  font-weight: 400;
  color: #9A9A9A;
  margin-bottom: 0px; }
  .card-category i,
  label i {
    font-size: 16px; }

.card-footer {
  padding-top: 0;
  background-color: transparent;
  line-height: 30px;
  border-top: none !important;
  font-size: 14px; }
  .card-footer .legend {
    padding: 5px 0; }
  .card-footer hr {
    margin-top: 5px;
    margin-bottom: 5px; }

.card-stats .card-body {
  padding: 15px 15px 0px; }
  .card-stats .card-body .numbers {
    font-size: 1.8rem;
    text-align: right; }
    .card-stats .card-body .numbers p {
      margin-bottom: 0; }

.card-stats .card-footer {
  padding: 0px 15px 10px 15px; }

.card-stats .icon-big {
  font-size: 3em;
  min-height: 64px; }
  .card-stats .icon-big i {
    font-weight: 700;
    line-height: 59px; }

.card-stats .card-body {
  padding: 15px 15px 0px; }
  .card-stats .card-body .numbers {
    font-size: 1.8rem;
    text-align: right; }
    .card-stats .card-body .numbers p {
      margin-bottom: 0; }

.card-stats .card-footer {
  padding: 0px 15px 10px 15px; }

.card-stats .icon-big {
  font-size: 3em;
  min-height: 64px; }
  .card-stats .icon-big i {
    font-weight: 700;
    line-height: 59px; }

.img-xxl {
  width: 60px !important;
  height: 60px !important;
  padding: 0px; }

@media only screen and (min-width: 427px) and (max-width: 768px) {
  .reloj1 {
    color: #15438b !important;
    font-size: 0.6rem !important;
    text-align: center !important;
    justify-content: center !important; }
  .centerPie {
    display: block;
    margin-left: auto;
    margin-right: auto;
    font-size: 0.8rem !important; }
  .col-titulo-login {
    border: 1px solid #eeeeee !important;
    background-color: #fff !important;
    border-radius: 5px !important;
    box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;
    margin-bottom: 10px !important;
    padding: 10px !important;
    margin-top: 10%;
    margin-right: auto;
    margin-left: auto;
    height: 100%;
    width: 90vw;
    min-height: 2.5rem;
    min-width: 2.5rem; }
  .btn {
    margin-top: 20px !important;
    padding-left: 2.5rem;
    padding-right: 2.5rem; }
  .CHDivider {
    padding: 0px !important;
    margin-top: 0px !important;
    margin-bottom: 0px !important; }
  .center-texto {
    margin-top: 20px !important;
    display: flex;
    justify-content: center;
    align-items: center; }
  .left-texto {
    justify-content: center;
    align-items: center; }
  .logo-empresa {
    width: 45%;
    background: #FFFFFF !important;
    border-radius: 5px !important;
    margin-top: 0px !important; }
  .logo-empresa1 {
    text-align: center !important;
    justify-content: center !important;
    width: 100% !important;
    background: #FFFFFF !important;
    border-radius: 5px !important;
    margin-top: 0px !important; } }

.leaflet-containerCasosAct {
  width: 100%;
  height: 100%; }

.img-DenunciaDetalleDespacho {
  padding: 0.1rem;
  height: 60px;
  max-width: 100%;
  border-radius: 5%;
  cursor: pointer;
  box-shadow: 3px 5px 7px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; }

.img-DenunciaDetalle {
  padding: 0.3rem;
  height: 80px;
  max-width: 100%;
  border-radius: 5%;
  cursor: pointer;
  box-shadow: 3px 5px 7px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; }

.img-DenunciaDetalle0 {
  padding: 0.3rem;
  height: 120px;
  border-radius: 5%;
  box-shadow: 3px 5px 7px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; }

.img-DenunciaDetalle1 {
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; }

.Row-leaflet-containerDen {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #eeeeee !important;
  background-color: #fff !important;
  border-radius: 5px !important;
  box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;
  margin-bottom: 10px !important;
  height: 87vh !important; }

.Row-leaflet-containerDenMapa {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #eeeeee !important;
  background-color: #fff !important;
  border-radius: 5px !important;
  box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;
  margin-bottom: 10px !important;
  height: 33vh !important; }

.Row-leaflet-containerInspeccion {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #eeeeee !important;
  background-color: #fff !important;
  border-radius: 5px !important;
  box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;
  margin-bottom: 10px !important;
  height: 66vh !important; }

.Row-leaflet-containerDenAdm {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #eeeeee !important;
  background-color: #fff !important;
  border-radius: 5px !important;
  box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;
  margin-bottom: 10px !important;
  height: 30vh !important; }

.Row-leaflet-containerDenAnt {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #eeeeee !important;
  background-color: #fff !important;
  border-radius: 5px !important;
  box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;
  margin-bottom: 10px !important;
  height: 40vh; }

.Row-leaflet-containerDenGrab {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #eeeeee !important;
  background-color: #fff !important;
  border-radius: 5px !important;
  box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;
  margin-bottom: 10px !important;
  height: 60vh !important; }

.request-popup {
  top: -340px !important; }

.request-popupDistancia {
  top: -240px !important; }

.img-Denuncia {
  height: 100px;
  max-width: 100%;
  border-radius: 5%;
  cursor: pointer;
  box-shadow: 3px 5px 7px rgba(0, 0, 0, 0.5); }

.img-Denuncia-despacho {
  height: 50px;
  max-width: 100%;
  border-radius: 5%;
  cursor: pointer;
  box-shadow: 3px 5px 7px rgba(0, 0, 0, 0.5); }

.img-DenunciaDetalle1 {
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; }

.img-DenunciaDetalle {
  padding: 0.3rem;
  height: 80px;
  max-width: 100%;
  border-radius: 5%;
  cursor: pointer;
  box-shadow: 3px 5px 7px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; }

.img-DenunciaDetalle0 {
  padding: 0.3rem;
  height: 120px;
  border-radius: 5%;
  box-shadow: 3px 5px 7px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; }

.textoCuadroDespacho {
  font-size: 0.7rem !important; }

.textoCuadroPosicion {
  font-size: 1rem !important; }

.textocentradoAntecedentes1 {
  color: #007BFF !important;
  font-size: 0.8rem !important; }

.textocentradoAntecedentes2 {
  color: #22ac11 !important;
  font-size: 0.8rem !important; }

.textocentradoAntecedentes1Titulo {
  color: #007BFF !important;
  font-size: 1rem !important; }

.textocentradoAntecedentes1TituloTurno {
  color: #DC3545 !important;
  font-size: 1.2rem !important; }

.textocentradoAntecedentes2Titulo {
  color: #22ac11 !important;
  font-size: 1rem !important; }

.text-primary, .text-primary:hover {
  color: #1D62F0 !important; }

.card-stats .card-body {
  padding: 15px 15px 0px; }
  .card-stats .card-body .numbers {
    font-size: 1.8rem;
    text-align: right; }
    .card-stats .card-body .numbers p {
      margin-bottom: 0; }

.card-stats .card-footer {
  padding: 0px 15px 10px 15px; }

.card-stats .icon-big {
  font-size: 3em;
  min-height: 64px; }
  .card-stats .icon-big i {
    font-weight: 700;
    line-height: 59px; }

.img-pointer {
  cursor: pointer; }

.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1; }

.fondo_antecedentes {
  box-shadow: 3px 5px 7px rgba(0, 0, 0, 0.5);
  border: 3px solid #cccccc; }

.img-DenunciaAntecedente {
  height: 4rem;
  width: 4rem;
  min-height: 4rem;
  min-width: 4rem;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  border-radius: 50%;
  padding: 0.1rem;
  cursor: pointer;
  box-shadow: 3px 5px 7px rgba(0, 0, 0, 0.5);
  align-items: center; }

.custom-checkbox-reverse {
  padding-left: 0;
  padding-right: 1.5rem; }

.custom-checkbox-reverse .custom-control-label::before,
.custom-checkbox-reverse .custom-control-label::after {
  left: auto;
  right: -1.5rem; }

.offcanvas-start {
  transform: translateX(-100%) !important; }

.offcanvas-end {
  transform: translateX(100%) !important; }

.offcanvas.show {
  transform: none !important; }

.flag-img1 {
  width: 55px;
  height: 25px;
  position: flex;
  border-radius: 5px;
  border: 1px solid; }

.icon-login {
  font-size: 35px !important;
  padding: 0px 0 0 5px !important;
  position: flex !important;
  border-radius: 5px !important; }

.form-control.input-error {
  border: 1px solid #f21e08 !important; }

.text-danger, .text-danger:hover {
  color: #DC3545 !important; }

.um_data {
  border: 1px solid #eeeeee !important;
  border-radius: 4px;
  box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;
  padding: 5px 10px 5px;
  margin-bottom: 10px; }

.leaflet-container {
  border-radius: 5px;
  width: 100%;
  height: 160px;
  border: 1px  solid #c0c0c0 !important; }

.col-texto-registro {
  display: flex !important;
  font-size: 1.5rem !important;
  justify-content: center !important; }

.col-titulo-registro {
  background-color: #fff !important;
  border-radius: 5px !important;
  text-align: center;
  padding: 10px !important; }

.steps {
  display: flex;
  justify-content: center;
  margin-top: 0rem; }
  .steps .step {
    margin: 0.5rem 1.5rem;
    display: flex;
    color: #ccc !important; }
    .steps .step a {
      color: #22ac11; }
    .steps .step div:first-of-type {
      border: 1px solid #ccc !important;
      padding: 5px;
      border-radius: 50%;
      margin-right: 0.5rem;
      width: 2.5rem;
      height: 2rem;
      text-align: center;
      line-height: 100%;
      padding-top: 2%;
      font-size: 1.5rem; }
    .steps .step :last-child {
      margin-top: 3%; }
    .steps .step.active div:first-of-type {
      background-color: #e67e22;
      border: 1px solid transparent;
      color: #fff; }
    .steps .step.active div:last-of-type {
      color: #e67e22; }

.col-titulo-loginR {
  border: 1px solid #eeeeee !important;
  background-color: #fff !important;
  border-radius: 5px !important;
  box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;
  margin-bottom: 10px !important;
  padding: 10px !important;
  margin-top: 3%;
  margin-right: auto;
  margin-left: auto;
  height: 100%;
  width: 45vw;
  min-height: 2.5rem;
  min-width: 2.5rem; }

.react-tel-input {
  font-size: 0.9rem !important; }

.react-tel-input .form-control {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  height: 3.5rem !important;
  position: relative;
  letter-spacing: .01rem;
  border-radius: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  width: 100% !important;
  font-size: 0.9rem !important; }

.col-titulo-denuncia {
  border: 1px solid #eeeeee !important;
  background-color: #fff !important;
  border-radius: 5px !important;
  box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;
  margin-bottom: 5px !important;
  padding: 5px !important; }

.col-texto-denuncia {
  display: flex !important;
  font-size: 1.5rem !important;
  justify-content: center !important; }

.logo-titulos {
  width: 50px;
  height: 50px;
  alt: ""; }

.logo-titulosDenuncia {
  width: 50px;
  height: 50px;
  padding: 0.2rem; }

.logo-titulos-inspeccion {
  width: 30px;
  height: 30px;
  alt: ""; }

.Row-leaflet-containerCasosAct {
  min-height: 31vh;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #eeeeee !important;
  background-color: #fff !important;
  border-radius: 5px !important;
  box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;
  margin-bottom: 10px !important; }

.Row-leaflet-containerTurnos {
  min-height: 31vh;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #eeeeee !important;
  background-color: #fff !important;
  border-radius: 5px !important;
  box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;
  margin-bottom: 10px !important; }

.img-DenunciaAntecedente2 {
  height: 3rem;
  width: 3rem;
  min-height: 3rem;
  min-width: 3rem;
  color: #e67e22 !important;
  font-size: 0.6rem !important;
  font-weight: bold !important;
  border-radius: 50%;
  padding: 0.1rem;
  cursor: pointer;
  box-shadow: 3px 5px 7px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; }

.circleTip {
  box-shadow: none;
  border-radius: 6px;
  border: 1px solid #007BFF;
  padding: 5px;
  font-size: 10px;
  font-weight: 600;
  text-align: center; }

.circleTipclassic1 {
  background: #fdfde1;
  border: 1px solid #FFAD33;
  font-weight: 800; }

.circleTipclassic {
  background: #fdfde1;
  background-color: rgba(255, 255, 255, 0.4);
  border: 0px solid #FFAD33;
  font-size: 0.6rem !important;
  font-weight: bold !important;
  white-space: pre-wrap;
  text-align: center; }

.classic {
  background: #FFFFAA;
  border: 1px solid #FFAD33; }

.critical {
  background: #FFCCAA;
  border: 1px solid #FF3334; }

.help {
  background: #9FDAEE;
  border: 1px solid #2BB0D7; }

.info {
  background: #9FDAEE;
  border: 1px solid #2BB0D7; }

.warning {
  background: #FFFFAA;
  border: 1px solid #FFAD33; }

.card-user .card-image {
  height: 110px; }

.card-user .card-image-plain {
  height: 0;
  margin-top: 110px; }

.card-user .author {
  text-align: center;
  text-transform: none;
  margin-top: -70px; }

.card-user .avatar {
  width: 124px;
  height: 124px;
  border: 5px solid #FFFFFF;
  position: relative;
  margin-bottom: 15px; }
  .card-user .avatar.border-gray {
    border-color: #EEEEEE; }

.card-user .title {
  line-height: 24px;
  font-size: 12px; }

.card-user .card-body {
  min-height: 240px; }

.card-user .card-footer,
.card-price .card-footer {
  padding: 5px 15px 10px; }

.card-user hr,
.card-price hr {
  margin: 5px 15px; }

.img-avatar {
  width: 40px;
  height: 40px;
  cursor: pointer; }

.img-avatar-Despacho {
  width: 40px;
  height: 30px;
  cursor: pointer; }

.mymarker svg path {
  fill: black; }

.mymarker {
  transition: transform 0.5s linear; }

.indicator {
  font-family: "Aldrich","Helvetica Neue",Arial,sans-serif;
  background-color: white;
  border: 1px solid dodgerblue;
  border-radius: 6px;
  color: dodgerblue;
  font-size: 8px;
  font-weight: 400;
  padding: 2px 4px;
  position: relative;
  bottom: 25px;
  white-space: nowrap;
  transition: transform 0.5s linear;
  top: 25px;
  left: -20px; }

.indicator1 {
  font-family: "Aldrich","Helvetica Neue",Arial,sans-serif;
  background-color: white;
  border: 1px solid #e67e22;
  border-radius: 6px;
  color: #e67e22;
  font-size: 8px;
  font-weight: 400;
  padding: 2px 4px;
  position: relative;
  bottom: 25px;
  white-space: nowrap;
  transition: transform 0.5s linear;
  top: 25px;
  left: -20px; }

.indicatorD {
  font-family: "Aldrich","Helvetica Neue",Arial,sans-serif;
  background-color: white;
  border: 1px solid #22ac11;
  border-radius: 6px;
  color: #22ac11;
  font-size: 8px;
  font-weight: 400;
  padding: 2px 4px;
  position: relative;
  bottom: 25px;
  white-space: nowrap;
  transition: transform 0.5s linear;
  top: 25px;
  left: -20px; }

.indicatorND {
  font-family: "Aldrich","Helvetica Neue",Arial,sans-serif;
  background-color: white;
  border: 1px solid #DC3545;
  border-radius: 6px;
  color: #DC3545;
  font-size: 8px;
  font-weight: 400;
  padding: 2px 4px;
  position: relative;
  bottom: 25px;
  white-space: nowrap;
  transition: transform 0.5s linear;
  top: 25px;
  left: -20px; }

.indicatorY {
  font-family: "Aldrich","Helvetica Neue",Arial,sans-serif;
  background-color: white;
  border: 1px solid dodgerblue;
  border-radius: 6px;
  color: dodgerblue;
  font-size: 8px;
  font-weight: 400;
  padding: 2px 4px;
  position: relative;
  bottom: 25px;
  white-space: nowrap;
  transition: transform 0.5s linear;
  top: 5px;
  left: -20px; }

.StyleSelect {
  font-size: 1.8rem !important;
  resize: 'none' !important; }

.StyleSelectPrioridad {
  font-size: 1.0rem !important;
  resize: 'none' !important; }

.StyleSelectFechas {
  font-size: 1.5rem !important;
  resize: 'none' !important; }

.StyleSelectFechasJPL {
  font-size: 1.3rem !important;
  resize: 'none' !important; }

.datetimeControl p {
  margin: 0;
  font-size: 16px; }

.audioControl {
  width: 550px !important;
  height: 50px !important; }

@media screen and (max-width: 426px) {
  .textoOption {
    font-size: 0.7rem !important; }
  .col-texto-denuncia {
    display: flex !important;
    font-size: 1.0rem !important;
    justify-content: center !important; }
  .col-titulo-login {
    border: 1px solid #eeeeee !important;
    background-color: #fff !important;
    border-radius: 5px !important;
    box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;
    margin-bottom: 10px !important;
    padding: 10px !important;
    margin-top: 3%;
    margin-right: auto;
    margin-left: auto;
    height: 100%;
    width: 90vw;
    min-height: 2.5rem;
    min-width: 2.5rem; }
  .centerT {
    margin-top: -5px !important;
    display: flex;
    align-items: center;
    width: 45%; }
  .reloj1 {
    color: #15438b !important;
    font-size: 0.5rem !important;
    text-align: center !important;
    justify-content: center !important; }
  .centerPie {
    display: block;
    margin-left: auto;
    margin-right: auto;
    font-size: 0.6rem !important; }
  .steps {
    display: flex;
    justify-content: center;
    margin-top: 0rem; }
    .steps .step {
      margin: 0.5rem 1.0rem;
      display: flex;
      color: #ccc !important; }
      .steps .step a {
        color: #22ac11; }
      .steps .step div:first-of-type {
        border: 1px solid #ccc !important;
        padding: 5px;
        border-radius: 50%;
        margin-right: 0.5rem;
        width: 1.5rem;
        height: 1.5rem;
        text-align: center;
        line-height: 100%;
        padding-top: 2%;
        font-size: 1.0rem; }
      .steps .step :last-child {
        margin-top: 2%; }
      .steps .step.active div:first-of-type {
        background-color: #e67e22;
        border: 1px solid transparent;
        color: #fff; }
      .steps .step.active div:last-of-type {
        color: #e67e22; }
  .StyleSelect {
    font-size: 1.2rem !important;
    resize: 'none' !important; }
  .StyleSelectFechas {
    font-size: 1.0rem !important;
    resize: 'none' !important; }
  .StyleSelectFechasJPL {
    font-size: 1.0rem !important;
    resize: 'none' !important; }
  .audioControl {
    width: 250px !important;
    height: 50px !important; }
  .logo-empresa1 {
    text-align: center !important;
    justify-content: center !important;
    width: 100% !important;
    background: #FFFFFF !important;
    border-radius: 5px !important;
    margin-top: 5px !important; }
  .logo-empresaT {
    width: 100% !important;
    background: #FFFFFF !important;
    border-radius: 5px !important;
    margin-top: 2px !important; }
  .logo-empresaT_MAHO {
    width: 100%;
    background: #FFFFFF !important;
    border-radius: 5px !important;
    margin-top: 2px !important; }
  .Row-leaflet-containerDen {
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #eeeeee !important;
    background-color: #fff !important;
    border-radius: 5px !important;
    box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;
    margin-bottom: 10px !important;
    height: 60vh !important; }
  .Row-leaflet-containerDenMapa {
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #eeeeee !important;
    background-color: #fff !important;
    border-radius: 5px !important;
    box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;
    margin-bottom: 10px !important;
    height: 60vh !important; }
  .Row-leaflet-containerInspeccion {
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #eeeeee !important;
    background-color: #fff !important;
    border-radius: 5px !important;
    box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;
    margin-bottom: 10px !important;
    height: 40vh !important; }
  .textoTurno {
    font-size: 0.8rem !important; } }
`, "",{"version":3,"sources":["webpack://./src/scss/style.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_banner.scss","webpack://./node_modules/@coreui/coreui/scss/_root.scss","webpack://./node_modules/@coreui/coreui/scss/vendor/_rfs.scss","webpack://./node_modules/@coreui/coreui/scss/_reboot.scss","webpack://./node_modules/@coreui/coreui/scss/_variables.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_ltr-rtl.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_border-radius.scss","webpack://./node_modules/@coreui/coreui/scss/_functions.scss","webpack://./node_modules/@coreui/coreui/scss/_type.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_lists.scss","webpack://./node_modules/@coreui/coreui/scss/_images.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_image.scss","webpack://./node_modules/@coreui/coreui/scss/_containers.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_container.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_breakpoints.scss","webpack://./node_modules/@coreui/coreui/scss/_grid.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_grid.scss","webpack://./node_modules/@coreui/coreui/scss/_tables.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_table-variants.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_labels.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-text.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-control.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_transition.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_gradients.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-select.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-check.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_form-range.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_floating-labels.scss","webpack://./node_modules/@coreui/coreui/scss/forms/_input-group.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_forms.scss","webpack://./node_modules/@coreui/coreui/scss/_buttons.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_buttons.scss","webpack://./node_modules/@coreui/coreui/scss/_transitions.scss","webpack://./node_modules/@coreui/coreui/scss/_dropdown.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_caret.scss","webpack://./node_modules/@coreui/coreui/scss/_button-group.scss","webpack://./node_modules/@coreui/coreui/scss/_nav.scss","webpack://./node_modules/@coreui/coreui/scss/_navbar.scss","webpack://./node_modules/@coreui/coreui/scss/_card.scss","webpack://./node_modules/@coreui/coreui/scss/_accordion.scss","webpack://./node_modules/@coreui/coreui/scss/_breadcrumb.scss","webpack://./node_modules/@coreui/coreui/scss/_pagination.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_pagination.scss","webpack://./node_modules/@coreui/coreui/scss/_badge.scss","webpack://./node_modules/@coreui/coreui/scss/_alert.scss","webpack://./node_modules/@coreui/coreui/scss/_progress.scss","webpack://./node_modules/@coreui/coreui/scss/_list-group.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_list-group.scss","webpack://./node_modules/@coreui/coreui/scss/_close.scss","webpack://./node_modules/@coreui/coreui/scss/_toasts.scss","webpack://./node_modules/@coreui/coreui/scss/_modal.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_backdrop.scss","webpack://./node_modules/@coreui/coreui/scss/_tooltip.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_reset-text.scss","webpack://./node_modules/@coreui/coreui/scss/_popover.scss","webpack://./node_modules/@coreui/coreui/scss/_carousel.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_clearfix.scss","webpack://./node_modules/@coreui/coreui/scss/_spinners.scss","webpack://./node_modules/@coreui/coreui/scss/_offcanvas.scss","webpack://./node_modules/@coreui/coreui/scss/_placeholders.scss","webpack://./node_modules/@coreui/coreui/scss/_avatar.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_avatar.scss","webpack://./node_modules/@coreui/coreui/scss/_callout.scss","webpack://./node_modules/@coreui/coreui/scss/_footer.scss","webpack://./node_modules/@coreui/coreui/scss/_header.scss","webpack://./node_modules/@coreui/coreui/scss/_icon.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_icon.scss","webpack://./node_modules/@coreui/coreui/scss/sidebar/_sidebar.scss","webpack://./node_modules/@coreui/coreui/scss/sidebar/_sidebar-nav.scss","webpack://./node_modules/@coreui/coreui/scss/sidebar/_sidebar-narrow.scss","webpack://./node_modules/@coreui/coreui/scss/_subheader.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_color-bg.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_colored-links.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_focus-ring.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_icon-link.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_ratio.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_position.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_stacks.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_visually-hidden.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_visually-hidden.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_stretched-link.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_text-truncation.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_text-truncate.scss","webpack://./node_modules/@coreui/coreui/scss/helpers/_vr.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_utilities.scss","webpack://./node_modules/@coreui/coreui/scss/utilities/_api.scss","webpack://./node_modules/@coreui/chartjs/scss/coreui-chartjs.scss","webpack://./node_modules/@coreui/chartjs/scss/_tooltips.scss","webpack://./src/scss/_layout.scss","webpack://./src/scss/_example.scss","webpack://./src/scss/_custom.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACCd;;;;IDIE;AELJ;EAQI,mBAAwB;EAAxB,qBAAwB;EAAxB,qBAAwB;EAAxB,mBAAwB;EAAxB,kBAAwB;EAAxB,qBAAwB;EAAxB,qBAAwB;EAAxB,oBAAwB;EAAxB,mBAAwB;EAAxB,mBAAwB;EAAxB,oBAAwB;EAAxB,iBAAwB;EAAxB,mBAAwB;EAAxB,wBAAwB;EAIxB,uBAAkC;EAAlC,uBAAkC;EAAlC,uBAAkC;EAAlC,uBAAkC;EAAlC,uBAAkC;EAAlC,uBAAkC;EAAlC,uBAAkC;EAAlC,uBAAkC;EAAlC,uBAAkC;EAIlC,sBAAwB;EAAxB,wBAAwB;EAAxB,sBAAwB;EAAxB,gBAAwB;EAAxB,sBAAwB;EAAxB,qBAAwB;EAAxB,oBAAwB;EAAxB,mBAAwB;EAIxB,8BAAgC;EAAhC,kCAAgC;EAAhC,8BAAgC;EAAhC,4BAAgC;EAAhC,+BAAgC;EAAhC,6BAAgC;EAAhC,8BAAgC;EAAhC,2BAAgC;EAGlC,8BAAiC;EACjC,yBAAiC;EACjC,gCAA2C;EAC3C,gCAAqC;EAMrC,qEAA6C;EAC7C,0GAA2C;EAC3C,0FAA+B;EAO/B,kDAA+C;ECsP3C,0BAnE+B;EDjLnC,2BAA+C;EAC/C,2BAA+C;EAK/C,wCAAmC;EACnC,gCAA2C;EAC3C,mBAA6B;EAC7B,gCAAqC;EAErC,6BAA2C;EAC3C,kCAAmD;EAEnD,8CAA6C;EAC7C,qCAAqD;EACrD,2BAAuC;EACvC,qCAA+C;EAE/C,4CAA2C;EAC3C,oCAAmD;EACnD,0BAAqC;EACrC,oCAA6C;EAG7C,2CAAyC;EACzC,8CAA6C;EAC7C,sCAA+B;EAE/B,sDAAyD;EACzD,uDAA6D;EAC7D,iDAA+C;EAE/C,4BAAyC;EAEzC,yBAAmC;EACnC,iCAA2C;EAC3C,gCAA6C;EAE7C,+BAA+C;EAC/C,uCAAuD;EAMvD,yBAAmC;EACnC,2BAAuC;EAGvC,uBAAuC;EACvC,yBAAuC;EACvC,2BAAuC;EACvC,qDAA+D;EAE/D,6BAAyC;EACzC,+BAA+C;EAC/C,8BAA+C;EAC/C,4BAA+C;EAC/C,6BAAiD;EACjD,qDAAiD;EACjD,+BAAmD;EAGnD,oDAAmC;EACnC,6DAAyC;EACzC,sDAAyC;EACzC,6DAA+C;EAI/C,+BAA+C;EAC/C,8BAAmD;EACnD,+CAA+C;EAI/C,+BAA+C;EAC/C,sCAA6D;EAC7D,iCAAmD;EACnD,wCAAiE,EAAA;;AE5GnE;;;EAGE,sBAAsB,EAAA;;AAepB;EFjCJ;IEkCM,uBAAuB,EAAA,EAG5B;;AAWD;EACE,SAAS;EACT,2DAAgE;EAAhE,wCAAgE;ED6O5D,eAnE+B;EAmE/B,oCAnE+B;ECxKnC,gBAAgE;EAAhE,wCAAgE;EAChE,gBAAgE;EAAhE,wCAAgE;EAChE,6BAA8C;EAA9C,4BAA8C;EAC9C,sCAA6D;EAC7D,sBAAmD;EAAnD,oCAAmD;EACnD,8BAA8B;EAC9B,8CCvCiB,EAAA;;ADgDnB;EACE,cAAsB;EACtB,cC6qBmC;ED5qBnC,SAAS;EACT,qBAAkC;EAAlC,yCAAkC;EAClC,aCmrB+B,EAAA;;ADzqBjC;EACE,aAAa;EACb,qBC0mBwC;EDvmBxC,gBC0mB+B;EDzmB/B,gBC0mB+B;EDzmB/B,cAAoD;EAApD,+BAAoD,EAAA;;AAGtD;EDuMQ,iCAf6B,EAAA;EA7IjC;IC3CJ;MD8MQ,iBA9E6B,EAAA,EC7HpC;;AAED;EDkMQ,iCAf6B,EAAA;EA7IjC;ICtCJ;MDyMQ,eA9E6B,EAAA,ECxHpC;;AAED;ED6LQ,+BAf6B,EAAA;EA7IjC;ICjCJ;MDoMQ,kBA9E6B,EAAA,ECnHpC;;AAED;EDwLQ,iCAf6B,EAAA;EA7IjC;IC5BJ;MD+LQ,iBA9E6B,EAAA,EC9GpC;;AAED;ED+KM,kBAnE+B,EAAA;;ACvGrC;ED0KM,eAnE+B,EAAA;;AC5FrC;EACE,aAAa;EACb,mBCyY8B,EAAA;;AD/XhC;EACE,yCAAiC;UAAjC,iCAAiC;EACjC,YAAY;EACZ,sCAA8B;UAA9B,8BAA8B,EAAA;;AAMhC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB,EAAA;;AAWtB;;;EAGE,aAAa;EACb,mBAAmB,EAAA;;AAGrB;;;;EAIE,gBAAgB,EAAA;;AAGlB;EACE,gBC+e+B,EAAA;;AD1ejC;EACE,oBAAoB,EAAA;EEtLlB;IAgCE,cFuJ6B,EAAA;EE/K/B;IA+BI,eAxBE,EAAA;;AF8KV;EACE,gBAAgB,EAAA;;AAQlB;;EAEE,mBCwdkC,EAAA;;ADhdpC;ED6EM,kBAnE+B,EAAA;;ACHrC;EACE,iBC+iBmC;ED9iBnC,yBAA6D;EAA7D,yCAA6D,EAAA;;AAS/D;;EAEE,kBAAkB;EDyDd,iBAnE+B;ECYnC,cAAc;EACd,wBAAwB,EAAA;;AAG1B;EAAM,cAAc,EAAA;;AACpB;EAAM,UAAU,EAAA;;AAKhB;EACE,2BAA4G;EAA5G,kEAA4G;EAC5G,0BCkQiD,EAAA;EDpQnD;IAKI,qDAA2C,EAAA;;AAS/C;EAGI,cAAc;EACd,qBAAqB,EAAA;;AAOzB;;;;EAIE,iGCoY2E;EDpY3E,sCCoY2E;EFpXvE,cAnE+B,EAAA;;AC2DrC;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,cAAc;EDIV,kBAnE+B;ECiEnC,6BAAwD,EAAA;EAN1D;IDQM,kBAnE+B;ICsEjC,cAAc;IACd,kBAAkB,EAAA;;AAItB;EDRM,kBAnE+B;EC6EnC,cAA8C;EAA9C,4BAA8C;EAC9C,qBAAqB,EAAA;EAGrB;IACE,cAAc,EAAA;;AAIlB;EACE,2BCqtDyC;EFzuDrC,kBAnE+B;ECyFnC,WAAwD;EAAxD,+CAAwD;EACxD,wCAA0D;EAA1D,0DAA0D;EGnSxD,sBFkkBgC,EAAA;EDnSpC;IAQI,UAAU;ID3BR,cAnE+B,EAAA;;ACyGrC;EACE,gBAAgB,EAAA;;AAMlB;;EAEE,sBAAsB,EAAA;;AAQxB;EACE,oBAAoB;EACpB,yBAAyB,EAAA;;AAG3B;EACE,mBC8biC;ED7bjC,sBC6biC;ED5bjC,8BAAsF;EAAtF,iEAAsF;EACtF,gBAAgB,EAAA;;AAOlB;EAEE,mBAAmB;EACnB,gCAAgC,EAAA;;AAGlC;;;;;;EAME,qBAAqB;EACrB,mBAAmB;EACnB,eAAe,EAAA;;AAQjB;EACE,qBAAqB,EAAA;;AAMvB;EAEE,gBAAgB,EAAA;;AAQlB;EACE,UAAU,EAAA;;AAKZ;;;;;EAKE,SAAS;EACT,oBAAoB;ED1HhB,kBAnE+B;EC+LnC,oBAAoB,EAAA;;AAItB;;EAEE,oBAAoB,EAAA;;AJhFtB;EIsFE,eAAe,EAAA;;AAGjB;EAGE,iBAAiB,EAAA;EAHnB;IAOI,UAAU,EAAA;;AJxFd;EIgGE,wBAAwB,EAAA;;AAQ1B;;;;EAIE,0BAA0B,EAAA;EAJ5B;;;;IAQM,eAAe,EAAA;;AAOrB;EACE,UAAU;EACV,kBAAkB,EAAA;;AAKpB;EACE,gBAAgB,EAAA;;AAUlB;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,SAAS,EAAA;;AAQX;EAEE,WAAW;EACX,UAAU;EACV,qBC+QiC;EF9d3B,iCAf6B;ECiOnC,oBAAoB,EAAA;EEnflB;IAgCE,WF6c0B,EAAA;EEre5B;IA+BI,YE+EmI,EAAA;ELevI;ICuWJ;MDpMQ,iBA9E6B,EAAA,EC8RpC;EAZD;IAUI,WAAW,EAAA;;AAOf;;;;;;;EAOE,UAAU,EAAA;;AAGZ;EACE,YAAY,EAAA;;AJ1Hd;EIoIE,6BAA6B;EAC7B,oBAAoB,EAAA;;AAMtB;;;;EAKI,cAAc,EAAA;;AAOlB;EACE,wBAAwB,EAAA;;AAK1B;EACE,UAAU,EAAA;;AAOZ;EACE,aAAa;EACb,0BAA0B,EAAA;;AAF5B;EACE,aAAa;EACb,0BAA0B,EAAA;;AAK5B;EACE,qBAAqB,EAAA;;AAKvB;EACE,SAAS,EAAA;;AAOX;EACE,kBAAkB;EAClB,eAAe,EAAA;;AAQjB;EACE,wBAAwB,EAAA;;AJpK1B;EI6KE,wBAAwB,EAAA;;AKlkB1B;ENmQM,kBAnE+B;EM9LnC,gBJ0rBiC,EAAA;;AIrrBjC;ENgQM,iCAf6B;EM7OjC,gBJ2qBqB;EI1qBrB,gBJ0pB6B,EAAA;EF3jB7B;IMpGF;MNuQM,eA9E6B,EAAA,EMnLlC;;AAND;ENgQM,iCAf6B;EM7OjC,gBJ2qBqB;EI1qBrB,gBJ0pB6B,EAAA;EF3jB7B;IMpGF;MNuQM,iBA9E6B,EAAA,EMnLlC;;AAND;ENgQM,iCAf6B;EM7OjC,gBJ2qBqB;EI1qBrB,gBJ0pB6B,EAAA;EF3jB7B;IMpGF;MNuQM,eA9E6B,EAAA,EMnLlC;;AAND;ENgQM,iCAf6B;EM7OjC,gBJ2qBqB;EI1qBrB,gBJ0pB6B,EAAA;EF3jB7B;IMpGF;MNuQM,iBA9E6B,EAAA,EMnLlC;;AAND;ENgQM,iCAf6B;EM7OjC,gBJ2qBqB;EI1qBrB,gBJ0pB6B,EAAA;EF3jB7B;IMpGF;MNuQM,eA9E6B,EAAA,EMnLlC;;AAND;ENgQM,iCAf6B;EM7OjC,gBJ2qBqB;EI1qBrB,gBJ0pB6B,EAAA;EF3jB7B;IMpGF;MNuQM,iBA9E6B,EAAA,EMnLlC;;AAkBH;ECtDE,gBAAgB,EAAA;EJHd;IAgCE,eI9B8B,EAAA;EJMhC;IA+BI,gBAxBE,EAAA;;AG+CV;EC3DE,gBAAgB,EAAA;EJHd;IAgCE,eI9B8B,EAAA;EJMhC;IA+BI,gBAxBE,EAAA;;AGkDV;EACE,qBAAqB,EAAA;EHlEnB;IAgCE,oBDquB6B,EAAA;EC7vB/B;IA+BI,mBAxBE,EAAA;;AGgEV;EN8MM,kBAnE+B;EMzInC,yBAAyB,EAAA;;AAI3B;EACE,mBJkXW;EF3KP,kBAnE+B,EAAA;EMrIrC;IAKI,gBAAgB,EAAA;;AAIpB;EACE,iBJyWW;EIxWX,mBJwWW;EF3KP,kBAnE+B;EMxHnC,cJrFiB,EAAA;EIiFnB;IAOI,qBAAqB,EAAA;;AEhGzB;ECIE,eAAe;EAGf,YAAY,EAAA;;ADDd;EACE,gBNqxDwC;EMpxDxC,sBAA4E;EAA5E,6DAA4E;EAC5E,yBAA8H;EAA9H,gGAA8H;EJG5H,uBFoxD6E;EEpxD7E,uCFoxD6E;EO5xD/E,eAAe;EAGf,YAAY,EAAA;;ADcd;EAEE,qBAAqB,EAAA;;AAGvB;EACE,qBAA2B;EAC3B,cAAc,EAAA;;AAGhB;ERyPM,kBAnE+B;EQpLnC,8BAAyF;EAAzF,kEAAyF,EAAA;;AElCzF;;;;;;;ECHA,sBAA+B;EAC/B,iBAA+B;EAC/B,WAAW;EACX,6CAA6D;EAC7D,4CAA4D;EAC5D,kBAAkB;EAClB,iBAAiB,EAAA;;ACsDf;EF5CE;IACE,gBRohBG,EAAA,EQnhBJ;;AE0CH;EF5CE;IACE,gBRqhBG,EAAA,EQphBJ;;AE0CH;EF5CE;IACE,gBRshBG,EAAA,EQrhBJ;;AE0CH;EF5CE;IACE,iBRuhBI,EAAA,EQthBL;;AE0CH;EF5CE;IACE,iBRwhBK,EAAA,EQvhBN;;AXrBP;EcMI,sBAA6C;EAA7C,0BAA6C;EAA7C,0BAA6C;EAA7C,0BAA6C;EAA7C,2BAA6C;EAA7C,4BAA6C;EAG/C,2BAAiD,EAAA;;AAIjD;ECRA,sBAA+B;EAC/B,iBAA+B;EAC/B,aAAa;EACb,eAAe;EAEf,0CAA0D;EAC1D,6CAA6D;EAC7D,4CAA4D,EAAA;EDC5D;ICQA,cAAc;IACd,WAAW;IACX,eAAe;IACf,6CAA6D;IAC7D,4CAA4D;IAC5D,+BAA+C,EAAA;;AA+C3C;EACE,SAAY,EAAA;;AAGd;EApCJ,cAAc;EACd,WAAW,EAAA;;AAcX;EACE,cAAc;EACd,WdiCqD,EAAA;;AcnCvD;EACE,cAAc;EACd,UdiCqD,EAAA;;AcnCvD;EACE,cAAc;EACd,gBdiCqD,EAAA;;AcnCvD;EACE,cAAc;EACd,UdiCqD,EAAA;;AcnCvD;EACE,cAAc;EACd,UdiCqD,EAAA;;AcnCvD;EACE,cAAc;EACd,gBdiCqD,EAAA;;AcFnD;EAhDJ,cAAc;EACd,WAAW,EAAA;;AAqDH;EAhEN,cAAc;EACd,eAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,UAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,UAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,UAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,WAA0C,EAAA;;AX9B1C;EAgCE,qBWa6D,EAAA;;AXrC/D;EA+BI,sBAxBE,EAAA;;AAfN;EAgCE,sBWa6D,EAAA;;AXrC/D;EA+BI,uBAxBE,EAAA;;AAfN;EAgCE,gBWa6D,EAAA;;AXrC/D;EA+BI,iBAxBE,EAAA;;AAfN;EAgCE,sBWa6D,EAAA;;AXrC/D;EA+BI,uBAxBE,EAAA;;AAfN;EAgCE,sBWa6D,EAAA;;AXrC/D;EA+BI,uBAxBE,EAAA;;AAfN;EAgCE,gBWa6D,EAAA;;AXrC/D;EA+BI,iBAxBE,EAAA;;AAfN;EAgCE,sBWa6D,EAAA;;AXrC/D;EA+BI,uBAxBE,EAAA;;AAfN;EAgCE,sBWa6D,EAAA;;AXrC/D;EA+BI,uBAxBE,EAAA;;AAfN;EAgCE,gBWa6D,EAAA;;AXrC/D;EA+BI,iBAxBE,EAAA;;AAfN;EAgCE,sBWa6D,EAAA;;AXrC/D;EA+BI,uBAxBE,EAAA;;AAfN;EAgCE,sBWa6D,EAAA;;AXrC/D;EA+BI,uBAxBE,EAAA;;AWiGF;;EAEE,iBAA+B,EAAA;;AAGjC;;EAEE,iBAA+B,EAAA;;AAPjC;;EAEE,uBAA+B,EAAA;;AAGjC;;EAEE,uBAA+B,EAAA;;AAPjC;;EAEE,sBAA+B,EAAA;;AAGjC;;EAEE,sBAA+B,EAAA;;AAPjC;;EAEE,oBAA+B,EAAA;;AAGjC;;EAEE,oBAA+B,EAAA;;AAPjC;;EAEE,sBAA+B,EAAA;;AAGjC;;EAEE,sBAA+B,EAAA;;AAPjC;;EAEE,oBAA+B,EAAA;;AAGjC;;EAEE,oBAA+B,EAAA;;AF1DrC;EEUE;IACE,SAAY,EAAA;EAGd;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,UdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,gBdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,UdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,UdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,gBdiCqD,EAAA;EcFnD;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EX9B1C;IAgCE,cWa2C,EAAA;EXrC7C;IA+BI,eAxBE,EAAA;EAfN;IAgCE,qBWa6D,EAAA;EXrC/D;IA+BI,sBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,gBWa6D,EAAA;EXrC/D;IA+BI,iBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,gBWa6D,EAAA;EXrC/D;IA+BI,iBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,gBWa6D,EAAA;EXrC/D;IA+BI,iBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EWiGF;;IAEE,iBAA+B,EAAA;EAGjC;;IAEE,iBAA+B,EAAA;EAPjC;;IAEE,uBAA+B,EAAA;EAGjC;;IAEE,uBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,oBAA+B,EAAA;EAGjC;;IAEE,oBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,oBAA+B,EAAA;EAGjC;;IAEE,oBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAY,EAAA;EAGd;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,UdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,gBdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,UdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,UdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,gBdiCqD,EAAA;EcFnD;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EX9B1C;IAgCE,cWa2C,EAAA;EXrC7C;IA+BI,eAxBE,EAAA;EAfN;IAgCE,qBWa6D,EAAA;EXrC/D;IA+BI,sBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,gBWa6D,EAAA;EXrC/D;IA+BI,iBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,gBWa6D,EAAA;EXrC/D;IA+BI,iBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,gBWa6D,EAAA;EXrC/D;IA+BI,iBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EWiGF;;IAEE,iBAA+B,EAAA;EAGjC;;IAEE,iBAA+B,EAAA;EAPjC;;IAEE,uBAA+B,EAAA;EAGjC;;IAEE,uBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,oBAA+B,EAAA;EAGjC;;IAEE,oBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,oBAA+B,EAAA;EAGjC;;IAEE,oBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAY,EAAA;EAGd;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,UdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,gBdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,UdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,UdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,gBdiCqD,EAAA;EcFnD;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EX9B1C;IAgCE,cWa2C,EAAA;EXrC7C;IA+BI,eAxBE,EAAA;EAfN;IAgCE,qBWa6D,EAAA;EXrC/D;IA+BI,sBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,gBWa6D,EAAA;EXrC/D;IA+BI,iBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,gBWa6D,EAAA;EXrC/D;IA+BI,iBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,gBWa6D,EAAA;EXrC/D;IA+BI,iBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EWiGF;;IAEE,iBAA+B,EAAA;EAGjC;;IAEE,iBAA+B,EAAA;EAPjC;;IAEE,uBAA+B,EAAA;EAGjC;;IAEE,uBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,oBAA+B,EAAA;EAGjC;;IAEE,oBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,oBAA+B,EAAA;EAGjC;;IAEE,oBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAY,EAAA;EAGd;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,UdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,gBdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,UdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,UdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,gBdiCqD,EAAA;EcFnD;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EX9B1C;IAgCE,cWa2C,EAAA;EXrC7C;IA+BI,eAxBE,EAAA;EAfN;IAgCE,qBWa6D,EAAA;EXrC/D;IA+BI,sBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,gBWa6D,EAAA;EXrC/D;IA+BI,iBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,gBWa6D,EAAA;EXrC/D;IA+BI,iBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,gBWa6D,EAAA;EXrC/D;IA+BI,iBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EWiGF;;IAEE,iBAA+B,EAAA;EAGjC;;IAEE,iBAA+B,EAAA;EAPjC;;IAEE,uBAA+B,EAAA;EAGjC;;IAEE,uBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,oBAA+B,EAAA;EAGjC;;IAEE,oBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,oBAA+B,EAAA;EAGjC;;IAEE,oBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAY,EAAA;EAGd;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,UdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,gBdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,UdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,UdiCqD,EAAA;EcnCvD;IACE,cAAc;IACd,gBdiCqD,EAAA;EcFnD;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EX9B1C;IAgCE,cWa2C,EAAA;EXrC7C;IA+BI,eAxBE,EAAA;EAfN;IAgCE,qBWa6D,EAAA;EXrC/D;IA+BI,sBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,gBWa6D,EAAA;EXrC/D;IA+BI,iBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,gBWa6D,EAAA;EXrC/D;IA+BI,iBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,gBWa6D,EAAA;EXrC/D;IA+BI,iBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EAfN;IAgCE,sBWa6D,EAAA;EXrC/D;IA+BI,uBAxBE,EAAA;EWiGF;;IAEE,iBAA+B,EAAA;EAGjC;;IAEE,iBAA+B,EAAA;EAPjC;;IAEE,uBAA+B,EAAA;EAGjC;;IAEE,uBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,oBAA+B,EAAA;EAGjC;;IAEE,oBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,oBAA+B,EAAA;EAGjC;;IAEE,oBAA+B,EAAA,EAChC;;ACtHT;EAEE,+BAA+C;EAC/C,4BAAyC;EACzC,gCAAiD;EACjD,6BAA2C;EAE3C,wCAAqC;EACrC,kCAA+B;EAC/B,iDAAmD;EACnD,kCAA6C;EAC7C,gDAAqD;EACrD,4CAA+C;EAC/C,+CAAmD;EACnD,0CAA6C;EAC7C,8CAAiD;EACjD,2CAA2C;EAE3C,WAAW;EACX,mBbmbW;EalbX,mBbuwB+B;EatwB/B,2CAAqE,EAAA;EArBvE;IA6BI,sBb0vB+B;IaxvB/B,6BAA4J;IAA5J,wFAA4J;IAC5J,qCAAqD;IACrD,wBb+wBqE;Ia/wBrE,4Cb+wBqE;Ia9wBrE,yDAAgL;IAAhL,8GAAgL,EAAA;EAlCpL;IAsCI,uBAAuB,EAAA;EAtC3B;IA0CI,sBAAsB,EAAA;;AAI1B;EACE,4CbuwBwC;EavwBxC,gEbuwBwC,EAAA;;AahwB1C;EACE,iBAAiB,EAAA;;AAQnB;EAGI,wBbutBgC,EAAA;;AazsBpC;EAEI,mBAAmC;EAAnC,uCAAmC,EAAA;EAFvC;IAMM,mBb0tBmE;Ia1tBnE,uCb0tBmE,EAAA;;AartBzE;EAGI,sBAAsB,EAAA;;AAH1B;EAOI,mBAAmB,EAAA;;AASvB;EAEI,sDAA+C;EAC/C,gDAAyC,EAAA;;AAK7C;EAEI,sDAA+C;EAC/C,gDAAyC,EAAA;;AAQ7C;EACE,sDAAiD;EACjD,gDAA2C,EAAA;;AAO7C;EAEI,qDAAiD;EACjD,+CAA2C,EAAA;;AC5I7C;EAOE,yCAAqC;EACrC,uBAA+B;EAC/B,oDAAmD;EACnD,mDAA+C;EAC/C,iDAAqD;EACrD,iDAA6C;EAC7C,gDAAmD;EACnD,kDAA2C;EAC3C,+CAAiD;EAEjD,6BAAgD;EAChD,2CAAqE,EAAA;;AAlBvE;EAOE,yCAAqC;EACrC,uBAA+B;EAC/B,oDAAmD;EACnD,mDAA+C;EAC/C,iDAAqD;EACrD,iDAA6C;EAC7C,gDAAmD;EACnD,kDAA2C;EAC3C,+CAAiD;EAEjD,6BAAgD;EAChD,2CAAqE,EAAA;;AAlBvE;EAOE,yCAAqC;EACrC,uBAA+B;EAC/B,oDAAmD;EACnD,mDAA+C;EAC/C,iDAAqD;EACrD,iDAA6C;EAC7C,gDAAmD;EACnD,kDAA2C;EAC3C,+CAAiD;EAEjD,6BAAgD;EAChD,2CAAqE,EAAA;;AAlBvE;EAOE,yCAAqC;EACrC,uBAA+B;EAC/B,oDAAmD;EACnD,mDAA+C;EAC/C,iDAAqD;EACrD,iDAA6C;EAC7C,gDAAmD;EACnD,kDAA2C;EAC3C,+CAAiD;EAEjD,6BAAgD;EAChD,2CAAqE,EAAA;;AAlBvE;EAOE,yCAAqC;EACrC,uBAA+B;EAC/B,oDAAmD;EACnD,mDAA+C;EAC/C,iDAAqD;EACrD,iDAA6C;EAC7C,gDAAmD;EACnD,kDAA2C;EAC3C,+CAAiD;EAEjD,6BAAgD;EAChD,2CAAqE,EAAA;;AAlBvE;EAOE,yCAAqC;EACrC,uBAA+B;EAC/B,oDAAmD;EACnD,mDAA+C;EAC/C,iDAAqD;EACrD,iDAA6C;EAC7C,gDAAmD;EACnD,kDAA2C;EAC3C,+CAAiD;EAEjD,6BAAgD;EAChD,2CAAqE,EAAA;;AAlBvE;EAOE,yCAAqC;EACrC,uBAA+B;EAC/B,oDAAmD;EACnD,mDAA+C;EAC/C,iDAAqD;EACrD,iDAA6C;EAC7C,gDAAmD;EACnD,kDAA2C;EAC3C,+CAAiD;EAEjD,6BAAgD;EAChD,2CAAqE,EAAA;;AAlBvE;EAOE,4CAAqC;EACrC,uBAA+B;EAC/B,mDAAmD;EACnD,iDAA+C;EAC/C,oDAAqD;EACrD,gDAA6C;EAC7C,mDAAmD;EACnD,iDAA2C;EAC3C,kDAAiD;EAEjD,6BAAgD;EAChD,2CAAqE,EAAA;;ADiJrE;EACE,gBAAgB;EAChB,iCAAiC,EAAA;;AH3FnC;EGyFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AH5FD;EGyFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AH5FD;EGyFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AH5FD;EGyFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AH5FD;EGyFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AEpKL;EACE,qBf87B2C;Ee17B3C,oCAA6E,EAAA;;AAK/E;EACE,iCZ2S8D;EY3S9D,qDZ2S8D;EY1S9D,oCZ0S8D;EY1S9D,wDZ0S8D;EYzS9D,gBAAgB;EjB8QZ,kBAnE+B;EiBvMnC,gBfipB+B;EehpB/B,oCAA6E,EAAA;;AAG/E;EACE,+BZgS8D;EYhS9D,mDZgS8D;EY/R9D,kCZ+R8D;EY/R9D,sDZ+R8D;EL3B1D,kBAnE+B,EAAA;;AiB7LrC;EACE,gCZ0R8D;EY1R9D,oDZ0R8D;EYzR9D,mCZyR8D;EYzR9D,uDZyR8D;EL3B1D,mBAnE+B,EAAA;;AkBxNrC;EACE,mBhBs7B4C;EF5pBxC,kBAnE+B;EkBnNnC,8BAA0E;EAA1E,6DAA0E,EAAA;;ACL5E;EACE,cAAc;EACd,WAAW;EACX,yBjB80BkC;EFtjB9B,eAnE+B;EmBlNnC,gBjBopB+B;EiBnpB/B,gBjB2pB+B;EiB1pB/B,6BAA8D;EAA9D,oDAA8D;EAC9D,wBAAgB;UAAhB,gBAAgB;EAChB,sBAAgE;EAAhE,yDAAgE;EAChE,4BAA4B;EAC5B,yBAA8G;EAA9G,4FAA8G;EfG5G,uBFi9BiF;EEj9BjF,uCFi9BiF;EkBp9B/E,wElB2+B4F,EAAA;EkBv+B5F;IDhBN;MCiBQ,gBAAgB,EAAA,ED8FvB;EA/GD;IAqBI,gBAAgB,EAAA;IArBpB;MAwBM,eAAe,EAAA;EAxBrB;IA8BI,6BAAgF;IAAhF,0DAAgF;IAChF,sBAAkF;IAAlF,+DAAkF;IAClF,qBAA4G;IAA5G,0DAA4G;IAC5G,UAAU;IAKR,iDjBsCiB,EAAA;EiB5EvB;IAmDI,eAAe;IAMf,aAAmE;IAKnE,SAAS,EAAA;EA9Db;IAoEI,cAAc;IACd,UAAU,EAAA;EArEd;IA0EI,8BAAkG;IAAlG,qEAAkG;IAElG,UAAU,EAAA;EA5Ed;IAsFI,yBjBk4B+E;IiBl4B/E,yCjBk4B+E;IiB/3B/E,UAAU,EAAA;EAzFd;IA8FI,yBjBmvBgC;IiBlvBhC,0BjBkvBgC;IiBjvBhC,2BjBivBgC;YiBjvBhC,0BjBivBgC;IiBhvBhC,6BAA+F;IAA/F,+DAA+F;IEjGjG,yBFkGsG;IElGtG,wEFkGsG;IACpG,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,4BjB6vBqE;IiB7vBrE,gDjB6vBqE;IiB5vBrE,gBAAgB;IC5Fd,6IlBm4B6I;IkBn4B7I,qIlBm4B6I,EAAA;EiB/4BnJ;IA8FI,yBjBmvBgC;IiBlvBhC,0BjBkvBgC;IiBjvBhC,2BjBivBgC;YiBjvBhC,0BjBivBgC;IiBhvBhC,6BAA+F;IAA/F,+DAA+F;IEjGjG,yBFkGsG;IElGtG,wEFkGsG;IACpG,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,4BjB6vBqE;IiB7vBrE,gDjB6vBqE;IiB5vBrE,gBAAgB;IC5Fd,qIlBm4B6I,EAAA;IkB/3B7I;MDhBN;QCiBQ,wBAAgB;QAAhB,gBAAgB,EAAA;MDjBxB;QCiBQ,gBAAgB,EAAA,EDyFrB;EA1GH;IA6GI,yBAAmH;IAAnH,+EAAmH,EAAA;EA7GvH;IA6GI,yBAAmH;IAAnH,+EAAmH,EAAA;;AASvH;EACE,cAAc;EACd,WAAW;EACX,mBAA2B;EAC3B,gBAAgB;EAChB,gBjBuiB+B;EiBtiB/B,6BAA4F;EAA5F,8DAA4F;EAC5F,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmC;EAAnC,uCAAmC,EAAA;EATrC;IAYI,UAAU,EAAA;EAZd;IAiBI,gBAAgB;IAChB,eAAe,EAAA;;AAWnB;EACE,gDdkK8D;EclK9D,oEdkK8D;EcjK9D,uBjBwsBiC;EFlkB7B,mBAnE+B;EIzMjC,sBFk9BuF;EEl9BvF,0CFk9BuF,EAAA;EiB90B3F;IAOI,uBjBmsB+B;IiBlsB/B,wBjBksB+B;IiBjsB/B,0BjBisB+B;YiBjsB/B,yBjBisB+B,EAAA;EiB1sBnC;IAOI,uBjBmsB+B;IiBlsB/B,wBjBksB+B;IiBjsB/B,0BjBisB+B;YiBjsB/B,yBjBisB+B,EAAA;;AiB7rBnC;EACE,8CdqJ8D;EcrJ9D,kEdqJ8D;EcpJ9D,oBjB+rBgC;EFtkB5B,kBAnE+B;EIzMjC,qBFm9BuF;EEn9BvF,0CFm9BuF,EAAA;EiBl0B3F;IAOI,oBjB0rB8B;IiBzrB9B,qBjByrB8B;IiBxrB9B,wBjBwrB8B;YiBxrB9B,uBjBwrB8B,EAAA;EiBjsBlC;IAOI,oBjB0rB8B;IiBzrB9B,qBjByrB8B;IiBxrB9B,wBjBwrB8B;YiBxrB9B,uBjBwrB8B,EAAA;;AiBjrBlC;EAEI,iDdoI4D;EcpI5D,qEdoI4D,EAAA;;ActIhE;EAMI,gDdgI4D;EchI5D,oEdgI4D,EAAA;;ActIhE;EAUI,8Cd4H4D;Ec5H5D,kEd4H4D,EAAA;;AcvHhE;EACE,WjByzB0C;EiBxzB1C,6CdqH8D;EcrH9D,iEdqH8D;EcpH9D,iBjB8oBmC,EAAA;EiBjpBrC;IAMI,eAAe,EAAA;EANnB;IAUI,oBAAoB;If1LpB,uBFi9BiF;IEj9BjF,uCFi9BiF,EAAA;EiBjyBrF;IAeI,oBAAoB;If/LpB,uBFi9BiF;IEj9BjF,uCFi9BiF,EAAA;EiBjyBrF;IAmBsB,4CdoG0C;IcpG1C,gEdoG0C,EAAA;EcvHhE;IAoBsB,0CdmG0C;IcnG1C,8DdmG0C,EAAA;;AiBrThE;EACE,iEAAmD;EAEnD,cAAc;EACd,WAAW;EAEX,uCjBuU8D;ELnD1D,eAnE+B;EsB9MnC,gBpBgpB+B;EoB/oB/B,gBpBupB+B;EoBtpB/B,6BAAgF;EAAhF,0DAAgF;EAChF,wBAAgB;UAAhB,gBAAgB;EAChB,sBAAkF;EAAlF,+DAAkF;EAClF,qDAA0I;EAA1I,qFAA0I;EAC1I,4BAA4B;EAE5B,0BpBkkC2C;EoBjkC3C,yBAAsI;EAAtI,kGAAsI;ElBJpI,uBFi9BiF;EEj9BjF,uCFi9BiF;EkBp9B/E,wElB2+B4F,EAAA;ECz/B9F;IA+DE,0CDoxB8B,EAAA;EC30BhC;IA2DI,0CD0gCsD,EAAA;EC7kC1D;IA+DE,yCDshCiE,EAAA;EC7kCnE;IA6DI,wCEiDmI,EAAA;EepGrI;IEfN;MFgBQ,gBAAgB,EAAA,EEmCvB;EAnDD;IAwBI,qBAA8H;IAA9H,gEAA8H;IAC9H,UAAU;IAKR,iDpB6CiB,EAAA;EoB3EvB;IAqCI,sBAAsB,EAAA;InBxCtB;MAgCE,sBDmzB8B,EAAA;IC30BhC;MA+BI,qBAxBE,EAAA;EmBZV;IAyCI,8CAA2G;IAC3G,yBAA6G;IAA7G,6EAA6G,EAAA;EA1CjH;IAgDI,kBAAkB;IAClB,yCAA4F;IAA5F,sEAA4F,EAAA;;AAIhG;EACE,oBpBqyBkC;EoBpyBlC,uBpBoyBkC;EFjkB9B,mBAnE+B;EIzMjC,sBFk9BuF;EEl9BvF,0CFk9BuF,EAAA;ECn+BvF;IAgCE,oBD+zB6B,EAAA;ECv1B/B;IA+BI,qBAxBE,EAAA;;AmBiDV;EACE,mBpBiyBiC;EoBhyBjC,sBpBgyBiC;EFrkB7B,kBAnE+B;EIzMjC,qBFm9BuF;EEn9BvF,0CFm9BuF,EAAA;ECp+BvF;IAgCE,kBDm0B4B,EAAA;EC31B9B;IA+BI,mBAxBE,EAAA;;AoBbV;EACE,cAAc;EACd,kBrB4/B2E;EqB1/B3E,uBrB4/B+C,EAAA;EClgC7C;IAgCE,mBDi+BkE,EAAA;ECz/BpE;IA+BI,oBAxBE,EAAA;EAfN;IAgCE,WoBvB4B,EAAA;EpBD9B;IA+BI,YE+EmI,EAAA;EFtHvI;IAgCE,mBoBtB4D,EAAA;EpBF9D;IA+BI,oBAxBE,EAAA;;AAfN;EAgCE,oBDi+BkE,EAAA;;ACz/BpE;EA+BI,mBAxBE,EAAA;;AAfN;EAgCE,eoBhB8B,EAAA;;ApBRhC;EA+BI,gBAxBE,EAAA;;AAfN;EAgCE,iBoBfgC,EAAA;;ApBTlC;EA+BI,gBE+EmI,EAAA;;AFtHvI;EAgCE,YoBZ6B,EAAA;;ApBZ/B;EA+BI,WE+EmI,EAAA;;AFtHvI;EAgCE,oBoBX6D,EAAA;;ApBb/D;EA+BI,mBAxBE,EAAA;;AAfN;EAgCE,coBV+B,EAAA;;ApBdjC;EA+BI,eAxBE,EAAA;;AoBWV;EACE,uCAAyC;EAEzC,UrBk+B2C;EqBj+B3C,WrBi+B2C;EqBh+B3C,kBAA8D;EAC9D,mBAAmB;EACnB,wBAAgB;UAAhB,gBAAgB;EAChB,0CAA+D;EAC/D,gDAA2E;EAC3E,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,yBrBm+BqI;EqBn+BrI,6DrBm+BqI;EqBl+BrI,iCAAyB;UAAzB,yBAAyB,EAAA;EAd3B;InBTI,qBF0/B2C,EAAA;EqBj/B/C;IAuBI,kBrB29ByC,EAAA;EqBl/B7C;IA2BI,uBrBk9BqD,EAAA;EqB7+BzD;IA+BI,qBlBmJiC;IkBlJjC,UAAU;IACV,iDrBmBmB,EAAA;EqBpDvB;IAqCI,yBAA2I;IAA3I,uEAA2I;IAC3I,qBAAmJ;IAAnJ,uEAAmJ,EAAA;IAtCvJ;MA4CQ,kEAAqD,EAAA;IA5C7D;MAoDQ,kEAAqD,EAAA;EApD7D;IA0DI,yBrBNmB;IqBOnB,qBrBPmB;IqBYjB,kEAAqD,EAAA;EAhE3D;IAqEI,oBAAoB;IACpB,YAAY;IACZ,YrB07ByC,EAAA;EqBjgC7C;IA+EM,eAAe;IACf,YrBi7BuC,EAAA;;AqB56B7C;EACE,0CAA+F,EAAA;;ApBhH7F;EAgCE,mBDqgCqD,EAAA;;AC7hCvD;EA+BI,oBAxBE,EAAA;;AoByGV;EAII,6DAA2C;EAE3C,UrBs6BiC;EqBp6BjC,2CAAiE;EACjE,gCAAgC;EnBhHhC,kBFmhCiC;EkBthC/B,iDlB0hCgE,EAAA;ECxiClE;IAgCE,mBoB+F6D,EAAA;EpBvH/D;IA+BI,oBAxBE,EAAA;EiBGJ;IGsGN;MHrGQ,gBAAgB,EAAA,EG+HrB;EA1BH;IAcM,6DAA2C,EAAA;EAdjD;IAkBM,iCrBq6BwC;IqBh6BtC,6DAA2C,EAAA;;ApB/I/C;EAgCE,oBDi+BkE,EAAA;;ACz/BpE;EA+BI,mBAxBE,EAAA;;AAfN;EAgCE,eoBsHgC,EAAA;;ApB9IlC;EA+BI,gBAxBE,EAAA;;AAfN;EAgCE,oBoByH+D,EAAA;;ApBjJjE;EA+BI,mBAxBE,EAAA;;AAfN;EAgCE,coB0HiC,EAAA;;ApBlJnC;EA+BI,eAxBE,EAAA;;AoBoJR;EACE,kBrBg5Bc,EAAA;ECpjCd;IAgCE,oBoBqI4C,EAAA;EpB7J9C;IA+BI,qBAxBE,EAAA;EoBoJR;IAKI,arB24BW;IqB14BX,crB24BY,EAAA;ICpjCd;MAgCE,oBoB0IoD,EAAA;IpBlKtD;MA+BI,qBAxBE,EAAA;EoBoJR;IAYI,sCAAwD,EAAA;;AAZ5D;EACE,iBrBo5Ba,EAAA;ECxjCb;IAgCE,mBoBqI4C,EAAA;EpB7J9C;IA+BI,oBAxBE,EAAA;EoBoJR;IAKI,UrB+4BQ;IqB94BR,arB+4BW,EAAA;ICxjCb;MAgCE,mBoB0IoD,EAAA;IpBlKtD;MA+BI,oBAxBE,EAAA;EoBoJR;IAYI,qCAAwD,EAAA;;AAK9D;EACE,qBAAqB,EAAA;EpBrLnB;IAgCE,kBD+/BgC,EAAA;ECvhClC;IA+BI,iBAxBE,EAAA;;AoB0KV;EACE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB,EAAA;EAHtB;IAQM,oBAAoB;IACpB,YAAY;IACZ,arBksB2B,EAAA;;AsBj4BjC;EACE,WAAW;EACX,cnB+S2B;EmB9S3B,UAAU;EACV,wBAAgB;UAAhB,gBAAgB;EAChB,6BAA6B,EAAA;EAL/B;IAQI,UAAU,EAAA;IARd;MAY8B,iEtB8DP,EAAA;IsB1EvB;MAa8B,iEtB6DP,EAAA;EsB1EvB;IAiBI,SAAS,EAAA;EAjBb;IAqBI,WtBmmC2C;IsBlmC3C,YtBkmC2C;IsBjmC3C,oBAAsE;IACtE,wBAAgB;YAAhB,gBAAgB;IH1BlB,yBG2BsG;IH3BtG,yDG2BsG;IACpG,StBimCwC;IE9mCxC,mBF+mC2C;IkBlnCzC,oHlBwnCkI;IkBxnClI,4GlBwnCkI,EAAA;IkBpnClI;MIdN;QJeQ,wBAAgB;QAAhB,gBAAgB,EAAA,EImBrB;IAlCH;MHFE,yBGkC6H;MHlC7H,gEGkC6H,EAAA;EAhC/H;IAqCI,WtB4kCkC;IsB3kClC,ctB4kCmC;IsB3kCnC,kBAAkB;IAClB,etB2kCqC;IsB1kCrC,yBAAiG;IAAjG,wEAAiG;IACjG,yBAAyB;IpB7BzB,mBFwmCkC,EAAA;EsBrnCtC;IAgDI,WtBwkC2C;IsBvkC3C,YtBukC2C;IsBtkC3C,gBAAgB;IHpDlB,yBGqDsG;IHrDtG,yDGqDsG;IACpG,StBukCwC;IE9mCxC,mBF+mC2C;IkBlnCzC,iHlBwnCkI;IkBxnClI,4GlBwnCkI,EAAA;IkBpnClI;MIdN;QJeQ,qBAAgB;QAAhB,gBAAgB,EAAA,EI6CrB;IA5DH;MHFE,yBG4D6H;MH5D7H,gEG4D6H,EAAA;EA1D/H;IA+DI,WtBkjCkC;IsBjjClC,ctBkjCmC;IsBjjCnC,kBAAkB;IAClB,etBijCqC;IsBhjCrC,yBAAiG;IAAjG,wEAAiG;IACjG,yBAAyB;IpBvDzB,mBFwmCkC,EAAA;EsBrnCtC;IA0EI,oBAAoB,EAAA;IA1ExB;MA6EM,yCAA4H;MAA5H,qFAA4H,EAAA;IA7ElI;MAiFM,yCAA4H;MAA5H,qFAA4H,EAAA;;ACvFlI;EACE,kBAAkB,EAAA;EADpB;;;IAMI,oCpBoT4D;IoBpT5D,wDpBoT4D;IoBnT5D,wCpBmT4D;IoBnT5D,4DpBmT4D;IoBlT5D,iBvB2oCwC,EAAA;EuBnpC5C;IAYI,kBAAkB;IAClB,MAAM;IAEN,UAAU;IACV,YAAY;IACZ,qBvBo0BgC;IuBn0BhC,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6C;IAA7C,iDAA6C;IAC7C,qBAAqB;ILRnB,gElB4oCoF,EAAA;IC1pCtF;MAgCE,OsBpBwB,EAAA;ItBJ1B;MA+BI,QAxBE,EAAA;IiBGJ;MKpBN;QLqBQ,gBAAgB,EAAA,EKKrB;EA1BH;;IA8BI,qBvBuzBgC,EAAA;IuBr1BpC;;MAiCM,kBAAkB,EAAA;IAjCxB;;;MAsCM,qBvBgnC0C;MuB/mC1C,wBvBgnCyC,EAAA;IuBvpC/C;;MA2CM,qBvB2mC0C;MuB1mC1C,wBvB2mCyC,EAAA;EuBvpC/C;IAiDI,qBvBqmC4C;IuBpmC5C,wBvBqmC2C,EAAA;EuBvpC/C;;;;IA0DM,6BAA6F;IAA7F,4CAA6F;IAC7F,8DvB+lCkF,EAAA;IuB1pCxF;;;;MA8DQ,kBAAkB;MAClB,oBAA+D;MAC/D,WAAW;MACX,avBulCqC;MuBtlCrC,WAAW;MACX,sBvBu5BiE;MuBv5BjE,oCvBu5BiE;MEv8BrE,uBFi9BiF;MEj9BjF,uCFi9BiF,EAAA;EuBp+BrF;IA2EM,6BAA6F;IAA7F,4CAA6F;IAC7F,8DvB8kCkF,EAAA;EuB1pCxF;IAkFM,mBAAmC;IAAnC,uCAAmC,EAAA;EAlFzC;;IAwFI,cvBzEe,EAAA;IuBfnB;;MA2FM,yBvBi4B6E;MuBj4B7E,yCvBi4B6E,EAAA;;AwBx9BnF;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,WAAW,EAAA;EALb;;;IAUI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,YAAY,EAAA;EAbhB;;;IAoBI,UAAU,EAAA;EApBd;IA2BI,kBAAkB;IAClB,UAAU,EAAA;IA5Bd;MA+BM,UAAU,EAAA;;AAWhB;EACE,aAAa;EACb,mBAAmB;EACnB,yBxBoyBkC;EFtjB9B,eAnE+B;E0BzKnC,gBxB2mB+B;EwB1mB/B,gBxBknB+B;EwBjnB/B,6BAAkG;EAAlG,gEAAkG;EAClG,kBAAkB;EAClB,mBAAmB;EACnB,yBAAoG;EAApG,yEAAoG;EACpG,yBAAkJ;EAAlJ,wGAAkJ;EtBtChJ,uBFi9BiF;EEj9BjF,uCFi9BiF,EAAA;;AwBj6BrF;;;;EAIE,oBxB8xBgC;EFtkB5B,kBAnE+B;EIzMjC,qBFm9BuF;EEn9BvF,0CFm9BuF,EAAA;;AwB15B3F;;;;EAIE,uBxBixBiC;EFlkB7B,mBAnE+B;EIzMjC,sBFk9BuF;EEl9BvF,0CFk9BuF,EAAA;;ACn+BvF;;EAgCE,mBuBqDqF,EAAA;;AvB7EvF;;EA+BI,kBAxBE,EAAA;;AAfN;;;;EAgCE,0BuBsE4B,EAAA;;AvB9F9B;;;;EA+BI,yBAxBE,EAAA;;AAfN;;;;EAgCE,6BuBsE4B,EAAA;;AvB9F9B;;;;EA+BI,4BAxBE,EAAA;;AAfN;;;;EAgCE,0BuB+E4B,EAAA;;AvBvG9B;;;;EA+BI,yBAxBE,EAAA;;AAfN;;;;EAgCE,6BuB+E4B,EAAA;;AvBvG9B;;;;EA+BI,4BAxBE,EAAA;;AAfN;EAgCE,2BuByF+D;EvBzF/D,+CuByF+D,EAAA;;AvBjHjE;EA+BI,4BAxBE;EAwBF,gDAxBE,EAAA;;AAfN;EAgCE,yBuB0F4B,EAAA;;AvBlH9B;EA+BI,0BAxBE,EAAA;;AAfN;EAgCE,4BuB0F4B,EAAA;;AvBlH9B;EA+BI,6BAxBE,EAAA;;AAfN;;EAgCE,yBuB+F4B,EAAA;;AvBvH9B;;EA+BI,0BAxBE,EAAA;;AAfN;;EAgCE,4BuB+F4B,EAAA;;AvBvH9B;;EA+BI,6BAxBE,EAAA;;AuByGoD;EC/F1D,aAAa;EACb,WAAW;EACX,mBzB85B0C;EF5pBxC,kBAnE+B;E2B5LjC,czBwpC4D;EyBxpC5D,kCzBwpC4D,EAAA;;AwB9jCtB;ECtFtC,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBzBw7C4C;EyBv7C5C,iBAAiB;E3BqPf,mBAnE+B;E2B/KjC,WzB6oCqB;EyB5oCrB,yBzB6oCqD;EyB7oCrD,oCzB6oCqD;EExqCrD,uBF28C6E;EE38C7E,uCF28C6E,EAAA;;AyBx9C7E;;;;EA+CE,cAAc,EAAA;;AA/ChB;EAqDE,qBzBkoC+E;EyBloC/E,gDzBkoC+E;EyB9nC7E,yDtBwE0E;EsBvE1E,4BAA4B;EAE5B,gEtBwPwD,EAAA;EFxT5D;IAgCE,oCEwR0D,EAAA;EFhT5D;IA+BI,mCAxBE,EAAA;EAfN;IA+DE,2DwBA6F,EAAA;ExBvD/F;IA2DI,0DwBJoI,EAAA;EA3DxI;IAgEI,qBzBunC6E;IyBvnC7E,gDzBunC6E;IyBtnC7E,iDzBqnC4I;IyBrnC5I,4DzBqnC4I,EAAA;;AC1rChJ;EAgCE,oCEwR0D,EAAA;;AFhT5D;EA+BI,mCAxBE,EAAA;;AAfN;EA+DE,kFEyP0D,EAAA;;AFhT5D;EA2DI,iFEqPwD,EAAA;;AsBpT5D;EAkFE,qBzBqmC+E;EyBrmC/E,gDzBqmC+E,EAAA;EyBvrCjF;IAuFM,kEAAqD;IAGrD,2EtB0NsD,EAAA;IFxT5D;MAgCE,uBD0jC+F,EAAA;ICllCjG;MA+BI,sBAxBE,EAAA;IAfN;MA+DE,+DwB8BuH,EAAA;IxBrFzH;MA6DI,6DEiDmI,EAAA;EsBlHvI;IA+FI,qBzBwlC6E;IyBxlC7E,gDzBwlC6E;IyBvlC7E,iDzBslC4I;IyBtlC5I,4DzBslC4I,EAAA;;AyBtrChJ;EAwGI,yCtB4MwD,EAAA;;AsBpT5D;EA+GE,qBzBwkC+E;EyBxkC/E,gDzBwkC+E,EAAA;EyBvrCjF;IAkHI,yBzBgkCwD;IyBhkCxD,6CzBgkCwD,EAAA;EyBlrC5D;IAsHI,iDzBgkC4I;IyBhkC5I,4DzBgkC4I,EAAA;EyBtrChJ;IA0HI,czBwjCwD;IyBxjCxD,kCzBwjCwD,EAAA;;ACtrC5D;EAgCE,kBwBoGoC,EAAA;;AxB5HtC;EA+BI,mBAxBE,EAAA;;AwBXN;;;;;EA0IM,UAAU,EAAA;;ADtBqF;EC/FrG,aAAa;EACb,WAAW;EACX,mBzB85B0C;EF5pBxC,kBAnE+B;E2B5LjC,czBgqCgE;EyBhqChE,oCzBgqCgE,EAAA;;AwBtkCe;ECtF/E,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBzBw7C4C;EyBv7C5C,iBAAiB;E3BqPf,mBAnE+B;E2B/KjC,WzBqpCqB;EyBppCrB,yBzBqpCmD;EyBrpCnD,mCzBqpCmD;EEhrCnD,uBF28C6E;EE38C7E,uCF28C6E,EAAA;;AyBx9C7E;;;;EA+CE,cAAc,EAAA;;AA/ChB;EAqDE,qBzB0oCmF;EyB1oCnF,kDzB0oCmF;EyBtoCjF,yDtBwE0E;EsBvE1E,4BAA4B;EAE5B,gEtBwPwD,EAAA;EFxT5D;IAgCE,oCEwR0D,EAAA;EFhT5D;IA+BI,mCAxBE,EAAA;EAfN;IA+DE,2DwBA6F,EAAA;ExBvD/F;IA2DI,0DwBJoI,EAAA;EA3DxI;IAgEI,qBzB+nCiF;IyB/nCjF,kDzB+nCiF;IyB9nCjF,iDzB6nC0I;IyB7nC1I,2DzB6nC0I,EAAA;;AClsC9I;EAgCE,oCEwR0D,EAAA;;AFhT5D;EA+BI,mCAxBE,EAAA;;AAfN;EA+DE,kFEyP0D,EAAA;;AFhT5D;EA2DI,iFEqPwD,EAAA;;AsBpT5D;EAkFE,qBzB6mCmF;EyB7mCnF,kDzB6mCmF,EAAA;EyB/rCrF;IAuFM,kEAAqD;IAGrD,2EtB0NsD,EAAA;IFxT5D;MAgCE,uBD0jC+F,EAAA;ICllCjG;MA+BI,sBAxBE,EAAA;IAfN;MA+DE,+DwB8BuH,EAAA;IxBrFzH;MA6DI,6DEiDmI,EAAA;EsBlHvI;IA+FI,qBzBgmCiF;IyBhmCjF,kDzBgmCiF;IyB/lCjF,iDzB8lC0I;IyB9lC1I,2DzB8lC0I,EAAA;;AyB9rC9I;EAwGI,yCtB4MwD,EAAA;;AsBpT5D;EA+GE,qBzBglCmF;EyBhlCnF,kDzBglCmF,EAAA;EyB/rCrF;IAkHI,yBzBwkC4D;IyBxkC5D,+CzBwkC4D,EAAA;EyB1rChE;IAsHI,iDzBwkC0I;IyBxkC1I,2DzBwkC0I,EAAA;EyB9rC9I;IA0HI,czBgkC4D;IyBhkC5D,oCzBgkC4D,EAAA;;AC9rChE;EAgCE,kBwBoGoC,EAAA;;AxB5HtC;EA+BI,mBAxBE,EAAA;;AwBXN;;;;;EA4IM,UAAU,EAAA;;AC9IpB;EAEE,4BAAyC;EACzC,6BAAyC;EACzC,uBAA6C;E5BuRzC,yBAnE+B;E4BlNnC,0BAA6C;EAC7C,0BAA6C;EAC7C,sCAAiC;EACjC,yBAA2B;EAC3B,+CAA+C;EAC/C,mCAA+C;EAC/C,iDAAiD;EACjD,yCAA2D;EAC3D,8FAA2C;EAC3C,gCAAuD;EACvD,mFAAuD;EAGvD,qBAAqB;EACrB,0DAAoG;EACpG,uCAA8D;E5BsQ1D,mCAnE+B;E4BjMnC,uCAA8D;EAC9D,uCAA8D;EAC9D,2BAA4C;EAC5C,kBAAkB;EAClB,qBAAwD;EAExD,sBAAsB;EACtB,eAA2C;EAC3C,yBAAiB;UAAjB,iBAAiB;EACjB,qEAAqH;ExBjBnH,2CwBkB0E;EPjC5E,mCOkCoD;ERtBhD,qIlBm4B6I,EAAA;EkB/3B7I;IQhBN;MRiBQ,gBAAgB,EAAA,EQ4FvB;EA7GD;IAuCI,iCAAwD;IAExD,yCAA6D;IAC7D,+CAA6E,EAAA;EAG/E;IAEE,2BAA4C;IAC5C,mCAAiD;IACjD,yCAAiE,EAAA;EAjDrE;IAqDI,iCAAwD;IPrD1D,yCOsDkE;IAChE,+CAA6E;IAC7E,UAAU;IAKR,2CAAuE,EAAA;EAI3E;IACE,+CAA6E;IAC7E,UAAU;IAKR,2CAAuE,EAAA;EAI3E;;IAKE,kCAA0D;IAC1D,0CAA+D;IAG/D,gDAA+E,EAAA;IATjF;;MAiBM,2CAAuE,EAAA;EA7F/E;;IAqGI,oCAA8D;IAC9D,oBAAoB;IACpB,4CAAmE;IAEnE,kDAAmF;IACnF,wCAAoE,EAAA;;AAUxE;EACE,0CAA6D;EAC7D,4CAAiE;EACjE,yCAA2D,EAAA;;AAK3D;EC3GA,0CAAiC;EACjC,qBAA2B;EAC3B,+BAA+C;EAC/C,gDAA6C;EAC7C,2BAAuC;EACvC,qCAA2D;EAC3D,uCAAuD;EACvD,iDAA+C;EAC/C,4BAAyC;EACzC,sCAA6D;EAC7D,8DAAiD;EACjD,mDAAmD;EACnD,8BAA6C;EAC7C,wCAAiE,EAAA;;AD8FjE;EC3GA,wBAAiC;EACjC,qBAA2B;EAC3B,+BAA+C;EAC/C,6CAA6C;EAC7C,2BAAuC;EACvC,qCAA2D;EAC3D,yCAAuD;EACvD,8CAA+C;EAC/C,4BAAyC;EACzC,sCAA6D;EAC7D,8DAAiD;EACjD,iCAAmD;EACnD,8BAA6C;EAC7C,wCAAiE,EAAA;;AD8FjE;EC3GA,wBAAiC;EACjC,qBAA2B;EAC3B,+BAA+C;EAC/C,6CAA6C;EAC7C,2BAAuC;EACvC,qCAA2D;EAC3D,uCAAuD;EACvD,8CAA+C;EAC/C,4BAAyC;EACzC,sCAA6D;EAC7D,8DAAiD;EACjD,iCAAmD;EACnD,8BAA6C;EAC7C,wCAAiE,EAAA;;AD8FjE;EC3GA,wBAAiC;EACjC,qBAA2B;EAC3B,+BAA+C;EAC/C,8BAA6C;EAC7C,2BAAuC;EACvC,qCAA2D;EAC3D,uCAAuD;EACvD,+BAA+C;EAC/C,4BAAyC;EACzC,sCAA6D;EAC7D,8DAAiD;EACjD,iCAAmD;EACnD,8BAA6C;EAC7C,wCAAiE,EAAA;;AD8FjE;EC3GA,uCAAiC;EACjC,qBAA2B;EAC3B,+BAA+C;EAC/C,8BAA6C;EAC7C,2BAAuC;EACvC,qCAA2D;EAC3D,wCAAuD;EACvD,+BAA+C;EAC/C,4BAAyC;EACzC,sCAA6D;EAC7D,8DAAiD;EACjD,gDAAmD;EACnD,8BAA6C;EAC7C,wCAAiE,EAAA;;AD8FjE;EC3GA,wBAAiC;EACjC,kBAA2B;EAC3B,4BAA+C;EAC/C,8BAA6C;EAC7C,2BAAuC;EACvC,qCAA2D;EAC3D,wCAAuD;EACvD,+BAA+C;EAC/C,4BAAyC;EACzC,sCAA6D;EAC7D,8DAAiD;EACjD,iCAAmD;EACnD,2BAA6C;EAC7C,qCAAiE,EAAA;;AD8FjE;EC3GA,uCAAiC;EACjC,qBAA2B;EAC3B,+BAA+C;EAC/C,6CAA6C;EAC7C,2BAAuC;EACvC,qCAA2D;EAC3D,yCAAuD;EACvD,8CAA+C;EAC/C,4BAAyC;EACzC,sCAA6D;EAC7D,8DAAiD;EACjD,gDAAmD;EACnD,8BAA6C;EAC7C,wCAAiE,EAAA;;AD8FjE;EC3GA,0CAAiC;EACjC,qBAA2B;EAC3B,+BAA+C;EAC/C,2BAA6C;EAC7C,2BAAuC;EACvC,qCAA2D;EAC3D,yCAAuD;EACvD,4BAA+C;EAC/C,4BAAyC;EACzC,sCAA6D;EAC7D,8DAAiD;EACjD,mDAAmD;EACnD,8BAA6C;EAC7C,wCAAiE,EAAA;;ADoGjE;ECpFA,wBAAiC;EACjC,+BAA+C;EAC/C,gDAA6C;EAC7C,2BAAuC;EACvC,qCAA2D;EAC3D,uCAAuD;EACvD,iDAA+C;EAC/C,4BAAyC;EACzC,sCAA6D;EAC7D,8DAAiD;EACjD,iCAAmD;EACnD,kCAA6C;EAC7C,oBAA+B,EAAA;;ADwE/B;ECpFA,wBAAiC;EACjC,+BAA+C;EAC/C,6CAA6C;EAC7C,2BAAuC;EACvC,qCAA2D;EAC3D,yCAAuD;EACvD,8CAA+C;EAC/C,4BAAyC;EACzC,sCAA6D;EAC7D,8DAAiD;EACjD,iCAAmD;EACnD,kCAA6C;EAC7C,oBAA+B,EAAA;;ADwE/B;ECpFA,wBAAiC;EACjC,+BAA+C;EAC/C,6CAA6C;EAC7C,2BAAuC;EACvC,qCAA2D;EAC3D,uCAAuD;EACvD,8CAA+C;EAC/C,4BAAyC;EACzC,sCAA6D;EAC7D,8DAAiD;EACjD,iCAAmD;EACnD,kCAA6C;EAC7C,oBAA+B,EAAA;;ADwE/B;ECpFA,wBAAiC;EACjC,+BAA+C;EAC/C,8BAA6C;EAC7C,2BAAuC;EACvC,qCAA2D;EAC3D,uCAAuD;EACvD,+BAA+C;EAC/C,4BAAyC;EACzC,sCAA6D;EAC7D,8DAAiD;EACjD,iCAAmD;EACnD,kCAA6C;EAC7C,oBAA+B,EAAA;;ADwE/B;ECpFA,wBAAiC;EACjC,+BAA+C;EAC/C,8BAA6C;EAC7C,2BAAuC;EACvC,qCAA2D;EAC3D,wCAAuD;EACvD,+BAA+C;EAC/C,4BAAyC;EACzC,sCAA6D;EAC7D,8DAAiD;EACjD,iCAAmD;EACnD,kCAA6C;EAC7C,oBAA+B,EAAA;;ADwE/B;ECpFA,qBAAiC;EACjC,4BAA+C;EAC/C,8BAA6C;EAC7C,2BAAuC;EACvC,qCAA2D;EAC3D,wCAAuD;EACvD,+BAA+C;EAC/C,4BAAyC;EACzC,sCAA6D;EAC7D,8DAAiD;EACjD,8BAAmD;EACnD,kCAA6C;EAC7C,oBAA+B,EAAA;;ADwE/B;ECpFA,wBAAiC;EACjC,+BAA+C;EAC/C,6CAA6C;EAC7C,2BAAuC;EACvC,qCAA2D;EAC3D,yCAAuD;EACvD,8CAA+C;EAC/C,4BAAyC;EACzC,sCAA6D;EAC7D,8DAAiD;EACjD,iCAAmD;EACnD,kCAA6C;EAC7C,oBAA+B,EAAA;;ADwE/B;ECpFA,wBAAiC;EACjC,+BAA+C;EAC/C,2BAA6C;EAC7C,2BAAuC;EACvC,qCAA2D;EAC3D,uCAAuD;EACvD,4BAA+C;EAC/C,4BAAyC;EACzC,sCAA6D;EAC7D,8DAAiD;EACjD,iCAAmD;EACnD,kCAA6C;EAC7C,oBAA+B,EAAA;;AD8E/B;EC9DA,wBAAiC;EACjC,2BAAuC;EACvC,qCAA2D;EAC3D,gDAA6C;EAC7C,4BAAyC;EACzC,sCAA6D;EAC7D,iDAA+C;EAC/C,iCAAmD;EACnD,wCAAmC,EAAA;;ADsDnC;EC9DA,wBAAiC;EACjC,2BAAuC;EACvC,qCAA2D;EAC3D,6CAA6C;EAC7C,4BAAyC;EACzC,sCAA6D;EAC7D,8CAA+C;EAC/C,iCAAmD;EACnD,0CAAmC,EAAA;;ADsDnC;EC9DA,wBAAiC;EACjC,2BAAuC;EACvC,qCAA2D;EAC3D,6CAA6C;EAC7C,4BAAyC;EACzC,sCAA6D;EAC7D,8CAA+C;EAC/C,iCAAmD;EACnD,wCAAmC,EAAA;;ADsDnC;EC9DA,wBAAiC;EACjC,2BAAuC;EACvC,qCAA2D;EAC3D,8BAA6C;EAC7C,4BAAyC;EACzC,sCAA6D;EAC7D,+BAA+C;EAC/C,iCAAmD;EACnD,wCAAmC,EAAA;;ADsDnC;EC9DA,wBAAiC;EACjC,2BAAuC;EACvC,qCAA2D;EAC3D,8BAA6C;EAC7C,4BAAyC;EACzC,sCAA6D;EAC7D,+BAA+C;EAC/C,iCAAmD;EACnD,yCAAmC,EAAA;;ADsDnC;EC9DA,qBAAiC;EACjC,2BAAuC;EACvC,qCAA2D;EAC3D,8BAA6C;EAC7C,4BAAyC;EACzC,sCAA6D;EAC7D,+BAA+C;EAC/C,8BAAmD;EACnD,yCAAmC,EAAA;;ADsDnC;EC9DA,wBAAiC;EACjC,2BAAuC;EACvC,qCAA2D;EAC3D,6CAA6C;EAC7C,4BAAyC;EACzC,sCAA6D;EAC7D,8CAA+C;EAC/C,iCAAmD;EACnD,0CAAmC,EAAA;;ADsDnC;EC9DA,wBAAiC;EACjC,2BAAuC;EACvC,qCAA2D;EAC3D,2BAA6C;EAC7C,4BAAyC;EACzC,sCAA6D;EAC7D,4BAA+C;EAC/C,iCAAmD;EACnD,wCAAmC,EAAA;;ADkErC;EACE,0BAA6C;EAC7C,sCAAiC;EACjC,yBAA2B;EAC3B,mCAA+C;EAC/C,kDAA6C;EAC7C,yCAA2D;EAC3D,0CAA6D;EAC7D,iCAAmD;EACnD,4CAAiE;EACjE,0BAA2C;EAC3C,uCAAuD;EAEvD,0B1BiViD,EAAA;E0B9VnD;IAwBI,2BAA4C,EAAA;;AAWhD;EC9FE,2BAAyC;EACzC,yBAAyC;E7BiMrC,4BAnE+B;E6B5HnC,oDAAiD,EAAA;;AD+FnD;EClGE,4BAAyC;EACzC,2BAAyC;E7BiMrC,6BAnE+B;E6B5HnC,oDAAiD,EAAA;;AChGnD;EVgBM,gClBwmB2C,EAAA;EkBpmB3C;IUpBN;MVqBQ,gBAAgB,EAAA,EUfvB;EAND;IAII,UAAU,EAAA;;AAKd;EAEI,aAAa,EAAA;;AAIjB;EACE,SAAS;EACT,gBAAgB;EVDZ,6BlB0mBwC,EAAA;EkBtmBxC;IULN;MVMQ,gBAAgB,EAAA,EUIvB;EAVD;IAMI,QAAQ;IACR,YAAY;IVNV,4BlB2mBuC,EAAA;IkBvmBvC;MULN;QVMQ,gBAAgB,EAAA,EUGrB;;ACvBH;;;;;;EAME,kBAAkB,EAAA;;AL6FG;EKzFrB,mBAAmB,EAAA;ECwBjB;IACE,qBAAqB;IAErB,uB9B6kB0C;I8B5kB1C,WAAW;IArCf,uBAAwB;IACxB,qCAAsC;IACtC,gBAAgB;IAChB,oCAAqC,EAAA;I7BHnC;MAgCE,oBDklB0C,EAAA;IC1mB5C;MA+BI,qBAxBE,EAAA;EAfN;IAgCE,c6B8BiC,EAAA;E7BtDnC;IA+BI,eAxBE,EAAA;;AuBmFmC;EKhF3C,2BAA6C;EAC7C,+BAAmD;EACnD,2BAAmD;EACnD,gCAAmD;EACnD,+BAA6C;E/BuQzC,8BAnE+B;E+BlMnC,2CAA2C;EAC3C,qCAAqC;EACrC,gEAAyD;EACzD,sDAA2D;EAC3D,oDAAyD;EACzD,4FAAuE;EACvE,8DAAqD;EACrD,uCAAiE;EACjE,6DAAqD;EACrD,gDAAqD;EACrD,sDAAiE;EACjE,oDAA2D;EAC3D,2DAAmE;EACnE,sCAA6D;EAC7D,6DAAuE;EACvE,mCAA6D;EAC7D,sCAA6D;EAC7D,oCAAyD;EACzD,qCAAiE;EACjE,uCAAiE;EAGjE,kBAAkB;EAClB,mCAA0D;EAC1D,aAAa;EACb,wCAAkE;EAClE,oEAAwH;EACxH,SAAS;E/B0OL,wCAnE+B;E+BrKnC,gCAAsD;EACtD,gBAAgB;EAChB,gBAAgB;EAChB,wCAA2D;EAC3D,4BAA4B;EAC5B,+EAAyI;E3BzCvI,gD2B0CoF,EAAA;EA3CxF;IA+CI,SAAS;IAET,sCAA6D,EAAA;I5BjE7D;MAgCE,O4BgCwB,EAAA;I5BxD1B;MA+BI,QAxBE,EAAA;;A4B0EN;EACE,qBAAe,EAAA;E5B1FjB;IAgCE,W4B6DgC,EAAA;E5BrFlC;IA+BI,UAxBE,EAAA;EAfN;IAgCE,O4B8D4B,EAAA;E5BtF9B;IA+BI,QAxBE,EAAA;;A4BmFN;EACE,mBAAe,EAAA;E5BnGjB;IAgCE,Q4BsE6B,EAAA;E5B9F/B;IA+BI,OAxBE,EAAA;EAfN;IAgCE,U4BuE+B,EAAA;E5B/FjC;IA+BI,WAxBE,EAAA;;AS8CN;EmB4BA;IACE,qBAAe,EAAA;I5B1FjB;MAgCE,W4B6DgC,EAAA;I5BrFlC;MA+BI,UAxBE,EAAA;IAfN;MAgCE,O4B8D4B,EAAA;I5BtF9B;MA+BI,QAxBE,EAAA;E4BmFN;IACE,mBAAe,EAAA;I5BnGjB;MAgCE,Q4BsE6B,EAAA;I5B9F/B;MA+BI,OAxBE,EAAA;IAfN;MAgCE,U4BuE+B,EAAA;I5B/FjC;MA+BI,WAxBE,EAAA,EALL;;ASmDD;EmB4BA;IACE,qBAAe,EAAA;I5B1FjB;MAgCE,W4B6DgC,EAAA;I5BrFlC;MA+BI,UAxBE,EAAA;IAfN;MAgCE,O4B8D4B,EAAA;I5BtF9B;MA+BI,QAxBE,EAAA;E4BmFN;IACE,mBAAe,EAAA;I5BnGjB;MAgCE,Q4BsE6B,EAAA;I5B9F/B;MA+BI,OAxBE,EAAA;IAfN;MAgCE,U4BuE+B,EAAA;I5B/FjC;MA+BI,WAxBE,EAAA,EALL;;ASmDD;EmB4BA;IACE,qBAAe,EAAA;I5B1FjB;MAgCE,W4B6DgC,EAAA;I5BrFlC;MA+BI,UAxBE,EAAA;IAfN;MAgCE,O4B8D4B,EAAA;I5BtF9B;MA+BI,QAxBE,EAAA;E4BmFN;IACE,mBAAe,EAAA;I5BnGjB;MAgCE,Q4BsE6B,EAAA;I5B9F/B;MA+BI,OAxBE,EAAA;IAfN;MAgCE,U4BuE+B,EAAA;I5B/FjC;MA+BI,WAxBE,EAAA,EALL;;ASmDD;EmB4BA;IACE,qBAAe,EAAA;I5B1FjB;MAgCE,W4B6DgC,EAAA;I5BrFlC;MA+BI,UAxBE,EAAA;IAfN;MAgCE,O4B8D4B,EAAA;I5BtF9B;MA+BI,QAxBE,EAAA;E4BmFN;IACE,mBAAe,EAAA;I5BnGjB;MAgCE,Q4BsE6B,EAAA;I5B9F/B;MA+BI,OAxBE,EAAA;IAfN;MAgCE,U4BuE+B,EAAA;I5B/FjC;MA+BI,WAxBE,EAAA,EALL;;ASmDD;EmB4BA;IACE,qBAAe,EAAA;I5B1FjB;MAgCE,W4B6DgC,EAAA;I5BrFlC;MA+BI,UAxBE,EAAA;IAfN;MAgCE,O4B8D4B,EAAA;I5BtF9B;MA+BI,QAxBE,EAAA;E4BmFN;IACE,mBAAe,EAAA;I5BnGjB;MAgCE,Q4BsE6B,EAAA;I5B9F/B;MA+BI,OAxBE,EAAA;IAfN;MAgCE,U4BuE+B,EAAA;I5B/FjC;MA+BI,WAxBE,EAAA,EALL;;A4BsGL;EAEI,SAAS;EACT,YAAY;EACZ,aAAa;EACb,yCAAgE,EAAA;;ACpFhE;EACE,qBAAqB;EAErB,uB9B6kB0C;E8B5kB1C,WAAW;EA9Bf,aAAa;EACb,qCAAsC;EACtC,0BAA2B;EAC3B,oCAAqC,EAAA;E7BVnC;IAgCE,oBDklB0C,EAAA;EC1mB5C;IA+BI,qBAxBE,EAAA;;AAfN;EAgCE,c6B8BiC,EAAA;;A7BtDnC;EA+BI,eAxBE,EAAA;;A4B8GV;EAEI,MAAM;EAGN,aAAa,EAAA;E5BlIb;IAgCE,W4BgG4B,EAAA;E5BxH9B;IA+BI,UAxBE,EAAA;EAfN;IAgCE,U4BiG2B,EAAA;E5BzH7B;IA+BI,WAxBE,EAAA;EAfN;IAgCE,uC4BmG+E,EAAA;E5B3HjF;IA+BI,wCAxBE,EAAA;;A6BkBN;EACE,qBAAqB;EAErB,uB9B6kB0C;E8B5kB1C,WAAW;EAvBf,mCAAoC;EACpC,eAAe;EACf,sCAAuC;EACvC,wBAAyB,EAAA;E7BjBvB;IAgCE,oBDklB0C,EAAA;EC1mB5C;IA+BI,qBAxBE,EAAA;;AAfN;EAgCE,c6B8BiC,EAAA;;A7BtDnC;EA+BI,eAxBE,EAAA;;A6BkBN;EDwGE,iBAAiB,EAAA;;AAKvB;EAEI,MAAM;EAGN,aAAa,EAAA;E5BnJb;IAgCE,W4BiH4B,EAAA;E5BzI9B;IA+BI,UAxBE,EAAA;EAfN;IAgCE,U4BkH2B,EAAA;E5B1I7B;IA+BI,WAxBE,EAAA;EAfN;IAgCE,wC4BoHgF,EAAA;E5B5IlF;IA+BI,uCAxBE,EAAA;;A6BkBN;EACE,qBAAqB;EAErB,uB9B6kB0C;E8B5kB1C,WAAW,EAAA;E7BrCb;IAgCE,oBDklB0C,EAAA;EC1mB5C;IA+BI,qBAxBE,EAAA;;A6BkBN;EAgBI,aAAa,EAAA;;AAGf;EACE,qBAAqB;EAErB,uB9B0jBwC;E8BzjBxC,WAAW;EAnCjB,mCAAoC;EACpC,yBAA0B;EAC1B,sCAAuC,EAAA;E7BvBrC;IAgCE,qBDklB0C,EAAA;EC1mB5C;IA+BI,oBAxBE,EAAA;;AAfN;EAgCE,c6B8BiC,EAAA;;A7BtDnC;EA+BI,eAxBE,EAAA;;A6BqCJ;EDsGA,iBAAiB,EAAA;;AAOvB;EACE,SAAS;EACT,8CAA+E;EAC/E,gBAAgB;EAChB,oDAA+E;EAC/E,UAAU,EAAA;;AAMZ;EACE,cAAc;EACd,WAAW;EACX,8EAA4I;EAC5I,WAAW;EACX,gB7B2e+B;E6B1e/B,qCAAgE;EAChE,mBAAmB;EACnB,qBAAwD;EACxD,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;E3BtKP,gB2BuKiG;E3BvKjG,wD2BuKiG,EAAA;EAZrG;IAgBI,2CAA4E;IV1L9E,mDU4LsF,EAAA;EAlBxF;IAuBI,4CAA8E;IAC9E,qBAAqB;IVlMvB,oDUmMwF,EAAA;EAzB1F;IA8BI,8CAAkF;IAClF,oBAAoB;IACpB,6BAA6B,EAAA;;AAMjC;EACE,cAAc,EAAA;;AAIhB;EACE,cAAc;EACd,kFAAoJ;EACpJ,gBAAgB;E/BmEZ,mBAnE+B;E+BEnC,uCAAoE;EACpE,mBAAmB,EAAA;;AAIrB;EACE,cAAc;EACd,8EAA4I;EAC5I,qCAAgE,EAAA;;AAIlE;EAEE,6BAA2C;EAC3C,0BAAqC;EACrC,gEAAyD;EACzD,2BAAqD;EACrD,kCAAqD;EACrD,0DAAiE;EACjE,8DAAqD;EACrD,uDAA2D;EAC3D,2DAAmE;EACnE,sCAA6D;EAC7D,2CAAuE;EACvE,oCAAyD,EAAA;;AEtP3D;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB,EAAA;EAJxB;;IAOI,kBAAkB;IAClB,cAAc,EAAA;EARlB;;;;;;;;;;;;IAmBI,UAAU,EAAA;;AAKd;EACE,aAAa;EACb,eAAe;EACf,2BAA2B,EAAA;EAH7B;IAMI,WAAW,EAAA;;AAIf;E7BhBI,uBF43BuE;EE53BvE,uCF43BuE,EAAA;EC74BvE;;IAgCE,2B8BO6D;I9BP7D,+C8BO6D,EAAA;E9B/B/D;;IA+BI,4BAxBE;IAwBF,gDAxBE,EAAA;EAfN;;;IAgCE,0B8Bc0B,EAAA;E9BtC5B;;;IA+BI,yBAxBE,EAAA;EAfN;;;IAgCE,6B8Bc0B,EAAA;E9BtC5B;;;IA+BI,4BAxBE,EAAA;EAfN;;;IAgCE,yB8BwB4B,EAAA;E9BhD9B;;;IA+BI,0BAxBE,EAAA;EAfN;;;IAgCE,4B8BwB4B,EAAA;E9BhD9B;;;IA+BI,6BAxBE,EAAA;;A8ByDV;EACE,wBAAmC;EACnC,uBAAkC,EAAA;E9B1EhC;;;IAgCE,c8B+C+B,EAAA;E9BvEjC;;;IA+BI,eAxBE,EAAA;EAfN;IAgCE,e8BmDgC,EAAA;E9B3ElC;IA+BI,cAxBE,EAAA;;A8BwEV;EACE,uBAAsC;EACtC,sBAAqC,EAAA;;AAGvC;EACE,sBAAsC;EACtC,qBAAqC,EAAA;;AAoBvC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB,EAAA;EAHzB;;IAOI,WAAW,EAAA;EAPf;;IAYI,0BAA2C;IAA3C,8CAA2C,EAAA;EAZ/C;;I7B1EI,6B6B4F+B;I7B3F/B,4B6B2F+B,EAAA;EAlBnC;;I7BxFI,yB6B+G4B;I7B9G5B,0B6B8G4B,EAAA;;ACtIhC;EAEE,8BAAmD;EACnD,gCAAmD;EAEnD,4BAAuD;EACvD,2CAA2C;EAC3C,uDAAuD;EACvD,yDAA6D;EAG7D,aAAa;EACb,eAAe;EAEf,gBAAgB;EAChB,gBAAgB,EAAA;E/BlBd;IAgCE,e+BhB8B,EAAA;E/BRhC;IA+BI,gBAxBE,EAAA;;A+BMV;EACE,cAAc;EACd,oEAAwH;ElCsQpH,wCAnE+B;EkCjMnC,4CAAwE;EACxE,gCAAsD;EACtD,qBAAwD;EACxD,gBAAgB;EAChB,SAAS;EdfL,uGlBkuCsH,EAAA;EkB9tCtH;IcGN;MdFQ,gBAAgB,EAAA,Ec+BvB;EA7BD;IAaI,sCAAkE,EAAA;EAbtE;IAkBI,UAAU;IACV,iDhCsCmB,EAAA;EgCzDvB;IAyBI,yCAAwE;IACxE,oBAAoB;IACpB,eAAe,EAAA;;AAQnB;EAEE,oDAAyD;EACzD,oDAAyD;EACzD,sDAA2D;EAC3D,+GAA+E;EAC/E,2DAAmE;EACnE,iDAA6D;EAC7D,2GAAiF;EAGjF,sFAAgJ,EAAA;EAXlJ;IAcI,0DAAuF;IACvF,0DAAuF;I9B7CvF,yD8B8C0F;I9B7C1F,0D8B6C0F,EAAA;IAhB9F;MAqBM,kBAAkB;MAClB,yDAAiG,EAAA;EAtBvG;;IA4BI,4CAA8E;IAC9E,oDAAmF;IACnF,0DAAmG,EAAA;EA9BvG;IAmCI,uDAAoF;I9BjEpF,yB8BmE4B;I9BlE5B,0B8BkE4B,EAAA;;AAShC;EAEE,uDAA6D;EAC7D,4DAAqE;EACrE,uCAA+D,EAAA;EAJjE;I9BrFI,iD8B6FwF,EAAA;EAR5F;;IAaI,6CAAgF;IbjHlF,qDakH0F,EAAA;;AAS5F;;EAGI,cAAc;EACd,kBAAkB,EAAA;;AAItB;;EAGI,aAAa;EACb,YAAY;EACZ,kBAAkB,EAAA;;AAItB;;EAGI,WAAW,EAAA;;AASf;EAEI,aAAa,EAAA;;AAFjB;EAKI,cAAc,EAAA;;AC5JlB;EAEE,yBAA+C;EAC/C,8BAA+C;EAC/C,6DAAuC;EACvC,kEAAmD;EACnD,qEAAyD;EACzD,iEAAqD;EACrD,uCAA2D;EAC3D,mCAA6D;EAC7D,qCAA2D;EAC3D,gEAAmD;EACnD,sEAA+D;EAC/D,uCAAiE;EACjE,uCAA+D;EAC/D,uCAA+D;EAC/D,uCAA+D;EAC/D,qEAA2D;EAC3D,4EAAqE;EACrE,4DAAuE;EACvE,yCAAmE;EACnE,6DAAiE;EAGjE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,gEAAgH,EAAA;EA7BlH;;;IAoCI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B,EAAA;;AAoBlC;EACE,8CAA4E;EAC5E,iDAA+E;EnC6N3E,4CAnE+B;EmCvJnC,oCAA8D;EAC9D,qBAAwD;EACxD,mBAAmB,EAAA;EhCrEjB;IAgCE,gDgCiC8F,EAAA;EhCzDhG;IA+BI,+CAxBE,EAAA;EgC+CV;IAWI,0CAA0E,EAAA;;AAU9E;EAEE,2BAAmD;EACnD,gCAAmD;EAEnD,4BAAuD;EACvD,6CAA2C;EAC3C,yDAAuD;EACvD,+DAA6D;EAG7D,aAAa;EACb,sBAAsB;EAEtB,gBAAgB;EAChB,gBAAgB,EAAA;EhClGd;IAgCE,egCgE8B,EAAA;EhCxFhC;IA+BI,gBAxBE,EAAA;EgCoEV;IAoBM,qCAAgE,EAAA;EApBtE;IAyBI,gBAAgB,EAAA;;AAQpB;EACE,mBjCqnCuC;EiCpnCvC,sBjConCuC;EiCnnCvC,8BAAkD,EAAA;EAHpD;;;IAQI,qCAAgE,EAAA;;AAapE;EACE,gBAAgB;EAChB,YAAY;EAGZ,mBAAmB,EAAA;;AAIrB;EACE,gFAAgJ;EnC0I5I,8CAnE+B;EmCrEnC,cAAc;EACd,8BAAkD;EAClD,6BAA6B;EAC7B,wDAAmI;EAAnI,4EAAmI;E/BvIjI,sD+BwIgG;Ef3I9F,gDe4IqF,EAAA;EfxIrF;IegIN;Mf/HQ,gBAAgB,EAAA,EekJvB;EAnBD;IAWI,qBAAqB,EAAA;EAXzB;IAeI,qBAAqB;IACrB,UAAU;IACV,uDAAyF,EAAA;;AAM7F;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mDAAiF;EACjF,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB,EAAA;;AAGvB;EACE,gBAA+D;EAA/D,0CAA+D;EAC/D,gBAAgB,EAAA;;AvBzHd;EuBqIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,mDAAoF;QACpF,kDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Mf7N9B,gBe+N4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AvB5LP;EuBqIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,mDAAoF;QACpF,kDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Mf7N9B,gBe+N4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AvB5LP;EuBqIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,mDAAoF;QACpF,kDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Mf7N9B,gBe+N4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AvB5LP;EuBqIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,mDAAoF;QACpF,kDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Mf7N9B,gBe+N4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AvB5LP;EuBqIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,mDAAoF;QACpF,kDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Mf7N9B,gBe+N4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AA7DX;EAQQ,iBAAiB;EACjB,2BAA2B,EAAA;EATnC;IAYU,mBAAmB,EAAA;IAZ7B;MAeY,kBAAkB,EAAA;IAf9B;MAmBY,mDAAoF;MACpF,kDAAmF,EAAA;EApB/F;IAyBU,iBAAiB,EAAA;EAzB3B;IA6BU,wBAAwB;IACxB,gBAAgB,EAAA;EA9B1B;IAkCU,aAAa,EAAA;EAlCvB;IAuCU,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,wCAAwC;IACxC,oBAAoB;IACpB,0BAA0B;If7N9B,gBe+N4B,EAAA;IAjDlC;MAqDY,aAAa,EAAA;IArDzB;MAyDY,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB,EAAA;;AAiB/B;EAEE,6CAAuC;EACvC,mDAAmD;EACnD,sDAAyD;EACzD,+BAAqD;EACrD,8BAAmD;EACnD,oCAA+D;EAC/D,2DAAqE;EACrE,sEAA2D,EAAA;;AChR7D;EAEE,yBAAyC;EACzC,yBAAyC;EACzC,iCAAqD;EACrD,wBAA+C;EAC/C,2BAAqD;EACrD,gDAAiD;EACjD,4DAAiD;EACjD,kDAAmD;EACnD,uBAA6C;EAC7C,0FAA+D;EAC/D,gCAAmD;EACnD,8BAAmD;EACnD,wDAAqC;EACrC,sBAA2C;EAC3C,mBAAqC;EACrC,kBAAmC;EACnC,iCAA6B;EAC7B,oCAA+D;EAC/D,gCAAiD;EAGjD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8BAAiD;EACjD,6BAA8C;EAA9C,4BAA8C;EAC9C,qBAAqB;EACrB,oCAAmD;EACnD,2BAA2B;EAC3B,uEAAyH;EhCjBvH,4CgCkB4E,EAAA;EAjChF;IAqCI,eAAe;IACf,cAAc,EAAA;EAtClB;IA0CI,mBAAmB;IACnB,sBAAsB,EAAA;IA3C1B;MA8CM,mBAAmB;MhCtBrB,2DgCuBgG;MhCtBhG,4DgCsBgG,EAAA;IA/CpG;MAmDM,sBAAsB;MhCbxB,+DgCcmG;MhCbnG,8DgCamG,EAAA;EApDvG;;IA4DI,aAAa,EAAA;;AAIjB;EAGE,cAAc;EACd,0DAAoG;EACpG,4BAA8C,EAAA;;AAGhD;EACE,6CAAwE;EACxE,kCAA0D,EAAA;;AAG5D;EACE,sDAAiF;EACjF,gBAAgB;EAChB,qCAAgE,EAAA;;AAGlE;EACE,gBAAgB,EAAA;;AjCtFd;EAgCE,qCiC+D2E,EAAA;;AjCvF7E;EA+BI,sCAxBE,EAAA;;AiCwFV;EACE,oEAAwH;EACxH,gBAAgB;EAChB,gCAAsD;EACtD,wCAA2D;EAC3D,8EAAgI,EAAA;EALlI;IhCtFI,0FgC8FkK,EAAA;;AAItK;EACE,oEAAwH;EACxH,gCAAsD;EACtD,wCAA2D;EAC3D,2EAA6H,EAAA;EAJ/H;IhClGI,0FgCyGkK,EAAA;;AAStK;EACE,uDAAiF;EACjF,uDAAiF;EACjF,sDAAgF;EAChF,gBAAgB,EAAA;EAJlB;IAOI,oCAAmD;IACnD,uCAAsD,EAAA;;AAI1D;EACE,uDAAiF;EACjF,sDAAgF,EAAA;;AAIlF;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,4CAA4E;EhC1I1E,kDgC2IwF,EAAA;;AAG5F;;;EAGE,WAAW,EAAA;;AAGb;;EhC3II,2DgC6I4F;EhC5I5F,4DgC4I4F,EAAA;;AAGhG;;EhClII,+DgCoI+F;EhCnI/F,8DgCmI+F,EAAA;;AAQnG;EAII,2CAAoE,EAAA;;AxB3HpE;EwBuHJ;IAQI,aAAa;IACb,mBAAmB,EAAA;IATvB;MAcM,SAAY;MACZ,gBAAgB,EAAA;MjCnMlB;QAgCE,ciCsKmC,EAAA;MjC9LrC;QA+BI,eAxBE,EAAA;MAfN;QAgCE,ciCuKmC,EAAA;MjC/LrC;QA+BI,eAxBE,EAAA;MAfN;QAgCE,0BiC6KgC,EAAA;MjCrMlC;QA+BI,yBAxBE,EAAA;MAfN;QAgCE,6BiC6KgC,EAAA;MjCrMlC;QA+BI,4BAxBE,EAAA;MiCqKV;;QA8BY,0BAA0B,EAAA;MA9BtC;;QAmCY,6BAA6B,EAAA;MjCvNrC;QAgCE,yBiC4LkC,EAAA;MjCpNpC;QA+BI,0BAxBE,EAAA;MAfN;QAgCE,4BiC4LkC,EAAA;MjCpNpC;QA+BI,6BAxBE,EAAA;MiCqKV;;QA6CY,yBAAyB,EAAA;MA7CrC;;QAkDY,4BAA4B,EAAA,EAC7B;;ACrOX;EAEE,4CAA6C;EAC7C,sCAAuC;EACvC,+KAAuD;EACvD,qDAA2D;EAC3D,qDAA2D;EAC3D,uDAA6D;EAC7D,+FAAyE;EACzE,sCAA6D;EAC7D,mCAA6D;EAC7D,gDAAqD;EACrD,+CAA+C;EAC/C,kEAAmD;EACnD,uCAA+D;EAC/D,mDAAuE;EACvE,+DAAyE;EACzE,yEAAiE;EACjE,+CAA+E;EAC/E,2EAA2E;EAC3E,uCAA+D;EAC/D,oCAA+D;EAC/D,qCAA2D;EAC3D,kCAAqD,EAAA;;AAIvD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8EAA4I;ErC2PxI,eAnE+B;EqCtLnC,qCAAgE;EAChE,gBAAgB;EAChB,6CAAqE;EACrE,SAAS;EjCtBP,gBiCuBsB;EACxB,qBAAqB;EjB3BjB,2CiB4B2E,EAAA;EjBxB3E;IiBWN;MjBVQ,gBAAgB,EAAA,EiB2DvB;EAjDD;IAgBI,wCAAsE;IACtE,gDAA2E;IAC3E,oGAAgK,EAAA;IAlBpK;MAqBM,sDAAuF;MACvF,kDAAsF,EAAA;EAtB5F;IA4BI,cAAc;IACd,0CAA0E;IAC1E,2CAA2E;IAC3E,iBAAiB;IACjB,WAAW;IACX,+CAAyE;IACzE,4BAA4B;IAC5B,oDAAoF;IjBlDlF,oDiBmD+F,EAAA;IjB/C/F;MiBWN;QjBVQ,gBAAgB,EAAA,EiB+CrB;EArCH;IAwCI,UAAU,EAAA;EAxCd;IA4CI,UAAU;IACV,yDAAiG;IACjG,UAAU;IACV,qDAA2F,EAAA;;AAI/F;EACE,gBAAgB,EAAA;;AAGlB;EACE,iCAAwD;EACxD,yCAA6D;EAC7D,iFAA6I,EAAA;EAH/I;IjC1DI,0DiCgE4F;IjC/D5F,2DiC+D4F,EAAA;IANhG;MjC1DI,gEiCmE0G;MjClE1G,iEiCkE0G,EAAA;EAT9G;IAcI,aAAa,EAAA;EAdjB;IjC5CI,8DiC+D+F;IjC9D/F,6DiC8D+F,EAAA;IAnBnG;MjC5CI,oEiCmE+G;MjClE/G,mEiCkE+G,EAAA;IAvBnH;MjC5CI,8DiCwEiG;MjCvEjG,6DiCuEiG,EAAA;;AAKrG;EACE,gFAAgJ,EAAA;;AAQlJ;EAEI,eAAe,EAAA;;AAFnB;EAMI,eAAe;EACf,cAAc;EjCpHd,gBiCqHwB,EAAA;EAR5B;IAUoB,aAAa,EAAA;EAVjC;IAWmB,gBAAgB,EAAA;EAXnC;IjC7GI,gBiC6H4B,EAAA;;AChJhC;EAEE,6BAAuD;EACvD,6BAAuD;EACvD,oCAA+D;EAE/D,qBAAyC;EACzC,gCAA+D;EAC/D,0DAA+D;EAC/D,uCAAiE;EACjE,8DAAuE;EAGvE,aAAa;EACb,eAAe;EACf,wEAAgI;EAChI,kDAAkF;EtC+Q9E,0CAnE+B;EsC1MnC,gBAAgB;EAChB,0CAA+D;ElCA7D,kDkCCwF,EAAA;;AnClBxF;EAgCE,kDmCRqG,EAAA;;AnChBvG;EA+BI,mDAxBE,EAAA;;AmCMV;EAQM,0CAA0E,EAAA;EnC7B5E;IAgCE,WmCL8B,EAAA;EnCnBhC;IA+BI,YE+EmI,EAAA;EFtHvI;IAgCE,mDmCJuG,EAAA;EnCpBzG;IA+BI,kDAxBE,EAAA;EAfN;IAgCE,YmCA0F;InCA1F,2CmCA0F,EAAA;EnCxB5F;IA4BI,YmCFgH;InCEhH,mDmCFgH,EAAA;;AAbxH;EAmBI,8CAAkF,EAAA;;AC1CtF;EAEE,mCAAuD;EACvD,oCAAuD;EvC4RnD,gCAnE+B;EuCvNnC,6CAA+C;EAC/C,uCAAyC;EACzC,sDAA6D;EAC7D,sDAA6D;EAC7D,wDAA+D;EAC/D,yDAA2D;EAC3D,iDAAqD;EACrD,4DAAyE;EACzE,yDAA2D;EAC3D,kDAAqD;EACrD,wEAAqE;EACrE,wDAA6D;EAC7D,mCAAuD;EACvD,6CAA2E;EAC3E,2DAAiE;EACjE,qDAA2D;EAC3D,+DAA+E;EAG/E,aAAa;EhCnBb,gBAAgB,EAAA;EJHd;IAgCE,eI9B8B,EAAA;EJMhC;IA+BI,gBAxBE,EAAA;;AoCWV;EACE,kBAAkB;EAClB,cAAc;EACd,wEAAgI;EvCgQ5H,0CAnE+B;EuC3LnC,kCAA0D;EAC1D,qBAAwD;EACxD,0CAA+D;EAC/D,mFAAiJ;EnBpB7I,qIlB63CoJ,EAAA;EkBz3CpJ;ImBQN;MnBPQ,gBAAgB,EAAA,EmBiDvB;EA1CD;IAYI,UAAU;IACV,wCAAsE;IAEtE,gDAA2E;IAC3E,sDAA2F,EAAA;EAhB/F;IAoBI,UAAU;IACV,wCAAsE;IACtE,gDAA2E;IAC3E,UrC40CiC;IqC30CjC,kDAAqF,EAAA;EAxBzF;;IA6BI,UAAU;IACV,yCAAwE;IlBtD1E,iDkBuDkF;IAChF,uDAA6F,EAAA;EAhCjG;;IAqCI,2CAA4E;IAC5E,oBAAoB;IACpB,mDAAiF;IACjF,yDAAiG,EAAA;;ApClEjG;EAgCE,2BDu1CoE;ECv1CpE,+CDu1CoE,EAAA;;AC/2CtE;EA+BI,4BAxBE;EAwBF,gDAxBE,EAAA;;AAfN;EAgCE,2DoC8CkG,EAAA;;ApCtEpG;EA+BI,4DAxBE,EAAA;;AAfN;EAgCE,8DoC8CkG,EAAA;;ApCtEpG;EA+BI,+DAxBE,EAAA;;AAfN;EAgCE,4DoCoDgG,EAAA;;ApC5ElG;EA+BI,2DAxBE,EAAA;;AAfN;EAgCE,+DoCoDgG,EAAA;;ApC5ElG;EA+BI,8DAxBE,EAAA;;AoCqFV;EClGE,kCAAuD;EACvD,mCAAuD;ExC0RnD,mCAnE+B;EwCrNnC,2DAA+D,EAAA;;ADmGjE;ECtGE,kCAAuD;EACvD,mCAAuD;ExC0RnD,oCAnE+B;EwCrNnC,2DAA+D,EAAA;;ACFjE;EAEE,6BAA6C;EAC7C,6BAA6C;EzCuRzC,6BAnE+B;EyClNnC,4BAAiD;EACjD,4CAAqC;EACrC,mDAAqD;EAGrD,qBAAqB;EACrB,8DAA4G;EzC+QxG,qCAnE+B;EyC1MnC,yCAAkE;EAClE,cAAc;EACd,6BAAgD;EAChD,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,gBAA2E;EAA3E,gDAA2E,EAAA;EAnB7E;IAwBI,aAAa,EAAA;;AAKjB;EACE,kBAAkB;EAClB,SAAS,EAAA;;AAOX;EACE,4BAA6C;EAC7C,4BAA6C;EzCkPzC,iBAnE+B,EAAA;;A0CxNrC;EAEE,2BAA+B;EAC/B,2BAA6C;EAC7C,2BAA6C;EAC7C,+BAAqD;EACrD,0BAAqC;EACrC,qCAAmD;EACnD,+EAAuC;EACvC,mDAAqD;EACrD,+BAA+C;EAG/C,kBAAkB;EAClB,8DAA4G;EAC5G,6CAAwE;EACxE,6BAAgD;EAChD,qCAAqD;EACrD,+BAAmD;EtCHjD,6CsCI8E,EAAA;;AAIlF;EAEE,cAAc,EAAA;;AAIhB;EACE,gBxC+nB+B;EwC9nB/B,kCAA0D,EAAA;;AvCjCxD;EAgCE,mBDkmD8C,EAAA;;AC1nDhD;EA+BI,kBAxBE,EAAA;;AuC0BV;EAKI,kBAAkB;EAClB,MAAM;EAEN,UxCycuC;EwCxcvC,qBxCsZS,EAAA;ECxcT;IAgCE,QuCgByB,EAAA;EvCxC3B;IA+BI,OAxBE,EAAA;;AuC2CR;EACE,0BAAqC;EACrC,uBAA+B;EAC/B,iCAAmD;EACnD,+BAA+C,EAAA;;AAJjD;EACE,0BAAqC;EACrC,uBAA+B;EAC/B,iCAAmD;EACnD,+BAA+C,EAAA;;AAJjD;EACE,0BAAqC;EACrC,uBAA+B;EAC/B,iCAAmD;EACnD,+BAA+C,EAAA;;AAJjD;EACE,0BAAqC;EACrC,uBAA+B;EAC/B,iCAAmD;EACnD,+BAA+C,EAAA;;AAJjD;EACE,0BAAqC;EACrC,uBAA+B;EAC/B,iCAAmD;EACnD,+BAA+C,EAAA;;AAJjD;EACE,0BAAqC;EACrC,uBAA+B;EAC/B,iCAAmD;EACnD,+BAA+C,EAAA;;AAJjD;EACE,0BAAqC;EACrC,uBAA+B;EAC/B,iCAAmD;EACnD,+BAA+C,EAAA;;AAJjD;EACE,0BAAqC;EACrC,uBAA+B;EAC/B,iCAAmD;EACnD,+BAA+C,EAAA;;AC5DjD;EACE;IAAK,2BzCoqD+B,EAAA,EAAA;;AyC/pDxC;;EAGE,2BAA6C;E3CkRzC,iCAnE+B;E2C7MnC,0CAAqC;EACrC,sDAA2D;EAC3D,sDAAqD;EACrD,mDAAmD;EACnD,yCAA6C;EAC7C,8CAA6D;EAG7D,aAAa;EACb,kCAAyD;EACzD,gBAAgB;E3CsQZ,wCAnE+B;E2CjMnC,wCAA2D;EvCRzD,gDuCSoF,EAAA;;AAIxF;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,oCAA8D;EAC9D,kBAAkB;EAClB,mBAAmB;EACnB,4CAAmE;EvBxB/D,8CuByBiF,EAAA;EvBrBjF;IuBYN;MvBXQ,gBAAgB,EAAA,EuBqBvB;;AAED;EtBAE,qMAA6I;EsBE7I,sEAAoH,EAAA;;AAGtH;EACE,iBAAiB,EAAA;;AAGnB;EACE,WAAW,EAAA;;AAIX;EACE,kDAA8D,EAAA;EAG5D;IAJJ;MAKM,eAAe,EAAA,EAGpB;;AAGH;EACE,WAAW,EAAA;;AAIb;EACE,0CAAyC,EAAA;EAD3C;IAGI,sBzCrEY,EAAA;;AyCyEhB;EACE,aAAa;EACb,mBAAmB;EACnB,mBzCsXW,EAAA;;AyCnXb;EACE,eAAe;EACf,kBAAkB,EAAA;;AAGpB;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,sBzColDkD,EAAA;;AyCjlDpD;EACE,YAAY;EACZ,kBAAkB,EAAA;EAFpB;IAKI,kBAAkB,EAAA;;AAItB;EACE,gBAAgB,EAAA;;ACzGlB;EAEE,6CAA+C;EAC/C,uCAAyC;EACzC,sDAA6D;EAC7D,sDAA6D;EAC7D,wDAA+D;EAC/D,qCAAiE;EACjE,uCAAiE;EACjE,yDAA6D;EAC7D,8DAAyE;EACzE,wDAAmE;EACnE,2DAA2E;EAC3E,0DAAqE;EACrE,2DAAiE;EACjE,gDAA2D;EAC3D,wDAA6D;EAC7D,mCAAuD;EACvD,6CAA2E;EAG3E,aAAa;EACb,sBAAsB;EAItB,gBAAgB;ExCXd,kDwCYwF,EAAA;EzC7BxF;IAgCE,eyCL8B,EAAA;EzCnBhC;IA+BI,gBAxBE,EAAA;;AyCiBV;EACE,qBAAqB;EACrB,sBAAsB,EAAA;EAFxB;IAMI,oCAAoC;IACpC,0BAA0B,EAAA;;AAS9B;EACE,WAAW;EACX,yCAAwE;EACxE,mBAAmB,EAAA;EAHrB;IAQI,UAAU;IACV,+CAAoF;IACpF,qBAAqB;IACrB,uDAAyF,EAAA;EAX7F;IAeI,gDAAsF;IACtF,wDAA2F,EAAA;;AAQ/F;EACE,kBAAkB;EAClB,cAAc;EACd,kFAAoJ;EACpJ,kCAA0D;EAC1D,qBAAwD;EACxD,0CAA+D;EAC/D,mFAAiJ,EAAA;EAPnJ;IxC9CI,+BwCwDkC;IxCvDlC,gCwCuDkC,EAAA;EAVtC;IxChCI,mCwC8CqC;IxC7CrC,kCwC6CqC,EAAA;EAdzC;IAmBI,2CAA4E;IAC5E,oBAAoB;IACpB,mDAAiF,EAAA;EArBrF;IA0BI,UAAU;IACV,yCAAwE;IACxE,iDAA6E;IAC7E,uDAA6F,EAAA;EA7BjG;IAkCI,mBAAmB,EAAA;IAlCvB;MAqCM,yDAAwF;MACxF,oDAAmF,EAAA;;AAarF;EACE,mBAAmB,EAAA;EzC5HrB;IAgCE,8DyCgG2G,EAAA;EzCxH7G;IA+BI,+DAxBE,EAAA;EAfN;IAgCE,0ByCiGoC,EAAA;EzCzHtC;IA+BI,yBAxBE,EAAA;EAfN;IAgCE,4DyCqGsG,EAAA;EzC7HxG;IA+BI,2DAxBE,EAAA;EAfN;IAgCE,4ByCsGyC,EAAA;EzC9H3C;IA+BI,6BAxBE,EAAA;EyC4GN;IAeM,aAAa,EAAA;EAfnB;IAmBM,oDAAmF,EAAA;IzC9IzF;MAgCE,oByC+G2C,EAAA;IzCvI7C;MA+BI,qBAxBE,EAAA;IAfN;MAgCE,0DyCkHkH,EAAA;IzC1IpH;MA+BI,2DAxBE,EAAA;IAfN;MAgCE,qDyCmH6G,EAAA;IzC3I/G;MA+BI,sDAxBE,EAAA;;AS8CN;EgC8DA;IACE,mBAAmB,EAAA;IzC5HrB;MAgCE,8DyCgG2G,EAAA;IzCxH7G;MA+BI,+DAxBE,EAAA;IAfN;MAgCE,0ByCiGoC,EAAA;IzCzHtC;MA+BI,yBAxBE,EAAA;IAfN;MAgCE,4DyCqGsG,EAAA;IzC7HxG;MA+BI,2DAxBE,EAAA;IAfN;MAgCE,4ByCsGyC,EAAA;IzC9H3C;MA+BI,6BAxBE,EAAA;IyC4GN;MAeM,aAAa,EAAA;IAfnB;MAmBM,oDAAmF,EAAA;MzC9IzF;QAgCE,oByC+G2C,EAAA;MzCvI7C;QA+BI,qBAxBE,EAAA;MAfN;QAgCE,0DyCkHkH,EAAA;MzC1IpH;QA+BI,2DAxBE,EAAA;MAfN;QAgCE,qDyCmH6G,EAAA;MzC3I/G;QA+BI,sDAxBE,EAAA,EALL;;ASmDD;EgC8DA;IACE,mBAAmB,EAAA;IzC5HrB;MAgCE,8DyCgG2G,EAAA;IzCxH7G;MA+BI,+DAxBE,EAAA;IAfN;MAgCE,0ByCiGoC,EAAA;IzCzHtC;MA+BI,yBAxBE,EAAA;IAfN;MAgCE,4DyCqGsG,EAAA;IzC7HxG;MA+BI,2DAxBE,EAAA;IAfN;MAgCE,4ByCsGyC,EAAA;IzC9H3C;MA+BI,6BAxBE,EAAA;IyC4GN;MAeM,aAAa,EAAA;IAfnB;MAmBM,oDAAmF,EAAA;MzC9IzF;QAgCE,oByC+G2C,EAAA;MzCvI7C;QA+BI,qBAxBE,EAAA;MAfN;QAgCE,0DyCkHkH,EAAA;MzC1IpH;QA+BI,2DAxBE,EAAA;MAfN;QAgCE,qDyCmH6G,EAAA;MzC3I/G;QA+BI,sDAxBE,EAAA,EALL;;ASmDD;EgC8DA;IACE,mBAAmB,EAAA;IzC5HrB;MAgCE,8DyCgG2G,EAAA;IzCxH7G;MA+BI,+DAxBE,EAAA;IAfN;MAgCE,0ByCiGoC,EAAA;IzCzHtC;MA+BI,yBAxBE,EAAA;IAfN;MAgCE,4DyCqGsG,EAAA;IzC7HxG;MA+BI,2DAxBE,EAAA;IAfN;MAgCE,4ByCsGyC,EAAA;IzC9H3C;MA+BI,6BAxBE,EAAA;IyC4GN;MAeM,aAAa,EAAA;IAfnB;MAmBM,oDAAmF,EAAA;MzC9IzF;QAgCE,oByC+G2C,EAAA;MzCvI7C;QA+BI,qBAxBE,EAAA;MAfN;QAgCE,0DyCkHkH,EAAA;MzC1IpH;QA+BI,2DAxBE,EAAA;MAfN;QAgCE,qDyCmH6G,EAAA;MzC3I/G;QA+BI,sDAxBE,EAAA,EALL;;ASmDD;EgC8DA;IACE,mBAAmB,EAAA;IzC5HrB;MAgCE,8DyCgG2G,EAAA;IzCxH7G;MA+BI,+DAxBE,EAAA;IAfN;MAgCE,0ByCiGoC,EAAA;IzCzHtC;MA+BI,yBAxBE,EAAA;IAfN;MAgCE,4DyCqGsG,EAAA;IzC7HxG;MA+BI,2DAxBE,EAAA;IAfN;MAgCE,4ByCsGyC,EAAA;IzC9H3C;MA+BI,6BAxBE,EAAA;IyC4GN;MAeM,aAAa,EAAA;IAfnB;MAmBM,oDAAmF,EAAA;MzC9IzF;QAgCE,oByC+G2C,EAAA;MzCvI7C;QA+BI,qBAxBE,EAAA;MAfN;QAgCE,0DyCkHkH,EAAA;MzC1IpH;QA+BI,2DAxBE,EAAA;MAfN;QAgCE,qDyCmH6G,EAAA;MzC3I/G;QA+BI,sDAxBE,EAAA,EALL;;ASmDD;EgC8DA;IACE,mBAAmB,EAAA;IzC5HrB;MAgCE,8DyCgG2G,EAAA;IzCxH7G;MA+BI,+DAxBE,EAAA;IAfN;MAgCE,0ByCiGoC,EAAA;IzCzHtC;MA+BI,yBAxBE,EAAA;IAfN;MAgCE,4DyCqGsG,EAAA;IzC7HxG;MA+BI,2DAxBE,EAAA;IAfN;MAgCE,4ByCsGyC,EAAA;IzC9H3C;MA+BI,6BAxBE,EAAA;IyC4GN;MAeM,aAAa,EAAA;IAfnB;MAmBM,oDAAmF,EAAA;MzC9IzF;QAgCE,oByC+G2C,EAAA;MzCvI7C;QA+BI,qBAxBE,EAAA;MAfN;QAgCE,0DyCkHkH,EAAA;MzC1IpH;QA+BI,2DAxBE,EAAA;MAfN;QAgCE,qDyCmH6G,EAAA;MzC3I/G;QA+BI,sDAxBE,EAAA,EALL;;AyCuJL;ExChJI,gBwCiJsB,EAAA;EAD1B;IAII,oDAAmF,EAAA;IAJvF;MAOM,sBAAsB,EAAA;;AAa1B;EC9KA,mFAA+C;EAC/C,4BAAyC;EACzC,kCAAqD;EACrD,gGAAyE;EACzE,0CAA2E;EAC3E,8FAAqE;EACrE,wGAAyF,EAAA;;ADwKzF;EC9KA,qFAA+C;EAC/C,4BAAyC;EACzC,kCAAqD;EACrD,kGAAyE;EACzE,0CAA2E;EAC3E,gGAAqE;EACrE,0GAAyF,EAAA;;ADwKzF;EC9KA,mFAA+C;EAC/C,4BAAyC;EACzC,kCAAqD;EACrD,gGAAyE;EACzE,0CAA2E;EAC3E,8FAAqE;EACrE,wGAAyF,EAAA;;ADwKzF;EC9KA,kFAA+C;EAC/C,4BAAyC;EACzC,kCAAqD;EACrD,+FAAyE;EACzE,0CAA2E;EAC3E,6FAAqE;EACrE,uGAAyF,EAAA;;ADwKzF;EC9KA,mFAA+C;EAC/C,4BAAyC;EACzC,kCAAqD;EACrD,gGAAyE;EACzE,0CAA2E;EAC3E,8FAAqE;EACrE,wGAAyF,EAAA;;ADwKzF;EC9KA,gFAA+C;EAC/C,4BAAyC;EACzC,kCAAqD;EACrD,6FAAyE;EACzE,0CAA2E;EAC3E,2FAAqE;EACrE,qGAAyF,EAAA;;ADwKzF;EC9KA,iFAA+C;EAC/C,4BAAyC;EACzC,kCAAqD;EACrD,8FAAyE;EACzE,0CAA2E;EAC3E,4FAAqE;EACrE,sGAAyF,EAAA;;ADwKzF;EC9KA,gFAA+C;EAC/C,4BAAyC;EACzC,kCAAqD;EACrD,6FAAyE;EACzE,0CAA2E;EAC3E,2FAAqE;EACrE,qGAAyF,EAAA;;ACV3F;EAEE,6CAA6C;EAC7C,4DAAuC;EACvC,4BAAiD;EACjD,mCAA6D;EAC7D,mEAA2D;EAC3D,gCAA6D;EAC7D,sCAAmE;EACnE,wEAA2D;EAG3D,uBAAuB;EACvB,U5C+8D8B;E4C98D9B,W5C88D8B;E4C78D9B,sB5C+8DgC;E4C98DhC,iCAAwD;EACxD,yEAA4G;EAC5G,SAAS;E1CJP,uBFikBiC;E4C3jBnC,qCAA8D,EAAA;EApBhE;IAwBI,iCAAwD;IACxD,qBAAqB;IACrB,2CAA0E,EAAA;EA1B9E;IA8BI,UAAU;IACV,6CAA2E;IAC3E,2CAA0E,EAAA;EAhC9E;IAqCI,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;IACjB,8CAAgF,EAAA;;AAIpF;EACE,yCAAuE,EAAA;;ACjDzE;EAEE,wBAAuC;EACvC,8BAA6C;EAC7C,6BAA6C;EAC7C,2BAAyC;EACzC,4BAA6C;E/CyRzC,+BAnE+B;E+CpNnC,mBAAqC;EACrC,kDAA+B;EAC/B,iDAAmD;EACnD,6DAAmD;EACnD,mDAAqD;EACrD,6CAA+C;EAC/C,oDAAmD;EACnD,yDAA6C;EAC7C,oEAAiE;EAGjE,iCAAwD;EACxD,eAAe;E/C2QX,qCAnE+B;E+CtMnC,6BAAgD;EAChD,oBAAoB;EACpB,qCAAqD;EACrD,4BAA4B;EAC5B,yEAA6H;EAC7H,uCAA+D;E3CR7D,6C2CS8E,EAAA;EA5BlF;IA+BI,UAAU,EAAA;EA/Bd;IAmCI,aAAa,EAAA;;AAIjB;EACE,wBAAuC;EAEvC,kBAAkB;EAClB,gCAAoD;EACpD,0BAAkB;EAAlB,kBAAkB;EAClB,eAAe;EACf,oBAAoB,EAAA;EAPtB;IAUI,uCAA4D,EAAA;;AAIhE;EACE,aAAa;EACb,mBAAmB;EACnB,8DAA4G;EAC5G,oCAA8D;EAC9D,4CAAmE;EACnE,4BAA4B;EAC5B,uFAAkJ;E3ChChJ,4F2CiCkJ;E3ChClJ,6F2CgCkJ,EAAA;E5C3DlJ;IAgCE,oD4C8B4F,EAAA;E5CtD9F;IA+BI,mDAxBE,EAAA;EAfN;IAgCE,uC4C+B+E,EAAA;E5CvDjF;IA+BI,wCAxBE,EAAA;;A4CoDV;EACE,mCAA0D;EAC1D,qBAAqB,EAAA;;AC9DvB;EAEE,wBAAuC;EACvC,wBAAqC;EACrC,yBAAyC;EACzC,0BAAuC;EACvC,mBAAqC;EACrC,kCAA+B;EAC/B,6DAAmD;EACnD,iDAAmD;EACnD,sDAAqD;EACrD,gEAA+C;EAC/C,8FAAiE;EACjE,kCAA2D;EAC3D,kCAA2D;EAC3D,qCAAuD;EACvD,wDAAiE;EACjE,wDAAiE;EACjE,kCAA6D;EAC7D,8BAA+C;EAC/C,uBAA6C;EAC7C,wDAAiE;EACjE,wDAAiE;EAGjE,eAAe;EACf,MAAM;EAEN,gCAAoD;EACpD,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAGhB,UAAU,EAAA;E7C3CR;IAgCE,O6CEsB,EAAA;E7C1BxB;IA+BI,QAxBE,EAAA;;A6CmCV;EACE,kBAAkB;EAClB,WAAW;EACX,+BAAmD;EAEnD,oBAAoB,EAAA;EAGpB;I5B5CI,mClBmlDoD;I8CriDtD,8B9CmiDmD,EAAA;IkB7kDjD;M4BwCJ;Q5BvCM,gBAAgB,EAAA,E4B0CrB;EACD;IACE,e9CiiDoC,EAAA;E8C7hDtC;IACE,sB9C8hD2C,EAAA;;A8C1hD/C;EACE,gDAAoE,EAAA;EADtE;IAII,gBAAgB;IAChB,gBAAgB,EAAA;EALpB;IASI,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,mBAAmB;EACnB,oDAAwE,EAAA;;AAI1E;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EAEX,6BAAgD;EAChD,oBAAoB;EACpB,qCAAqD;EACrD,4BAA4B;EAC5B,yEAA6H;E5CrF3H,6C4CsF8E;EAGhF,UAAU,EAAA;;AAIZ;EAEE,2BAA6C;EAC7C,0BAAqC;EACrC,2BAA+C;EClH/C,eAAe;EACf,MAAM;EACN,OAAO;EACP,mCDkH2E;ECjH3E,YAAY;EACZ,aAAa;EACb,wCD+GsH,EAAA;EC5GtH;IAAS,UAAU,EAAA;EACnB;IAAS,oCD2GkK,EAAA;;AAK7K;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAoE;EACpE,8FAAgK;E5CtG9J,4D4CuG8F;E5CtG9F,6D4CsG8F,EAAA;EAPlG;IAUI,kGAA8J,EAAA;I7CpI9J;MA+DE,sJ6CsE4Q,EAAA;I7C7H9Q;MA2DI,sJ6CkEof,EAAA;;AAK5f;EACE,gBAAgB;EAChB,+CAA8E,EAAA;;AAKhF;EACE,kBAAkB;EAGlB,cAAc;EACd,iCAAsD,EAAA;;AAIxD;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,0EAAuH;EACvH,4CAAmE;EACnE,2FAA6J;E5C1H3J,gE4C2HiG;E5C1HjG,+D4C0HiG,EAAA;EATrG;IAeI,8CAAsE,EAAA;;ApC5GtE;EoCtDJ;IAyKI,2BAAuC;IACvC,0DAA+C,EAAA;EA/HnD;IAoII,iCAAoD;IACpD,kBAAkB;IAClB,iBAAiB,EAAA;EAGnB;IACE,wBAAqC,EAAA,EACtC;;ApChIC;EoCoIF;;IAEE,wBAAqC,EAAA,EACtC;;ApCvIC;EoC2IF;IACE,yBAAqC,EAAA,EACtC;;AASC;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,SAAS,EAAA;EAJX;IAOI,YAAY;IACZ,SAAS;I5C1Mb,gB4C2M4B,EAAA;EAT5B;;I5ClMA,gB4CgN4B,EAAA;EAd5B;IAkBI,gBAAgB,EAAA;;ApC3JpB;EoCyIA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M5C1Mb,gB4C2M4B,EAAA;IAT5B;;M5ClMA,gB4CgN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;ApC5JH;EoCyIA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M5C1Mb,gB4C2M4B,EAAA;IAT5B;;M5ClMA,gB4CgN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;ApC5JH;EoCyIA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M5C1Mb,gB4C2M4B,EAAA;IAT5B;;M5ClMA,gB4CgN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;ApC5JH;EoCyIA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M5C1Mb,gB4C2M4B,EAAA;IAT5B;;M5ClMA,gB4CgN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;ApC5JH;EoCyIA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M5C1Mb,gB4C2M4B,EAAA;IAT5B;;M5ClMA,gB4CgN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;AEvOP;EAEE,0BAA2C;EAC3C,8BAAiD;EACjD,+BAAiD;EACjD,gCAAiD;EACjD,sBAA2C;ElDwRvC,iCAnE+B;EkDnNnC,uCAAyC;EACzC,2CAAmC;EACnC,qDAAyD;EACzD,0BAA6C;EAC7C,iCAAqD;EACrD,kCAAuD;EAGvD,kCAAwD;EACxD,cAAc;EACd,iCAAuD;EClBvD,2DjDipB6E;EiDjpB7E,uCjDipB6E;EiD/oB7E,kBAAkB;EAClB,gBjD0pB+B;EiDzpB/B,gBjDiqB+B;EiDhqB/B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EnDgRZ,uCAnE+B;EkDlMnC,qBAAqB;EACrB,UAAU,EAAA;EA1BZ;IA4BW,mCAA0D,EAAA;EA5BrE;IA+BI,cAAc;IACd,qCAAgE;IAChE,uCAAmE,EAAA;IAjCvE;MAoCM,kBAAkB;MAClB,WAAW;MACX,yBAAyB;MACzB,mBAAmB,EAAA;;AAKzB;EACE,kDAA8E,EAAA;EADhF;IAII,SAAS;IACT,yFAAgJ;IAChJ,uCAAyD,EAAA;;AAI7D,qBAAA;AACA;EACE,gDAA4E;EAC5E,sCAAkE;EAClE,sCAAiE,EAAA;EAHnE;IAMI,WAAW;IACX,mIAAqN;IACrN,yCAA2D,EAAA;;AAI/D,mBAAA;AAEA;EACE,+CAA2E,EAAA;EAD7E;IAII,YAAY;IACZ,yFAAgJ;IAChJ,0CAA4D,EAAA;;AAIhE,qBAAA;AACA;EACE,iDAA6E;EAC7E,sCAAkE;EAClE,sCAAiE,EAAA;EAHnE;IAMI,UAAU;IACV,mIAAqN;IACrN,wCAA0D,EAAA;;AAI9D,mBAAA;AAkBA;EACE,uCAAgE;EAChE,kEAAoH;EACpH,+BAAoD;EACpD,kBAAkB;EAClB,uCAAyD;E9CjGvD,+C8CkGkF,EAAA;;AErHtF;EAEE,0BAA2C;EAC3C,8BAAiD;EpD4R7C,iCAnE+B;EoDvNnC,oCAAmC;EACnC,mDAAuD;EACvD,+DAAuD;EACvD,wDAAyD;EACzD,8FAAqE;EACrE,4DAAmD;EACnD,oCAA+D;EAC/D,sCAA+D;EpDmR3D,oCAnE+B;EoD9MnC,mCAAuD;EACvD,gDAAiD;EACjD,kCAA2D;EAC3D,kCAA2D;EAC3D,+CAAmD;EACnD,+BAAqD;EACrD,kCAAuD;EACvD,2DAAuD;EAGvD,kCAAwD;EACxD,cAAc;EACd,uCAAgE;EDzBhE,2DjDipB6E;EiDjpB7E,uCjDipB6E;EiD/oB7E,kBAAkB;EAClB,gBjD0pB+B;EiDzpB/B,gBjDiqB+B;EiDhqB/B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EnDgRZ,uCAnE+B;EoD5LnC,qBAAqB;EACrB,uCAAyD;EACzD,4BAA4B;EAC5B,6EAAqI;EhDhBnI,+CgDiBkF,EAAA;EApCtF;IAwCI,cAAc;IACd,qCAAgE;IAChE,uCAAmE,EAAA;IA1CvE;MA8CM,kBAAkB;MAClB,cAAc;MACd,WAAW;MACX,yBAAyB;MACzB,mBAAmB;MACnB,eAAe,EAAA;;AAKrB;EAEI,sFAA8I,EAAA;EAFlJ;IAMM,yFAAgJ,EAAA;EANtJ;IAUM,SAAS;IACT,iDAA6E,EAAA;EAXnF;IAeM,uCAAmE;IACnE,uCAAyD,EAAA;;AAK/D,qBAAA;AACA;EAEI,oFAA4I;EAC5I,sCAAkE;EAClE,sCAAiE,EAAA;EAJrE;IAQM,mIAAqN,EAAA;EAR3N;IAYM,OAAO;IACP,mDAA+E,EAAA;EAbrF;IAiBM,qCAAiE;IACjE,yCAA2D,EAAA;;AAKjE,mBAAA;AAEA;EAEI,mFAA2I,EAAA;EAF/I;IAMM,yFAAgJ,EAAA;EANtJ;IAUM,MAAM;IACN,oDAAgF,EAAA;EAXtF;IAeM,oCAAgE;IAChE,0CAA4D,EAAA;;AAhBlE;EAsBI,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,cAAc;EACd,qCAAgE;EAChE,uDAAkF;EAClF,WAAW;EACX,iFAAsI,EAAA;;AAI1I,qBAAA;AACA;EAEI,qFAA6I;EAC7I,sCAAkE;EAClE,sCAAiE,EAAA;EAJrE;IAQM,mIAAqN,EAAA;EAR3N;IAYM,QAAQ;IACR,kDAA8E,EAAA;EAbpF;IAiBM,sCAAkE;IAClE,wCAA0D,EAAA;;AAKhE,mBAAA;AAkBA;EACE,gFAAgJ;EAChJ,gBAAgB;EpD2GZ,8CAnE+B;EoDtCnC,sCAAkE;EAClE,8CAAuE;EACvE,oFAA4I;EhD5J1I,8DgD6JkG;EhD5JlG,+DgD4JkG,EAAA;EAPtG;IAUI,aAAa,EAAA;;AAIjB;EACE,4EAAwI;EACxI,oCAA8D,EAAA;;ACrLhE;EACE,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB,EAAA;ECtBhB;IACE,cAAc;IACd,WAAW;IACX,WAAW,EAAA;;ADuBf;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,mCAA2B;UAA3B,2BAA2B;EjClBvB,sClB+0DkF,EAAA;EkB30DlF;IiCQN;MjCPQ,gBAAgB,EAAA,EiCevB;;AAED;;;EAGE,cAAc,EAAA;;AAGhB;;EAEE,2BAA2B,EAAA;;AAG7B;;EAEE,4BAA4B,EAAA;;AAQ9B;EAEI,UAAU;EACV,4BAA4B;EAC5B,eAAe,EAAA;;AAJnB;;;EAUI,UAAU;EACV,UAAU,EAAA;;AAXd;;EAgBI,UAAU;EACV,UAAU;EjC5DR,2BlB80DkC,EAAA;EkB10DlC;IiCuCN;;MjCtCQ,gBAAgB,EAAA,EiCyDrB;;AAQH;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EAEV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UnDsuDsC;EmDruDtC,UAAU;EACV,gCAA+F;EAA/F,mEAA+F;EAC/F,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,YnDiuDqC;EkBvzDjC,8BlByzDgD,EAAA;EkBrzDhD;IiCkEN;;MjCjEQ,gBAAgB,EAAA,EiC4FvB;EA3BD;;;IAsBI,gCAA+F;IAA/F,mEAA+F;IAC/F,qBAAqB;IACrB,UAAU;IACV,YnDytDmC,EAAA;;AmDttDvC;EACE,OAAO,EAAA;;AAGT;EACE,QAAQ,EAAA;;AAKV;;EAEE,qBAAqB;EACrB,WnD0tDuC;EmDztDvC,YnDytDuC;EmDxtDvC,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B,EAAA;;AAG5B;;;;;;;GxDq9KG;AwD78KH;EACE,0DhDRgF,EAAA;;AgDUlF;EACE,0DhDXgF,EAAA;;AgDmBlF;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,UAAU;EAEV,iBnDkqDsC;EmDjqDtC,mBAAmB;EACnB,gBnDgqDsC;EmD/pDtC,gBAAgB,EAAA;EAblB;IAgBI,uBAAuB;IACvB,cAAc;IACd,WnD+pDqC;ImD9pDrC,WnD+pDoC;ImD9pDpC,UAAU;IACV,iBnD+pDoC;ImD9pDpC,gBnD8pDoC;ImD7pDpC,mBAAmB;IACnB,eAAe;IACf,sBAA4H;IAA5H,+DAA4H;IAC5H,4BAA4B;IAC5B,SAAS;IAET,kCAAiE;IACjE,qCAAoE;IACpE,YnDspDmC;IkB/zDjC,6BlBk0D+C,EAAA;IkB9zD/C;MiCsIN;QjCrIQ,gBAAgB,EAAA,EiCsKrB;EAjCH;IAoCI,UnDmpDkC,EAAA;;AmD1oDtC;EACE,kBAAkB;EAClB,UAA4C;EAC5C,enD6oD0C;EmD5oD1C,SAA2C;EAC3C,oBnD0oD0C;EmDzoD1C,uBnDyoD0C;EmDxoD1C,gCAA+F;EAA/F,mEAA+F;EAC/F,kBAAkB,EAAA;;AAKpB;EACE,2CAAuE;EACvE,oDAA2D,EAAA;EAF7D;;IAKI,gCnD4oDyD,EAAA;EmDjpD7D;IASI,yBnD1Me,EAAA;EmDiMnB;IAaI,6BhDdiC,EAAA;;AkD/MrC;;EAEE,qBAAqB;EACrB,+BAAoD;EACpD,iCAAuD;EACvD,iDAA+E;EAE/E,kBAAkB;EAClB,+FAA4J,EAAA;;AAI9J;EACE;IAAK,0CAA+C,EAAA,EAAA;;AAItD;EAEE,yBAAyC;EACzC,0BAA2C;EAC3C,sCAA2D;EAC3D,kCAAuD;EACvD,oCAA6D;EAC7D,4CAA2D;EAG3D,0DAAsF;EACtF,+BAA+B,EAAA;;AAGjC;EAEE,yBAAyC;EACzC,0BAA2C;EAC3C,iCAAuD,EAAA;;AASzD;EACE;IACE,mBAAmB,EAAA;EAErB;IACE,UAAU;IACV,eAAe,EAAA,EAAA;;AAKnB;EAEE,yBAAyC;EACzC,0BAA2C;EAC3C,sCAA2D;EAC3D,oCAA6D;EAC7D,0CAA2D;EAG3D,8BAA8B;EAC9B,UAAU,EAAA;;AAGZ;EACE,yBAAyC;EACzC,0BAA2C,EAAA;;AAI3C;EACE;;IAEE,mCAA6D,EAAA,EAC9D;;AChFL;EAEE,4BAA+C;EAC/C,4BAA6C;EAC7C,4BAA+C;EAC/C,+BAAqD;EACrD,+BAAqD;EACrD,4CAA6C;EAC7C,sCAAuC;EACvC,qDAA2D;EAC3D,iEAA2D;EAC3D,oEAAuD;EACvD,sDAAuD;EACvD,sCAAqE,EAAA;;A5C6DnE;E4C5CF;IAEI,eAAe;IACf,SAAS;IACT,oCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,iCAAwD;IACxD,kBAAkB;IAClB,yCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IpC5BV,2CoC8B+E,EAAA,EAqElF;EpC/FG;IoCYJ;MpCXM,gBAAgB,EAAA,EoC8FrB;;A5CvCC;I4C5CF;MAiBM,MAAM;MAEN,iCAAwD,EAAA;MrDjD5D;QAgCE,OqDgB4B,EAAA;MrDxC9B;QA+BI,QAxBE,EAAA;MAfN;QAgCE,uFqDkBwK,EAAA;MrD1C1K;QA+BI,sFAxBE,EAAA;MAfN;QA+DE,4BqDZ4D,EAAA;MrD3C9D;QA2DI,2BqDhB4E,EAAA;IArBlF;MAyBM,MAAM;MAEN,iCAAwD;MAExD,2BAA2B,EAAA;MrD3D/B;QAgCE,QqDwB6B,EAAA;MrDhD/B;QA+BI,OAxBE,EAAA;MAfN;QAgCE,sFqD0BuK,EAAA;MrDlDzK;QA+BI,uFAxBE,EAAA;IqDeR;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,mCAA2D;MAC3D,gBAAgB;MAChB,wFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,mCAA2D;MAC3D,gBAAgB;MAChB,qFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,0BAA0B,EAAA;IArDhC;MA2DM,mBAAmB,EAAA,EACpB;;A5C7BH;E4C/BF;IAiEM,4BAA+C;IAC/C,+BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A5CpCL;E4C5CF;IAEI,eAAe;IACf,SAAS;IACT,oCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,iCAAwD;IACxD,kBAAkB;IAClB,yCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IpC5BV,2CoC8B+E,EAAA,EAqElF;EpC/FG;IoCYJ;MpCXM,gBAAgB,EAAA,EoC8FrB;;A5CvCC;I4C5CF;MAiBM,MAAM;MAEN,iCAAwD,EAAA;MrDjD5D;QAgCE,OqDgB4B,EAAA;MrDxC9B;QA+BI,QAxBE,EAAA;MAfN;QAgCE,uFqDkBwK,EAAA;MrD1C1K;QA+BI,sFAxBE,EAAA;MAfN;QA+DE,4BqDZ4D,EAAA;MrD3C9D;QA2DI,2BqDhB4E,EAAA;IArBlF;MAyBM,MAAM;MAEN,iCAAwD;MAExD,2BAA2B,EAAA;MrD3D/B;QAgCE,QqDwB6B,EAAA;MrDhD/B;QA+BI,OAxBE,EAAA;MAfN;QAgCE,sFqD0BuK,EAAA;MrDlDzK;QA+BI,uFAxBE,EAAA;IqDeR;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,mCAA2D;MAC3D,gBAAgB;MAChB,wFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,mCAA2D;MAC3D,gBAAgB;MAChB,qFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,0BAA0B,EAAA;IArDhC;MA2DM,mBAAmB,EAAA,EACpB;;A5C7BH;E4C/BF;IAiEM,4BAA+C;IAC/C,+BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A5CpCL;E4C5CF;IAEI,eAAe;IACf,SAAS;IACT,oCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,iCAAwD;IACxD,kBAAkB;IAClB,yCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IpC5BV,2CoC8B+E,EAAA,EAqElF;EpC/FG;IoCYJ;MpCXM,gBAAgB,EAAA,EoC8FrB;;A5CvCC;I4C5CF;MAiBM,MAAM;MAEN,iCAAwD,EAAA;MrDjD5D;QAgCE,OqDgB4B,EAAA;MrDxC9B;QA+BI,QAxBE,EAAA;MAfN;QAgCE,uFqDkBwK,EAAA;MrD1C1K;QA+BI,sFAxBE,EAAA;MAfN;QA+DE,4BqDZ4D,EAAA;MrD3C9D;QA2DI,2BqDhB4E,EAAA;IArBlF;MAyBM,MAAM;MAEN,iCAAwD;MAExD,2BAA2B,EAAA;MrD3D/B;QAgCE,QqDwB6B,EAAA;MrDhD/B;QA+BI,OAxBE,EAAA;MAfN;QAgCE,sFqD0BuK,EAAA;MrDlDzK;QA+BI,uFAxBE,EAAA;IqDeR;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,mCAA2D;MAC3D,gBAAgB;MAChB,wFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,mCAA2D;MAC3D,gBAAgB;MAChB,qFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,0BAA0B,EAAA;IArDhC;MA2DM,mBAAmB,EAAA,EACpB;;A5C7BH;E4C/BF;IAiEM,4BAA+C;IAC/C,+BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A5CpCL;E4C5CF;IAEI,eAAe;IACf,SAAS;IACT,oCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,iCAAwD;IACxD,kBAAkB;IAClB,yCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IpC5BV,2CoC8B+E,EAAA,EAqElF;EpC/FG;IoCYJ;MpCXM,gBAAgB,EAAA,EoC8FrB;;A5CvCC;I4C5CF;MAiBM,MAAM;MAEN,iCAAwD,EAAA;MrDjD5D;QAgCE,OqDgB4B,EAAA;MrDxC9B;QA+BI,QAxBE,EAAA;MAfN;QAgCE,uFqDkBwK,EAAA;MrD1C1K;QA+BI,sFAxBE,EAAA;MAfN;QA+DE,4BqDZ4D,EAAA;MrD3C9D;QA2DI,2BqDhB4E,EAAA;IArBlF;MAyBM,MAAM;MAEN,iCAAwD;MAExD,2BAA2B,EAAA;MrD3D/B;QAgCE,QqDwB6B,EAAA;MrDhD/B;QA+BI,OAxBE,EAAA;MAfN;QAgCE,sFqD0BuK,EAAA;MrDlDzK;QA+BI,uFAxBE,EAAA;IqDeR;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,mCAA2D;MAC3D,gBAAgB;MAChB,wFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,mCAA2D;MAC3D,gBAAgB;MAChB,qFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,0BAA0B,EAAA;IArDhC;MA2DM,mBAAmB,EAAA,EACpB;;A5C7BH;E4C/BF;IAiEM,4BAA+C;IAC/C,+BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A5CpCL;E4C5CF;IAEI,eAAe;IACf,SAAS;IACT,oCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,iCAAwD;IACxD,kBAAkB;IAClB,yCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IpC5BV,2CoC8B+E,EAAA,EAqElF;EpC/FG;IoCYJ;MpCXM,gBAAgB,EAAA,EoC8FrB;;A5CvCC;I4C5CF;MAiBM,MAAM;MAEN,iCAAwD,EAAA;MrDjD5D;QAgCE,OqDgB4B,EAAA;MrDxC9B;QA+BI,QAxBE,EAAA;MAfN;QAgCE,uFqDkBwK,EAAA;MrD1C1K;QA+BI,sFAxBE,EAAA;MAfN;QA+DE,4BqDZ4D,EAAA;MrD3C9D;QA2DI,2BqDhB4E,EAAA;IArBlF;MAyBM,MAAM;MAEN,iCAAwD;MAExD,2BAA2B,EAAA;MrD3D/B;QAgCE,QqDwB6B,EAAA;MrDhD/B;QA+BI,OAxBE,EAAA;MAfN;QAgCE,sFqD0BuK,EAAA;MrDlDzK;QA+BI,uFAxBE,EAAA;IqDeR;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,mCAA2D;MAC3D,gBAAgB;MAChB,wFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,mCAA2D;MAC3D,gBAAgB;MAChB,qFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,0BAA0B,EAAA;IArDhC;MA2DM,mBAAmB,EAAA,EACpB;;A5C7BH;E4C/BF;IAiEM,4BAA+C;IAC/C,+BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;AAhFP;EAEI,eAAe;EACf,SAAS;EACT,oCAA4D;EAC5D,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,iCAAwD;EACxD,kBAAkB;EAClB,yCAA6D;EAC7D,4BAA4B;EAC5B,UAAU;EpC5BV,2CoC8B+E,EAAA;EpC1B/E;IoCYJ;MpCXM,gBAAgB,EAAA,EoC8FrB;EAnFD;IAiBM,MAAM;IAEN,iCAAwD,EAAA;IrDjD5D;MAgCE,OqDgB4B,EAAA;IrDxC9B;MA+BI,QAxBE,EAAA;IAfN;MAgCE,uFqDkBwK,EAAA;IrD1C1K;MA+BI,sFAxBE,EAAA;IAfN;MA+DE,4BqDZ4D,EAAA;IrD3C9D;MA2DI,2BqDhB4E,EAAA;EArBlF;IAyBM,MAAM;IAEN,iCAAwD;IAExD,2BAA2B,EAAA;IrD3D/B;MAgCE,QqDwB6B,EAAA;IrDhD/B;MA+BI,OAxBE,EAAA;IAfN;MAgCE,sFqD0BuK,EAAA;IrDlDzK;MA+BI,uFAxBE,EAAA;EqDeR;IAiCM,MAAM;IACN,QAAQ;IACR,OAAO;IACP,mCAA2D;IAC3D,gBAAgB;IAChB,wFAAoJ;IACpJ,4BAA4B,EAAA;EAvClC;IA2CM,QAAQ;IACR,OAAO;IACP,mCAA2D;IAC3D,gBAAgB;IAChB,qFAAiJ;IACjJ,2BAA2B,EAAA;EAhDjC;IAqDM,0BAA0B,EAAA;EArDhC;IA2DM,mBAAmB,EAAA;;AA2B3B;EPpHE,eAAe;EACf,MAAM;EACN,OAAO;EACP,a/CgtCsC;E+C/sCtC,YAAY;EACZ,aAAa;EACb,yBO+G2I;EP/G3I,2DO+G2I,EAAA;EP5G3I;IAAS,UAAU,EAAA;EACnB;IAAS,Y/CokD2B,EAAA;;AsDt9CtC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sEAA4H,EAAA;EAJ9H;IAOI,4FAAkJ;IAClJ,sDAAiF;IAEjF,yDAAoF,EAAA;IrDlIpF;MAgCE,wDqDiGoG,EAAA;IrDzHtG;MA+BI,uDAxBE,EAAA;;AqDuHV;EACE,gBAAgB;EAChB,mDAAsF,EAAA;;AAGxF;EACE,YAAY;EACZ,sEAA4H;EAC5H,gBAAgB,EAAA;;AChJlB;EACE,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,YvDi5CoC,EAAA;EuDv5CtC;IASI,qBAAqB;IACrB,WAAW,EAAA;;AAKf;EACE,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB,EAAA;;AAGlB;EACE,iBAAiB,EAAA;;AAInB;EAEI,mDAAmD,EAAA;;AAIvD;EACE;IACE,YvDo3CkC,EAAA,EAAA;;AuDh3CtC;EACE,6FAA8G;UAA9G,qFAA8G;EAC9G,4BAAoB;UAApB,oBAAoB;EACpB,8CAA8C,EAAA;;AAGhD;EACE;IACE,+BAAuB;YAAvB,uBAAuB,EAAA,EAAA;;AChD3B;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EtDcpB,mBsDbyB;EtCUvB,wBlBmmDyB;EyDlnD7B,WzDymDkB;EyDxmDlB,YzDwmDkB;EyDvmDlB,iBAAsB,EAAA;EvCiBlB;IsCpBN;MtCqBQ,gBAAgB,EAAA,EsCZvB;ECJC;IACE,iB3DqFqD;I2DpFrD,kB3DoFqD,EAAA;;A0DhFzD;EACE,WAAW;EACX,YAAY;EtDMV,mBsDLyB,EAAA;;AAG7B;EACE,kBAAkB;EAElB,SAAS;EACT,cAAc;EACd,sBxDdc;EEWZ,mBsDIyB,EAAA;EvDrBzB;IAgCE,QuDfuB,EAAA;EvDTzB;IA+BI,OAxBE,EAAA;;AuDUR;EC1BA,azD4mDU;EyD3mDV,czD2mDU;EyD1mDV,iBAAsB,EAAA;EAEtB;IACE,a3DqFqD;I2DpFrD,c3DoFqD,EAAA;;A0DhEvD;EC1BA,azD6mDU;EyD5mDV,czD4mDU;EyD3mDV,eAAsB,EAAA;EAEtB;IACE,iB3DqFqD;I2DpFrD,kB3DoFqD,EAAA;;A0DhEvD;EC1BA,WzD8mDQ;EyD7mDR,YzD6mDQ;EyD5mDR,iBAAsB,EAAA;EAEtB;IACE,a3DqFqD;I2DpFrD,c3DoFqD,EAAA;;A0DhEvD;EC1BA,WzD+mDQ;EyD9mDR,YzD8mDQ;EyD7mDR,iBAAsB,EAAA;EAEtB;IACE,iB3DqFqD;I2DpFrD,kB3DoFqD,EAAA;;A0D3DzD;EACE,aAAa,EAAA;EvD/BX;IAgCE,qBuDEoD,EAAA;EvD1BtD;IA+BI,oBAxBE,EAAA;EAfN;IAgCE,euDKkC,EAAA;EvD7BpC;IA+BI,cAxBE,EAAA;EAfN;IAgCE,qBuDW+C,EAAA;EvDnCjD;IA+BI,oBAxBE,EAAA;EAfN;IAgCE,mBuDW+C,EAAA;EvDnCjD;IA+BI,kBAxBE,EAAA;EAfN;IAgCE,qBuDW+C,EAAA;EvDnCjD;IA+BI,oBAxBE,EAAA;EAfN;IAgCE,qBuDW+C,EAAA;EvDnCjD;IA+BI,oBAxBE,EAAA;;AyDjBV;EAEE,6BAAiD;EACjD,6BAAiD;EACjD,yBAA+C;EAC/C,4BAA+C;EAC/C,mDAAuD;EACvD,mDAAuD;EACvD,gEAAiE;EACjE,qDAAyD;EAGzD,kEAAoH;EACpH,+DAA+G;EAC/G,6EAAqI;ExDKnI,+CwDFkF,EAAA;EzDflF;IAgCE,uDyDnBuG,EAAA;EzDLzG;IA+BI,yDE+EmI,EAAA;EFtHvI;IAgCE,uDyDlBuG,EAAA;EzDNzG;IA+BI,yDE+EmI,EAAA;;AuDjGzI;EACE,wCAAiE,EAAA;;AADnE;EACE,wCAAiE,EAAA;;AADnE;EACE,wCAAiE,EAAA;;AADnE;EACE,wCAAiE,EAAA;;AADnE;EACE,wCAAiE,EAAA;;AADnE;EACE,qCAAiE,EAAA;;AADnE;EACE,wCAAiE,EAAA;;AADnE;EACE,wCAAiE,EAAA;;ACxBrE;EAEE,6BAAiD;EACjD,4BAA+C;EAC/C,8BAA+C;EAC/C,yCAAuC;EACvC,uCAAiC;EACjC,kDAAqD;EACrD,iFAAyC;EAGzC,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAiE;EACjE,gEAAgH;EAChH,8BAAkD;EAClD,gCAAiD;EACjD,oCAAyD,EAAA;;AAG3D;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,OAAO;EACP,a3DwrCsC,EAAA;;A2DrrCxC;EACE,wBAAgB;EAAhB,gBAAgB;EAChB,SAAS;EACT,a3DkrCsC,EAAA;;A4DntCxC;EAEE,6BAAiD;EACjD,8BAA+C;EAC/C,8BAA+C;EAC/C,mCAAiC;EACjC,6DAAuC;EACvC,kDAAqD;EACrD,iFAAyC;EACzC,kEAAmD;EACnD,qEAAyD;EACzD,iEAAqD;EACrD,uCAA2D;EAC3D,iCAAmD;EACnD,uCAA+D;EAC/D,uCAA+D;EAC/D,uCAA+D;EAC/D,oCAAiD;EACjD,qEAAuD;EACvD,4DAAuE;EACvE,wEAAmE;EACnE,sEAA2D;EAC3D,4EAAuE;EACvE,uCAAiE;EACjE,uCAAiE;EACjE,0DAAqE;EACrE,iGAAyD;EACzD,gCAAuD;EAGvD,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAiE;EACjE,gEAAgH;EAChH,gCAAiD;EACjD,uCAA4D,EAAA;EAtC9D;;;IA4CI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B,EAAA;EA/ClC;;;;;;;IA+DI,kFAAmI,EAAA;EA/DvI;;;;;;;IAoEI,qFAAyI,EAAA;EApE7I;IAwEI,wBAAgB;IAAhB,gBAAgB;IAChB,MAAM;IACN,a5DyoCoC,EAAA;;A4DroCxC;EACE,0DAAkF;EAClF,SAAS;EACT,0EAA0H;EAC1H,4CAAyE,EAAA;;AAO3E;EACE,8CAA4E;EAC5E,iDAA+E;E9DoM3E,kBAnE+B;E8D9HnC,oCAA8D;EAC9D,qBAAwD;EACxD,mBAAmB,EAAA;E3D9FjB;IAgCE,kBDgtD8B,EAAA;ECxuDhC;IA+BI,iBAxBE,EAAA;E2DwEV;IAWI,0CAA0E,EAAA;;AAS9E;EACE,aAAa;EACb,mBAAmB;EAEnB,gBAAgB;EAChB,gBAAgB,EAAA;E3DhHd;IAgCE,e2D8E8B,EAAA;E3DtGhC;IA+BI,gBAxBE,EAAA;E2D4FV;IAQI,kFAAoJ;IACpJ,8BAAkD,EAAA;IATtD;MAaM,oCAA8D,EAAA;IAbpE;MAiBM,uCAAoE,EAAA;EAjB1E;;IAuBI,qCAAgE,EAAA;EAvBpE;IA2BI,kBAAkB,EAAA;;AAStB;EACE,iDAAkF;EAClF,oDAAqF;EACrF,8BAAkD,EAAA;EAHpD;IAMI,qCAAgE,EAAA;IANpE;MAUM,qCAAgE,EAAA;;AAKtE;EACE,gFAAgJ;E9D8H5I,kBAnE+B;E8DzDnC,sCAAkE;EAClE,8CAAuE;EACvE,SAAS;E1DlJP,sD0DmJgG,EAAA;EANpG;IASI,4CAA8E;IAC9E,qBAAqB,EAAA;EAVzB;IAcI,UAAU,EAAA;EAdd;IAmBI,eAAe,EAAA;;AAInB;EACE,cAAc;EACd,iBAAwC;EACxC,mDAAiF;EACjF,4BAA4B;EAC5B,kCAAkC;EAClC,0BAA0B,EAAA;EAN5B;IASI,yDAA6F,EAAA;;AChMjG;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB,EAAA;EALpB;ICEE,W9D4wBoB;I8D3wBpB,Y9D2wBoB;I8D1wBpB,e9D0wBoB,EAAA;I6D9wBtB;MCEE,W9DgxBmC;M8D/wBnC,Y9D+wBmC;M8D9wBnC,e9D8wBmC,EAAA;I6DlxBrC;MCEE,a9D+wBqC;M8D9wBrC,c9D8wBqC;M8D7wBrC,iB9D6wBqC,EAAA;I6DjxBvC;MCEE,c9D8wBsC;M8D7wBtC,e9D6wBsC;M8D5wBtC,kB9D4wBsC,EAAA;I6DhxBxC;MCEE,e9D6wBsC;M8D5wBtC,gB9D4wBsC;M8D3wBtC,mB9D2wBsC,EAAA;I6D/wBxC;MCEE,WDyB6C;MCxB7C,YDwB6C;MCvB7C,eDuB6C,EAAA;IA3B/C;MCEE,WDyB6C;MCxB7C,YDwB6C;MCvB7C,eDuB6C,EAAA;IA3B/C;MCEE,WDyB6C;MCxB7C,YDwB6C;MCvB7C,eDuB6C,EAAA;IA3B/C;MCEE,WDyB6C;MCxB7C,YDwB6C;MCvB7C,eDuB6C,EAAA;IA3B/C;MCEE,WDyB6C;MCxB7C,YDwB6C;MCvB7C,eDuB6C,EAAA;IA3B/C;MCEE,WDyB6C;MCxB7C,YDwB6C;MCvB7C,eDuB6C,EAAA;IA3B/C;MCEE,WDyB6C;MCxB7C,YDwB6C;MCvB7C,eDuB6C,EAAA;;AE3B/C;EAEE,0BAAyC;EACzC,yBAAmC;EACnC,0BAAiD;EACjD,0BAAiD;EACjD,8CAAyC;EACzC,6BAAuD;EACvD,uCAAuD;EACvD,oDAAqD;EACrD,gCAAuD;EACvD,2CAA+C;EAC/C,iCAAyD;EACzD,4CAAiD;EACjD,oCAA+D;EAC/D,uCAA+D;EAC/D,4CAAiD;EACjD,iCAAyD;EACzD,oCAA+D;EAC/D,uCAA+D;EAC/D,6CAAmD;EACnD,kCAA2D;EAC3D,yEAAiE;EACjE,2CAA6E;EAC7E,4CAA+E;EAC/E,kDAA+D;EAC/D,+EAA6E;EAE7E,gCAAuD;EAEvD,uCAAqE;EACrE,0CAAqE;EACrE,wCAAuE;EACvE,uDAA6D;EAC7D,sCAAmE;EACnE,2CAAmE;EACnE,sDAA2D;EAC3D,sCAAqD;EACrD,gDAAyE;EACzE,+EAA6D;EAC7D,uCAA2E;EAC3E,8DAAyE;EACzE,2DAAmE;EACnE,mEAAmF;EACnF,gEAA6E;EAC7E,oEAAuF;EACvF,6DAAuE;EACvE,0DAAiE;EACjE,kEAAiF;EACjF,kCAA2D;EAC3D,sCAA6D;EAC7D,yCAAmE;EACnE,2DAAqE;EACrE,8CAAuD;EACvD,0CAAiF;EACjF,0CAAiF;EACjF,2EAAqE;EACrE,iFAAiF;EACjF,mEAAqF;EAGrF,kBAAkB;EAClB,aAAa;EAEb,kCAAuD;EACvD,sBAAsB;EAEtB,SAAS;EACT,+BAAoD;EACpD,kEAAoH;EACpH,+BAAoD;EACpD,iCAAmD;EAEnD,gBAAgB;E7CzDZ,yHlBq2D4I,EAAA;ECn3D9I;IAgCE,mF8DsC0J,EAAA;E9D9D5J;IA+BI,kFAxBE,EAAA;EiBGJ;I6CpBN;M7CqBQ,gBAAgB,EAAA,E6CwLvB;E9D3MG;IAgCE,c8D2C+B,EAAA;E9DnEjC;IA+BI,eAxBE,EAAA;E8DjBV;IA+EM,iCAAuD,EAAA;EA/E7D;IAoFI,SAAS,EAAA;I9DlFT;MAgCE,e8DmDgC,EAAA;I9D3ElC;MA+BI,cAxBE,EAAA;I8DjBV;MAuFM,+BAAmD,EAAA;EAvFzD;IA4FI,iC/DzEe,EAAA;E+DnBnB;IAiGM,0BAAyC,EAAA;IrDlC3C;MqD/DJ;QAqGY,iCAAuD,EAAA;MArGnE;QA0GY,+BAAmD,EAAA,EACpD;EA3GX;IAiGM,0BAAyC,EAAA;IrDlC3C;MqD/DJ;QAqGY,iCAAuD,EAAA;MArGnE;QA0GY,+BAAmD,EAAA,EACpD;EA3GX;IAiGM,0BAAyC,EAAA;IrDlC3C;MqD/DJ;QAqGY,iCAAuD,EAAA;MArGnE;QA0GY,+BAAmD,EAAA,EACpD;ErD5CP;IT7DA;MAgCE,gD8DkF0F,EAAA;I9D1G5F;MA+BI,iDAxBE,EAAA;I8DjBV;MAsHU,6BAAuD,EAAA;I9DpH7D;MAgCE,iD8DwF2F,EAAA;I9DhH7F;MA+BI,gDAxBE,EAAA;I8DjBV;MA4HU,2BAAmD,EAAA,EACpD;ErD9DL;IqD/DJ;MAoIM,eAAe;MACf,MAAM;MACN,SAAS;MACT,a/D4kCkC,EAAA;MCjtCpC;QAgCE,O8DwG4B,EAAA;M9DhI9B;QA+BI,QAxBE,EAAA;MAfN;QAgCE,Q8D4G6B,EAAA;M9DpI/B;QA+BI,OAxBE,EAAA,EALL;ESmDD;IqD/DJ;MAqJM,wBAAgB;MAAhB,gBAAgB;MAChB,MAAM;MACN,aAAa,EAAA,EAEhB;EAzJH;IA4JI,eAAe;IACf,MAAM;IACN,SAAS;IACT,a/DojCoC,EAAA;ICjtCpC;MAgCE,O8DgI0B,EAAA;I9DxJ5B;MA+BI,QAxBE,EAAA;I8DjBV;MAoKQ,6BAAuD,EAAA;I9DlK3D;MAgCE,Q8DuI2B,EAAA;I9D/J7B;MA+BI,OAxBE,EAAA;I8DjBV;MA2KQ,2BAAmD,EAAA;ErD/FvD;IqD5EJ;MAkLI,qBAAiC;MACjC,eAAe;MACf,MAAM;MACN,SAAS;MACT,a/D6hCoC,EAAA;MCjtCpC;QAgCE,O8DuJ0B,EAAA;M9D/K5B;QA+BI,QAxBE,EAAA;M8DjBV;QA2LQ,wCAAuD,EAAA;M9DzL3D;QAgCE,gD8D6J0F,EAAA;M9DrL5F;QA+BI,iDAxBE,EAAA;MAfN;QAgCE,Q8DiK2B,EAAA;M9DzL7B;QA+BI,OAxBE,EAAA;M8DjBV;QAqMQ,sCAAmD,EAAA;M9DnMvD;QAgCE,iD8DuK2F,EAAA;M9D/L7F;QA+BI,gDAxBE,EAAA,EALL;;A8DmML;EACE,kBAAkB;EAClB,MAAM;EAEN,+BAAoD;EACpD,wCAAqE;EACrE,+BAAoD;EACpD,uBAAuB;EACvB,SAAS,EAAA;E9DrNP;IAgCE,Q8DgLuB,EAAA;E9DxMzB;IA+BI,OAxBE,EAAA;E8D8LV;IAWI,qBAAqB,EAAA;EAXzB;IAeI,UAAU,EAAA;;AAId;EACE,aAAa;EACb,yCAAqE;EACrE,mBAAmB;EACnB,uBAAuB;EACvB,qCAAgE;EAChE,uCAA+D,EAAA;EANjE;IASI,aAAa,EAAA;;AAIjB;EACE,0CAAuE;EACvE,gFAAgJ;EAChJ,kBAAkB;EAClB,wCAAiE;E7CnO7D,uClB+2D8D,EAAA;EkB32D9D;I6C2NN;M7C1NQ,gBAAgB,EAAA,E6CsOvB;EAZD;IAQI,aAAa;IACb,mBAAmB;IACnB,4CAAyE,EAAA;;AAI7E;EACE,0CAAuE;EACvE,gFAAgJ;EAChJ,wCAAiE;E7ChP7D,uClBu6D8D,EAAA;EkBn6D9D;I6CyON;M7CxOQ,gBAAgB,EAAA,E6C6OvB;;AAED;EACE,aAAa;EACb,2CAAyE;EACzE,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,eAAe;EACf,+CAAyE;EACzE,SAAS,EAAA;ErDhMP;IqDwLJ;MAWI,aAAa,EAAA,EAmChB;EA9CD;IAeI,cAAc;IACd,iDAAwF;IACxF,mDAA2F;IAC3F,WAAW;IACX,sDAAuF;IACvF,4BAA4B;IAC5B,2BAA2B;IAC3B,wEAAgH;I7C1Q9G,2BlB26DmD,EAAA;IkBv6DnD;M6CgPN;Q7C/OQ,gBAAgB,EAAA,E6C0QrB;I9DrRC;M8DmRE,0BAA0B,EAAA;EAzBhC;IA8BI,UAAU,EAAA;EA9Bd;IAkCI,qDAAqF,EAAA;IAlCzF;MAoCM,4DAAmG,EAAA;EAIvG;IACE,2BAA2B,EAAA;IAD7B;MAGI,0BAA0B,EAAA;;AAOhC;EAEE,2BAA6C;EAC7C,0BAAqC;EACrC,2BAA+C,EAAA;ErD9O7C;IqD0OJ;MhBpTE,eAAe;MACf,MAAM;MACN,OAAO;MACP,mCgByT6E;MhBxT7E,YAAY;MACZ,aAAa;MACb,wCgBsTwH,EAAA;MhBnTxH;QAAS,UAAU,EAAA;MACnB;QAAS,oCgBkToK,EAAA,EhBlTtI;;AiBVzC;EACE,kBAAkB;EAClB,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB,EAAA;EATlB;IAYI,sFAA4J;IAC5J,mDAAuF;IACvF,cAAc;IACd,gBAAgB;IAChB,yCAAwE;IACxE,yBAAyB;I9CHvB,sClB03D6D,EAAA;IkBt3D7D;M8ClBN;Q9CmBQ,gBAAgB,EAAA,E8CArB;EAnBH;IAsBI,aAAa;IACb,SAAO;IACP,mBAAmB;IACnB,oFAAwJ;IACxJ,wCAAsE;IACtE,qBAAqB;IACrB,mBAAmB;IACnB,0CAAqE;IACrE,0CAAyE;I9DbzE,wD8DcsG;I9CjBpG,mDlBm4D0E,EAAA;IkB/3D1E;M8ClBN;Q9CmBQ,gBAAgB,EAAA,E8C8DrB;IAjFH;MAmCM,+CAAoF;MACpF,iDAAmF,EAAA;MApCzF;QAuCQ,oDAA8F,EAAA;IAvCtG;MA4CM,iDAAwF;MACxF,oBAAoB;MACpB,mBAAmB;MACnB,uBAAuB,EAAA;MA/C7B;QAkDQ,sDAAkG,EAAA;MAlD1G;QAsDQ,iDAAwF,EAAA;QAtDhG;UAyDU,sDAAkG,EAAA;QAzD5G;UA6DU,8DAAuG,EAAA;IAK7G;MAlEJ;QAoEQ,8CAAkF;QAClF,qBAAqB;QACrB,gDAAiF,EAAA;QAtEzF;UAyEU,mDAA4F,EAAA;QAzEtG;UA6EU,8DAAuG,EAAA,EACxG;EA9ET;IAoFI,2CAAyE;IACzE,0CAAyE;IACzE,gDAAkF;IAClF,6CAAgF;IAChF,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;I9C5EhB,mB8C6EyB,EAAA;I9CzEzB;M8ClBN;Q9CmBQ,gBAAgB,EAAA,E8C6ErB;I/DhGC;MAgCE,6D+D8DkH,EAAA;I/DtFpH;MA+BI,8DAxBE,EAAA;E+DfV;IAmGI,gBAAgB,EAAA;EAnGpB;IAuGI,kBAAkB;I9CzFhB,wClBs5DgE,EAAA;IkBl5DhE;M8ClBN;Q9CmBQ,gBAAgB,EAAA,E8CgHrB;IAnIH;MA2GM,kGAAoL;MACpL,gBAAgB;M9C9FhB,6BlB25DqD,EAAA;MkBv5DrD;Q8ClBN;U9CmBQ,gBAAgB,EAAA,E8C2FnB;IA9GL;MAiHM,aAAa,EAAA;IAjHnB;MAqHM,2CAAuE,EAAA;MArH7E;QAwHQ,qDAAgG,EAAA;MAxHxG;QA4HQ,yBAAyB,EAAA;MA5HjC;QAgIQ,eAAe,EAAA;EAhIvB;IAsII,eAAe,EAAA;IAtInB;MAyIM,cAAc;MACd,cAAY;MACZ,YAAY;MAEZ,WAAW;MACX,wDAA2F;MAC3F,4BAA4B;MAC5B,2BAA2B;M9ClI3B,2BlBi6DmD,EAAA;MC/6DrD;QAgCE,iB+D4GoC,EAAA;M/DpItC;QA+BI,kBAxBE,EAAA;MiBGJ;Q8ClBN;U9CmBQ,gBAAgB,EAAA,E8C+HnB;EAlJL;IAsJI,UAAU;IACV,gBAAgB,EAAA;I/DvJhB;MAgCE,+C+D0HgG,EAAA;I/DlJlG;MA+BI,gDAxBE,EAAA;IAfN;MAgCE,yD+D6H4G,EAAA;I/DrJ9G;MA+BI,0DAxBE,EAAA;E+DfV;;IAqKM,6DAA+F;IAC/F,gEAAkG,EAAA;;AtDzGpG;EuD/DJ;IAEI,ajEitCoC;IiEhtCpC,yCAAqE;IACrE,sCAAkE;IAClE,iDAA+E;IAC/E,iBAAiB,EAAA;IAEjB;MACE,ajE0sCkC;MiEzsClC,sCAAkE,EAAA;IAGpE;MACE,aAAa,EAAA;IAGf;MACE,cAAc,EAAA;IAGhB;;;;;;;;;;;;;;;MAQE,oBAAoB;MACpB,UAAU;MACV,SAAS;MACT,kBAAkB;MAClB,UAAU,EAAA;IAGZ;MACE,eAAe;MACf,SAAS,EAAA;MhEpCX;QAgCE,0BgEO+C,EAAA;MhE/BjD;QA4BI,uBgEGiE,EAAA;IAIrE;MACE,uBAAuB,EAAA,EACxB;;AAIL;EAGI,gCAAuD,EAAA;;AAH3D;EAMI,8BAAmD,EAAA;;AAIvD;EACE,eAAe;EACf,ajEopCsC,EAAA;EiEtpCxC;IAKI,gCAAuD,EAAA;EAL3D;IAQI,8BAAmD,EAAA;EhEnEnD;IAgCE,0BgE6C+C,EAAA;EhErEjD;IA4BI,uBgEyCiE,EAAA;EAlBzE;IAuBM,uBAAuB,EAAA;;AhElFzB;EAgCE,uDgE+D0G,EAAA;;AhEvF5G;EA+BI,wDAxBE,EAAA;;AAfN;EAgCE,wDgEkE2G,EAAA;;AhE1F7G;EA+BI,uDAxBE,EAAA;;AS2DN;ET1EA;IAgCE,uDgE+D0G,EAAA;EhEvF5G;IA+BI,wDAxBE,EAAA;EAfN;IAgCE,wDgEkE2G,EAAA;EhE1F7G;IA+BI,uDAxBE,EAAA,EALL;;ASgED;ET1EA;IAgCE,uDgE+D0G,EAAA;EhEvF5G;IA+BI,wDAxBE,EAAA;EAfN;IAgCE,wDgEkE2G,EAAA;EhE1F7G;IA+BI,uDAxBE,EAAA,EALL;;ASgED;ET1EA;IAgCE,uDgE+D0G,EAAA;EhEvF5G;IA+BI,wDAxBE,EAAA;EAfN;IAgCE,wDgEkE2G,EAAA;EhE1F7G;IA+BI,uDAxBE,EAAA,EALL;;ASgED;ET1EA;IAgCE,uDgE+D0G,EAAA;EhEvF5G;IA+BI,wDAxBE,EAAA;EAfN;IAgCE,wDgEkE2G,EAAA;EhE1F7G;IA+BI,uDAxBE,EAAA,EALL;;ASgED;ET1EA;IAgCE,uDgE+D0G,EAAA;EhEvF5G;IA+BI,wDAxBE,EAAA;EAfN;IAgCE,wDgEkE2G,EAAA;EhE1F7G;IA+BI,uDAxBE,EAAA,EALL;;AiEZL;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,gBlEuwDmC;EkEtwDnC,oBlEmcW;EkElcX,gBAAsE;EAAtE,yCAAsE;EACtE,gCAAsM;EAAtM,0IAAsM,EAAA;;AAGxM;EACE,wBAAgB;EAAhB,gBAAgB;EAChB,MAAM;EACN,alEosCsC,EAAA;;AkE7rCxC;EACE,aAAa;EACb,mBAAmB;EAEnB,gBAAgB;EAChB,gBAAgB,EAAA;EjEzBd;IAgCE,eiET8B,EAAA;EjEfhC;IA+BI,gBAxBE,EAAA;EiEKV;IAQI,qBlEqvDiC;IkEpvDjC,oBlEovDiC;IkEnvDjC,8BAA0E;IAA1E,6DAA0E,EAAA;IAV9E;MAcM,6BAA4F;MAA5F,8DAA4F,EAAA;IAdlG;MAkBM,6BAAqG;MAArG,kEAAqG,EAAA;EAlB3G;;IAwBI,6BAA+F;IAA/F,+DAA+F,EAAA;EAxBnG;IA4BI,kBAAkB,EAAA;;AAQtB;EACE,mBlEirCuC;EkEhrCvC,sBlEgrCuC;EkE/qCvC,8BAA0E;EAA1E,6DAA0E,EAAA;EAH5E;IAMI,6BAA+F;IAA/F,+DAA+F,EAAA;IANnG;MAUM,6BAA+F;MAA/F,+DAA+F,EAAA;;AdlEnG;EACE,cAAc;EACd,WAAW;EACX,WAAW,EAAA;;AeHb;EACE,2CAAwE;EACxE,iDAAmJ;EAAnJ,mFAAmJ,EAAA;;AAFrJ;EACE,yBAAwE;EACxE,mDAAmJ;EAAnJ,qFAAmJ,EAAA;;AAFrJ;EACE,yBAAwE;EACxE,iDAAmJ;EAAnJ,mFAAmJ,EAAA;;AAFrJ;EACE,yBAAwE;EACxE,kDAAmJ;EAAnJ,gFAAmJ,EAAA;;AAFrJ;EACE,wCAAwE;EACxE,kDAAmJ;EAAnJ,mFAAmJ,EAAA;;AAFrJ;EACE,yBAAwE;EACxE,iDAAmJ;EAAnJ,kFAAmJ,EAAA;;AAFrJ;EACE,wCAAwE;EACxE,mDAAmJ;EAAnJ,iFAAmJ,EAAA;;AAFrJ;EACE,2CAAwE;EACxE,iDAAmJ;EAAnJ,gFAAmJ,EAAA;;ACFrJ;EACE,sCAA4I;EAA5I,0EAA4I;EAC5I,8DAAgL;UAAhL,sDAAgL;EAAhL,4GAAgL;UAAhL,oGAAgL,EAAA;EAFlL;IAQM,sCAA+H;IAA/H,+DAA+H;IAC/H,8DAAgK;YAAhK,sDAAgK;IAAhK,iGAAgK;YAAhK,yFAAgK,EAAA;;AATtK;EACE,wCAA4I;EAA5I,4EAA4I;EAC5I,gEAAgL;UAAhL,wDAAgL;EAAhL,8GAAgL;UAAhL,sGAAgL,EAAA;EAFlL;IAQM,wCAA+H;IAA/H,iEAA+H;IAC/H,gEAAgK;YAAhK,wDAAgK;IAAhK,mGAAgK;YAAhK,2FAAgK,EAAA;;AATtK;EACE,sCAA4I;EAA5I,0EAA4I;EAC5I,8DAAgL;UAAhL,sDAAgL;EAAhL,4GAAgL;UAAhL,oGAAgL,EAAA;EAFlL;IAQM,uCAA+H;IAA/H,gEAA+H;IAC/H,+DAAgK;YAAhK,uDAAgK;IAAhK,kGAAgK;YAAhK,0FAAgK,EAAA;;AATtK;EACE,uCAA4I;EAA5I,uEAA4I;EAC5I,+DAAgL;UAAhL,uDAAgL;EAAhL,yGAAgL;UAAhL,iGAAgL,EAAA;EAFlL;IAQM,uCAA+H;IAA/H,gEAA+H;IAC/H,+DAAgK;YAAhK,uDAAgK;IAAhK,kGAAgK;YAAhK,0FAAgK,EAAA;;AATtK;EACE,uCAA4I;EAA5I,0EAA4I;EAC5I,+DAAgL;UAAhL,uDAAgL;EAAhL,4GAAgL;UAAhL,oGAAgL,EAAA;EAFlL;IAQM,uCAA+H;IAA/H,gEAA+H;IAC/H,+DAAgK;YAAhK,uDAAgK;IAAhK,kGAAgK;YAAhK,0FAAgK,EAAA;;AATtK;EACE,sCAA4I;EAA5I,yEAA4I;EAC5I,8DAAgL;UAAhL,sDAAgL;EAAhL,2GAAgL;UAAhL,mGAAgL,EAAA;EAFlL;IAQM,wCAA+H;IAA/H,iEAA+H;IAC/H,gEAAgK;YAAhK,wDAAgK;IAAhK,mGAAgK;YAAhK,2FAAgK,EAAA;;AATtK;EACE,wCAA4I;EAA5I,wEAA4I;EAC5I,gEAAgL;UAAhL,wDAAgL;EAAhL,0GAAgL;UAAhL,kGAAgL,EAAA;EAFlL;IAQM,wCAA+H;IAA/H,iEAA+H;IAC/H,gEAAgK;YAAhK,wDAAgK;IAAhK,mGAAgK;YAAhK,2FAAgK,EAAA;;AATtK;EACE,sCAA4I;EAA5I,uEAA4I;EAC5I,8DAAgL;UAAhL,sDAAgL;EAAhL,yGAAgL;UAAhL,iGAAgL,EAAA;EAFlL;IAQM,wCAA+H;IAA/H,iEAA+H;IAC/H,gEAAgK;YAAhK,wDAAgK;IAAhK,mGAAgK;YAAhK,2FAAgK,EAAA;;AAOxK;EACE,mCAA+J;EAA/J,iFAA+J;EAC/J,2DAAmM;UAAnM,mDAAmM;EAAnM,mHAAmM;UAAnM,2GAAmM,EAAA;EAFrM;IAOM,sCAAiK;IAAjK,oFAAiK;IACjK,8DAAqM;YAArM,sDAAqM;IAArM,sHAAqM;YAArM,8GAAqM,EAAA;;AC1B3M;EACE,UAAU;EAEV,iDAAsQ;EAAtQ,uJAAsQ,EAAA;;ACHxQ;EACE,oBAAoB;EACpB,atE8fmC;EsE7fnC,mBAAmB;EACnB,qDAA6H;UAA7H,6CAA6H;EAA7H,4FAA6H;UAA7H,oFAA6H;EAC7H,6BtE4fiC;EsE3fjC,mCAA2B;UAA3B,2BAA2B,EAAA;EAN7B;IASI,cAAc;IACd,UtEwf6B;IsEvf7B,WtEuf6B;IsEtf7B,kBAAkB;IpDIhB,sClBmfiD,EAAA;IkB/ejD;MoDpBN;QpDqBQ,gBAAgB,EAAA,EoDPrB;;AAGH;EAIM,oCAA+F;EAA/F,oEAA+F,EAAA;;ACnBrG;EACE,kBAAkB;EAClB,WAAW,EAAA;EAFb;IAKI,cAAc;IACd,oCAAwD;IACxD,WAAW,EAAA;EAPf;IAWI,kBAAkB;IAClB,MAAM;IAEN,WAAW;IACX,YAAY,EAAA;ItEfZ;MAgCE,OsEnBwB,EAAA;ItEL1B;MA+BI,QAxBE,EAAA;;AsEKR;EACE,wBAAuC,EAAA;;AADzC;EACE,sCAAuC,EAAA;;AADzC;EACE,uCAAuC,EAAA;;AADzC;EACE,uCAAuC,EAAA;;ACrB3C;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,axE4sCsC,EAAA;;AwEzsCxC;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,OAAO;EACP,axEosCsC,EAAA;;AwE5rCpC;EACE,wBAAgB;EAAhB,gBAAgB;EAChB,MAAM;EACN,axEwrCkC,EAAA;;AwErrCpC;EACE,wBAAgB;EAAhB,gBAAgB;EAChB,SAAS;EACT,axEkrCkC,EAAA;;AUnpCpC;E8DxCA;IACE,wBAAgB;IAAhB,gBAAgB;IAChB,MAAM;IACN,axEwrCkC,EAAA;EwErrCpC;IACE,wBAAgB;IAAhB,gBAAgB;IAChB,SAAS;IACT,axEkrCkC,EAAA,EwEjrCnC;;A9D8BD;E8DxCA;IACE,wBAAgB;IAAhB,gBAAgB;IAChB,MAAM;IACN,axEwrCkC,EAAA;EwErrCpC;IACE,wBAAgB;IAAhB,gBAAgB;IAChB,SAAS;IACT,axEkrCkC,EAAA,EwEjrCnC;;A9D8BD;E8DxCA;IACE,wBAAgB;IAAhB,gBAAgB;IAChB,MAAM;IACN,axEwrCkC,EAAA;EwErrCpC;IACE,wBAAgB;IAAhB,gBAAgB;IAChB,SAAS;IACT,axEkrCkC,EAAA,EwEjrCnC;;A9D8BD;E8DxCA;IACE,wBAAgB;IAAhB,gBAAgB;IAChB,MAAM;IACN,axEwrCkC,EAAA;EwErrCpC;IACE,wBAAgB;IAAhB,gBAAgB;IAChB,SAAS;IACT,axEkrCkC,EAAA,EwEjrCnC;;A9D8BD;E8DxCA;IACE,wBAAgB;IAAhB,gBAAgB;IAChB,MAAM;IACN,axEwrCkC,EAAA;EwErrCpC;IACE,wBAAgB;IAAhB,gBAAgB;IAChB,SAAS;IACT,axEkrCkC,EAAA,EwEjrCnC;;AChCL;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,mBAAmB,EAAA;;ACRrB;;ECIE,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;EAC9B,oBAAoB,EAAA;EAGpB;;IACE,6BAA6B,EAAA;;ACfjC;EAEI,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,U5EifuC;E4EhfvC,WAAW,EAAA;;ACRf;ECAE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;ACNrB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,U/E2vBuE;E+E3vBvE,8B/E2vBuE;E+E1vBvE,eAAe;EACf,UAAU;EACV,8BAA8B;EAC9B,a/EovB+B,EAAA;;AgFtrBzB;EAUM,mCAA+D,EAAA;;AAVrE;EAUM,8BAA+D,EAAA;;AAVrE;EAUM,iCAA+D,EAAA;;AAVrE;EAUM,iCAA+D,EAAA;;AAVrE;EAUM,sCAA+D,EAAA;;AAVrE;EAUM,mCAA+D,EAAA;;A/E7EzE;EAgCE,sB+E2CkG,EAAA;;A/EnEpG;EA+BI,uB+EoCgG,EAAA;;A/E3EpG;EAgCE,uB+E2CkG,EAAA;;A/EnEpG;EA+BI,sB+EoCgG,EAAA;;A/E3EpG;EAgCE,sB+E2CkG,EAAA;;A/EnEpG;EA+BI,sB+EoCgG,EAAA;;AARhG;EAUM,8BAA+D,EAAA;;AAVrE;EAUM,4BAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,iCAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,qBAA+D,EAAA;;AAVrE;EAUM,wBAA+D,EAAA;;AAVrE;EAUM,uBAA+D,EAAA;;AAVrE;EAUM,wBAA+D,EAAA;;AAVrE;EAUM,qBAA+D,EAAA;;AAVrE;EAUM,yBAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,4BAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,6BAA+D,EAAA;;AAVrE;EAUM,8BAA+D,EAAA;;AAVrE;EAUM,6BAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,6BAA+D,EAAA;;AAVrE;EAUM,8BAA+D,EAAA;;AAVrE;EAUM,6BAA+D,EAAA;;AAVrE;EAUM,0BAA+D,EAAA;;AAVrE;EAUM,gCAA+D,EAAA;;AAVrE;EAUM,yBAA+D,EAAA;;AAVrE;EAUM,wBAA+D,EAAA;;AAVrE;EAUM,+BAA+D,EAAA;;AAVrE;EAUM,yBAA+D,EAAA;;AAVrE;EAUM,6BAA+D,EAAA;;AAVrE;EAUM,8BAA+D,EAAA;;AAVrE;EAUM,wBAA+D,EAAA;;AAVrE;EAUM,+BAA+D,EAAA;;AAVrE;EAUM,wBAA+D,EAAA;;AAVrE;EAUM,yDAA+D,EAAA;;AAVrE;EAUM,+DAA+D,EAAA;;AAVrE;EAUM,wDAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AApBrE;EACE,mFAAoC,EAAA;;AADtC;EACE,qFAAoC,EAAA;;AADtC;EACE,mFAAoC,EAAA;;AADtC;EACE,gFAAoC,EAAA;;AADtC;EACE,mFAAoC,EAAA;;AADtC;EACE,kFAAoC,EAAA;;AADtC;EACE,iFAAoC,EAAA;;AADtC;EACE,gFAAoC,EAAA;;AAStC;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,6BAA+D,EAAA;;AAVrE;EAUM,6BAA+D,EAAA;;AAVrE;EAUM,0BAA+D,EAAA;;AAVrE;EAUM,mCAA+D;EAA/D,2BAA+D,EAAA;;AAVrE;EAUM,iBAA+D,EAAA;;AAVrE;EAUM,mBAA+D,EAAA;;AAVrE;EAUM,oBAA+D,EAAA;;AAVrE;EAUM,oBAA+D,EAAA;;AAVrE;EAUM,sBAA+D,EAAA;;AAVrE;EAUM,uBAA+D,EAAA;;AAVrE;EAUM,kBAA+D,EAAA;;AAVrE;EAUM,oBAA+D,EAAA;;AAVrE;EAUM,qBAA+D,EAAA;;AAVrE;EAUM,mBAA+D,EAAA;;AAVrE;EAUM,qBAA+D,EAAA;;AAVrE;EAUM,sBAA+D,EAAA;;AAVrE;EAUM,2CAA+D,EAAA;;AAVrE;EAUM,sCAA+D,EAAA;;AAVrE;EAUM,sCAA+D,EAAA;;AAVrE;EAUM,oCAA+D;EAA/D,0FAA+D,EAAA;;AAVrE;EAUM,oBAA+D,EAAA;;AAVrE;EAUM,wCAA+D;EAA/D,8FAA+D,EAAA;;AAVrE;EAUM,wBAA+D,EAAA;;A/E7EzE;EAgCE,0C+E2CkG;E/E3ClG,gG+E2CkG,EAAA;;A/EnEpG;EA+BI,yC+EoCgG;E/EpChG,+F+EoCgG,EAAA;;A/E3EpG;EAgCE,0B+E2CkG,EAAA;;A/EnEpG;EA+BI,yB+EoCgG,EAAA;;AARhG;EAUM,2CAA+D;EAA/D,iGAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;A/E7EzE;EAgCE,yC+E2CkG;E/E3ClG,+F+E2CkG,EAAA;;A/EnEpG;EA+BI,0C+EoCgG;E/EpChG,gG+EoCgG,EAAA;;A/E3EpG;EAgCE,yB+E2CkG,EAAA;;A/EnEpG;EA+BI,0B+EoCgG,EAAA;;AARhG;EAIQ,uBAA4B;EAM9B,qEAA+D;EAA/D,gFAA+D,EAAA;;AAVrE;EAIQ,uBAA4B;EAM9B,uEAA+D;EAA/D,kFAA+D,EAAA;;AAVrE;EAIQ,uBAA4B;EAM9B,qEAA+D;EAA/D,gFAA+D,EAAA;;AAVrE;EAIQ,uBAA4B;EAM9B,sEAA+D;EAA/D,6EAA+D,EAAA;;AAVrE;EAIQ,uBAA4B;EAM9B,sEAA+D;EAA/D,gFAA+D,EAAA;;AAVrE;EAIQ,uBAA4B;EAM9B,qEAA+D;EAA/D,+EAA+D,EAAA;;AAVrE;EAIQ,uBAA4B;EAM9B,uEAA+D;EAA/D,8EAA+D,EAAA;;AAVrE;EAIQ,uBAA4B;EAM9B,qEAA+D;EAA/D,6EAA+D,EAAA;;AAVrE;EAIQ,uBAA4B;EAM9B,uEAA+D;EAA/D,8EAA+D,EAAA;;AAVrE;EAUM,oCAA+D,EAAA;;AAVrE;EAUM,oCAA+D,EAAA;;AAVrE;EAUM,oCAA+D,EAAA;;AAVrE;EAUM,iCAA+D,EAAA;;AAVrE;EAUM,oCAA+D,EAAA;;AAVrE;EAUM,oCAA+D,EAAA;;AAVrE;EAUM,oCAA+D,EAAA;;AAVrE;EAUM,oCAA+D,EAAA;;AAVrE;EAUM,iCAA+D,EAAA;;A/E7EzE;EAgCE,sC+E2CkG,EAAA;;A/EnEpG;EA+BI,qC+EoCgG,EAAA;;A/E3EpG;EAgCE,sC+E2CkG,EAAA;;A/EnEpG;EA+BI,qC+EoCgG,EAAA;;A/E3EpG;EAgCE,sC+E2CkG,EAAA;;A/EnEpG;EA+BI,qC+EoCgG,EAAA;;A/E3EpG;EAgCE,mC+E2CkG,EAAA;;A/EnEpG;EA+BI,kC+EoCgG,EAAA;;A/E3EpG;EAgCE,sC+E2CkG,EAAA;;A/EnEpG;EA+BI,qC+EoCgG,EAAA;;A/E3EpG;EAgCE,sC+E2CkG,EAAA;;A/EnEpG;EA+BI,qC+EoCgG,EAAA;;A/E3EpG;EAgCE,sC+E2CkG,EAAA;;A/EnEpG;EA+BI,qC+EoCgG,EAAA;;A/E3EpG;EAgCE,sC+E2CkG,EAAA;;A/EnEpG;EA+BI,qC+EoCgG,EAAA;;A/E3EpG;EAgCE,mC+E2CkG,EAAA;;A/EnEpG;EA+BI,kC+EoCgG,EAAA;;AARhG;EAUM,uCAA+D,EAAA;;AAVrE;EAUM,uCAA+D,EAAA;;AAVrE;EAUM,uCAA+D,EAAA;;AAVrE;EAUM,oCAA+D,EAAA;;AAVrE;EAUM,uCAA+D,EAAA;;AAVrE;EAUM,uCAA+D,EAAA;;AAVrE;EAUM,uCAA+D,EAAA;;AAVrE;EAUM,uCAA+D,EAAA;;AAVrE;EAUM,oCAA+D,EAAA;;A/E7EzE;EAgCE,qC+E2CkG,EAAA;;A/EnEpG;EA+BI,sC+EoCgG,EAAA;;A/E3EpG;EAgCE,qC+E2CkG,EAAA;;A/EnEpG;EA+BI,sC+EoCgG,EAAA;;A/E3EpG;EAgCE,qC+E2CkG,EAAA;;A/EnEpG;EA+BI,sC+EoCgG,EAAA;;A/E3EpG;EAgCE,kC+E2CkG,EAAA;;A/EnEpG;EA+BI,mC+EoCgG,EAAA;;A/E3EpG;EAgCE,qC+E2CkG,EAAA;;A/EnEpG;EA+BI,sC+EoCgG,EAAA;;A/E3EpG;EAgCE,qC+E2CkG,EAAA;;A/EnEpG;EA+BI,sC+EoCgG,EAAA;;A/E3EpG;EAgCE,qC+E2CkG,EAAA;;A/EnEpG;EA+BI,sC+EoCgG,EAAA;;A/E3EpG;EAgCE,qC+E2CkG,EAAA;;A/EnEpG;EA+BI,sC+EoCgG,EAAA;;A/E3EpG;EAgCE,kC+E2CkG,EAAA;;A/EnEpG;EA+BI,mC+EoCgG,EAAA;;AARhG;EAUM,4BAA+D,EAAA;;AAVrE;EAUM,4BAA+D,EAAA;;AAVrE;EAUM,4BAA+D,EAAA;;AAVrE;EAUM,4BAA+D,EAAA;;AAVrE;EAUM,4BAA+D,EAAA;;AAVrE;EAUM,gCAA+D,EAAA;;AAVrE;EAUM,gCAA+D,EAAA;;AAVrE;EAUM,gCAA+D,EAAA;;AAVrE;EAUM,gCAA+D,EAAA;;AAVrE;EAUM,gCAA+D,EAAA;;A/E7EzE;EAgCE,kC+E2CkG,EAAA;;A/EnEpG;EA+BI,iC+EoCgG,EAAA;;A/E3EpG;EAgCE,kC+E2CkG,EAAA;;A/EnEpG;EA+BI,iC+EoCgG,EAAA;;A/E3EpG;EAgCE,kC+E2CkG,EAAA;;A/EnEpG;EA+BI,iC+EoCgG,EAAA;;A/E3EpG;EAgCE,kC+E2CkG,EAAA;;A/EnEpG;EA+BI,iC+EoCgG,EAAA;;A/E3EpG;EAgCE,kC+E2CkG,EAAA;;A/EnEpG;EA+BI,iC+EoCgG,EAAA;;AARhG;EAUM,mCAA+D,EAAA;;AAVrE;EAUM,mCAA+D,EAAA;;AAVrE;EAUM,mCAA+D,EAAA;;AAVrE;EAUM,mCAA+D,EAAA;;AAVrE;EAUM,mCAA+D,EAAA;;A/E7EzE;EAgCE,iC+E2CkG,EAAA;;A/EnEpG;EA+BI,kC+EoCgG,EAAA;;A/E3EpG;EAgCE,iC+E2CkG,EAAA;;A/EnEpG;EA+BI,kC+EoCgG,EAAA;;A/E3EpG;EAgCE,iC+E2CkG,EAAA;;A/EnEpG;EA+BI,kC+EoCgG,EAAA;;A/E3EpG;EAgCE,iC+E2CkG,EAAA;;A/EnEpG;EA+BI,kC+EoCgG,EAAA;;A/E3EpG;EAgCE,iC+E2CkG,EAAA;;A/EnEpG;EA+BI,kC+EoCgG,EAAA;;AAlBhG;EACE,yBAAoC,EAAA;;AADtC;EACE,0BAAoC,EAAA;;AADtC;EACE,yBAAoC,EAAA;;AADtC;EACE,0BAAoC,EAAA;;AADtC;EACE,uBAAoC,EAAA;;AAStC;EAUM,qBAA+D,EAAA;;AAVrE;EAUM,qBAA+D,EAAA;;AAVrE;EAUM,qBAA+D,EAAA;;AAVrE;EAUM,sBAA+D,EAAA;;AAVrE;EAUM,sBAA+D,EAAA;;AAVrE;EAUM,0BAA+D,EAAA;;AAVrE;EAUM,uBAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,sBAA+D,EAAA;;AAVrE;EAUM,sBAA+D,EAAA;;AAVrE;EAUM,sBAA+D,EAAA;;AAVrE;EAUM,uBAA+D,EAAA;;AAVrE;EAUM,uBAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,wBAA+D,EAAA;;AAVrE;EAUM,4BAA+D,EAAA;;AAVrE;EAUM,yBAA+D,EAAA;;AAVrE;EAUM,8BAA+D,EAAA;;AAVrE;EAUM,iCAA+D,EAAA;;AAVrE;EAUM,sCAA+D,EAAA;;AAVrE;EAUM,yCAA+D,EAAA;;AAVrE;EAUM,uBAA+D,EAAA;;AAVrE;EAUM,uBAA+D,EAAA;;AAVrE;EAUM,yBAA+D,EAAA;;AAVrE;EAUM,yBAA+D,EAAA;;AAVrE;EAUM,0BAA+D,EAAA;;AAVrE;EAUM,4BAA+D,EAAA;;AAVrE;EAUM,kCAA+D,EAAA;;AAVrE;EAUM,sCAA+D,EAAA;;AAVrE;EAUM,oCAA+D,EAAA;;AAVrE;EAUM,kCAA+D,EAAA;;AAVrE;EAUM,yCAA+D,EAAA;;AAVrE;EAUM,wCAA+D,EAAA;;AAVrE;EAUM,wCAA+D,EAAA;;AAVrE;EAUM,kCAA+D,EAAA;;AAVrE;EAUM,gCAA+D,EAAA;;AAVrE;EAUM,8BAA+D,EAAA;;AAVrE;EAUM,gCAA+D,EAAA;;AAVrE;EAUM,+BAA+D,EAAA;;AAVrE;EAUM,oCAA+D,EAAA;;AAVrE;EAUM,kCAA+D,EAAA;;AAVrE;EAUM,gCAA+D,EAAA;;AAVrE;EAUM,uCAA+D,EAAA;;AAVrE;EAUM,sCAA+D,EAAA;;AAVrE;EAUM,iCAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,iCAA+D,EAAA;;AAVrE;EAUM,+BAA+D,EAAA;;AAVrE;EAUM,6BAA+D,EAAA;;AAVrE;EAUM,+BAA+D,EAAA;;AAVrE;EAUM,8BAA+D,EAAA;;AAVrE;EAUM,oBAA+D,EAAA;;AAVrE;EAUM,mBAA+D,EAAA;;AAVrE;EAUM,mBAA+D,EAAA;;AAVrE;EAUM,mBAA+D,EAAA;;AAVrE;EAUM,mBAA+D,EAAA;;AAVrE;EAUM,mBAA+D,EAAA;;AAVrE;EAUM,mBAA+D,EAAA;;AAVrE;EAUM,mBAA+D,EAAA;;AAVrE;EAUM,oBAA+D,EAAA;;AAVrE;EAUM,0BAA+D,EAAA;;AAVrE;EAUM,yBAA+D,EAAA;;AAVrE;EAUM,uBAA+D,EAAA;;AAVrE;EAUM,yBAA+D,EAAA;;AAVrE;EAUM,uBAA+D,EAAA;;AAVrE;EAUM,uBAA+D,EAAA;;AAVrE;EAUM,0BAA+D;EAA/D,yBAA+D,EAAA;;AAVrE;EAUM,gCAA+D;EAA/D,+BAA+D,EAAA;;AAVrE;EAUM,+BAA+D;EAA/D,8BAA+D,EAAA;;AAVrE;EAUM,6BAA+D;EAA/D,4BAA+D,EAAA;;AAVrE;EAUM,+BAA+D;EAA/D,8BAA+D,EAAA;;AAVrE;EAUM,6BAA+D;EAA/D,4BAA+D,EAAA;;AAVrE;EAUM,6BAA+D;EAA/D,4BAA+D,EAAA;;AAVrE;EAUM,wBAA+D;EAA/D,2BAA+D,EAAA;;AAVrE;EAUM,8BAA+D;EAA/D,iCAA+D,EAAA;;AAVrE;EAUM,6BAA+D;EAA/D,gCAA+D,EAAA;;AAVrE;EAUM,2BAA+D;EAA/D,8BAA+D,EAAA;;AAVrE;EAUM,6BAA+D;EAA/D,gCAA+D,EAAA;;AAVrE;EAUM,2BAA+D;EAA/D,8BAA+D,EAAA;;AAVrE;EAUM,2BAA+D;EAA/D,8BAA+D,EAAA;;AAVrE;EAUM,wBAA+D,EAAA;;AAVrE;EAUM,8BAA+D,EAAA;;AAVrE;EAUM,6BAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,6BAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;A/E7EzE;EAgCE,0B+E2CkG,EAAA;;A/EnEpG;EA+BI,yB+EoCgG,EAAA;;A/E3EpG;EAgCE,gC+E2CkG,EAAA;;A/EnEpG;EA+BI,+B+EoCgG,EAAA;;A/E3EpG;EAgCE,+B+E2CkG,EAAA;;A/EnEpG;EA+BI,8B+EoCgG,EAAA;;A/E3EpG;EAgCE,6B+E2CkG,EAAA;;A/EnEpG;EA+BI,4B+EoCgG,EAAA;;A/E3EpG;EAgCE,+B+E2CkG,EAAA;;A/EnEpG;EA+BI,8B+EoCgG,EAAA;;A/E3EpG;EAgCE,6B+E2CkG,EAAA;;A/EnEpG;EA+BI,4B+EoCgG,EAAA;;A/E3EpG;EAgCE,6B+E2CkG,EAAA;;A/EnEpG;EA+BI,4B+EoCgG,EAAA;;AARhG;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,iCAA+D,EAAA;;AAVrE;EAUM,gCAA+D,EAAA;;AAVrE;EAUM,8BAA+D,EAAA;;AAVrE;EAUM,gCAA+D,EAAA;;AAVrE;EAUM,8BAA+D,EAAA;;AAVrE;EAUM,8BAA+D,EAAA;;A/E7EzE;EAgCE,yB+E2CkG,EAAA;;A/EnEpG;EA+BI,0B+EoCgG,EAAA;;A/E3EpG;EAgCE,+B+E2CkG,EAAA;;A/EnEpG;EA+BI,gC+EoCgG,EAAA;;A/E3EpG;EAgCE,8B+E2CkG,EAAA;;A/EnEpG;EA+BI,+B+EoCgG,EAAA;;A/E3EpG;EAgCE,4B+E2CkG,EAAA;;A/EnEpG;EA+BI,6B+EoCgG,EAAA;;A/E3EpG;EAgCE,8B+E2CkG,EAAA;;A/EnEpG;EA+BI,+B+EoCgG,EAAA;;A/E3EpG;EAgCE,4B+E2CkG,EAAA;;A/EnEpG;EA+BI,6B+EoCgG,EAAA;;A/E3EpG;EAgCE,4B+E2CkG,EAAA;;A/EnEpG;EA+BI,6B+EoCgG,EAAA;;AARhG;EAUM,qBAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,0BAA+D,EAAA;;AAVrE;EAUM,wBAA+D,EAAA;;AAVrE;EAUM,0BAA+D,EAAA;;AAVrE;EAUM,wBAA+D,EAAA;;AAVrE;EAUM,2BAA+D;EAA/D,0BAA+D,EAAA;;AAVrE;EAUM,iCAA+D;EAA/D,gCAA+D,EAAA;;AAVrE;EAUM,gCAA+D;EAA/D,+BAA+D,EAAA;;AAVrE;EAUM,8BAA+D;EAA/D,6BAA+D,EAAA;;AAVrE;EAUM,gCAA+D;EAA/D,+BAA+D,EAAA;;AAVrE;EAUM,8BAA+D;EAA/D,6BAA+D,EAAA;;AAVrE;EAUM,yBAA+D;EAA/D,4BAA+D,EAAA;;AAVrE;EAUM,+BAA+D;EAA/D,kCAA+D,EAAA;;AAVrE;EAUM,8BAA+D;EAA/D,iCAA+D,EAAA;;AAVrE;EAUM,4BAA+D;EAA/D,+BAA+D,EAAA;;AAVrE;EAUM,8BAA+D;EAA/D,iCAA+D,EAAA;;AAVrE;EAUM,4BAA+D;EAA/D,+BAA+D,EAAA;;AAVrE;EAUM,yBAA+D,EAAA;;AAVrE;EAUM,+BAA+D,EAAA;;AAVrE;EAUM,8BAA+D,EAAA;;AAVrE;EAUM,4BAA+D,EAAA;;AAVrE;EAUM,8BAA+D,EAAA;;AAVrE;EAUM,4BAA+D,EAAA;;A/E7EzE;EAgCE,2B+E2CkG,EAAA;;A/EnEpG;EA+BI,0B+EoCgG,EAAA;;A/E3EpG;EAgCE,iC+E2CkG,EAAA;;A/EnEpG;EA+BI,gC+EoCgG,EAAA;;A/E3EpG;EAgCE,gC+E2CkG,EAAA;;A/EnEpG;EA+BI,+B+EoCgG,EAAA;;A/E3EpG;EAgCE,8B+E2CkG,EAAA;;A/EnEpG;EA+BI,6B+EoCgG,EAAA;;A/E3EpG;EAgCE,gC+E2CkG,EAAA;;A/EnEpG;EA+BI,+B+EoCgG,EAAA;;A/E3EpG;EAgCE,8B+E2CkG,EAAA;;A/EnEpG;EA+BI,6B+EoCgG,EAAA;;AARhG;EAUM,4BAA+D,EAAA;;AAVrE;EAUM,kCAA+D,EAAA;;AAVrE;EAUM,iCAA+D,EAAA;;AAVrE;EAUM,+BAA+D,EAAA;;AAVrE;EAUM,iCAA+D,EAAA;;AAVrE;EAUM,+BAA+D,EAAA;;A/E7EzE;EAgCE,0B+E2CkG,EAAA;;A/EnEpG;EA+BI,2B+EoCgG,EAAA;;A/E3EpG;EAgCE,gC+E2CkG,EAAA;;A/EnEpG;EA+BI,iC+EoCgG,EAAA;;A/E3EpG;EAgCE,+B+E2CkG,EAAA;;A/EnEpG;EA+BI,gC+EoCgG,EAAA;;A/E3EpG;EAgCE,6B+E2CkG,EAAA;;A/EnEpG;EA+BI,8B+EoCgG,EAAA;;A/E3EpG;EAgCE,+B+E2CkG,EAAA;;A/EnEpG;EA+BI,gC+EoCgG,EAAA;;A/E3EpG;EAgCE,6B+E2CkG,EAAA;;A/EnEpG;EA+BI,8B+EoCgG,EAAA;;AARhG;EAUM,iBAA+D,EAAA;;AAVrE;EAUM,uBAA+D,EAAA;;AAVrE;EAUM,sBAA+D,EAAA;;AAVrE;EAUM,oBAA+D,EAAA;;AAVrE;EAUM,sBAA+D,EAAA;;AAVrE;EAUM,oBAA+D,EAAA;;AAVrE;EAUM,qBAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,0BAA+D,EAAA;;AAVrE;EAUM,wBAA+D,EAAA;;AAVrE;EAUM,0BAA+D,EAAA;;AAVrE;EAUM,wBAA+D,EAAA;;AAVrE;EAUM,wBAA+D,EAAA;;AAVrE;EAUM,8BAA+D,EAAA;;AAVrE;EAUM,6BAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,6BAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,4GAA+D;EAA/D,iDAA+D,EAAA;;AAVrE;EAUM,4CAA+D,EAAA;;AAVrE;EAUM,4CAA+D,EAAA;;AAVrE;EAUM,0CAA+D,EAAA;;AAVrE;EAUM,4CAA+D,EAAA;;AAVrE;EAUM,6BAA+D,EAAA;;AAVrE;EAUM,0BAA+D,EAAA;;AAVrE;EAUM,6BAA+D,EAAA;;AAVrE;EAUM,6BAA+D,EAAA;;AAVrE;EAUM,+BAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,8BAA+D,EAAA;;AAVrE;EAUM,yBAA+D,EAAA;;AAVrE;EAUM,4BAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,yBAA+D,EAAA;;A/E7EzE;EAgCE,2B+E2CkG,EAAA;;A/EnEpG;EA+BI,4B+EoCgG,EAAA;;A/E3EpG;EAgCE,4B+E2CkG,EAAA;;A/EnEpG;EA+BI,2B+EoCgG,EAAA;;A/E3EpG;EAgCE,6B+E2CkG,EAAA;;A/EnEpG;EA+BI,6B+EoCgG,EAAA;;AARhG;EAUM,gCAA+D,EAAA;;AAVrE;EAUM,qCAA+D,EAAA;;AAVrE;EAUM,wCAA+D,EAAA;;AAVrE;EAUM,oCAA+D,EAAA;;AAVrE;EAUM,oCAA+D,EAAA;;AAVrE;EAUM,qCAA+D,EAAA;;AAVrE;EAUM,8BAA+D,EAAA;;AAVrE;EAUM,8BAA+D,EAAA;;AAxBrE,qBAAA;AAcA;EAUM,gCAA+D;EAA/D,iCAA+D,EAAA;;AAoBrE,mBAAA;AA9BA;EAIQ,qBAA4B;EAM9B,4DAA+D;EAA/D,uEAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,8DAA+D;EAA/D,yEAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,4DAA+D;EAA/D,uEAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,6DAA+D;EAA/D,oEAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,6DAA+D;EAA/D,uEAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,4DAA+D;EAA/D,sEAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,8DAA+D;EAA/D,qEAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,4DAA+D;EAA/D,oEAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,yDAA+D;EAA/D,qEAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,8DAA+D;EAA/D,qEAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,2DAA+D;EAA/D,0EAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,yCAA+D;EAA/D,4CAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,qCAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,0CAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,yCAA+D;EAA/D,4CAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,wCAA+D;EAA/D,2CAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,yBAA+D;EAA/D,2CAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,yBAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,2CAA+D;EAA/D,kDAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,0CAA+D;EAA/D,oDAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,2CAA+D;EAA/D,6CAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,wCAA+D;EAA/D,0CAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,yCAA+D;EAA/D,4CAA+D,EAAA;;AAVrE;EAIQ,qBAA4B;EAM9B,wCAA+D;EAA/D,qCAA+D,EAAA;;AApBrE;EACE,wBAAoC,EAAA;;AADtC;EACE,uBAAoC,EAAA;;AADtC;EACE,wBAAoC,EAAA;;AADtC;EACE,qBAAoC,EAAA;;AADtC;EACE,uBAAoC,EAAA;;AAIpC;EACE,uBAAoC,EAAA;;AANxC;EACE,wBAAoC,EAAA;;AAIpC;EACE,wBAAoC,EAAA;;AANxC;EACE,uBAAoC,EAAA;;AAIpC;EACE,uBAAoC,EAAA;;AANxC;EACE,wBAAoC,EAAA;;AAIpC;EACE,wBAAoC,EAAA;;AANxC;EACE,qBAAoC,EAAA;;AAIpC;EACE,qBAAoC,EAAA;;AAIxC;EAUM,yCAA+D,EAAA;;AAMnE;EAOI,yCAA+D,EAAA;;AAvBrE;EAUM,wCAA+D,EAAA;;AAMnE;EAOI,wCAA+D,EAAA;;AAvBrE;EAUM,yCAA+D,EAAA;;AAMnE;EAOI,yCAA+D,EAAA;;AAvBrE;EAIQ,+BAA4B;EAM9B,8FAA+D;UAA/D,sFAA+D;EAA/D,yGAA+D;UAA/D,iGAA+D,EAAA;;AAVrE;EAIQ,+BAA4B;EAM9B,gGAA+D;UAA/D,wFAA+D;EAA/D,2GAA+D;UAA/D,mGAA+D,EAAA;;AAVrE;EAIQ,+BAA4B;EAM9B,8FAA+D;UAA/D,sFAA+D;EAA/D,yGAA+D;UAA/D,iGAA+D,EAAA;;AAVrE;EAIQ,+BAA4B;EAM9B,+FAA+D;UAA/D,uFAA+D;EAA/D,sGAA+D;UAA/D,8FAA+D,EAAA;;AAVrE;EAIQ,+BAA4B;EAM9B,+FAA+D;UAA/D,uFAA+D;EAA/D,yGAA+D;UAA/D,iGAA+D,EAAA;;AAVrE;EAIQ,+BAA4B;EAM9B,8FAA+D;UAA/D,sFAA+D;EAA/D,wGAA+D;UAA/D,gGAA+D,EAAA;;AAVrE;EAIQ,+BAA4B;EAM9B,gGAA+D;UAA/D,wFAA+D;EAA/D,uGAA+D;UAA/D,+FAA+D,EAAA;;AAVrE;EAIQ,+BAA4B;EAM9B,8FAA+D;UAA/D,sFAA+D;EAA/D,sGAA+D;UAA/D,8FAA+D,EAAA;;AAVrE;EAIQ,+BAA4B;EAM9B,8DAA+D;UAA/D,sDAA+D;EAA/D,+GAA+D;UAA/D,uGAA+D,EAAA;;AApBrE;EACE,+BAAoC,EAAA;;AAIpC;EACE,+BAAoC,EAAA;;AANxC;EACE,iCAAoC,EAAA;;AAIpC;EACE,iCAAoC,EAAA;;AANxC;EACE,kCAAoC,EAAA;;AAIpC;EACE,kCAAoC,EAAA;;AANxC;EACE,iCAAoC,EAAA;;AAIpC;EACE,iCAAoC,EAAA;;AANxC;EACE,kCAAoC,EAAA;;AAIpC;EACE,kCAAoC,EAAA;;AANxC;EACE,+BAAoC,EAAA;;AAIpC;EACE,+BAAoC,EAAA;;AAIxC;EAIQ,mBAA4B;EAM9B,qEAA+D;EAA/D,gFAA+D,EAAA;;AAVrE;EAIQ,mBAA4B;EAM9B,uEAA+D;EAA/D,kFAA+D,EAAA;;AAVrE;EAIQ,mBAA4B;EAM9B,qEAA+D;EAA/D,gFAA+D,EAAA;;AAVrE;EAIQ,mBAA4B;EAM9B,sEAA+D;EAA/D,6EAA+D,EAAA;;AAVrE;EAIQ,mBAA4B;EAM9B,sEAA+D;EAA/D,gFAA+D,EAAA;;AAVrE;EAIQ,mBAA4B;EAM9B,qEAA+D;EAA/D,+EAA+D,EAAA;;AAVrE;EAIQ,mBAA4B;EAM9B,uEAA+D;EAA/D,8EAA+D,EAAA;;AAVrE;EAIQ,mBAA4B;EAM9B,qEAA+D;EAA/D,6EAA+D,EAAA;;AAVrE;EAIQ,mBAA4B;EAM9B,kEAA+D;EAA/D,8EAA+D,EAAA;;AAVrE;EAIQ,mBAA4B;EAM9B,uEAA+D;EAA/D,8EAA+D,EAAA;;AAVrE;EAIQ,mBAA4B;EAM9B,uEAA+D;EAA/D,gFAA+D,EAAA;;AAVrE;EAIQ,mBAA4B;EAM9B,wCAA+D,EAAA;;AAVrE;EAIQ,mBAA4B;EAM9B,uEAA+D;EAA/D,qFAA+D,EAAA;;AAVrE;EAIQ,mBAA4B;EAM9B,uEAA+D;EAA/D,oFAA+D,EAAA;;AApBrE;EACE,qBAAoC,EAAA;;AADtC;EACE,sBAAoC,EAAA;;AADtC;EACE,qBAAoC,EAAA;;AADtC;EACE,sBAAoC,EAAA;;AADtC;EACE,mBAAoC,EAAA;;AAStC;EAUM,uGAA+D;EAA/D,gDAA+D,EAAA;;AAVrE;EAUM,mCAA+D;UAA/D,2BAA+D,EAAA;;AAVrE;EAUM,oCAA+D;UAA/D,4BAA+D,EAAA;;AAVrE;EAUM,oCAA+D;UAA/D,4BAA+D,EAAA;;AAVrE;EAUM,+BAA+D,EAAA;;AAVrE;EAUM,+BAA+D,EAAA;;AAVrE;EAUM,kCAA+D;EAA/D,kDAA+D,EAAA;;AAVrE;EAUM,2BAA+D,EAAA;;AAVrE;EAUM,iCAA+D;EAA/D,qDAA+D,EAAA;;AAVrE;EAUM,kCAA+D;EAA/D,kDAA+D,EAAA;;AAVrE;EAUM,gCAA+D;EAA/D,qDAA+D,EAAA;;AAVrE;EAUM,8BAA+D;EAA/D,qDAA+D,EAAA;;AAVrE;EAUM,8BAA+D;EAA/D,sDAA+D,EAAA;;AAVrE;EAUM,6BAA+D,EAAA;;AAVrE;EAUM,+BAA+D;EAA/D,uDAA+D,EAAA;;AAVrE;EAUM,2CAA+D;EAA/D,2DAA+D;EAA/D,4CAA+D;EAA/D,4DAA+D,EAAA;;AAVrE;EAUM,oCAA+D;EAA/D,qCAA+D,EAAA;;AAVrE;EAUM,0CAA+D;EAA/D,8DAA+D;EAA/D,2CAA+D;EAA/D,+DAA+D,EAAA;;AAVrE;EAUM,2CAA+D;EAA/D,2DAA+D;EAA/D,4CAA+D;EAA/D,4DAA+D,EAAA;;AAVrE;EAUM,yCAA+D;EAA/D,8DAA+D;EAA/D,0CAA+D;EAA/D,+DAA+D,EAAA;;AAVrE;EAUM,uCAA+D;EAA/D,8DAA+D;EAA/D,wCAA+D;EAA/D,+DAA+D,EAAA;;AAVrE;EAUM,uCAA+D;EAA/D,+DAA+D;EAA/D,wCAA+D;EAA/D,gEAA+D,EAAA;;AAVrE;EAUM,sCAA+D;EAA/D,uCAA+D,EAAA;;AAVrE;EAUM,wCAA+D;EAA/D,gEAA+D;EAA/D,yCAA+D;EAA/D,iEAA+D,EAAA;;A/E7EzE;EAgCE,4C+E2CkG;E/E3ClG,4D+E2CkG,EAAA;;A/EnEpG;EA+BI,2C+EoCgG;E/EpChG,2D+EoCgG,EAAA;;A/E3EpG;EAgCE,+C+E2CkG;E/E3ClG,+D+E2CkG,EAAA;;A/EnEpG;EA+BI,8C+EoCgG;E/EpChG,8D+EoCgG,EAAA;;A/E3EpG;EAgCE,qC+E2CkG,EAAA;;A/EnEpG;EA+BI,oC+EoCgG,EAAA;;A/E3EpG;EAgCE,wC+E2CkG,EAAA;;A/EnEpG;EA+BI,uC+EoCgG,EAAA;;A/E3EpG;EAgCE,2C+E2CkG;E/E3ClG,+D+E2CkG,EAAA;;A/EnEpG;EA+BI,0C+EoCgG;E/EpChG,8D+EoCgG,EAAA;;A/E3EpG;EAgCE,8C+E2CkG;E/E3ClG,kE+E2CkG,EAAA;;A/EnEpG;EA+BI,6C+EoCgG;E/EpChG,iE+EoCgG,EAAA;;A/E3EpG;EAgCE,4C+E2CkG;E/E3ClG,4D+E2CkG,EAAA;;A/EnEpG;EA+BI,2C+EoCgG;E/EpChG,2D+EoCgG,EAAA;;A/E3EpG;EAgCE,+C+E2CkG;E/E3ClG,+D+E2CkG,EAAA;;A/EnEpG;EA+BI,8C+EoCgG;E/EpChG,8D+EoCgG,EAAA;;A/E3EpG;EAgCE,0C+E2CkG;E/E3ClG,+D+E2CkG,EAAA;;A/EnEpG;EA+BI,yC+EoCgG;E/EpChG,8D+EoCgG,EAAA;;A/E3EpG;EAgCE,6C+E2CkG;E/E3ClG,kE+E2CkG,EAAA;;A/EnEpG;EA+BI,4C+EoCgG;E/EpChG,iE+EoCgG,EAAA;;A/E3EpG;EAgCE,wC+E2CkG;E/E3ClG,+D+E2CkG,EAAA;;A/EnEpG;EA+BI,uC+EoCgG;E/EpChG,8D+EoCgG,EAAA;;A/E3EpG;EAgCE,2C+E2CkG;E/E3ClG,kE+E2CkG,EAAA;;A/EnEpG;EA+BI,0C+EoCgG;E/EpChG,iE+EoCgG,EAAA;;A/E3EpG;EAgCE,wC+E2CkG;E/E3ClG,gE+E2CkG,EAAA;;A/EnEpG;EA+BI,uC+EoCgG;E/EpChG,+D+EoCgG,EAAA;;A/E3EpG;EAgCE,2C+E2CkG;E/E3ClG,mE+E2CkG,EAAA;;A/EnEpG;EA+BI,0C+EoCgG;E/EpChG,kE+EoCgG,EAAA;;A/E3EpG;EAgCE,uC+E2CkG,EAAA;;A/EnEpG;EA+BI,sC+EoCgG,EAAA;;A/E3EpG;EAgCE,0C+E2CkG,EAAA;;A/EnEpG;EA+BI,yC+EoCgG,EAAA;;A/E3EpG;EAgCE,yC+E2CkG;E/E3ClG,iE+E2CkG,EAAA;;A/EnEpG;EA+BI,wC+EoCgG;E/EpChG,gE+EoCgG,EAAA;;A/E3EpG;EAgCE,4C+E2CkG;E/E3ClG,oE+E2CkG,EAAA;;A/EnEpG;EA+BI,2C+EoCgG;E/EpChG,mE+EoCgG,EAAA;;AARhG;EAUM,+CAA+D;EAA/D,+DAA+D;EAA/D,8CAA+D;EAA/D,8DAA+D,EAAA;;AAVrE;EAUM,wCAA+D;EAA/D,uCAA+D,EAAA;;AAVrE;EAUM,8CAA+D;EAA/D,kEAA+D;EAA/D,6CAA+D;EAA/D,iEAA+D,EAAA;;AAVrE;EAUM,+CAA+D;EAA/D,+DAA+D;EAA/D,8CAA+D;EAA/D,8DAA+D,EAAA;;AAVrE;EAUM,6CAA+D;EAA/D,kEAA+D;EAA/D,4CAA+D;EAA/D,iEAA+D,EAAA;;AAVrE;EAUM,2CAA+D;EAA/D,kEAA+D;EAA/D,0CAA+D;EAA/D,iEAA+D,EAAA;;AAVrE;EAUM,2CAA+D;EAA/D,mEAA+D;EAA/D,0CAA+D;EAA/D,kEAA+D,EAAA;;AAVrE;EAUM,0CAA+D;EAA/D,yCAA+D,EAAA;;AAVrE;EAUM,4CAA+D;EAA/D,oEAA+D;EAA/D,2CAA+D;EAA/D,mEAA+D,EAAA;;A/E7EzE;EAgCE,8C+E2CkG;E/E3ClG,8D+E2CkG,EAAA;;A/EnEpG;EA+BI,+C+EoCgG;E/EpChG,+D+EoCgG,EAAA;;A/E3EpG;EAgCE,2C+E2CkG;E/E3ClG,2D+E2CkG,EAAA;;A/EnEpG;EA+BI,4C+EoCgG;E/EpChG,4D+EoCgG,EAAA;;A/E3EpG;EAgCE,uC+E2CkG,EAAA;;A/EnEpG;EA+BI,wC+EoCgG,EAAA;;A/E3EpG;EAgCE,oC+E2CkG,EAAA;;A/EnEpG;EA+BI,qC+EoCgG,EAAA;;A/E3EpG;EAgCE,6C+E2CkG;E/E3ClG,iE+E2CkG,EAAA;;A/EnEpG;EA+BI,8C+EoCgG;E/EpChG,kE+EoCgG,EAAA;;A/E3EpG;EAgCE,0C+E2CkG;E/E3ClG,8D+E2CkG,EAAA;;A/EnEpG;EA+BI,2C+EoCgG;E/EpChG,+D+EoCgG,EAAA;;A/E3EpG;EAgCE,8C+E2CkG;E/E3ClG,8D+E2CkG,EAAA;;A/EnEpG;EA+BI,+C+EoCgG;E/EpChG,+D+EoCgG,EAAA;;A/E3EpG;EAgCE,2C+E2CkG;E/E3ClG,2D+E2CkG,EAAA;;A/EnEpG;EA+BI,4C+EoCgG;E/EpChG,4D+EoCgG,EAAA;;A/E3EpG;EAgCE,4C+E2CkG;E/E3ClG,iE+E2CkG,EAAA;;A/EnEpG;EA+BI,6C+EoCgG;E/EpChG,kE+EoCgG,EAAA;;A/E3EpG;EAgCE,yC+E2CkG;E/E3ClG,8D+E2CkG,EAAA;;A/EnEpG;EA+BI,0C+EoCgG;E/EpChG,+D+EoCgG,EAAA;;A/E3EpG;EAgCE,0C+E2CkG;E/E3ClG,iE+E2CkG,EAAA;;A/EnEpG;EA+BI,2C+EoCgG;E/EpChG,kE+EoCgG,EAAA;;A/E3EpG;EAgCE,uC+E2CkG;E/E3ClG,8D+E2CkG,EAAA;;A/EnEpG;EA+BI,wC+EoCgG;E/EpChG,+D+EoCgG,EAAA;;A/E3EpG;EAgCE,0C+E2CkG;E/E3ClG,kE+E2CkG,EAAA;;A/EnEpG;EA+BI,2C+EoCgG;E/EpChG,mE+EoCgG,EAAA;;A/E3EpG;EAgCE,uC+E2CkG;E/E3ClG,+D+E2CkG,EAAA;;A/EnEpG;EA+BI,wC+EoCgG;E/EpChG,gE+EoCgG,EAAA;;A/E3EpG;EAgCE,yC+E2CkG,EAAA;;A/EnEpG;EA+BI,0C+EoCgG,EAAA;;A/E3EpG;EAgCE,sC+E2CkG,EAAA;;A/EnEpG;EA+BI,uC+EoCgG,EAAA;;A/E3EpG;EAgCE,2C+E2CkG;E/E3ClG,mE+E2CkG,EAAA;;A/EnEpG;EA+BI,4C+EoCgG;E/EpChG,oE+EoCgG,EAAA;;A/E3EpG;EAgCE,wC+E2CkG;E/E3ClG,gE+E2CkG,EAAA;;A/EnEpG;EA+BI,yC+EoCgG;E/EpChG,iE+EoCgG,EAAA;;AARhG;EAUM,8BAA+D,EAAA;;AAVrE;EAUM,6BAA+D,EAAA;;AAVrE;EAUM,sBAA+D,EAAA;;AAVrE;EAUM,qBAA+D,EAAA;;AAVrE;EAUM,qBAA+D,EAAA;;AAVrE;EAUM,qBAA+D,EAAA;;AAVrE;EAUM,qBAA+D,EAAA;;AtEhBzE;ET7DA;IAgCE,sB+E2CkG,EAAA;E/EnEpG;IA+BI,uB+EoCgG,EAAA;E/E3EpG;IAgCE,uB+E2CkG,EAAA;E/EnEpG;IA+BI,sB+EoCgG,EAAA;E/E3EpG;IAgCE,sB+E2CkG,EAAA;E/EnEpG;IA+BI,sB+EoCgG,EAAA;EARhG;IAUM,8BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,sCAA+D,EAAA;EAVrE;IAUM,yCAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,sCAA+D,EAAA;EAVrE;IAUM,oCAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,yCAA+D,EAAA;EAVrE;IAUM,wCAA+D,EAAA;EAVrE;IAUM,wCAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,oCAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,uCAA+D,EAAA;EAVrE;IAUM,sCAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,oBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,oBAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,0BAA+D;IAA/D,yBAA+D,EAAA;EAVrE;IAUM,gCAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,+BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,4BAA+D,EAAA;EAVrE;IAUM,+BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,4BAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,4BAA+D,EAAA;EAVrE;IAUM,wBAA+D;IAA/D,2BAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,iCAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,gCAA+D,EAAA;EAVrE;IAUM,2BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,gCAA+D,EAAA;EAVrE;IAUM,2BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,2BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;E/E7EzE;IAgCE,0B+E2CkG,EAAA;E/EnEpG;IA+BI,yB+EoCgG,EAAA;E/E3EpG;IAgCE,gC+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,8B+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,4B+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,8B+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,4B+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,4B+EoCgG,EAAA;EARhG;IAUM,2BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;E/E7EzE;IAgCE,yB+E2CkG,EAAA;E/EnEpG;IA+BI,0B+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,gC+EoCgG,EAAA;E/E3EpG;IAgCE,8B+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,4B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;E/E3EpG;IAgCE,8B+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,4B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;E/E3EpG;IAgCE,4B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;EARhG;IAUM,qBAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,2BAA+D;IAA/D,0BAA+D,EAAA;EAVrE;IAUM,iCAA+D;IAA/D,gCAA+D,EAAA;EAVrE;IAUM,gCAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,6BAA+D,EAAA;EAVrE;IAUM,gCAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,6BAA+D,EAAA;EAVrE;IAUM,yBAA+D;IAA/D,4BAA+D,EAAA;EAVrE;IAUM,+BAA+D;IAA/D,kCAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,iCAA+D,EAAA;EAVrE;IAUM,4BAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,iCAA+D,EAAA;EAVrE;IAUM,4BAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA;E/E7EzE;IAgCE,2B+E2CkG,EAAA;E/EnEpG;IA+BI,0B+EoCgG,EAAA;E/E3EpG;IAgCE,iC+E2CkG,EAAA;E/EnEpG;IA+BI,gC+EoCgG,EAAA;E/E3EpG;IAgCE,gC+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,8B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;E/E3EpG;IAgCE,gC+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,8B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;EARhG;IAUM,4BAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;E/E7EzE;IAgCE,0B+E2CkG,EAAA;E/EnEpG;IA+BI,2B+EoCgG,EAAA;E/E3EpG;IAgCE,gC+E2CkG,EAAA;E/EnEpG;IA+BI,iC+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,gC+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,8B+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,gC+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,8B+EoCgG,EAAA;EARhG;IAUM,iBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,sBAA+D,EAAA;EAVrE;IAUM,oBAA+D,EAAA;EAVrE;IAUM,sBAA+D,EAAA;EAVrE;IAUM,oBAA+D,EAAA;EAVrE;IAUM,qBAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;E/E7EzE;IAgCE,2B+E2CkG,EAAA;E/EnEpG;IA+BI,4B+EoCgG,EAAA;E/E3EpG;IAgCE,4B+E2CkG,EAAA;E/EnEpG;IA+BI,2B+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA,E/EjEnG;;ASmDD;ET7DA;IAgCE,sB+E2CkG,EAAA;E/EnEpG;IA+BI,uB+EoCgG,EAAA;E/E3EpG;IAgCE,uB+E2CkG,EAAA;E/EnEpG;IA+BI,sB+EoCgG,EAAA;E/E3EpG;IAgCE,sB+E2CkG,EAAA;E/EnEpG;IA+BI,sB+EoCgG,EAAA;EARhG;IAUM,8BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,sCAA+D,EAAA;EAVrE;IAUM,yCAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,sCAA+D,EAAA;EAVrE;IAUM,oCAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,yCAA+D,EAAA;EAVrE;IAUM,wCAA+D,EAAA;EAVrE;IAUM,wCAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,oCAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,uCAA+D,EAAA;EAVrE;IAUM,sCAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,oBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,oBAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,0BAA+D;IAA/D,yBAA+D,EAAA;EAVrE;IAUM,gCAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,+BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,4BAA+D,EAAA;EAVrE;IAUM,+BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,4BAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,4BAA+D,EAAA;EAVrE;IAUM,wBAA+D;IAA/D,2BAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,iCAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,gCAA+D,EAAA;EAVrE;IAUM,2BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,gCAA+D,EAAA;EAVrE;IAUM,2BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,2BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;E/E7EzE;IAgCE,0B+E2CkG,EAAA;E/EnEpG;IA+BI,yB+EoCgG,EAAA;E/E3EpG;IAgCE,gC+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,8B+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,4B+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,8B+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,4B+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,4B+EoCgG,EAAA;EARhG;IAUM,2BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;E/E7EzE;IAgCE,yB+E2CkG,EAAA;E/EnEpG;IA+BI,0B+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,gC+EoCgG,EAAA;E/E3EpG;IAgCE,8B+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,4B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;E/E3EpG;IAgCE,8B+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,4B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;E/E3EpG;IAgCE,4B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;EARhG;IAUM,qBAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,2BAA+D;IAA/D,0BAA+D,EAAA;EAVrE;IAUM,iCAA+D;IAA/D,gCAA+D,EAAA;EAVrE;IAUM,gCAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,6BAA+D,EAAA;EAVrE;IAUM,gCAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,6BAA+D,EAAA;EAVrE;IAUM,yBAA+D;IAA/D,4BAA+D,EAAA;EAVrE;IAUM,+BAA+D;IAA/D,kCAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,iCAA+D,EAAA;EAVrE;IAUM,4BAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,iCAA+D,EAAA;EAVrE;IAUM,4BAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA;E/E7EzE;IAgCE,2B+E2CkG,EAAA;E/EnEpG;IA+BI,0B+EoCgG,EAAA;E/E3EpG;IAgCE,iC+E2CkG,EAAA;E/EnEpG;IA+BI,gC+EoCgG,EAAA;E/E3EpG;IAgCE,gC+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,8B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;E/E3EpG;IAgCE,gC+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,8B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;EARhG;IAUM,4BAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;E/E7EzE;IAgCE,0B+E2CkG,EAAA;E/EnEpG;IA+BI,2B+EoCgG,EAAA;E/E3EpG;IAgCE,gC+E2CkG,EAAA;E/EnEpG;IA+BI,iC+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,gC+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,8B+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,gC+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,8B+EoCgG,EAAA;EARhG;IAUM,iBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,sBAA+D,EAAA;EAVrE;IAUM,oBAA+D,EAAA;EAVrE;IAUM,sBAA+D,EAAA;EAVrE;IAUM,oBAA+D,EAAA;EAVrE;IAUM,qBAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;E/E7EzE;IAgCE,2B+E2CkG,EAAA;E/EnEpG;IA+BI,4B+EoCgG,EAAA;E/E3EpG;IAgCE,4B+E2CkG,EAAA;E/EnEpG;IA+BI,2B+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA,E/EjEnG;;ASmDD;ET7DA;IAgCE,sB+E2CkG,EAAA;E/EnEpG;IA+BI,uB+EoCgG,EAAA;E/E3EpG;IAgCE,uB+E2CkG,EAAA;E/EnEpG;IA+BI,sB+EoCgG,EAAA;E/E3EpG;IAgCE,sB+E2CkG,EAAA;E/EnEpG;IA+BI,sB+EoCgG,EAAA;EARhG;IAUM,8BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,sCAA+D,EAAA;EAVrE;IAUM,yCAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,sCAA+D,EAAA;EAVrE;IAUM,oCAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,yCAA+D,EAAA;EAVrE;IAUM,wCAA+D,EAAA;EAVrE;IAUM,wCAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,oCAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,uCAA+D,EAAA;EAVrE;IAUM,sCAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,oBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,oBAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,0BAA+D;IAA/D,yBAA+D,EAAA;EAVrE;IAUM,gCAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,+BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,4BAA+D,EAAA;EAVrE;IAUM,+BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,4BAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,4BAA+D,EAAA;EAVrE;IAUM,wBAA+D;IAA/D,2BAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,iCAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,gCAA+D,EAAA;EAVrE;IAUM,2BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,gCAA+D,EAAA;EAVrE;IAUM,2BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,2BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;E/E7EzE;IAgCE,0B+E2CkG,EAAA;E/EnEpG;IA+BI,yB+EoCgG,EAAA;E/E3EpG;IAgCE,gC+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,8B+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,4B+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,8B+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,4B+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,4B+EoCgG,EAAA;EARhG;IAUM,2BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;E/E7EzE;IAgCE,yB+E2CkG,EAAA;E/EnEpG;IA+BI,0B+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,gC+EoCgG,EAAA;E/E3EpG;IAgCE,8B+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,4B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;E/E3EpG;IAgCE,8B+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,4B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;E/E3EpG;IAgCE,4B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;EARhG;IAUM,qBAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,2BAA+D;IAA/D,0BAA+D,EAAA;EAVrE;IAUM,iCAA+D;IAA/D,gCAA+D,EAAA;EAVrE;IAUM,gCAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,6BAA+D,EAAA;EAVrE;IAUM,gCAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,6BAA+D,EAAA;EAVrE;IAUM,yBAA+D;IAA/D,4BAA+D,EAAA;EAVrE;IAUM,+BAA+D;IAA/D,kCAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,iCAA+D,EAAA;EAVrE;IAUM,4BAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,iCAA+D,EAAA;EAVrE;IAUM,4BAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA;E/E7EzE;IAgCE,2B+E2CkG,EAAA;E/EnEpG;IA+BI,0B+EoCgG,EAAA;E/E3EpG;IAgCE,iC+E2CkG,EAAA;E/EnEpG;IA+BI,gC+EoCgG,EAAA;E/E3EpG;IAgCE,gC+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,8B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;E/E3EpG;IAgCE,gC+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,8B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;EARhG;IAUM,4BAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;E/E7EzE;IAgCE,0B+E2CkG,EAAA;E/EnEpG;IA+BI,2B+EoCgG,EAAA;E/E3EpG;IAgCE,gC+E2CkG,EAAA;E/EnEpG;IA+BI,iC+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,gC+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,8B+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,gC+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,8B+EoCgG,EAAA;EARhG;IAUM,iBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,sBAA+D,EAAA;EAVrE;IAUM,oBAA+D,EAAA;EAVrE;IAUM,sBAA+D,EAAA;EAVrE;IAUM,oBAA+D,EAAA;EAVrE;IAUM,qBAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;E/E7EzE;IAgCE,2B+E2CkG,EAAA;E/EnEpG;IA+BI,4B+EoCgG,EAAA;E/E3EpG;IAgCE,4B+E2CkG,EAAA;E/EnEpG;IA+BI,2B+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA,E/EjEnG;;ASmDD;ET7DA;IAgCE,sB+E2CkG,EAAA;E/EnEpG;IA+BI,uB+EoCgG,EAAA;E/E3EpG;IAgCE,uB+E2CkG,EAAA;E/EnEpG;IA+BI,sB+EoCgG,EAAA;E/E3EpG;IAgCE,sB+E2CkG,EAAA;E/EnEpG;IA+BI,sB+EoCgG,EAAA;EARhG;IAUM,8BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,sCAA+D,EAAA;EAVrE;IAUM,yCAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,sCAA+D,EAAA;EAVrE;IAUM,oCAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,yCAA+D,EAAA;EAVrE;IAUM,wCAA+D,EAAA;EAVrE;IAUM,wCAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,oCAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,uCAA+D,EAAA;EAVrE;IAUM,sCAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,oBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,oBAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,0BAA+D;IAA/D,yBAA+D,EAAA;EAVrE;IAUM,gCAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,+BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,4BAA+D,EAAA;EAVrE;IAUM,+BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,4BAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,4BAA+D,EAAA;EAVrE;IAUM,wBAA+D;IAA/D,2BAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,iCAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,gCAA+D,EAAA;EAVrE;IAUM,2BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,gCAA+D,EAAA;EAVrE;IAUM,2BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,2BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;E/E7EzE;IAgCE,0B+E2CkG,EAAA;E/EnEpG;IA+BI,yB+EoCgG,EAAA;E/E3EpG;IAgCE,gC+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,8B+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,4B+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,8B+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,4B+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,4B+EoCgG,EAAA;EARhG;IAUM,2BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;E/E7EzE;IAgCE,yB+E2CkG,EAAA;E/EnEpG;IA+BI,0B+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,gC+EoCgG,EAAA;E/E3EpG;IAgCE,8B+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,4B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;E/E3EpG;IAgCE,8B+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,4B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;E/E3EpG;IAgCE,4B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;EARhG;IAUM,qBAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,2BAA+D;IAA/D,0BAA+D,EAAA;EAVrE;IAUM,iCAA+D;IAA/D,gCAA+D,EAAA;EAVrE;IAUM,gCAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,6BAA+D,EAAA;EAVrE;IAUM,gCAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,6BAA+D,EAAA;EAVrE;IAUM,yBAA+D;IAA/D,4BAA+D,EAAA;EAVrE;IAUM,+BAA+D;IAA/D,kCAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,iCAA+D,EAAA;EAVrE;IAUM,4BAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,iCAA+D,EAAA;EAVrE;IAUM,4BAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA;E/E7EzE;IAgCE,2B+E2CkG,EAAA;E/EnEpG;IA+BI,0B+EoCgG,EAAA;E/E3EpG;IAgCE,iC+E2CkG,EAAA;E/EnEpG;IA+BI,gC+EoCgG,EAAA;E/E3EpG;IAgCE,gC+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,8B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;E/E3EpG;IAgCE,gC+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,8B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;EARhG;IAUM,4BAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;E/E7EzE;IAgCE,0B+E2CkG,EAAA;E/EnEpG;IA+BI,2B+EoCgG,EAAA;E/E3EpG;IAgCE,gC+E2CkG,EAAA;E/EnEpG;IA+BI,iC+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,gC+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,8B+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,gC+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,8B+EoCgG,EAAA;EARhG;IAUM,iBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,sBAA+D,EAAA;EAVrE;IAUM,oBAA+D,EAAA;EAVrE;IAUM,sBAA+D,EAAA;EAVrE;IAUM,oBAA+D,EAAA;EAVrE;IAUM,qBAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;E/E7EzE;IAgCE,2B+E2CkG,EAAA;E/EnEpG;IA+BI,4B+EoCgG,EAAA;E/E3EpG;IAgCE,4B+E2CkG,EAAA;E/EnEpG;IA+BI,2B+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA,E/EjEnG;;ASmDD;ET7DA;IAgCE,sB+E2CkG,EAAA;E/EnEpG;IA+BI,uB+EoCgG,EAAA;E/E3EpG;IAgCE,uB+E2CkG,EAAA;E/EnEpG;IA+BI,sB+EoCgG,EAAA;E/E3EpG;IAgCE,sB+E2CkG,EAAA;E/EnEpG;IA+BI,sB+EoCgG,EAAA;EARhG;IAUM,8BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,sCAA+D,EAAA;EAVrE;IAUM,yCAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,sCAA+D,EAAA;EAVrE;IAUM,oCAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,yCAA+D,EAAA;EAVrE;IAUM,wCAA+D,EAAA;EAVrE;IAUM,wCAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,oCAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,uCAA+D,EAAA;EAVrE;IAUM,sCAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,oBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,mBAA+D,EAAA;EAVrE;IAUM,oBAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,0BAA+D;IAA/D,yBAA+D,EAAA;EAVrE;IAUM,gCAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,+BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,4BAA+D,EAAA;EAVrE;IAUM,+BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,4BAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,4BAA+D,EAAA;EAVrE;IAUM,wBAA+D;IAA/D,2BAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,iCAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,gCAA+D,EAAA;EAVrE;IAUM,2BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D;IAA/D,gCAA+D,EAAA;EAVrE;IAUM,2BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,2BAA+D;IAA/D,8BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;E/E7EzE;IAgCE,0B+E2CkG,EAAA;E/EnEpG;IA+BI,yB+EoCgG,EAAA;E/E3EpG;IAgCE,gC+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,8B+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,4B+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,8B+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,4B+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,4B+EoCgG,EAAA;EARhG;IAUM,2BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;E/E7EzE;IAgCE,yB+E2CkG,EAAA;E/EnEpG;IA+BI,0B+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,gC+EoCgG,EAAA;E/E3EpG;IAgCE,8B+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,4B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;E/E3EpG;IAgCE,8B+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,4B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;E/E3EpG;IAgCE,4B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;EARhG;IAUM,qBAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,2BAA+D;IAA/D,0BAA+D,EAAA;EAVrE;IAUM,iCAA+D;IAA/D,gCAA+D,EAAA;EAVrE;IAUM,gCAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,6BAA+D,EAAA;EAVrE;IAUM,gCAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,6BAA+D,EAAA;EAVrE;IAUM,yBAA+D;IAA/D,4BAA+D,EAAA;EAVrE;IAUM,+BAA+D;IAA/D,kCAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,iCAA+D,EAAA;EAVrE;IAUM,4BAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D;IAA/D,iCAA+D,EAAA;EAVrE;IAUM,4BAA+D;IAA/D,+BAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA;E/E7EzE;IAgCE,2B+E2CkG,EAAA;E/EnEpG;IA+BI,0B+EoCgG,EAAA;E/E3EpG;IAgCE,iC+E2CkG,EAAA;E/EnEpG;IA+BI,gC+EoCgG,EAAA;E/E3EpG;IAgCE,gC+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,8B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;E/E3EpG;IAgCE,gC+E2CkG,EAAA;E/EnEpG;IA+BI,+B+EoCgG,EAAA;E/E3EpG;IAgCE,8B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA;EARhG;IAUM,4BAA+D,EAAA;EAVrE;IAUM,kCAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,iCAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;E/E7EzE;IAgCE,0B+E2CkG,EAAA;E/EnEpG;IA+BI,2B+EoCgG,EAAA;E/E3EpG;IAgCE,gC+E2CkG,EAAA;E/EnEpG;IA+BI,iC+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,gC+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,8B+EoCgG,EAAA;E/E3EpG;IAgCE,+B+E2CkG,EAAA;E/EnEpG;IA+BI,gC+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,8B+EoCgG,EAAA;EARhG;IAUM,iBAA+D,EAAA;EAVrE;IAUM,uBAA+D,EAAA;EAVrE;IAUM,sBAA+D,EAAA;EAVrE;IAUM,oBAA+D,EAAA;EAVrE;IAUM,sBAA+D,EAAA;EAVrE;IAUM,oBAA+D,EAAA;EAVrE;IAUM,qBAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,2BAA+D,EAAA;E/E7EzE;IAgCE,2B+E2CkG,EAAA;E/EnEpG;IA+BI,4B+EoCgG,EAAA;E/E3EpG;IAgCE,4B+E2CkG,EAAA;E/EnEpG;IA+BI,2B+EoCgG,EAAA;E/E3EpG;IAgCE,6B+E2CkG,EAAA;E/EnEpG;IA+BI,6B+EoCgG,EAAA,E/EjEnG;;AgFOL;EDkDQ;IAUM,4BAA+D,EAAA;EAVrE;IAUM,0BAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,4BAA+D,EAAA,EAGpE;;AC5CT;ED+BQ;IAUM,0BAA+D,EAAA;EAVrE;IAUM,gCAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,yBAA+D,EAAA;EAVrE;IAUM,6BAA+D,EAAA;EAVrE;IAUM,8BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA;EAVrE;IAUM,+BAA+D,EAAA;EAVrE;IAUM,wBAA+D,EAAA,EAGpE;;AElFT;;;;;;EvF2jXE;AwFzjXF;EACE,kBAAkB;EAClB,anF8sCsC;EmF7sCtC,uBAAuC;EACvC,WAAW;EACX,oBAAoB;EACpB,8BAA6B;EAC7B,UAAU;EjEON,0BiEN6B;EACjC,6BAA6B;EjFQ3B,uBFikBiC,EAAA;EkBhkB/B;IiElBN;MjEmBQ,gBAAgB,EAAA,EiERvB;;AAED;EACE,qBAA6B,EAAA;;AAG/B;EACE,mBnFqoBkD;EmFpoBlD,gBnF4oB+B,EAAA;;AmFzoBjC;EACE,mBAAmB;EACnB,mBnF+nBkD;EmF9nBlD,mBAAmB,EAAA;;AC3BrB;EACE,WAAW;EAEX,iBAAiB;ElEab,yBkEZ4B,EAAA;EnFF9B;IAgCE,emFhC+D;InFgC/D,gDmFhC+D,EAAA;EnFQjE;IA+BI,gBAxBE;IAwBF,iDAxBE,EAAA;EiBGJ;IkEpBN;MlEqBQ,gBAAgB,EAAA,EkEhBvB;;ACLD;EAEI,kBAAkB,EAAA;;AAFtB;EAMI,oCAAsC,EAAA;EAE9B;IACN,qDAAoD,EAAA;;AAT1D;;EAeI,6BAA6B,EAAA;;AAfjC;;EAoBI,uBAAuB,EAAA;;AApB3B;EAwBI,kBACF,EAAA;;AAzBF;;EA+BM,gBAAgB,EAAA;;AA/BtB;;EAoCQ,iBAAiB,EAAA;;AApCzB;;;;;;;;EA4CM,gBAAgB,EAAA;;AA5CtB;;EAgDM,gBAAgB;EAChB,cAAc,EAAA;;AAjDpB;;EAqDM,gBAAgB,EAAA;;AArDtB;;;;EA2DM,kBAAkB,EAAA;;AA3DxB;;;;EAiEM,sBAAsB,EAAA;;AAjE5B;;EAoEM,iBAAiB,EAAA;;AApEvB;;EAyEM,gBAAgB,EAAA;;AAzEtB;;EA6EM,eAAe,EAAA;;AA7ErB;;;;EAmFM,gBAAgB;EAChB,wBAAwB,EAAA;;AApF9B;;EAwFM,gBAAgB;EAChB,wBAAwB,EAAA;;A3E1B1B;E2E/DJ;;;;IA+FQ,4BAA4B,EAAA;EA/FpC;;IAkGQ,4BAA4B,EAAA,EAC7B;;AAnGP;;EAwGM,iBAAiB;EACjB,oBAAoB,EAAA;;AChG1B,kBAAA;AACA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,iBAAiB;EACjB,oCAAoC;EACpC,2CAAA;EACA,sBAAA;EACA,iBAAiB;EACjB,WAAW,EAAA;;AAEb;EACE,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,WAAW,EAAA;;AAGb;EACE,kBAAkB;EAClB,WAAW,EAAA;;AAGb;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,YAAY,EAAA;;AAGd;EACE,qBAAqB;EACrB,uBAAwC,EAAA;;AAG1C;EACE,yBAAwB,EAAA;;AAG1B;EACE,yBAAwB,EAAA;;AAG1B;EACE,gCAAgC;EAChC,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB,EAAA;;AAG3B;EACE,4BAA4B;EAC5B,yBAAyB,EAAA;;AAG3B;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,6BAA6B,EAAA;;AAG/B;EACE,2BAA2B,EAAA;;AAG7B;EACE,cArEmB,EAAA;;AAwErB;EACI,UAAU,EAAA;;AAGZ;EACE,sBAAsB,EAAA;;AAGxB;EACE,sBAAsB;EACtB,uBAAuB,EAAA;;AAGzB;EACE,4BAA4B,EAAA;;AAG9B;EACE,4BAA4B,EAAA;;AAG9B;EACE,4BAA4B,EAAA;;AAG9B;EACE,4BAA4B,EAAA;;AAG9B;EACE,4BAA4B,EAAA;;AtB3GhC;EsB+GI,yBAAyB;EACzB,uBAAuB;EAEvB,+BAA+B;EAC/B,uEAAuE;EACvE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB,EAAA;;AAGvB;EACE,sBAAsB;EACtB,uBAAuB,EAAA;;AvB7HzB;EuBiIE,qCAAoB,EAAA;;AAIpB;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;EAC7B,2DAA6F;EAC7F,8BAA8B;EAC9B,uBAAuB,EAAA;;AAKzB;EACE,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;EAC7B,2DAA2D;EAC3D,8BAA8B;EAC9B,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,yBAAyB;EACzB,2BAA2B,EAAA;;A5DnK/B;E4DwKI,2BAA2B;EAC3B,qBAAqB;EACrB,sBAAsB,EAAA;;AAGxB;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,sBAAsB,EAAA;;AAfxB;EAmBE,yBAAyB;EACzB,2BAA2B,EAAA;;AAI7B;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,wBAAwB;EACxB,iCAAiC;EACjC,4BAA4B,EAAA;;AAI9B;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,6BAA6B,EAAA;;AAG/B;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB,EAAA;;AAIrB;EACE,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;;AAIrB;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EAGzB,iBAAiB;EACjB,oBAAoB;EACpB,wCAAqC;EACrC,yBAAoC;EACpC,4BAA4B,EAAA;;AAGhC;EACE,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EAGzB,iBAAiB;EACjB,oBAAoB;EACpB,wCAAqC;EACrC,yBAAiC;EACjC,4BAA4B,EAAA;;AAG9B;EACE,kBAAkB;EAClB,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EAGzB,iBAAiB;EACjB,oBAAoB;EACpB,wCAAqC;EACrC,yBAAiC;EACjC,4BAA4B,EAAA;;AAI5B;EACE,UAAU;EACV,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B,EAAA;;AAG5B;EACE,WAAW;EACX,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B,EAAA;;AAG5B;EACE,UAAU;EACV,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B,EAAA;;AAG5B;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,qBAAqB;EACrB,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B,EAAA;;AAG7B;EACC,yBAAwB,EAAA;;AAGzB;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,UAAU,EAAA;;AAGZ;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B,EAAA;;AAX5B;EAeE,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,UAAU,EAAA;;AAGZ;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAA;;AAGf;EACE,yBAAoC;EACpC,0BAA0B;EAC1B,6BAA6B;EAC7B,kCAAkC,EAAA;;AAGpC;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,qBAAqB;EACrB,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B,EAAA;;AAM7B;EACE,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,iBAAgB,EAAA;;AASlB;EACE,yBAAyB,EAAA;;AAE7B;EACI,yBAAyB,EAAA;;AAE7B;EACI,yBAAyB,EAAA;;AAE7B;EACI,yBAAyB,EAAA;;AAE7B;EACI,yBAAyB,EAAA;;AAE3B;EACE,cAAc;EACd,4BAA4B,EAAA;;AAG9B;;EAEI,etF0P4B;EsFzP5B,gBtF+P2B;EsF9P3B,cA5BgC;EA6BhC,kBAAkB,EAAA;EALtB;;IAQQ,eA9B2B,EAAA;;ApDjRrC;EoDoTI,cAAc;EACd,6BArCsC;EAsCtC,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe,EAAA;EALjB;IAQM,cAAc,EAAA;EARpB;IAYM,eAAe;IACf,kBAAkB,EAAA;;AAIxB;EAEM,sBAAsB,EAAA;EAF5B;IAKU,iBAAiB;IACjB,iBAAiB,EAAA;IAN3B;MASc,gBAAgB,EAAA;;AAT9B;EAcM,2BAA2B,EAAA;;AAdjC;EAiBM,cAAc;EACd,gBAAgB,EAAA;EAlBtB;IAqBU,gBAAgB;IAChB,iBAAiB,EAAA;;AAtB3B;EA6BM,sBAAsB,EAAA;EA7B5B;IAgCU,iBAAiB;IACjB,iBAAiB,EAAA;IAjC3B;MAoCc,gBAAgB,EAAA;;AApC9B;EAyCM,2BAA2B,EAAA;;AAzCjC;EA+CM,cAAc;EACd,gBAAgB,EAAA;EAhDtB;IAmDU,gBAAgB;IAChB,iBAAiB,EAAA;;AAK7B;EACE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY,EAAA;;AAKZ;EApJA;IAsJI,yBAAoC;IACpC,4BAA4B;IAC5B,6BAA6B;IAC7B,kCAAkC,EAAA;EArLtC;IAyLI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B,EAAA;EAjXhC;IAqXM,oCAAoC;IACpC,iCAAiC;IACjC,6BAA6B;IAC7B,2DAA2D;IAC3D,8BAA8B;IAC9B,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB,EAAA;E5DlhBzB;I4DshBQ,2BAA2B;IAC3B,oBAAoB;IACpB,qBAAqB,EAAA;EAGvB;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,6BAA6B,EAAA;EAzUnC;IA6UM,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB,EAAA;EAlUzB;IAsUM,uBAAuB;IACvB,mBAAmB,EAAA;EA7QzB;IAiRM,UAAU;IACV,8BAA6B;IAC7B,6BAA6B;IAC7B,0BAA0B,EAAA;EAxMhC;IA4MM,6BAA6B;IAC7B,kCAAkC;IAClC,sBAAsB;IACtB,8BAA8B;IAC9B,6BAA6B;IAC7B,0BAA0B,EAAA,EAC3B;;AAML;EAEE,WAAW;EACX,YAAY,EAAA;;AAId;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,0CAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,0CAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,0CAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;EAC7B,2DAA6F;EAC7F,8BAA8B;EAC9B,uBAAuB,EAAA;;AAGzB;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;EAC7B,2DAA6F;EAC7F,8BAA8B;EAC9B,uBAAuB,EAAA;;AAGzB;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;EAC7B,2DAA6F;EAC7F,8BAA8B;EAC9B,uBAAuB,EAAA;;AAGzB;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;EAC7B,2DAA6F;EAC7F,8BAA8B;EAC9B,uBAAuB,EAAA;;AAGzB;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;EAC7B,2DAA6F;EAC7F,8BAA8B;EAC9B,YAAY,EAAA;;AAvjBd;EA2jBE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;EAC7B,2DAA6F;EAC7F,8BAA8B;EAC9B,uBAAuB,EAAA;;AAGzB;EACE,sBAAsB,EAAA;;AAGxB;EACE,sBAAsB,EAAA;;AAGxB;EAEE,aAAa;EACb,eAAe;EAEf,iBAAiB;EACjB,eAAe;EACf,0CAAuC,EAAA;;AAGzC;EAEE,YAAY;EACZ,eAAe;EAEf,iBAAiB;EACjB,eAAe;EACf,0CAAuC,EAAA;;AArHzC;EAyHE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB,EAAA;;AArJrB;EAyJE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,0CAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB,EAAA;;AArJrB;EAyJE,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,0CAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,4BAA4B,EAAA;;AAG9B;EACE,0BAA0B,EAAA;;AAG5B;EACE,yBAA8B;EAC9B,4BAA4B,EAAA;;AAE9B;EACE,yBAA6B;EAC7B,4BAA4B,EAAA;;AAG9B;EACE,yBAA8B;EAC9B,0BAA0B,EAAA;;AAG5B;EACE,yBAA8B;EAC9B,4BAA4B,EAAA;;AAG9B;EACE,yBAA6B;EAC7B,0BAA0B,EAAA;;AAG5B;EACE,yBAAyB,EAAA;;AAjX3B;EAuXI,sBAAsB,EAAA;EAvX1B;IA0XQ,iBAAiB;IACjB,iBAAiB,EAAA;IA3XzB;MA8XY,gBAAgB,EAAA;;AA9X5B;EAmYI,2BAA2B,EAAA;;AAnY/B;EAwYI,cAAc;EACd,gBAAgB,EAAA;EAzYpB;IA4YQ,gBAAgB;IAChB,iBAAiB,EAAA;;AAO3B;EACE,eAAe,EAAA;;AAGjB;EACC,YAAY;EACZ,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,WAAW,EAAA;;AAGZ;EACE,0CAAuC;EACvC,yBAAoC,EAAA;;AAGtC;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,0CAAuC;EACvC,mBAAmB,EAAA;;AAGrB;EACE,eAAe;EACf,qBAAqB,EAAA;;AAGvB;;EAEE,UAAU;EACV,cAAc,EAAA;;AAIhB;EACE,uCAAuC,EAAA;;AAGzC;EACE,sCAAsC,EAAA;;AAGxC;EAEE,0BAA0B,EAAA;;AAOxB;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iBAAiB,EAAA;;AAGnB;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,yBAAyB;EACzB,6BAA6B,EAAA;;AAG/B;EACE,oCAAoC,EAAA;;AAGtC;EACE,yBAA8B,EAAA;;AAGhC;EACE,oCAAoC;EACpC,kBAAkB;EAClB,2DAA6F;EAC7F,qBAAqB;EACrB,mBAAmB,EAAA;;AAIrB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,qCACwB,EAAA;;AAG1B;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,kCAAkC,EAAA;;AAGpC;EAEE,iCAAiC;EACjC,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB,EAAA;;AAI1B;EACE,aAAa;EACb,uBAAuB;EAEvB,gBAAgB,EAAA;EAJlB;IAOI,qBAAqB;IACrB,aAAa;IACb,sBAAsB,EAAA;IAT1B;MAaM,cA98BU,EAAA;IAi8BhB;MAiBM,iCAAiC;MACjC,YAAY;MACZ,kBAAkB;MAClB,oBAAoB;MACpB,aAAa;MACb,YAAY;MACZ,kBAAkB;MAClB,iBAAiB;MACjB,eAAe;MACf,iBAAiB,EAAA;IA1BvB;MA8BM,cAAc,EAAA;IA9BpB;MAmCQ,yBAn+BQ;MAo+BR,6BAA6B;MAC7B,WAAW,EAAA;IArCnB;MAyCQ,cAz+BQ,EAAA;;AA++BhB;EACE,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;EAC7B,2DAA2D;EAC3D,8BAA8B;EAC9B,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB,EAAA;;AAInB;EACE,4BAA4B,EAAA;;AAG9B;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,wBAAwB;EACxB,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B,EAAA;;AAO9B;EACE,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;EAC7B,2DAA6F;EAC7F,6BAA6B;EAC7B,uBAAuB,EAAA;;AAIzB;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,kCAAkC,EAAA;;AAGpC;EACE,WAAW;EACX,YAAY;EACZ,OAAO,EAAA;;AAIT;EACE,WAAW;EACX,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,WAAW;EACX,YAAY;EACZ,OAAO,EAAA;;AAGT;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;EAC7B,2DAA6F;EAC7F,8BAA8B,EAAA;;AAIhC;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;EAC7B,2DAA6F;EAC7F,8BAA8B,EAAA;;AAIhC;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4BAA4B;EAC5B,4BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,0CAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB,EAAA;;AAGlB;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,4BAA4B;EAC5B,4BAA2B;EAC3B,qBAAqB;EACrB,kBAAkB,EAAA;;AAGpB;EAAW,mBAAmB;EAAE,yBAAyB,EAAA;;AACzD;EAAY,mBAAmB;EAAE,yBAAyB,EAAA;;AAC1D;EAAQ,mBAAmB;EAAE,yBAAyB,EAAA;;AACtD;EAAQ,mBAAmB;EAAE,yBAAyB,EAAA;;AAAI;EAAW,mBAAmB;EAAE,yBAAyB,EAAA;;AAOnH;EAEU,aAAa,EAAA;;AAFvB;EAKU,SAAS;EACT,iBAAiB,EAAA;;AAN3B;EASU,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB,EAAA;;AAX3B;EAcU,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB,EAAA;EAlB7B;IAqBc,qBAAqB,EAAA;;AArBnC;EAyBU,iBAAiB;EACjB,eAAe,EAAA;;AA1BzB;EA6BU,iBAAiB,EAAA;;AAIzB;;EAGQ,sBAAsB,EAAA;;AAH9B;;EAMQ,gBAAgB,EAAA;;AAIxB;EACI,WAAW;EACX,YAAY;EAEZ,eAAe,EAAA;;AAGjB;EACE,WAAW;EACX,YAAY;EACZ,eAAe,EAAA;;AAKf;EAAqB,WAAW,EAAA;;AACtC;EACE,iCAAiC,EAAA;;AAEnC;EACE,wDAAwD;EACxD,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,SAAS;EACT,WAAW,EAAA;;AAGb;EACE,wDAAwD;EACxD,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EAEZ,mBAAmB;EACnB,iCAAiC;EACjC,SAAS;EACT,WAAW,EAAA;;AAGb;EACE,wDAAwD;EACxD,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,SAAS;EACT,WAAW,EAAA;;AAGb;EACE,wDAAwD;EACxD,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,SAAS;EACT,WAAW,EAAA;;AAGb;EACE,wDAAwD;EACxD,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,QAAQ;EACR,WAAW,EAAA;;AAGb;EACE,4BAA4B;EAC5B,yBACF,EAAA;;AAEA;EACE,4BAA4B;EAC5B,yBACF,EAAA;;AAEA;EACE,4BAA4B;EAC5B,yBACF,EAAA;;AAEA;EACE,4BAA4B;EAC5B,yBACF,EAAA;;AAGA;EACE,SAAS;EACT,eAAe,EAAA;;AAGnB;EACE,uBAAuB;EACvB,uBAAuB,EAAA;;AAGvB;EA3tCF;IA6tCM,4BAA4B,EAAA;EAlShC;IAsSI,wBAAwB;IACxB,4BAA4B;IAC5B,kCAAkC,EAAA;EAtrCxC;IA0rCM,oCAAoC;IACpC,iCAAiC;IACjC,6BAA6B;IAC7B,2DAA2D;IAC3D,8BAA8B;IAC9B,wBAAwB;IACxB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB,EAAA;EApgCvB;IAwgCM,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,UAAU,EAAA;EA5/BhB;IAggCM,yBAAoC;IACpC,4BAA4B;IAC5B,6BAA6B;IAC7B,kCAAkC,EAAA;EA/hCxC;IAmiCM,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B,EAAA;EA5ahC;IAgbI,aAAa;IACb,uBAAuB;IAEvB,gBAAgB,EAAA;IAnbpB;MAsbM,qBAAqB;MACrB,aAAa;MACb,sBAAsB,EAAA;MAxb5B;QA4bQ,cA73CQ,EAAA;MAi8BhB;QAgcQ,iCAAiC;QACjC,YAAY;QACZ,kBAAkB;QAClB,oBAAoB;QACpB,aAAa;QACb,cAAc;QACd,kBAAkB;QAClB,iBAAiB;QACjB,eAAe;QACf,iBAAiB,EAAA;MAzczB;QA6cQ,cAAc,EAAA;MA7ctB;QAkdU,yBAl5CM;QAm5CN,6BAA6B;QAC7B,WAAW,EAAA;MApdrB;QAwdU,cAx5CM,EAAA;EAgyChB;IA+HI,4BAA4B;IAC5B,yBACF,EAAA;EAvHF;IA0HI,4BAA4B;IAC5B,yBACF,EAAA;EAvHF;IA0HI,4BAA4B;IAC5B,yBACF,EAAA;EAjHJ;IAqHM,uBAAuB;IACvB,uBAAuB,EAAA;EAvkC7B;IA2kCM,6BAA6B;IAC7B,kCAAkC;IAClC,sBAAsB;IACtB,8BAA8B;IAC9B,6BAA6B;IAC7B,0BAA0B,EAAA;EArpChC;IAypCM,sBAAsB;IACtB,8BAA8B;IAC9B,6BAA6B;IAC7B,0BAA0B,EAAA;EArpChC;IAypCM,WAAW;IACX,8BAA8B;IAC9B,6BAA6B;IAC7B,0BAA0B,EAAA;EAl1BhC;IAq1BM,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;IACpC,iCAAiC;IACjC,6BAA6B;IAC7B,2DAA6F;IAC7F,8BAA8B;IAC9B,uBAAuB,EAAA;EAj1B7B;IAq1BM,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;IACpC,iCAAiC;IACjC,6BAA6B;IAC7B,2DAA6F;IAC7F,8BAA8B;IAC9B,uBAAuB,EAAA;EAj1B7B;IAq1BM,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;IACpC,iCAAiC;IACjC,6BAA6B;IAC7B,2DAA6F;IAC7F,8BAA8B;IAC9B,uBAAuB,EAAA;EAx4C7B;IA64CM,4BAA4B,EAAA,EAC7B","sourcesContent":["\n@import \"variables\";\n\n$enable-ltr: true;\n$enable-rtl: true;\n\n// Import CoreUI for React components library\n@import \"@coreui/coreui/scss/coreui\";\n\n// Import Chart.js custom tooltips styles\n@import \"@coreui/chartjs/scss/coreui-chartjs\";\n\n@import \"layout\";\n@import \"example\";\n\n// If you want to add custom CSS you can put it here.\n@import \"custom\";\n","@mixin bsBanner($file) {\n  /*!\n   * CoreUI #{$file} v4.3.0 (https://coreui.io)\n   * Copyright (c) 2023 creativeLabs Łukasz Holeczek\n   * Licensed under MIT (https://github.com/coreui/coreui/blob/main/LICENSE)\n   */\n}\n",":root {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}high-emphasis: #{$text-high-emphasis};\n  --#{$prefix}medium-emphasis: #{$text-medium-emphasis};\n  --#{$prefix}disabled: #{$text-disabled};\n\n  --#{$prefix}high-emphasis-inverse: #{$text-high-emphasis-inverse};\n  --#{$prefix}medium-emphasis-inverse: #{$text-medium-emphasis-inverse};\n  --#{$prefix}disabled-inverse: #{$text-disabled-inverse};\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.0.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\n// ol,\n// ul {\n//   @include ltr-rtl(\"padding-left\", 2rem); // TODO: find solution\n// }\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  @include ltr-rtl(\"margin-left\", 0); // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}pre-color, $pre-color);\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: var(--#{$prefix}kbd-color, $kbd-color);\n  background-color: var(--#{$prefix}kbd-bg, $kbd-bg);\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: var(--#{$prefix}table-caption-color, $table-caption-color);\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  @include ltr-rtl(\"float\", left); // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n\n*[dir=\"rtl\"] {\n  [type=\"tel\"],\n  [type=\"url\"],\n  [type=\"email\"],\n  [type=\"number\"] {\n    direction: ltr;\n  }\n}\n\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:     #fff !default;\n$gray-base: #3c4b64 !default;\n$gray-100:  #ebedef !default;\n$gray-200:  #d8dbe0 !default;\n$gray-300:  #c4c9d0 !default;\n$gray-400:  #b1b7c1 !default;\n$gray-500:  #9da5b1 !default;\n$gray-600:  #8a93a2 !default;\n$gray-700:  #768192 !default;\n$gray-800:  #636f83 !default;\n$gray-900:  #4f5d73 !default;\n$black:     #000015 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n$high-emphasis:            rgba(shift-color($gray-base, +26%), .95) !default;\n$medium-emphasis:          rgba(shift-color($gray-base, +26%), .681) !default;\n$disabled:                 rgba(shift-color($gray-base, +26%), .38) !default;\n\n$high-emphasis-inverse:    rgba($white, .87) !default;\n$medium-emphasis-inverse:  rgba($white, .6) !default;\n$disabled-inverse:         rgba($white, .38) !default;\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// fusv-disable\n$primary-dark:  #1f1498 !default;\n$primary-base:  #321fdb !default;\n$primary-50:    #988fed !default;\n$primary-25:    #ccc7f6 !default;\n\n$secondary-dark:  #212233 !default;\n$secondary-base:  #9da5b1 !default;\n$secondary-50:    #9da5b1 !default;\n$secondary-25:    #ced2d8 !default;\n\n$success-dark:  #1b9e3e !default;\n$success-base:  #2eb85c !default;\n$success-50:    #96dbad !default;\n$success-25:    #cbedd6 !default;\n\n$info-dark:  #2982cc !default;\n$info-base:  #39f !default;\n$info-50:    #80c6ff !default;\n$info-25:    #c0e6ff !default;\n\n$warning-dark:  #f6960b !default;\n$warning-base:  #f9b115 !default;\n$warning-50:    #fcd88a !default;\n$warning-25:    #feecc5 !default;\n\n$danger-dark:  #d93737 !default;\n$danger-base:  #e55353 !default;\n$danger-50:    #f2a9a9 !default;\n$danger-25:    #f9d4d4 !default;\n\n$light-dark:     $gray-100 !default;\n$light-base:     $gray-100 !default;\n$light-50:       shift-color($light-base, -70%) !default;\n$light-25:       shift-color($light-base, -80%) !default;\n\n$dark-dark:      $gray-900 !default;\n$dark-base:      $gray-900 !default;\n$dark-50:        shift-color($dark-base, -70%) !default;\n$dark-25:        shift-color($dark-base, -80%) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $primary-base !default;\n$secondary:     $secondary-base !default;\n$success:       $success-base !default;\n$info:          $info-base !default;\n$warning:       $warning-base !default;\n$danger:        $danger-base !default;\n$light:         $light-base !default;\n$dark:          $dark-base !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-colors-rgb\n$theme-colors-rgb: map-loop($theme-colors, to-rgb, \"$value\") !default;\n// scss-docs-end theme-colors-rgb\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $high-emphasis-inverse !default;\n$color-contrast-light:     $high-emphasis !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n$enable-ltr:                  true !default;\n$enable-rtl:                  false !default;\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             cui- !default; // Deprecated in v4.3.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Set mobile breakpoint\n\n$mobile-breakpoint:           md !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $high-emphasis !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      $medium-emphasis !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       $disabled !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n\n$border-style:                solid !default;\n$border-color:                $gray-200 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.0.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $high-emphasis-inverse !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:                $font-size-base * 1.25 !default;\n$lead-font-weight:              300 !default;\n\n$small-font-size:               .875em !default;\n\n$sub-sup-font-size:             .75em !default;\n\n$text-high-emphasis:            $high-emphasis !default;\n$text-medium-emphasis:          $medium-emphasis !default;\n$text-disabled:                 $disabled !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 4.3.0\n// fusv-enable\n\n$text-high-emphasis-inverse:    $high-emphasis-inverse !default;\n$text-medium-emphasis-inverse:  $medium-emphasis-inverse !default;\n$text-disabled-inverse:         $disabled-inverse !default;\n\n$initialism-font-size:          $small-font-size !default;\n\n$blockquote-margin-y:           $spacer !default;\n$blockquote-font-size:          $font-size-base * 1.25 !default;\n$blockquote-footer-color:       $gray-600 !default;\n$blockquote-footer-font-size:   $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v4.2.6\n$hr-height:                   null !default; // Deprecated in v4.2.6\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n// Icons\n$icon-size-base:  1rem !default;\n$icon-size-sm:    $icon-size-base * .875 !default;\n$icon-size-lg:    $icon-size-base * 1.25 !default;\n$icon-size-xl:    $icon-size-base * 1.5 !default;\n$icon-size-xxl:   $icon-size-base * 2 !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}body-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba($black, $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba($black, $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba($black, $table-hover-bg-factor) !default;\n\n$table-border-factor:         .1 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n\n// scss-docs-start button-variants\n$button-variants: (\n  \"primary\": btn-color-map($primary, $primary),\n  \"secondary\": btn-color-map($secondary, $secondary),\n  \"success\": btn-color-map($success, $success),\n  \"danger\": btn-color-map($danger, $danger),\n  \"warning\": btn-color-map($warning, $warning),\n  \"info\": btn-color-map($info, $info),\n  \"light\": btn-color-map($light, $light),\n  \"dark\": btn-color-map($dark, $dark)\n) !default;\n\n$button-outline-ghost-variants: (\n  \"primary\": btn-outline-color-map($primary),\n  \"secondary\": btn-outline-color-map($secondary),\n  \"success\": btn-outline-color-map($success),\n  \"danger\": btn-outline-color-map($danger),\n  \"warning\": btn-outline-color-map($warning),\n  \"info\": btn-outline-color-map($info),\n  \"light\": btn-outline-color-map($light),\n  \"dark\": btn-outline-color-map($dark)\n) !default;\n// scss-docs-end button-variants\n// scss-docs-end btn-variables\n\n\n// Forms\n// scss-docs-start form-variables\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      $box-shadow-inset !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n\n$form-switch-widths: (\n  lg: (\n    width: 1.75em,\n    height: 1.25em\n  ),\n  xl: (\n    width: 2em,\n    height: 1.5em\n  )\n) !default;\n// scss-docs-end form-switch-variables\n\n$form-check-inline-margin-end:    1rem !default;\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          $box-shadow-inset !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     $box-shadow-inset !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n// scss-docs-end form-variables\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-sidebar-backdrop:           1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               $box-shadow !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v4.2.6\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $high-emphasis-inverse !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              tint-color($component-active-bg, 90%) !default;\n$accordion-button-active-color:           shade-color($primary, 10%) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $accordion-button-color !default;\n$accordion-icon-active-color:             $accordion-button-active-color !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 4.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                $box-shadow !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in 4.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $high-emphasis-inverse !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n$badge-font-size-sm:                .65em !default;\n$badge-padding-y-sm:                .3em !default;\n$badge-padding-x-sm:                .5em !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       $box-shadow-sm !default;\n$modal-content-box-shadow-sm-up:    $box-shadow !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Avatars\n// scss-docs-start avatar-variables\n$avatar-width:  2rem !default;\n\n$avatar-widths: (\n  sm: 1.5rem,\n  md: 2.5rem,\n  lg: 3rem,\n  xl: 4rem\n) !default;\n\n$avatar-transition: margin .15s !default;\n// scss-docs-end avatar-variables\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-bg-scale:                -80% !default;\n$alert-border-scale:            -70% !default;\n$alert-color-scale:             40% !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// scss-docs-start alert-variants\n$alert-variants: () !default;\n@each $state, $value in $theme-colors {\n  $map: ();\n  $alert-variants: map-merge($alert-variants, map-merge($map, ($state: alert-color-map($value))));\n}\n\n// Callouts\n// scss-docs-start callout-variables\n$callout-padding-y:                 $spacer !default;\n$callout-padding-x:                 $spacer !default;\n$callout-margin-y:                  $spacer !default;\n$callout-margin-x:                  0 !default;\n$callout-border-radius:             var(--#{$prefix}border-radius) !default;\n$callout-border-width:              var(--#{$prefix}border-width) !default;\n$callout-border-color:              var(--#{$prefix}border-color) !default;\n$callout-border-left-width:         calc($callout-border-width * 4) !default; // stylelint-disable-line function-disallowed-list\n\n$callout-variants: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"danger\":     $danger,\n  \"warning\":    $warning,\n  \"info\":       $info,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end callout-variables\n\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $high-emphasis-inverse !default;\n$progress-bar-bg:                   var(--#{$prefix}primary) !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n$progress-group-margin-bottom:         $spacer !default;\n$progress-group-header-margin-bottom:  $spacer * .25 !default;\n// scss-docs-end progress-variables\n\n// List group\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n$list-group-item-bg-scale:          -80% !default;\n$list-group-item-color-scale:       40% !default;\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n$list-group-variants: (\n  \"primary\": list-group-color-map($primary),\n  \"secondary\": list-group-color-map($secondary),\n  \"success\": list-group-color-map($success),\n  \"danger\": list-group-color-map($danger),\n  \"warning\": list-group-color-map($warning),\n  \"info\": list-group-color-map($info),\n  \"light\": list-group-color-map($light),\n  \"dark\": list-group-color-map($dark)\n) !default;\n// scss-docs-end list-group-variables\n\n\n// Header\n// scss-docs-start header-variables\n$header-min-height:             4rem !default;\n$header-padding-y:              $spacer * .5 !default;\n$header-padding-x:              $spacer * .5 !default;\n$header-brand-font-size:        $font-size-lg !default;\n$header-color:                  rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$header-bg:                     var(--#{$prefix}body-bg) !default;\n$header-border-color:           var(--#{$prefix}border-color) !default;\n$header-border-width:           var(--#{$prefix}border-width) !default;\n$header-hover-color:            rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$header-active-color:           rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$header-disabled-color:         rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n\n// Compute the header-brand padding-y so the header-brand will have the same height as header-text and nav-link\n$nav-link-height:               $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$header-brand-height:           $header-brand-font-size * $line-height-base !default;\n$header-brand-padding-y:        ($nav-link-height - $header-brand-height) * .5 !default;\n$header-brand-margin-end:       1rem !default;\n$header-brand-font-size:        $font-size-lg !default;\n$header-brand-color:            $gray-900 !default;\n$header-brand-hover-color:      shade-color($gray-900, 10%) !default;\n\n$header-toggler-padding-y:      .25rem !default;\n$header-toggler-padding-x:      .75rem !default;\n$header-toggler-font-size:      $font-size-lg !default;\n$header-toggler-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$header-toggler-bg:             transparent !default;\n$header-toggler-border-radius:  $btn-border-radius !default;\n$header-toggler-hover-color:    rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n\n$header-toggler-icon-color:        currentColor !default; // stylelint-disable-line value-keyword-case\n$header-toggler-icon-bg:           url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-toggler-icon-color}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\") !default;\n$header-toggler-hover-icon-color:  currentColor !default; // stylelint-disable-line value-keyword-case\n$header-toggler-hover-icon-bg:     url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-toggler-hover-icon-color}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\") !default;\n\n$header-nav-link-padding-x:     .5rem !default;\n$header-nav-link-padding-y:     .5rem !default;\n\n$header-divider-border-width:   var(--#{$prefix}border-width) !default;\n$header-divider-border-color:   var(--#{$prefix}border-color) !default;\n// scss-docs-end header-variables\n\n// Subheader\n// scss-docs-start subheader-variables\n$subheader-min-height:           3rem !default;\n$subheader-padding-y:            $spacer * .5 !default;\n$subheader-padding-x:            $spacer !default;\n$subheader-border-color:         var(--#{$prefix}border-color) !default;\n$subheader-border-width:         var(--#{$prefix}border-width) !default;\n\n$subheader-nav-link-padding-x:  .5rem !default;\n// scss-docs-end subheader-variables\n\n// Default theme\n// scss-docs-start subheader-default-themes\n$subheader-bg:                     $white !default;\n$subheader-color:                  var(--#{$prefix}secondary-color) !default;\n$subheader-hover-color:            var(--#{$prefix}body-color) !default;\n$subheader-active-color:           var(--#{$prefix}body-color) !default;\n$subheader-disabled-color:         $disabled !default;\n// scss-docs-end subheader-default-themes\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n// scss-docs-start carousel-variables\n$carousel-control-color:             $high-emphasis-inverse !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $high-emphasis-inverse !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $high-emphasis !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n// scss-docs-start sidebar-variables\n$sidebar-width:                            16rem !default;\n$sidebar-widths: (\n  sm: 12rem,\n  lg: 20rem,\n  xl: 24rem\n) !default;\n$sidebar-padding-y:                        0 !default;\n$sidebar-padding-x:                        0 !default;\n$sidebar-color:                            $high-emphasis-inverse !default;\n$sidebar-bg:                               $gray-base !default;\n$sidebar-border-width:                     0 !default;\n$sidebar-border-color:                     transparent !default;\n$sidebar-transition:                       margin-left .15s, margin-right .15s, box-shadow .075s, transform .15s, width .15s, z-index 0s ease .15s !default;\n\n$sidebar-brand-height:                     4rem !default;\n$sidebar-brand-color:                      $high-emphasis-inverse !default;\n$sidebar-brand-bg:                         rgba($black, .2) !default;\n\n$sidebar-header-height:                    4rem !default;\n$sidebar-header-padding-y:                 .75rem !default;\n$sidebar-header-padding-x:                 1rem !default;\n$sidebar-header-bg:                        rgba($black, .2) !default;\n$sidebar-header-height-transition:         height .15s, padding .15s !default;\n\n$sidebar-narrow-width:                     4rem !default;\n\n$sidebar-backdrop-bg:                      $black !default;\n$sidebar-backdrop-opacity:                 .5 !default;\n\n$sidebar-nav-title-padding-y:              .75rem !default;\n$sidebar-nav-title-padding-x:              1rem !default;\n$sidebar-nav-title-margin-top:             1rem !default;\n$sidebar-nav-title-color:                  $medium-emphasis-inverse !default;\n$sidebar-nav-title-transition:             height .15s, margin .15s !default;\n\n$sidebar-nav-link-padding-y:               .8445rem !default;\n$sidebar-nav-link-padding-x:               1rem !default;\n$sidebar-nav-link-color:                   $medium-emphasis-inverse !default;\n$sidebar-nav-link-bg:                      transparent !default;\n$sidebar-nav-link-border-width:            0 !default;\n$sidebar-nav-link-border-color:            transparent !default;\n$sidebar-nav-link-border-radius:           0 !default;\n$sidebar-nav-link-transition:              background .15s ease, color .15s ease !default;\n$sidebar-nav-link-icon-color:              $medium-emphasis-inverse !default;\n\n$sidebar-nav-link-hover-color:             $high-emphasis-inverse !default;\n$sidebar-nav-link-hover-bg:                rgba($white, .05) !default;\n$sidebar-nav-link-hover-icon-color:        $high-emphasis-inverse !default;\n\n$sidebar-nav-link-active-color:            $high-emphasis-inverse !default;\n$sidebar-nav-link-active-bg:               rgba($white, .05) !default;\n$sidebar-nav-link-active-icon-color:       $high-emphasis-inverse !default;\n\n$sidebar-nav-link-disabled-color:          $disabled-inverse !default;\n$sidebar-nav-link-disabled-icon-color:     $sidebar-nav-link-icon-color !default;\n\n$sidebar-nav-icon-width:                   4rem !default;\n$sidebar-nav-icon-height:                  1.25rem !default;\n$sidebar-nav-icon-font-size:               $sidebar-nav-icon-height !default;\n\n$sidebar-nav-group-bg:                     rgba(0, 0, 0, .2) !default;\n$sidebar-nav-group-transition:             background .15s ease-in-out !default;\n$sidebar-nav-group-toggle-show-color:      $sidebar-nav-link-color !default;\n\n$sidebar-nav-group-items-padding-y:        0 !default;\n$sidebar-nav-group-items-padding-x:        0 !default;\n$sidebar-nav-group-items-transition:       height .15s ease !default;\n\n$sidebar-nav-group-indicator-color:        $medium-emphasis-inverse !default;\n$sidebar-nav-group-indicator-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$sidebar-nav-group-indicator-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$sidebar-nav-group-indicator-hover-color:  $sidebar-nav-link-hover-color !default;\n$sidebar-nav-group-indicator-hover-icon:   url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$sidebar-nav-group-indicator-hover-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$sidebar-nav-group-indicator-transition:   transform .15s !default;\n\n$sidebar-footer-height:                    auto !default;\n$sidebar-footer-padding-y:                 .75rem !default;\n$sidebar-footer-padding-x:                 1rem !default;\n$sidebar-footer-bg:                        rgba($black, .2) !default;\n$sidebar-footer-height-transition:         height .15s, padding .15s !default;\n\n$sidebar-toggler-height:                   3rem !default;\n$sidebar-toggler-bg:                       rgba($black, .2) !default;\n$sidebar-toggler-transition:               transform .15s !default;\n\n$sidebar-toggler-indicator-width:          4rem !default;\n$sidebar-toggler-indicator-height:         3rem !default;\n$sidebar-toggler-indicator-color:          $disabled-inverse !default;\n$sidebar-toggler-indicator-icon:           url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-toggler-indicator-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\") !default;\n$sidebar-toggler-hover-bg:                 rgba(0, 0, 0, .3) !default;\n$sidebar-toggler-indicator-hover-color:    $sidebar-nav-link-hover-color !default;\n$sidebar-toggler-indicator-hover-icon:     url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-toggler-indicator-hover-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\") !default;\n// scss-docs-end sidebar-variables\n\n// Footer\n// scss-docs-start footer-variables\n$footer-min-height:    3rem !default;\n$footer-padding-y:     $spacer * .5 !default;\n$footer-padding-x:     $spacer !default;\n$footer-bg:            var(--#{$prefix}tertiary-bg) !default;\n$footer-color:         var(--#{$prefix}body-color) !default;\n$footer-border-width:  var(--#{$prefix}border-width) !default;\n$footer-border-color:  var(--#{$prefix}border-color) !default;\n// scss-docs-end footer-variables\n\n// Spinners\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $high-emphasis !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v4.2.6, removing in v6\n\n$pre-color:                         null !default;\n","@mixin ltr {\n  @if $enable-ltr {\n    html:not([dir=\"rtl\"]) & {\n      @content;\n    }\n  }\n}\n\n@mixin rtl {\n  @if $enable-rtl {\n    *[dir=\"rtl\"] & {\n      @content;\n    }\n  }\n}\n\n@function reflect($element) {\n  $string: #{$element};\n  @if str-index($string, \"left\") {\n    @return str-replace($string, \"left\", \"right\");\n  }\n  @if str-index($string, \"right\") {\n    @return str-replace($string, \"right\", \"left\");\n  }\n\n  @return unquote($string);\n}\n\n@mixin ltr-rtl($property, $value, $property-rtl: null, $value-rtl: null, $important: null) {\n  $property-reflected: reflect($property);\n  $value-reflected: reflect($value);\n\n  @if $enable-ltr and $enable-rtl {\n    @include ltr() {\n      #{$property}: $value $important;\n    }\n    @include rtl() {\n      @if $value-rtl {\n        #{$property-reflected}: $value-rtl $important;\n      }\n      @else {\n        #{$property-reflected}: $value-reflected $important;\n      }\n    }\n  }\n  @else {\n    @if $enable-rtl {\n      @if $value-rtl {\n        #{$property-reflected}: $value-rtl $important;\n      }\n      @else {\n        #{$property-reflected}: $value-reflected $important;\n      }\n    }\n    @else {\n      #{$property}: $value $important;\n    }\n  }\n}\n\n@mixin ltr-rtl-value-only($property, $value, $value-rtl: null, $important: null) {\n  $value-reflected: reflect($value);\n\n  @if $enable-ltr and $enable-rtl {\n    @include ltr() {\n      #{$property}: $value $important;\n    }\n    @include rtl() {\n      @if $value-rtl {\n        #{$property}: $value-rtl $important;\n      } @else {\n        #{$property}: $value-reflected $important;\n      }\n    }\n  }\n  @else {\n    @if $enable-rtl {\n      @if $value-rtl {\n        #{$property}: $value-rtl $important;\n      } @else {\n        #{$property}: $value-reflected $important;\n      }\n    } @else {\n      #{$property}: $value $important;\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-top-right-radius\", valid-radius($radius));\n    @include ltr-rtl(\"border-bottom-right-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-top-left-radius\", valid-radius($radius));\n    @include ltr-rtl(\"border-bottom-left-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-top-right-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-bottom-right-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-bottom-left-radius\", valid-radius($radius));\n  }\n}\n// scss-docs-end border-radius-mixins\n","// Bootstrap functions\n//\n// Utility mixins and functions for evaluating source code across our variables, maps, and mixins.\n\n// Ascending\n// Used to evaluate Sass maps like our grid breakpoints.\n@mixin _assert-ascending($map, $map-name) {\n  $prev-key: null;\n  $prev-num: null;\n  @each $key, $num in $map {\n    @if $prev-num == null or unit($num) == \"%\" or unit($prev-num) == \"%\" {\n      // Do nothing\n    } @else if not comparable($prev-num, $num) {\n      @warn \"Potentially invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} whose unit makes it incomparable to #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\n    } @else if $prev-num >= $num {\n      @warn \"Invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} which isn't greater than #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\n    }\n    $prev-key: $key;\n    $prev-num: $num;\n  }\n}\n\n// Starts at zero\n// Used to ensure the min-width of the lowest breakpoint starts at 0.\n@mixin _assert-starts-at-zero($map, $map-name: \"$grid-breakpoints\") {\n  @if length($map) > 0 {\n    $values: map-values($map);\n    $first-value: nth($values, 1);\n    @if $first-value != 0 {\n      @warn \"First breakpoint in #{$map-name} must start at 0, but starts at #{$first-value}.\";\n    }\n  }\n}\n\n// Colors\n@function to-rgb($value) {\n  @return red($value), green($value), blue($value);\n}\n\n// stylelint-disable scss/dollar-variable-pattern\n@function rgba-css-var($identifier, $target) {\n  @if $identifier == \"body\" and $target == \"bg\" {\n    @return rgba(var(--#{$prefix}#{$identifier}-bg-rgb), var(--#{$prefix}#{$target}-opacity));\n  } @if $identifier == \"body\" and $target == \"text\" {\n    @return rgba(var(--#{$prefix}#{$identifier}-color-rgb), var(--#{$prefix}#{$target}-opacity));\n  } @else {\n    @return rgba(var(--#{$prefix}#{$identifier}-rgb), var(--#{$prefix}#{$target}-opacity));\n  }\n}\n\n@function map-loop($map, $func, $args...) {\n  $_map: ();\n\n  @each $key, $value in $map {\n    // allow to pass the $key and $value of the map as an function argument\n    $_args: ();\n    @each $arg in $args {\n      $_args: append($_args, if($arg == \"$key\", $key, if($arg == \"$value\", $value, $arg)));\n    }\n\n    $_map: map-merge($_map, ($key: call(get-function($func), $_args...)));\n  }\n\n  @return $_map;\n}\n// stylelint-enable scss/dollar-variable-pattern\n\n@function varify($list) {\n  $result: null;\n  @each $entry in $list {\n    $result: append($result, var(--#{$prefix}#{$entry}), space);\n  }\n  @return $result;\n}\n\n// Internal Bootstrap function to turn maps into its negative variant.\n// It prefixes the keys with `n` and makes the value negative.\n@function negativify-map($map) {\n  $result: ();\n  @each $key, $value in $map {\n    @if $key != 0 {\n      $result: map-merge($result, (\"n\" + $key: (-$value)));\n    }\n  }\n  @return $result;\n}\n\n// Get multiple keys from a sass map\n@function map-get-multiple($map, $values) {\n  $result: ();\n  @each $key, $value in $map {\n    @if (index($values, $key) != null) {\n      $result: map-merge($result, ($key: $value));\n    }\n  }\n  @return $result;\n}\n\n// Merge multiple maps\n@function map-merge-multiple($maps...) {\n  $merged-maps: ();\n\n  @each $map in $maps {\n    $merged-maps: map-merge($merged-maps, $map);\n  }\n  @return $merged-maps;\n}\n\n// Replace `$search` with `$replace` in `$string`\n// Used on our SVG icon backgrounds for custom forms.\n//\n// @author Kitty Giraudel\n// @param {String} $string - Initial string\n// @param {String} $search - Substring to replace\n// @param {String} $replace ('') - New value\n// @return {String} - Updated string\n@function str-replace($string, $search, $replace: \"\") {\n  $index: str-index($string, $search);\n\n  @if $index {\n    @return str-slice($string, 1, $index - 1) + $replace + str-replace(str-slice($string, $index + str-length($search)), $search, $replace);\n  }\n\n  @return $string;\n}\n\n// See https://codepen.io/kevinweber/pen/dXWoRw\n//\n// Requires the use of quotes around data URIs.\n\n@function escape-svg($string) {\n  @if str-index($string, \"data:image/svg+xml\") {\n    @each $char, $encoded in $escaped-characters {\n      // Do not escape the url brackets\n      @if str-index($string, \"url(\") == 1 {\n        $string: url(\"#{str-replace(str-slice($string, 6, -3), $char, $encoded)}\");\n      } @else {\n        $string: str-replace($string, $char, $encoded);\n      }\n    }\n  }\n\n  @return $string;\n}\n\n// Color contrast\n// See https://github.com/twbs/bootstrap/pull/30168\n\n// A list of pre-calculated numbers of pow(divide((divide($value, 255) + .055), 1.055), 2.4). (from 0 to 255)\n// stylelint-disable-next-line scss/dollar-variable-default, scss/dollar-variable-pattern\n$_luminance-list: .0008 .001 .0011 .0013 .0015 .0017 .002 .0022 .0025 .0027 .003 .0033 .0037 .004 .0044 .0048 .0052 .0056 .006 .0065 .007 .0075 .008 .0086 .0091 .0097 .0103 .011 .0116 .0123 .013 .0137 .0144 .0152 .016 .0168 .0176 .0185 .0194 .0203 .0212 .0222 .0232 .0242 .0252 .0262 .0273 .0284 .0296 .0307 .0319 .0331 .0343 .0356 .0369 .0382 .0395 .0409 .0423 .0437 .0452 .0467 .0482 .0497 .0513 .0529 .0545 .0561 .0578 .0595 .0612 .063 .0648 .0666 .0685 .0704 .0723 .0742 .0762 .0782 .0802 .0823 .0844 .0865 .0887 .0908 .0931 .0953 .0976 .0999 .1022 .1046 .107 .1095 .1119 .1144 .117 .1195 .1221 .1248 .1274 .1301 .1329 .1356 .1384 .1413 .1441 .147 .15 .1529 .1559 .159 .162 .1651 .1683 .1714 .1746 .1779 .1812 .1845 .1878 .1912 .1946 .1981 .2016 .2051 .2086 .2122 .2159 .2195 .2232 .227 .2307 .2346 .2384 .2423 .2462 .2502 .2542 .2582 .2623 .2664 .2705 .2747 .2789 .2831 .2874 .2918 .2961 .3005 .305 .3095 .314 .3185 .3231 .3278 .3325 .3372 .3419 .3467 .3515 .3564 .3613 .3663 .3712 .3763 .3813 .3864 .3916 .3968 .402 .4072 .4125 .4179 .4233 .4287 .4342 .4397 .4452 .4508 .4564 .4621 .4678 .4735 .4793 .4851 .491 .4969 .5029 .5089 .5149 .521 .5271 .5333 .5395 .5457 .552 .5583 .5647 .5711 .5776 .5841 .5906 .5972 .6038 .6105 .6172 .624 .6308 .6376 .6445 .6514 .6584 .6654 .6724 .6795 .6867 .6939 .7011 .7084 .7157 .7231 .7305 .7379 .7454 .7529 .7605 .7682 .7758 .7835 .7913 .7991 .807 .8148 .8228 .8308 .8388 .8469 .855 .8632 .8714 .8796 .8879 .8963 .9047 .9131 .9216 .9301 .9387 .9473 .956 .9647 .9734 .9823 .9911 1;\n\n@function color-contrast($background, $color-contrast-dark: $color-contrast-dark, $color-contrast-light: $color-contrast-light, $min-contrast-ratio: $min-contrast-ratio) {\n  $foregrounds: $color-contrast-light, $color-contrast-dark, $white, $black;\n  $max-ratio: 0;\n  $max-ratio-color: null;\n\n  @each $color in $foregrounds {\n    $contrast-ratio: contrast-ratio($background, $color);\n    @if $contrast-ratio > $min-contrast-ratio {\n      @return $color;\n    } @else if $contrast-ratio > $max-ratio {\n      $max-ratio: $contrast-ratio;\n      $max-ratio-color: $color;\n    }\n  }\n\n  @warn \"Found no color leading to #{$min-contrast-ratio}:1 contrast ratio against #{$background}...\";\n\n  @return $max-ratio-color;\n}\n\n@function contrast-ratio($background, $foreground: $color-contrast-light) {\n  $l1: luminance($background);\n  $l2: luminance(opaque($background, $foreground));\n\n  @return if($l1 > $l2, divide($l1 + .05, $l2 + .05), divide($l2 + .05, $l1 + .05));\n}\n\n// Return WCAG2.1 relative luminance\n// See https://www.w3.org/TR/WCAG/#dfn-relative-luminance\n// See https://www.w3.org/TR/WCAG/#dfn-contrast-ratio\n@function luminance($color) {\n  $rgb: (\n    \"r\": red($color),\n    \"g\": green($color),\n    \"b\": blue($color)\n  );\n\n  @each $name, $value in $rgb {\n    $value: if(divide($value, 255) < .03928, divide(divide($value, 255), 12.92), nth($_luminance-list, $value + 1));\n    $rgb: map-merge($rgb, ($name: $value));\n  }\n\n  @return (map-get($rgb, \"r\") * .2126) + (map-get($rgb, \"g\") * .7152) + (map-get($rgb, \"b\") * .0722);\n}\n\n// Return opaque color\n// opaque(#fff, rgba(0, 0, 0, .5)) => #808080\n@function opaque($background, $foreground) {\n  @return mix(rgba($foreground, 1), $background, opacity($foreground) * 100%);\n}\n\n// scss-docs-start color-functions\n// Tint a color: mix a color with white\n@function tint-color($color, $weight) {\n  @return mix(white, $color, $weight);\n}\n\n// Shade a color: mix a color with black\n@function shade-color($color, $weight) {\n  @return mix(black, $color, $weight);\n}\n\n// Shade the color if the weight is positive, else tint it\n@function shift-color($color, $weight) {\n  @return if($weight > 0, shade-color($color, $weight), tint-color($color, -$weight));\n}\n// scss-docs-end color-functions\n\n// scss-docs-start alert-color-functions\n@function alert-color-map($color) {\n  @return (\n    \"alert-bg\": shift-color($color, $alert-bg-scale),\n    \"alert-border\": shift-color($color, $alert-border-scale),\n    \"alert-color\": shift-color($color, $alert-color-scale),\n    \"base-color\": $color\n  );\n}\n// scss-docs-end alert-color-functions\n\n// scss-docs-start button-color-functions\n@function btn-color($color, $shade, $tint) {\n  @return if(color-contrast($color) == $color-contrast-light, shade-color($color, $shade), tint-color($color, $tint));\n}\n\n@function btn-color-map($background, $border-color) {\n  @return (\n    \"bg\": $background,\n    \"border-color\": $border-color,\n    \"color\": color-contrast($background),\n    \"hover-bg\": btn-color($background, $btn-hover-bg-shade-amount, $btn-hover-bg-tint-amount),\n    \"hover-border-color\": btn-color($border-color, $btn-hover-border-shade-amount, $btn-hover-border-tint-amount),\n    \"hover-color\": color-contrast(btn-color($background, $btn-hover-bg-shade-amount, $btn-hover-bg-tint-amount)),\n    \"active-bg\": btn-color($background, $btn-active-bg-shade-amount, $btn-active-bg-tint-amount),\n    \"active-border-color\": btn-color($border-color, $btn-active-border-shade-amount, $btn-active-border-tint-amount),\n    \"active-color\": color-contrast(btn-color($border-color, $btn-active-border-shade-amount, $btn-active-border-tint-amount)),\n    \"disabled-bg\": $background,\n    \"disabled-border-color\": $border-color,\n    \"disabled-color\": color-contrast($background),\n    \"shadow\": rgba(mix($background, $border-color, 15%), .5)\n  );\n}\n\n@function btn-outline-color-map($background) {\n  @return (\n    \"color\": $background,\n    \"hover-bg\": btn-color($background, $btn-hover-bg-shade-amount, $btn-hover-bg-tint-amount),\n    \"hover-border-color\": btn-color($background, $btn-hover-border-shade-amount, $btn-hover-border-tint-amount),\n    \"hover-color\": color-contrast(btn-color($background, $btn-hover-bg-shade-amount, $btn-hover-bg-tint-amount)),\n    \"active-bg\": btn-color($background, $btn-active-bg-shade-amount, $btn-active-bg-tint-amount),\n    \"active-border-color\": btn-color($background, $btn-active-border-shade-amount, $btn-active-border-tint-amount),\n    \"active-color\": color-contrast(btn-color($background, $btn-active-border-shade-amount, $btn-active-border-tint-amount)),\n    \"disabled-color\": $background,\n    \"shadow\": rgba(mix($background, $background, 15%), .5)\n  );\n}\n// scss-docs-end button-color-functions\n\n// scss-docs-start list-group-color-functions\n@function list-group-color-map($color) {\n  @return (\n    \"bg\": shift-color($color, $list-group-item-bg-scale),\n    \"bg-hover\": shade-color($color, 10%),\n    \"color\": shift-color($color, $list-group-item-color-scale)\n  );\n}\n// scss-docs-end list-group-color-functions\n\n// scss-docs-start table-color-functions\n@function table-color-map($background, $body-bg: $body-bg) {\n  $color: color-contrast(opaque($body-bg, $background));\n  $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n  $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n  $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n\n  @return (\n    \"bg\": $background,\n    \"color\": $color,\n    \"border-color\": mix($color, $background, percentage($table-border-factor)),\n    \"striped-bg\": $striped-bg,\n    \"striped-color\": color-contrast($striped-bg),\n    \"active-bg\": $active-bg,\n    \"active-color\": color-contrast($active-bg),\n    \"hover-bg\": $hover-bg,\n    \"hover-color\": color-contrast($hover-bg)\n  );\n}\n// scss-docs-end table-color-functions\n\n// Return valid calc\n@function add($value1, $value2, $return-calc: true) {\n  @if $value1 == null {\n    @return $value2;\n  }\n\n  @if $value2 == null {\n    @return $value1;\n  }\n\n  @if type-of($value1) == number and type-of($value2) == number and comparable($value1, $value2) {\n    @return $value1 + $value2;\n  }\n\n  @return if($return-calc == true, calc(#{$value1} + #{$value2}), $value1 + unquote(\" + \") + $value2);\n}\n\n@function subtract($value1, $value2, $return-calc: true) {\n  @if $value1 == null and $value2 == null {\n    @return null;\n  }\n\n  @if $value1 == null {\n    @return -$value2;\n  }\n\n  @if $value2 == null {\n    @return $value1;\n  }\n\n  @if type-of($value1) == number and type-of($value2) == number and comparable($value1, $value2) {\n    @return $value1 - $value2;\n  }\n\n  @if type-of($value2) != number {\n    $value2: unquote(\"(\") + $value2 + unquote(\")\");\n  }\n\n  @return if($return-calc == true, calc(#{$value1} - #{$value2}), $value1 + unquote(\" - \") + $value2);\n}\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    @include ltr-rtl(\"margin-right\", $list-inline-padding);\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  @include ltr-rtl(\"padding-left\", 0);\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: var(--#{$prefix}thumbnail-bg, $thumbnail-bg);\n  border: $thumbnail-border-width solid var(--#{$prefix}thumbnail-border-color, $thumbnail-border-color);\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: var(--#{$prefix}figure-caption-color, $figure-caption-color);\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n\n  --#{$prefix}mobile-breakpoint: #{$mobile-breakpoint};\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  @include ltr-rtl(\"margin-left\", if($num == 0, 0, percentage($num)));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: divide(100%, $count);\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: var(--#{$prefix}form-label-color, $form-label-color);\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: var(--#{$prefix}form-label-color, $form-label-color);\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: var(--#{$prefix}form-text-color, $form-text-color);\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: var(--#{$prefix}input-color, $input-color);\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: var(--#{$prefix}input-bg, $input-bg);\n  background-clip: padding-box;\n  border: $input-border-width solid var(--#{$prefix}input-border-color, $input-border-color);\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: var(--#{$prefix}input-focus-color, $input-focus-color);\n    background-color: var(--#{$prefix}input-focus-bg, $input-focus-bg);\n    border-color: var(--#{$prefix}input-focus-border-color, $input-focus-border-color);\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  // Add some height to date inputs on iOS\n  // https://github.com/twbs/bootstrap/issues/23307\n  // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: var(--#{$prefix}input-placeholder-color, $input-placeholder-color);\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: var(--#{$prefix}form-file-button-color, $form-file-button-color);\n    @include gradient-bg(var(--#{$prefix}form-file-button-bg, $form-file-button-bg));\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: var(--#{$prefix}form-file-button-hover-bg, $form-file-button-hover-bg);\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: var(--#{$prefix}input-plaintext-color, $input-plaintext-color);\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  @include ltr-rtl-value-only(\"padding\", $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x, $form-select-padding-y $form-select-padding-x $form-select-padding-y $form-select-indicator-padding);\n  -moz-padding-start: subtract($form-select-padding-x, 3px); // See https://github.com/twbs/bootstrap/issues/32636\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: var(--#{$prefix}form-select-color, $form-select-color);\n  appearance: none;\n  background-color: var(--#{$prefix}form-select-bg, $form-select-bg);\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  @include ltr-rtl-value-only(\"background-position\", $form-select-bg-position);\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid var(--#{$prefix}form-select-border-color, $form-select-border-color);\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: var(--#{$prefix}form-select-focus-border-color, $form-select-focus-border-color);\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    @include ltr-rtl(\"padding-right\", $form-select-padding-x);\n    background-image: none;\n  }\n\n  &:disabled {\n    color: var(--#{$prefix}form-select-disabled-color, $form-select-disabled-color);\n    background-color: var(--#{$prefix}form-select-disabled-bg, $form-select-disabled-bg);\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 var(--#{$prefix}form-select-color, $form-select-color);\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  @include ltr-rtl(\"padding-left\", $form-select-padding-x-sm);\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  @include ltr-rtl(\"padding-left\", $form-select-padding-x-lg);\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  @include ltr-rtl(\"padding-left\", $form-check-padding-start);\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    @include ltr-rtl(\"float\", left);\n    @include ltr-rtl(\"margin-left\", $form-check-padding-start * -1);\n  }\n}\n\n.form-check-reverse {\n  @include ltr-rtl(\"padding-right\", $form-check-padding-start);\n  @include ltr-rtl(\"padding-left\", 0);\n  @include ltr-rtl(\"text-align\", right);\n\n  .form-check-input {\n    @include ltr-rtl(\"float\", right);\n    @include ltr-rtl(\"margin-right\", $form-check-padding-start * -1);\n    @include ltr-rtl(\"margin-left\", 0);\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: var(--#{$prefix}form-check-input-checked-bg-color, $form-check-input-checked-bg-color);\n    border-color: var(--#{$prefix}form-check-input-checked-border-color, $form-check-input-checked-border-color);\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: var(--#{$prefix}form-check-label-color, $form-check-label-color);\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  @include ltr-rtl(\"padding-left\", $form-switch-padding-start);\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    @include ltr-rtl(\"margin-left\", $form-switch-padding-start * -1);\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    @include ltr-rtl(\"padding-right\", $form-check-padding-start);\n    @include ltr-rtl(\"padding-left\", 0);\n\n    .form-check-input {\n      @include ltr-rtl(\"margin-right\", $form-check-padding-start * -1);\n      @include ltr-rtl(\"margin-left\", 0);\n    }\n  }\n}\n\n@each $size, $map in $form-switch-widths {\n  $width: map-get($map, \"width\");\n  $height: map-get($map, \"height\");\n\n  .form-switch-#{$size} {\n    min-height: $height;\n    @include ltr-rtl(\"padding-left\", $width + .5em);\n\n    .form-check-input {\n      width: $width;\n      height: $height;\n      @include ltr-rtl(\"margin-left\", ($width + .5em) * -1);\n    }\n\n    .form-check-label {\n      // stylelint-disable-next-line function-disallowed-list\n      padding-top: calc((#{$height} - #{$font-size-base}) / 2);\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  @include ltr-rtl(\"margin-right\", $form-check-inline-margin-end);\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg(var(--#{$prefix}form-range-thumb-bg, $form-range-thumb-bg));\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg(var(--#{$prefix}form-range-thumb-active-bg, $form-range-thumb-active-bg));\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: var(--#{$prefix}form-range-track-bg, $form-range-track-bg);\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg(var(--#{$prefix}form-range-thumb-bg, $form-range-thumb-bg));\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg(var(--#{$prefix}form-range-thumb-active-bg, $form-range-thumb-active-bg));\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: var(--#{$prefix}form-range-track-bg, $form-range-track-bg);\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: var(--#{$prefix}form-range-thumb-disabled-bg, $form-range-thumb-disabled-bg);\n    }\n\n    &::-moz-range-thumb {\n      background-color: var(--#{$prefix}form-range-thumb-disabled-bg, $form-range-thumb-disabled-bg);\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    @include ltr-rtl(\"left\", 0);\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: var(--#{$prefix}input-group-addon-color, $input-group-addon-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}input-group-addon-bg, $input-group-addon-bg);\n  border: $input-border-width solid var(--#{$prefix}input-group-addon-border-color, $input-group-addon-border-color);\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  @include ltr-rtl(\"padding-right\", $form-select-padding-x + $form-select-indicator-padding);\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    @include ltr-rtl(\"margin-left\", calc(#{$input-border-width} * -1));\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        @include ltr-rtl(\"padding-right\", $input-height-inner);\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        @include ltr-rtl-value-only(\"background-position\", right $input-height-inner-quarter center, left $input-height-inner-quarter center);\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        @include ltr-rtl(\"padding-right\", $input-height-inner);\n        @include ltr-rtl-value-only(\"background-position\", top $input-height-inner-quarter right $input-height-inner-quarter, top $input-height-inner-quarter left $input-height-inner-quarter);\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          @include ltr-rtl(\"padding-right\", $form-select-feedback-icon-padding-end);\n          @include ltr-rtl-value-only(\"background-position\", #{$form-select-bg-position, $form-select-feedback-icon-position});\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      @include ltr-rtl(\"margin-left\", .5em);\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n.btn-transparent {\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-hover-border-color: transparent;\n}\n\n// scss-docs-start btn-variant-loops\n@each $state, $variant in $button-variants {\n  .btn-#{$state} {\n    @include button-variant($variant);\n  }\n}\n\n@each $state, $variant in $button-outline-ghost-variants {\n  .btn-outline-#{$state} {\n    @include button-outline-variant($variant);\n  }\n}\n\n@each $state, $variant in $button-outline-ghost-variants {\n  .btn-ghost-#{$state} {\n    @include button-ghost-variant($variant);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: none;\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix(color-contrast($primary), $primary, 15%))};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant($variant) {\n  $background: map-get($variant, \"bg\");\n  $border-color: map-get($variant, \"border-color\");\n  $color: map-get($variant, \"color\");\n  $hover-background: map-get($variant, \"hover-bg\");\n  $hover-border-color: map-get($variant, \"hover-border-color\");\n  $hover-color: map-get($variant, \"hover-color\");\n  $active-background: map-get($variant, \"active-bg\");\n  $active-border-color: map-get($variant, \"active-border-color\");\n  $active-color: map-get($variant, \"active-color\");\n  $disabled-background: map-get($variant, \"disabled-bg\");\n  $disabled-border-color: map-get($variant, \"disabled-border-color\");\n  $disabled-color: map-get($variant, \"disabled-color\");\n  $shadow: map-get($variant, \"shadow\");\n\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border-color};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border-color};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border-color, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border-color};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border-color};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant($variant) {\n  $color: map-get($variant, \"color\");\n  $hover-background: map-get($variant, \"hover-bg\");\n  $hover-border-color: map-get($variant, \"hover-border-color\");\n  $hover-color: map-get($variant, \"hover-color\");\n  $active-background: map-get($variant, \"active-bg\");\n  $active-border-color: map-get($variant, \"active-border-color\");\n  $active-color: map-get($variant, \"active-color\");\n  $disabled-color: map-get($variant, \"disabled-color\");\n  $shadow: map-get($variant, \"shadow\");\n\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border-color};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border-color};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-ghost-variant-mixin\n@mixin button-ghost-variant($variant) {\n  $color: map-get($variant, \"color\");\n  $hover-background: map-get($variant, \"hover-bg\");\n  $hover-border-color: map-get($variant, \"hover-border-color\");\n  $hover-color: map-get($variant, \"hover-color\");\n  $active-background: map-get($variant, \"active-bg\");\n  $active-border-color: map-get($variant, \"active-border-color\");\n  $active-color: map-get($variant, \"active-color\");\n  $disabled-color: map-get($variant, \"disabled-color\");\n  $shadow: map-get($variant, \"shadow\");\n\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border-color};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border-color};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-shadow: #{$shadow};\n}\n// scss-docs-end btn-ghost-variant-mixin\n\n// Button sizes\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-coreui-popper] {\n    top: 100%;\n    @include ltr-rtl(\"left\", 0);\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `cui-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --cui-position: start;\n\n      &[data-coreui-popper] {\n        @include ltr-rtl(\"right\", auto);\n        @include ltr-rtl(\"left\", 0);\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --cui-position: end;\n\n      &[data-coreui-popper] {\n        @include ltr-rtl(\"right\", 0);\n        @include ltr-rtl(\"left\", auto);\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-coreui-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-coreui-popper] {\n    top: 0;\n    @include ltr-rtl(\"right\", auto);\n    @include ltr-rtl(\"left\", 100%);\n    margin-top: 0;\n    @include ltr-rtl(\"margin-left\", var(--#{$prefix}dropdown-spacer));\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-coreui-popper] {\n    top: 0;\n    @include ltr-rtl(\"right\", 100%);\n    @include ltr-rtl(\"left\", auto);\n    margin-top: 0;\n    @include ltr-rtl(\"margin-right\", var(--#{$prefix}dropdown-spacer));\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      @include ltr-rtl(\"margin-left\", $spacing);\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        @include ltr-rtl(\"margin-right\", $spacing);\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      @include ltr-rtl(\"margin-left\", 0);\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    @include ltr-rtl(\"margin-left\", calc(#{$btn-border-width} * -1));\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    @include ltr-rtl(\"margin-left\", 0);\n  }\n\n  .dropstart &::before {\n    @include ltr-rtl(\"margin-right\", 0);\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  @include ltr-rtl(\"padding-left\", 0);\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  @include ltr-rtl(\"margin-right\", var(--#{$prefix}navbar-brand-margin-end));\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  @include ltr-rtl(\"padding-left\", 0);\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v4.3.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    @include ltr-rtl(\"margin-left\", var(--#{$prefix}card-spacer-x));\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        @include ltr-rtl(\"margin-left\", 0);\n        @include ltr-rtl(\"border-left\", 0);\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    @include ltr-rtl(\"padding-left\",  var(--#{$prefix}breadcrumb-item-padding-x));\n\n    &::before {\n      @include ltr-rtl(\"float\", left); // Suppress inline spacings and underlining of the separator\n      @include ltr-rtl(\"padding-right\", var(--#{$prefix}breadcrumb-item-padding-x));\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      @include ltr-rtl(\n        \"content\",\n        var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)),\n        null,\n        var(--#{$prefix}breadcrumb-divider-flipped, escape-svg($breadcrumb-divider-flipped))\n      );\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    @include ltr-rtl(\"margin-left\", $pagination-margin-start);\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--#{$prefix}badge-border-radius, 0); // stylelint-disable-line property-disallowed-list\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n//\n// Badge Sizes\n//\n\n.badge-sm {\n  --#{$prefix}badge-padding-x: #{$badge-padding-x-sm};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y-sm};\n  @include font-size($badge-font-size-sm);\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  @include ltr-rtl(\"padding-right\", $alert-dismissible-padding-r);\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    @include ltr-rtl(\"right\", 0);\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert.\n@each $state, $value in $alert-variants {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: #{map-get($value, \"alert-color\")};\n    --#{$prefix}alert-bg: #{map-get($value, \"alert-bg\")};\n    --#{$prefix}alert-border-color: #{map-get($value, \"alert-border\")};\n    --#{$prefix}alert-link-color: #{shade-color(map-get($value, \"alert-color\"), 20%)};\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n\n.progress-thin {\n  height: 4px;\n}\n\n// White progress bar\n.progress.progress-white {\n  background-color: rgba(255, 255, 255, .2);\n  .progress-bar {\n    background-color: $white;\n  }\n}\n\n.progress-group {\n  display: flex;\n  flex-flow: row wrap;\n  margin-bottom: $progress-group-margin-bottom;\n}\n\n.progress-group-prepend {\n  flex: 0 0 100px;\n  align-self: center;\n}\n\n.progress-group-header {\n  display: flex;\n  flex-basis: 100%;\n  align-items: center;\n  margin-bottom: $progress-group-header-margin-bottom;\n}\n\n.progress-group-bars {\n  flex-grow: 1;\n  align-self: center;\n\n  .progress:not(:last-child) {\n    margin-bottom: 2px;\n  }\n}\n\n.progress-group-header + .progress-group-bars {\n  flex-basis: 100%;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  @include ltr-rtl(\"padding-left\", 0); // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          @include ltr-rtl(\"border-left-width\", 0);\n\n          &.active {\n            @include ltr-rtl(\"margin-left\", calc(-1 * var(--#{$prefix}list-group-border-width)));\n            @include ltr-rtl(\"border-left-width\", var(--#{$prefix}list-group-border-width));\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state, $variant in $list-group-variants {\n  .list-group-item-#{$state} {\n    @include list-group-item-variant($state, $variant);\n  }\n}\n// scss-docs-end list-group-modifiers\n","@include deprecate(\"`list-group-item-variant()`\", \"v4.3.0\", \"v6.0.0\");\n\n// List Groups\n// scss-docs-start list-group-mixin\n@mixin list-group-item-variant($state, $variant) {\n  $background: map-get($variant, \"bg\");\n  $background-hover: map-get($variant, \"bg-hover\");\n  $color: contrast-ratio-correction(map-get($variant, \"color\"), map-get($variant, \"bg\"), abs($alert-color-scale), $state);\n\n  --#{$prefix}list-group-color: #{$color};\n  --#{$prefix}list-group-bg: #{$background};\n  --#{$prefix}list-group-hover-bg: #{$background-hover};\n  --#{$prefix}list-group-action-hover-color: #{$color};\n  --#{$prefix}list-group-action-active-color: #{$white};\n  --#{$prefix}list-group-action-active-bg: #{$color};\n  --#{$prefix}list-group-action-active-border-color: #{$color};\n}\n// scss-docs-end list-group-mixin\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n.btn-close-white {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    @include ltr-rtl(\"margin-right\", calc(-.5 * var(--#{$prefix}toast-padding-x)));\n    @include ltr-rtl(\"margin-left\", var(--#{$prefix}toast-padding-x));\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  @include ltr-rtl(\"left\", 0);\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    @include ltr-rtl-value-only(\"margin\", calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto, calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)));\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v4\", \"v4.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: var(--#{$prefix}carousel-control-color, $carousel-control-color);\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}carousel-control-color, $carousel-control-color);\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-coreui-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  [data-coreui-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: var(--#{$prefix}carousel-indicator-active-bg, $carousel-indicator-active-bg);\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color, $carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n.carousel-dark {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-dark-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-dark-caption-color};\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-coreui-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        @include ltr-rtl(\"left\", 0);\n        width: var(--#{$prefix}offcanvas-width);\n        @include ltr-rtl(\"border-right\", var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color));\n        @include ltr-rtl-value-only(\"transform\", translateX(-100%), translateX(100%));\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        @include ltr-rtl(\"right\", 0);\n        width: var(--#{$prefix}offcanvas-width);\n        @include ltr-rtl(\"border-left\", var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color));\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none !important; // stylelint-disable-line declaration-no-important\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, var(--#{$prefix}offcanvas-backdrop-bg, $offcanvas-backdrop-bg), $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    @include ltr-rtl(\"margin-right\", calc(-.5 * var(--#{$prefix}offcanvas-padding-x)));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n",".avatar {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  vertical-align: middle;\n  @include border-radius(50em);\n  @include transition($avatar-transition);\n  @include avatar($avatar-width);\n}\n\n.avatar-img {\n  width: 100%;\n  height: auto;\n  @include border-radius(50em);\n}\n\n.avatar-status {\n  position: absolute;\n  @include ltr-rtl(\"right\", 0);\n  bottom: 0;\n  display: block;\n  border: 1px solid $white;\n  @include border-radius(50em);\n}\n\n@each $width, $value in $avatar-widths {\n  .avatar-#{$width} {\n    @include avatar($value);\n  }\n}\n\n.avatars-stack {\n  display: flex;\n\n  .avatar {\n    @include ltr-rtl(\"margin-right\", - ($avatar-width * .4));\n\n    &:hover {\n      @include ltr-rtl(\"margin-right\", 0);\n    }\n  }\n\n  @each $width, $value in $avatar-widths {\n    .avatar-#{$width} {\n      @include ltr-rtl(\"margin-right\", - ($value * .4));\n    }\n  }\n}\n","@mixin avatar($width) {\n  width: $width;\n  height: $width;\n  font-size: $width * .4;\n\n  .avatar-status {\n    width: divide($width, 3.75);\n    height: divide($width, 3.75);\n  }\n}\n",".callout {\n  // scss-docs-start callout-css-vars\n  --#{$prefix}callout-padding-x: #{$callout-padding-x};\n  --#{$prefix}callout-padding-y: #{$callout-padding-y};\n  --#{$prefix}callout-margin-x: #{$callout-margin-x};\n  --#{$prefix}callout-margin-y: #{$callout-margin-y};\n  --#{$prefix}callout-border-width: #{$callout-border-width};\n  --#{$prefix}callout-border-color: #{$callout-border-color};\n  --#{$prefix}callout-border-left-width: #{$callout-border-left-width};\n  --#{$prefix}callout-border-radius: #{$callout-border-radius};\n  // scss-docs-end callout-css-vars\n\n  padding: var(--#{$prefix}callout-padding-y) var(--#{$prefix}callout-padding-x);\n  margin: var(--#{$prefix}callout-margin-y) var(--#{$prefix}callout-margin-x);\n  border: var(--#{$prefix}callout-border-width) solid var(--#{$prefix}callout-border-color);\n  @include ltr-rtl(\"border-left-width\", var(--#{$prefix}callout-border-left-width));\n  @include ltr-rtl(\"border-left-color\", var(--#{$prefix}callout-border-left-color));\n  @include border-radius(var(--#{$prefix}callout-border-radius));\n}\n\n// scss-docs-start callout-modifiers\n// Generate contextual modifier classes for colorizing the collor.\n@each $state, $value in $callout-variants {\n  .callout-#{$state} {\n    --#{$prefix}callout-border-left-color: #{$value};\n  }\n}\n// scss-docs-end callout-modifiers\n",".footer {\n  // scss-docs-start footer-css-vars\n  --#{$prefix}footer-min-height: #{$footer-min-height};\n  --#{$prefix}footer-padding-x: #{$footer-padding-x};\n  --#{$prefix}footer-padding-y: #{$footer-padding-y};\n  --#{$prefix}footer-color: #{$footer-color};\n  --#{$prefix}footer-bg: #{$footer-bg};\n  --#{$prefix}footer-border-color: #{$footer-border-color};\n  --#{$prefix}footer-border: #{$footer-border-width} solid var(--#{$prefix}footer-border-color);\n  // scss-docs-end footer-css-vars\n\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between;\n  min-height: var(--#{$prefix}footer-min-height);\n  padding: var(--#{$prefix}footer-padding-y) var(--#{$prefix}footer-padding-x);\n  color: var(--#{$prefix}footer-color);\n  background: var(--#{$prefix}footer-bg);\n  border-top: var(--#{$prefix}footer-border);\n}\n\n.footer-fixed {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.footer-sticky {\n  position: sticky;\n  bottom: 0;\n  z-index: $zindex-fixed;\n}\n",".header {\n  // scss-docs-start header-css-vars\n  --#{$prefix}header-min-height: #{$header-min-height};\n  --#{$prefix}header-padding-x: #{$header-padding-x};\n  --#{$prefix}header-padding-y: #{$header-padding-y};\n  --#{$prefix}header-bg: #{$header-bg};\n  --#{$prefix}header-color: #{$header-color};\n  --#{$prefix}header-border-color: #{$header-border-color};\n  --#{$prefix}header-border: #{$header-border-width} solid var(--#{$prefix}header-border-color);\n  --#{$prefix}header-hover-color: #{$header-hover-color};\n  --#{$prefix}header-disabled-color: #{$header-disabled-color};\n  --#{$prefix}header-active-color: #{$header-active-color};\n  --#{$prefix}header-brand-padding-y: #{$header-brand-padding-y};\n  --#{$prefix}header-brand-color: #{$header-brand-color};\n  --#{$prefix}header-brand-hover-color: #{$header-brand-hover-color};\n  --#{$prefix}header-toggler-padding-x: #{$header-toggler-padding-x};\n  --#{$prefix}header-toggler-padding-y: #{$header-toggler-padding-y};\n  --#{$prefix}header-toggler-bg: #{$header-toggler-bg};\n  --#{$prefix}header-toggler-color: #{$header-toggler-color};\n  --#{$prefix}header-toggler-border-radius: #{$header-toggler-border-radius};\n  --#{$prefix}header-toggler-hover-color: #{$header-toggler-hover-color};\n  --#{$prefix}header-toggler-icon-bg: #{escape-svg($header-toggler-icon-bg)};\n  --#{$prefix}header-toggler-hover-icon-bg: #{escape-svg($header-toggler-hover-icon-bg)};\n  --#{$prefix}header-nav-link-padding-x: #{$header-nav-link-padding-x};\n  --#{$prefix}header-nav-link-padding-y: #{$header-nav-link-padding-y};\n  --#{$prefix}header-divider-border-color: #{$header-divider-border-color};\n  --#{$prefix}header-divider-border: #{$header-divider-border-width} solid var(--#{$prefix}header-divider-border-color);\n  --#{$prefix}subheader-min-height: #{$subheader-min-height};\n  // scss-docs-end header-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  min-height: var(--#{$prefix}header-min-height);\n  padding: var(--#{$prefix}header-padding-y) var(--#{$prefix}header-padding-x);\n  background: var(--#{$prefix}header-bg);\n  border-bottom: var(--#{$prefix}header-border);\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n\n  .container:first-child,\n  .container-fluid:first-child {\n    min-height: calc(var(--#{$prefix}header-min-height) - (2 * var(--#{$prefix}header-padding-y))); // stylelint-disable-line function-disallowed-list\n  }\n\n  .container:nth-child(n+2),\n  .container-fluid:nth-child(n+2) {\n    min-height: calc(var(--#{$prefix}subheader-min-height) - (2 * var(--#{$prefix}header-padding-y))); // stylelint-disable-line function-disallowed-list\n  }\n\n  &.header-sticky {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-fixed - 1;\n  }\n}\n\n.header-divider {\n  flex-basis: calc(100% + (2 * var(--#{$prefix}header-padding-x))); // stylelint-disable-line function-disallowed-list\n  height: 0;\n  margin: var(--#{$prefix}header-padding-y) calc(var(--#{$prefix}header-padding-x) * -1); // stylelint-disable-line function-disallowed-list\n  border-top: var(--#{$prefix}header-divider-border);\n}\n\n// Header brand\n//\n// Used for brand, project, or site names.\n\n.header-brand {\n  padding-top: var(--#{$prefix}header-brand-padding-y);\n  padding-bottom: var(--#{$prefix}header-brand-padding-y);\n  @include ltr-rtl(\"margin-right\", $header-brand-margin-end);\n  @include font-size($header-brand-font-size);\n  color: var(--#{$prefix}header-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}header-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n// Header nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.header-nav {\n  display: flex;\n  flex-direction: row; // cannot use `inherit` to get the `.header`s value\n  @include ltr-rtl(\"padding-left\", 0);\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding: var(--#{$prefix}header-nav-link-padding-y) var(--#{$prefix}header-nav-link-padding-x);\n    color: var(--#{$prefix}header-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}header-hover-color);\n    }\n\n    &.disabled {\n      color: var(--#{$prefix}header-disabled-color);\n    }\n  }\n\n  .show > .nav-link,\n  .nav-link.active {\n    color: var(--#{$prefix}header-active-color);\n  }\n\n  .dropdown-menu {\n    position: absolute;\n  }\n}\n\n\n// Header text\n//\n//\n\n.header-text {\n  padding-top: var(--#{$prefix}header-nav-link-padding-y);\n  padding-bottom: var(--#{$prefix}header-nav-link-padding-y);\n  color: var(--#{$prefix}header-color);\n\n  a {\n    color: var(--#{$prefix}header-active-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}header-active-color);\n    }\n  }\n}\n\n.header-toggler {\n  padding: var(--#{$prefix}header-toggler-padding-y) var(--#{$prefix}header-toggler-padding-x);\n  @include font-size($header-toggler-font-size);\n  color: var(--#{$prefix}header-toggler-color);\n  background-color: var(--#{$prefix}header-toggler-bg);\n  border: 0; // remove default button style\n  @include border-radius(var(--#{$prefix}header-toggler-border-radius));\n\n  &:hover {\n    color: var(--#{$prefix}header-toggler-hover-color);\n    text-decoration: none;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  // Opinionated: add \"hand\" cursor to non-disabled .navbar-toggler elements\n  &:not(:disabled) {\n    cursor: pointer;\n  }\n}\n\n.header-toggler-icon {\n  display: block;\n  height: $header-toggler-font-size * 1.25;\n  background-image: var(--#{$prefix}header-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 100% 100%;\n\n  &:hover {\n    background-image: var(--#{$prefix}header-toggler-hover-icon-bg);\n  }\n}\n",".icon {\n  display: inline-block;\n  color: inherit;\n  text-align: center;\n  vertical-align: -.125rem; // Fix the position of icon\n  fill: currentcolor;\n  &:not(.icon-c-s):not(.icon-custom-size) {\n    @include icon-size($icon-size-base);\n\n    &.icon-xxl {\n      @include icon-size($icon-size-xxl);\n    }\n\n    &.icon-xl {\n      @include icon-size($icon-size-xl);\n    }\n\n    &.icon-lg {\n      @include icon-size($icon-size-lg);\n    }\n\n    &.icon-sm {\n      @include icon-size($icon-size-sm);\n    }\n\n    @for $i from 3 through 9 {\n      &.icon-#{$i}xl {\n        @include icon-size($i * $icon-size-base);\n      }\n    }\n  }\n}\n","// Icon sizes\n@mixin icon-size($icon-size) {\n  width: $icon-size;\n  height: $icon-size;\n  font-size: $icon-size;\n}\n",".sidebar {\n  // scss-docs-start sidebar-css-vars\n  --#{$prefix}sidebar-width: #{$sidebar-width};\n  --#{$prefix}sidebar-bg: #{$sidebar-bg};\n  --#{$prefix}sidebar-padding-x: #{$sidebar-padding-x};\n  --#{$prefix}sidebar-padding-y: #{$sidebar-padding-y};\n  --#{$prefix}sidebar-color: #{$sidebar-color};\n  --#{$prefix}sidebar-border-width: #{$sidebar-border-width};\n  --#{$prefix}sidebar-border-color: #{$sidebar-border-color};\n  --#{$prefix}sidebar-brand-color: #{$sidebar-brand-color};\n  --#{$prefix}sidebar-brand-height: #{$sidebar-brand-height};\n  --#{$prefix}sidebar-brand-bg: #{$sidebar-brand-bg};\n  --#{$prefix}sidebar-header-height: #{$sidebar-header-height};\n  --#{$prefix}sidebar-header-bg: #{$sidebar-header-bg};\n  --#{$prefix}sidebar-header-padding-x: #{$sidebar-header-padding-x};\n  --#{$prefix}sidebar-header-padding-y: #{$sidebar-header-padding-y};\n  --#{$prefix}sidebar-footer-bg: #{$sidebar-footer-bg};\n  --#{$prefix}sidebar-footer-height: #{$sidebar-footer-height};\n  --#{$prefix}sidebar-footer-padding-x: #{$sidebar-footer-padding-x};\n  --#{$prefix}sidebar-footer-padding-y: #{$sidebar-footer-padding-y};\n  --#{$prefix}sidebar-toggler-bg: #{$sidebar-toggler-bg};\n  --#{$prefix}sidebar-toggler-height: #{$sidebar-toggler-height};\n  --#{$prefix}sidebar-toggler-indicator: #{escape-svg($sidebar-toggler-indicator-icon)};\n  --#{$prefix}sidebar-toggler-indicator-width: #{$sidebar-toggler-indicator-width};\n  --#{$prefix}sidebar-toggler-indicator-height: #{$sidebar-toggler-indicator-height};\n  --#{$prefix}sidebar-toggler-hover-bg: #{$sidebar-toggler-hover-bg};\n  --#{$prefix}sidebar-toggler-indicator-hover: #{escape-svg($sidebar-toggler-indicator-hover-icon)};\n\n  --#{$prefix}sidebar-narrow-width: #{$sidebar-narrow-width};\n\n  --#{$prefix}sidebar-nav-title-padding-x: #{$sidebar-nav-title-padding-x};\n  --#{$prefix}sidebar-nav-title-padding-y: #{$sidebar-nav-title-padding-y};\n  --#{$prefix}sidebar-nav-title-margin-top: #{$sidebar-nav-title-margin-top};\n  --#{$prefix}sidebar-nav-title-color: #{$sidebar-nav-title-color};\n  --#{$prefix}sidebar-nav-link-padding-x: #{$sidebar-nav-link-padding-x};\n  --#{$prefix}sidebar-nav-link-padding-y: #{$sidebar-nav-link-padding-y};\n  --#{$prefix}sidebar-nav-link-color: #{$sidebar-nav-link-color};\n  --#{$prefix}sidebar-nav-link-bg: #{$sidebar-nav-link-bg};\n  --#{$prefix}sidebar-nav-link-border-color: #{$sidebar-nav-link-border-color};\n  --#{$prefix}sidebar-nav-link-border: #{$sidebar-nav-link-border-width} solid var(--#{$prefix}sidebar-nav-link-border-color);\n  --#{$prefix}sidebar-nav-link-border-radius: #{$sidebar-nav-link-border-radius};\n  --#{$prefix}sidebar-nav-link-active-color: #{$sidebar-nav-link-active-color};\n  --#{$prefix}sidebar-nav-link-active-bg: #{$sidebar-nav-link-active-bg};\n  --#{$prefix}sidebar-nav-link-active-icon-color: #{$sidebar-nav-link-active-icon-color};\n  --#{$prefix}sidebar-nav-link-disabled-color: #{$sidebar-nav-link-disabled-color};\n  --#{$prefix}sidebar-nav-link-disabled-icon-color: #{$sidebar-nav-link-disabled-icon-color};\n  --#{$prefix}sidebar-nav-link-hover-color: #{$sidebar-nav-link-hover-color};\n  --#{$prefix}sidebar-nav-link-hover-bg: #{$sidebar-nav-link-hover-bg};\n  --#{$prefix}sidebar-nav-link-hover-icon-color: #{$sidebar-nav-link-hover-icon-color};\n  --#{$prefix}sidebar-nav-icon-width: #{$sidebar-nav-icon-width};\n  --#{$prefix}sidebar-nav-icon-height: #{$sidebar-nav-icon-height};\n  --#{$prefix}sidebar-nav-icon-font-size: #{$sidebar-nav-icon-font-size};\n  --#{$prefix}sidebar-nav-link-icon-color: #{$sidebar-nav-link-icon-color};\n  --#{$prefix}sidebar-nav-group-bg: #{$sidebar-nav-group-bg};\n  --#{$prefix}sidebar-nav-group-items-padding-y: #{$sidebar-nav-group-items-padding-y};\n  --#{$prefix}sidebar-nav-group-items-padding-x: #{$sidebar-nav-group-items-padding-x};\n  --#{$prefix}sidebar-nav-group-indicator: #{escape-svg($sidebar-nav-group-indicator-icon)};\n  --#{$prefix}sidebar-nav-group-indicator-hover: #{escape-svg($sidebar-nav-group-indicator-hover-icon)};\n  --#{$prefix}sidebar-nav-group-toggle-show-color: #{$sidebar-nav-group-toggle-show-color};\n  // scss-docs-end sidebar-css-vars\n\n  position: relative;\n  display: flex;\n  // $sidebar-width is the width of the columns\n  flex: 0 0 var(--#{$prefix}sidebar-width);\n  flex-direction: column;\n  // put the nav on the left\n  order: -1;\n  width: var(--#{$prefix}sidebar-width);\n  padding: var(--#{$prefix}sidebar-padding-y) var(--#{$prefix}sidebar-padding-x);\n  color: var(--#{$prefix}sidebar-color);\n  background: var(--#{$prefix}sidebar-bg);\n  @include ltr-rtl(\"border-right\", var(--#{$prefix}sidebar-border-width) solid var(--#{$prefix}sidebar-border-color));\n  box-shadow: none;\n  @include transition($sidebar-transition);\n\n  &:not(.sidebar-end){\n    @include ltr-rtl(\"margin-left\", 0);\n    ~ * {\n      --#{$prefix}sidebar-occupy-start: #{$sidebar-width};\n    }\n  }\n\n  &.sidebar-end {\n    order: 99;\n    @include ltr-rtl(\"margin-right\", 0);\n    ~ * {\n      --#{$prefix}sidebar-occupy-end: #{$sidebar-width};\n    }\n  }\n\n  &[class*=\"bg-\"]  {\n    border-color: rgba($black, .1);\n  }\n\n  @each $width, $value in $sidebar-widths {\n    &.sidebar-#{$width} {\n      --#{$prefix}sidebar-width: #{$value};\n      @include media-breakpoint-up($mobile-breakpoint) {\n        &:not(.sidebar-end):not(.hide) {\n          ~ * {\n            --#{$prefix}sidebar-occupy-start: #{$value};\n          }\n        }\n        &.sidebar-end:not(.hide) {\n          ~ * {\n            --#{$prefix}sidebar-occupy-end: #{$value};\n          }\n        }\n      }\n    }\n  }\n\n  @include media-breakpoint-up($mobile-breakpoint) {\n    &.hide {\n      &:not(.sidebar-end){\n        @include ltr-rtl(\"margin-left\", calc(-1 * var(--#{$prefix}sidebar-width)));\n        ~ * {\n          --#{$prefix}sidebar-occupy-start: 0;\n        }\n      }\n      &.sidebar-end {\n        @include ltr-rtl(\"margin-right\", calc(-1 * var(--#{$prefix}sidebar-width)));\n        ~ * {\n          --#{$prefix}sidebar-occupy-end: 0;\n        }\n      }\n    }\n  }\n\n  &.sidebar-fixed {\n    @include media-breakpoint-up($mobile-breakpoint) {\n      position: fixed;\n      top: 0;\n      bottom: 0;\n      z-index: $zindex-fixed;\n\n      &:not(.sidebar-end) {\n        @include ltr-rtl(\"left\", 0);\n      }\n\n      &.sidebar-end {\n        @include ltr-rtl(\"right\", 0);\n      }\n    }\n  }\n\n  &.sidebar-sticky {\n    @include media-breakpoint-up($mobile-breakpoint) {\n      position: sticky;\n      top: 0;\n      height: 100vh;\n    }\n  }\n\n  &.sidebar-overlaid {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    z-index: $zindex-fixed + 2;\n\n    &:not(.sidebar-end) {\n      @include ltr-rtl(\"left\", 0);\n      ~ * {\n        --#{$prefix}sidebar-occupy-start: 0;\n      }\n    }\n\n    &.sidebar-end {\n      @include ltr-rtl(\"right\", 0);\n      ~ * {\n        --#{$prefix}sidebar-occupy-end: 0;\n      }\n    }\n  }\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    // Some of our components use this property to detect if the sidebar has mobile behavior.\n    --#{$prefix}is-mobile: true;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    z-index: $zindex-fixed + 1;\n\n    &:not(.sidebar-end) {\n      @include ltr-rtl(\"left\", 0);\n      ~ * {\n        --#{$prefix}sidebar-occupy-start: 0 !important; // stylelint-disable-line\n      }\n\n      &:not(.show) {\n        @include ltr-rtl(\"margin-left\", calc(-1 * var(--#{$prefix}sidebar-width)));\n      }\n    }\n    &.sidebar-end {\n      @include ltr-rtl(\"right\", 0);\n      ~ * {\n        --#{$prefix}sidebar-occupy-end: 0 !important; // stylelint-disable-line\n      }\n\n      &:not(.show) {\n        @include ltr-rtl(\"margin-right\", calc(-1 * var(--#{$prefix}sidebar-width)));\n      }\n    }\n  }\n}\n\n.sidebar-close {\n  position: absolute;\n  top: 0;\n  @include ltr-rtl(\"right\", 0);\n  width: var(--#{$prefix}sidebar-width);\n  height: var(--#{$prefix}sidebar-header-height);\n  color: var(--#{$prefix}sidebar-color);\n  background: transparent;\n  border: 0;\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n}\n\n.sidebar-brand {\n  display: flex;\n  flex: 0 0 var(--#{$prefix}sidebar-brand-height);\n  align-items: center;\n  justify-content: center;\n  color: var(--#{$prefix}sidebar-brand-color);\n  background: var(--#{$prefix}sidebar-brand-bg);\n\n  .sidebar-brand-narrow {\n    display: none;\n  }\n}\n\n.sidebar-header {\n  flex: 0 0 var(--#{$prefix}sidebar-header-height);\n  padding: var(--#{$prefix}sidebar-header-padding-y) var(--#{$prefix}sidebar-header-padding-x);\n  text-align: center;\n  background: var(--#{$prefix}sidebar-header-bg);\n  @include transition($sidebar-header-height-transition);\n\n  .nav-link {\n    display: flex;\n    align-items: center;\n    min-height: var(--#{$prefix}sidebar-header-height);\n  }\n}\n\n.sidebar-footer {\n  flex: 0 0 var(--#{$prefix}sidebar-footer-height);\n  padding: var(--#{$prefix}sidebar-footer-padding-y) var(--#{$prefix}sidebar-footer-padding-x);\n  background: var(--#{$prefix}sidebar-footer-bg);\n  @include transition($sidebar-footer-height-transition);\n}\n\n.sidebar-toggler {\n  display: flex;\n  flex: 0 0 var(--#{$prefix}sidebar-toggler-height);\n  justify-content: flex-end;\n  width: inherit;\n  padding: 0;\n  cursor: pointer;\n  background-color: var(--#{$prefix}sidebar-toggler-bg);\n  border: 0;\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    display: none;\n  }\n\n  &::before {\n    display: block;\n    width: var(--#{$prefix}sidebar-toggler-indicator-width);\n    height: var(--#{$prefix}sidebar-toggler-indicator-height);\n    content: \"\";\n    background-image: var(--#{$prefix}sidebar-toggler-indicator);\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: calc(var(--#{$prefix}sidebar-toggler-indicator-height) * .25); // stylelint-disable-line function-disallowed-list\n    @include transition($sidebar-toggler-transition);\n    @include rtl() {\n      transform: rotate(-180deg);\n    }\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:hover {\n    background-color: var(--#{$prefix}sidebar-toggler-hover-bg);\n    &::before {\n      background-image: var(--#{$prefix}sidebar-toggler-indicator-hover);\n    }\n  }\n\n  .sidebar-end & {\n    justify-content: flex-start;\n    &::before {\n      transform: rotate(-180deg);\n    }\n  }\n}\n\n// Backdrop background\n\n.sidebar-backdrop {\n  // scss-docs-start sidebar-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-sidebar-backdrop};\n  --#{$prefix}backdrop-bg: #{$sidebar-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$sidebar-backdrop-opacity};\n  // scss-docs-end sidebar-backdrop-css-vars\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n  }\n}\n","// Sidebar navigation\n\n.sidebar-nav {\n  position: relative;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding: 0;\n  margin-bottom: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  list-style: none;\n\n  .nav-title {\n    padding: var(--#{$prefix}sidebar-nav-title-padding-y) var(--#{$prefix}sidebar-nav-title-padding-x);\n    margin-top: var(--#{$prefix}sidebar-nav-title-margin-top);\n    font-size: 80%;\n    font-weight: 700;\n    color: var(--#{$prefix}sidebar-nav-title-color);\n    text-transform: uppercase;\n    @include transition($sidebar-nav-title-transition);\n  }\n\n  .nav-link {\n    display: flex;\n    flex: 1;\n    align-items: center;\n    padding: var(--#{$prefix}sidebar-nav-link-padding-y) var(--#{$prefix}sidebar-nav-link-padding-x);\n    color: var(--#{$prefix}sidebar-nav-link-color);\n    text-decoration: none;\n    white-space: nowrap;\n    background: var(--#{$prefix}sidebar-nav-link-bg);\n    border: var(--#{$prefix}sidebar-nav-link-border);\n    @include border-radius(var(--#{$prefix}sidebar-nav-link-border-radius));\n    @include transition($sidebar-nav-link-transition);\n\n    &.active {\n      color: var(--#{$prefix}sidebar-nav-link-active-color);\n      background: var(--#{$prefix}sidebar-nav-link-active-bg);\n\n      .nav-icon {\n        color: var(--#{$prefix}sidebar-nav-link-active-icon-color);\n      }\n    }\n\n    &.disabled {\n      color: var(--#{$prefix}sidebar-nav-link-disabled-color);\n      pointer-events: none;\n      cursor: not-allowed;\n      background: transparent;\n\n      .nav-icon {\n        color: var(--#{$prefix}sidebar-nav-link-disabled-icon-color);\n      }\n\n      &:hover {\n        color: var(--#{$prefix}sidebar-nav-link-disabled-color);\n\n        .nav-icon {\n          color: var(--#{$prefix}sidebar-nav-link-disabled-icon-color);\n        }\n\n        &.nav-dropdown-toggle::after {\n          background-image: var(--#{$prefix}sidebar-nav-group-indicator-hover);\n        }\n      }\n    }\n\n    @media (hover: hover), (-ms-high-contrast: none) {\n      &:hover {\n        color: var(--#{$prefix}sidebar-nav-link-hover-color);\n        text-decoration: none;\n        background: var(--#{$prefix}sidebar-nav-link-hover-bg);\n\n        .nav-icon {\n          color: var(--#{$prefix}sidebar-nav-link-hover-icon-color);\n        }\n\n        &.nav-group-toggle::after {\n          background-image: var(--#{$prefix}sidebar-nav-group-indicator-hover);\n        }\n      }\n    }\n  }\n\n  .nav-icon {\n    flex: 0 0 var(--#{$prefix}sidebar-nav-icon-width);\n    height: var(--#{$prefix}sidebar-nav-icon-height);\n    font-size: var(--#{$prefix}sidebar-nav-icon-font-size);\n    color: var(--#{$prefix}sidebar-nav-link-icon-color);\n    text-align: center;\n    pointer-events: none;\n    fill: currentcolor;\n    @include transition(inherit);\n\n    &:first-child {\n      @include ltr-rtl(\"margin-left\", calc(var(--#{$prefix}sidebar-nav-link-padding-x) * -1));\n    }\n  }\n  // stylelint-disable-next-line selector-no-qualifying-type\n  svg.nav-icon {\n    overflow: hidden; // fix chrome 105+ width issue\n  }\n\n  .nav-group {\n    position: relative;\n    @include transition($sidebar-nav-group-transition);\n\n    .nav-group-items {\n      padding: var(--#{$prefix}sidebar-nav-group-items-padding-y) var(--#{$prefix}sidebar-nav-group-items-padding-x);\n      overflow: hidden;\n      @include transition($sidebar-nav-group-items-transition);\n    }\n\n    &:not(.show) .nav-group-items {\n      display: none;\n    }\n\n    &.show {\n      background: var(--#{$prefix}sidebar-nav-group-bg);\n\n      .nav-group-toggle {\n        color: var(--#{$prefix}sidebar-nav-group-toggle-show-color);\n      }\n\n      > .nav-group-toggle::after {\n        transform: rotate(180deg);\n      }\n\n      + .show {\n        margin-top: 1px;\n      }\n    }\n  }\n\n  .nav-group-toggle {\n    cursor: pointer;\n\n    &::after {\n      display: block;\n      flex: 0 12px;\n      height: 12px;\n      @include ltr-rtl(\"margin-left\", auto);\n      content: \"\";\n      background-image: var(--#{$prefix}sidebar-nav-group-indicator);\n      background-repeat: no-repeat;\n      background-position: center;\n      @include transition($sidebar-nav-group-indicator-transition);\n    }\n  }\n\n  .nav-group-items {\n    padding: 0;\n    list-style: none;\n\n    .nav-link {\n      @include ltr-rtl(\"padding-left\", var(--#{$prefix}sidebar-nav-icon-width));\n\n      .nav-icon {\n        @include ltr-rtl(\"margin-left\", calc(var(--#{$prefix}sidebar-nav-icon-width) * -1));\n      }\n    }\n  }\n\n  &.compact,\n  .compact {\n    .nav-link {\n      padding-top: calc(var(--#{$prefix}sidebar-nav-link-padding-y) * .5); // stylelint-disable-line function-disallowed-list\n      padding-bottom: calc(var(--#{$prefix}sidebar-nav-link-padding-y) * .5); // stylelint-disable-line function-disallowed-list\n    }\n  }\n}\n","%sidebar-narrow {\n  @include media-breakpoint-up($mobile-breakpoint) {\n    z-index: $zindex-fixed + 1;\n    flex: 0 0 var(--#{$prefix}sidebar-narrow-width);\n    width: var(--#{$prefix}sidebar-narrow-width);\n    padding-bottom: var(--#{$prefix}sidebar-toggler-height);\n    overflow: visible;\n\n    &.sidebar-fixed {\n      z-index: $zindex-fixed + 1;\n      width: var(--#{$prefix}sidebar-narrow-width);\n    }\n\n    .sidebar-brand-full {\n      display: none;\n    }\n\n    .sidebar-brand-narrow {\n      display: block;\n    }\n\n    .d-narrow-none,\n    .nav-label,\n    .nav-title,\n    .nav-group-items,\n    .nav-group.show .nav-group-items,\n    .sidebar-footer,\n    .sidebar-form,\n    .sidebar-header {\n      height: 0 !important; // stylelint-disable-line declaration-no-important\n      padding: 0;\n      margin: 0;\n      visibility: hidden;\n      opacity: 0;\n    }\n\n    .sidebar-toggler {\n      position: fixed;\n      bottom: 0;\n\n      &::before {\n        @include ltr-rtl(\"transform\", rotate(-180deg), null, rotate(0deg));\n      }\n    }\n\n    &.sidebar-end .sidebar-toggler::before {\n      transform: rotate(0deg);\n    }\n  }\n}\n\n.sidebar-narrow {\n  @extend %sidebar-narrow;\n  &:not(.sidebar-end) ~ * {\n    --#{$prefix}sidebar-occupy-start: #{$sidebar-narrow-width};\n  }\n  &.sidebar-end ~ * {\n    --#{$prefix}sidebar-occupy-end: #{$sidebar-narrow-width};\n  }\n}\n\n.sidebar-narrow-unfoldable {\n  position: fixed;\n  z-index: $zindex-fixed + 1;\n\n  &:not(.sidebar-end) ~ * {\n    --#{$prefix}sidebar-occupy-start: #{$sidebar-narrow-width};\n  }\n  &.sidebar-end ~ * {\n    --#{$prefix}sidebar-occupy-end: #{$sidebar-narrow-width};\n  }\n\n  &:not(:hover) {\n    @extend %sidebar-narrow;\n  }\n\n  &:hover {\n    .sidebar-toggler {\n      &::before {\n        @include ltr-rtl(\"transform\", rotate(-180deg), null, rotate(0deg));\n      }\n    }\n\n    &.sidebar-end .sidebar-toggler::before {\n      transform: rotate(0deg);\n    }\n  }\n}\n\n// Responsive behavior\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-down($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n    .sidebar:not(.show).sidebar-self-hiding#{$infix} {\n      &.sidebar-narrow,\n      &.sidebar-narrow-unfoldable {\n        &:not(.sidebar-end) {\n          @include ltr-rtl(\"margin-left\", calc(var(--#{$prefix}sidebar-narrow-width) * -1));\n        }\n        &.sidebar-end {\n          @include ltr-rtl(\"margin-right\", calc(var(--#{$prefix}sidebar-narrow-width) * -1));\n        }\n      }\n    }\n  }\n}\n",".subheader {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  min-height: $subheader-min-height;\n  padding: $subheader-padding-y $subheader-padding-x;\n  background: var(--#{$prefix}subheader-bg, $subheader-bg);\n  border-bottom: var(--#{$prefix}subheader-border-width, $subheader-border-width) solid var(--#{$prefix}subheader-border-color, $subheader-border-color);\n}\n\n.subheader-sticky {\n  position: sticky;\n  top: 0;\n  z-index: $zindex-fixed - 1;\n}\n\n// Subheader nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.subheader-nav {\n  display: flex;\n  flex-direction: row; // cannot use `inherit` to get the `.header`s value\n  @include ltr-rtl(\"padding-left\", 0);\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: $subheader-nav-link-padding-x;\n    padding-left: $subheader-nav-link-padding-x;\n    color: var(--#{$prefix}subheader-color, $subheader-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}subheader-hover-color, $subheader-hover-color);\n    }\n\n    &.disabled {\n      color: var(--#{$prefix}subheader-disabled-color, $subheader-disabled-color);\n    }\n  }\n\n  .show > .nav-link,\n  .nav-link.active {\n    color: var(--#{$prefix}subheader-active-color, $subheader-active-color);\n  }\n\n  .dropdown-menu {\n    position: absolute;\n  }\n}\n\n// Subheader text\n//\n//\n\n.subheader-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}subheader-color, $subheader-color);\n\n  a {\n    color: var(--#{$prefix}subheader-active-color, $subheader-active-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}subheader-active-color, $subheader-active-color);\n    }\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--cui-focus-ring-x`, `--cui-focus-ring-y`, or `--cui-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    @include ltr-rtl(\"left\", 0);\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  padding: 0;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix, $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    // Generate RTL version\n    $generate-rtl: if(map-has-key($utility, rtl), map-get($utility, rtl), false);\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            @if $generate-rtl == true {\n              @include ltr-rtl($property, $value, null, null, if($enable-important-utilities, !important, null));\n            } @else {\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","/*!\n * CoreUI Plugins - Chart.js for CoreUI 3\n * @version v3.1.2\n * @link https://coreui.io\n * Copyright (c) 2021 creativeLabs Łukasz Holeczek\n * Licensed under MIT (https://github.com/coreui/coreui-chartjs/blob/main/LICENSE)\n */\n\n\n@import \"@coreui/coreui/scss/functions\";\n@import \"@coreui/coreui/scss/variables\";\n@import \"@coreui/coreui/scss/mixins\";\n@import \"tooltips\";\n","// Custom tooltips\n\n.chartjs-tooltip {\n  position: absolute;\n  z-index: $zindex-sticky + 1;\n  padding: ($spacer * .25) ($spacer * .5);\n  color: #fff;\n  pointer-events: none;\n  background: rgba(0, 0, 0, .7);\n  opacity: 0;\n  @include transition(all .15s ease);\n  transform: translate(-50%, 0);\n  @include border-radius($border-radius);\n}\n\n.chartjs-tooltip-header {\n  margin-bottom: ($spacer * .5);\n}\n\n.chartjs-tooltip-header-item {\n  font-size: $font-size-sm;\n  font-weight: $font-weight-bold;\n}\n\n.chartjs-tooltip-body-item {\n  align-items: center;\n  font-size: $font-size-sm;\n  white-space: nowrap;\n}\n",".wrapper {\n  width: 100%;\n  @include ltr-rtl(\"padding-left\", var(--cui-sidebar-occupy-start, 0));\n  will-change: auto;\n  @include transition(padding .15s);\n}\n",".example {\n  &:not(:first-child) {\n    margin-top: 1.5rem;\n  }\n\n  .tab-content {\n    background-color: $light-50 !important;\n\n    @at-root .dark-theme & {\n      background-color: rgba(255, 255, 255, .1) !important;\n    }\n  }\n\n  code[class*=\"language-\"],\n  pre[class*=\"language-\"] {\n    font-size: .875rem !important;\n  }\n\n  :not(pre) > code[class*=\"language-\"],\n  pre[class*=\"language-\"] {\n    background: transparent;\n  }\n\n  & + p {\n    margin-top: 1.5rem\n  }\n\n  // Components examples\n  .preview,\n  .preview .col {\n    + p {\n      margin-top: 2rem;\n    }\n\n    > .form-control {\n      + .form-control {\n        margin-top: .5rem;\n      }\n    }\n\n    > .nav + .nav,\n    > .alert + .alert,\n    > .navbar + .navbar,\n    > .progress + .progress {\n      margin-top: 1rem;\n    }\n\n    > .dropdown-menu {\n      position: static;\n      display: block;\n    }\n\n    > :last-child {\n      margin-bottom: 0;\n    }\n\n    // Images\n    > svg + svg,\n    > img + img {\n      margin-left: .5rem;\n    }\n\n    // Buttons\n    > .btn,\n    > .btn-group {\n      margin: .25rem .125rem;\n    }\n    > .btn-toolbar + .btn-toolbar {\n      margin-top: .5rem;\n    }\n\n    // List groups\n    > .list-group {\n      max-width: 400px;\n    }\n\n    > [class*=\"list-group-horizontal\"] {\n      max-width: 100%;\n    }\n\n    // Navbars\n    .fixed-top,\n    .sticky-top {\n      position: static;\n      margin: -1rem -1rem 1rem;\n    }\n\n    .fixed-bottom {\n      position: static;\n      margin: 1rem -1rem -1rem;\n    }\n\n    @include media-breakpoint-up(sm) {\n      .fixed-top,\n      .sticky-top {\n        margin: -1.5rem -1.5rem 1rem;\n      }\n      .fixed-bottom {\n        margin: 1rem -1.5rem -1.5rem;\n      }\n    }\n\n    // Pagination\n    .pagination {\n      margin-top: .5rem;\n      margin-bottom: .5rem;\n    }\n  }\n}\n","// Here you can add other styles\n@import url(\"~leaflet/dist/leaflet.css\");\n\n$base-color: #22ac11;\n$blue-color: #e67e22;\n$blue-color1: #DC3545;\n$text-color: black;\n$text-color3: #007BFF;\n\n/*Legend specific*/\n.legend {\n  padding: 6px 8px;\n  font: 14px Arial, Helvetica, sans-serif;\n  background: white;\n  background: rgba(255, 255, 255, 0.8);\n  /*box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);*/\n  /*border-radius: 5px;*/\n  line-height: 24px;\n  color: #555;\n}\n.legend h4 {\n  text-align: center;\n  font-size: 16px;\n  margin: 2px 12px 8px;\n  color: #777;\n}\n\n.legend span {\n  position: relative;\n  bottom: 3px;\n}\n\n.legend i {\n  width: 18px;\n  height: 18px;\n  float: left;\n  margin: 0 8px 0 0;\n  opacity: 0.7;\n}\n\n.legend i.icon {\n  background-size: 18px;\n  background-color: rgba(255, 255, 255, 1);\n}\n\n.icon-Disponible {\n  color:#22ac11 !important;\n}\n\n.icon-NoDisponible {\n  color:#DC3545 !important;\n}\n\n.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {\n  border-bottom: 5px solid #007BFF;\n  background: #E1F4FF;\n  font-size: 1.2rem !important;\n  color: #007BFF !important;\n}\n\n.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link {\n  font-size: 1.2rem !important;\n  color: #9A9A9A !important;\n}\n\n.loading {\n  font-size: 1.2rem !important;\n  color: #DC3545 !important;\n  text-align: center !important;\n}\n\n.MuiTableCell-alignLeft {\n  text-align: left !important;\n}\n\n.CIconColor {\n  color: $text-color3;\n}\n\n.logo-empresaBpsystem {\n    width: 70%;\n  }\n\n  .img_carrucelPerfil{\n    width: 100% !important;\n  }\n\n  .img_carrucel {\n    width: 100% !important;\n    height: 100% !important;\n  }\n\n  .textoMenu {\n    font-size: 1.0rem !important;\n  }\n\n  .textoMenuOFF {\n    font-size: 1.0rem !important;\n  }\n\n  .textoTabla {\n    font-size: 0.8rem !important;\n  }\n\n  .textoOption {\n    font-size: 0.8rem !important;\n  }\n  \n  .textoTurno {\n    font-size: 1.0rem !important;\n  }\n  // ------------ sidebar --------------------------------------------------------------\n  .sidebar-nav .nav-icon {\n    flex: 0 0 3rem !important;\n    height: 2rem !important;\n\n    color: rgba(255, 255, 255, 0.6);\n    color: var(--cui-sidebar-nav-link-icon-color, rgba(255, 255, 255, 0.6));\n    text-align: center;\n    fill: currentColor;\n    transition: inherit;\n}\n\n.nav-icon{\n  width: 30px !important;\n  height: 30px !important;\n}\n\n.sidebar {\n  --cui-sidebar-width: 17rem !important;\n}\n  // ------------ sidebar --------------------------------------------------------------\n\n  .Row-leaflet-containerDenGrab {\n    padding: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #eeeeee !important;\n    background-color: #fff !important;\n    border-radius: 5px !important;\n    box-shadow: 0 2px 3px rgba(212, 207, 207, 20%), 0 3px 3px rgba(212, 207, 207, 20%) !important;\n    margin-bottom: 10px !important;\n    height: 60vh !important;\n  }\n\n  //------------Login----------------------------------------------------------------------------\n\n  .col-titulo-login{\n    border: 1px solid #eeeeee !important;\n    background-color: #fff !important;\n    border-radius: 5px !important;\n    box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;\n    margin-bottom: 10px !important;\n    padding: 10px !important;\n    margin-top: 3%;\n    margin-right: auto;\n    margin-left: auto;\n    height: 100%;\n    width: 30vw;\n    min-height: 2.5rem;\n    min-width: 2.5rem;\n  }\n\n  .um_data-login-row{\n    padding: 10px  !important;\n    margin-top: 10px !important;\n    \n  }\n\n  .btn{\n    margin-top: 10px !important;\n    padding-left: 1.22rem;\n    padding-right: 1.22rem;\n  }\n\n  .btn1{\n    margin-top: 0px !important;\n    padding-left: 1.22rem;\n    padding-right: 1.22rem;\n  }\n\n  .um_data-login-row{\n    padding: 10px  !important;\n    margin-top: 10px !important;\n    \n  }\n\n  .container2{\n    margin-left: 0px !important;  \n    transition: margin-left .2s ease-in !important;  \n    padding: 10px !important;  \n    box-sizing: border-box !important;  \n    background: #ffff !important;  \n\n  }\n\n  .container1 {\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .container3 {\n    justify-content: center !important;\n    align-items: center !important;\n    text-align: center !important;\n  }\n\n  .texto-label-login-U{\n    font-size: 0.7rem !important;  \n    justify-content: center;\n    align-items: center;\n    \n  }\n\n  .center-texto {\n    margin-top: 30px !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .center-texto-SinTop {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  \n  .left-texto {\n    display: flex;\n    justify-content: left;\n    align-items: left;\n  }\n\n  .leaflet-tooltip-own {\n    position: absolute;\n    padding: 4px;\n    background-color: rgba(255, 255, 255, 0.4);\n    border: 0px solid #000;\n    color: #FFFFFF;\n    white-space: nowrap;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    pointer-events: none;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.4);\n    color:  rgba(21,67,139,1) !important;\n    font-size: 0.6rem !important;\n}\n\n.leaflet-tooltip-ownRojo {\n  position: absolute;\n  padding: 4px;\n  background-color: rgba(255, 255, 255, 0.4);\n  border: 0px solid #000;\n  color: #FFFFFF;\n  white-space: nowrap;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  pointer-events: none;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.4);\n  color:  rgb(254, 0, 0) !important;\n  font-size: 0.6rem !important;\n}\n\n.leaflet-tooltip-ownVerde {\n  position: absolute;\n  padding: 4px;\n  background-color: rgba(255, 255, 255, 0.4);\n  border: 0px solid #000;\n  color: #FFFFFF;\n  white-space: nowrap;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  pointer-events: none;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.4);\n  color:  rgb(5, 176, 2) !important;\n  font-size: 0.6rem !important;\n}\n\n\n  .logo-empresa {\n    width: 40%;\n    background: #FFFFFF !important;\n    border-radius: 5px !important;\n    margin-top: 2px !important;\n  }\n\n  .logo-empresaT {\n    width: 100%;\n    background: #FFFFFF !important;\n    border-radius: 5px !important;\n    margin-top: 2px !important;\n  }\n\n  .logo-empresaT_MAHO {\n    width: 50%;\n    background: #FFFFFF !important;\n    border-radius: 5px !important;\n    margin-top: 2px !important;\n  }\n\n  .logo-empresaR {\n    text-align: center !important;\n    justify-content: center !important;\n    width: 50% !important;\n    background: #FFFFFF !important;\n    border-radius: 5px !important;\n    margin-top: 10px !important;\n  }\n\n  .icon-Bpsystem {\n\t  color:#e67e22 !important;\n  }\n\n  .center {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    width: 50%;\n  }\n\n  .centerPie{\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    font-size: 1rem !important;\n  }\n\n  .center {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .centerT {\n    margin-top: 0px !important;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    width: 60%;\n  }\n\n  .centerT_MAHO {\n    margin-top: 0px !important;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n  }\n\n  .reloj1 {\n    color:  rgba(21,67,139,1) !important;\n    font-size: 1rem !important;\n    text-align: center !important;\n    justify-content: center !important;\n  }\n\n  .logo-empresa1 {\n    text-align: center !important;\n    justify-content: center !important;\n    width: 85% !important;\n    background: #FFFFFF !important;\n    border-radius: 5px !important;\n    margin-top: 10px !important;\n  }\n\n  \n\n  \n  .errorMsg {\n    width: 100% !important;\n    color: #f21e08 !important;\n    padding: 1px 0;\n    margin-top: 1%;\n    font-size: 0.8rem;  \n    font-weight:bold;\n  }\n\n\n  //-------------------Dashboard-----------------------------------------------------------------------------------\n  $dark-gray:                  #9A9A9A !default;\n  $transparent-bg:             transparent !default;\n  $font-paragraph:               16px !default;\n\n  .text-SOS, .text-SOS:hover {\n    color: #9368E9 !important; }\n  \n.text-EME, .text-EME:hover {\n    color: #DC3545 !important; }\n  \n.text-URG, .text-URG:hover {\n    color: #FFC107 !important; }\n  \n.text-DEN, .text-DEN:hover {\n    color: #007BFF !important; }\n    \n.text-PLA, .text-PLA:hover {\n    color: #afb6c0 !important; }\n\n  .stats{\n    color: #a9a9a9;\n    font-size: 0.7rem !important;\n}\n\n  .card-category,\n  label{\n      font-size: $font-size-base;\n      font-weight: $font-weight-normal;\n      color: $dark-gray;\n      margin-bottom: 0px;\n\n      i{\n          font-size: $font-paragraph;\n      }\n  }\n\n  .card-footer{\n    padding-top: 0;\n    background-color: $transparent-bg;\n    line-height: 30px;\n    border-top: none !important;\n    font-size: 14px;\n\n    .legend{\n        padding: 5px 0;\n    }\n\n    hr{\n        margin-top: 5px;\n        margin-bottom: 5px;\n    }\n}\n\n  .card-stats{\n    .card-body{\n        padding: 15px 15px 0px;\n\n        .numbers{\n            font-size: 1.8rem;\n            text-align: right;\n\n            p{\n                margin-bottom: 0;\n            }\n        }\n    }\n    .card-footer{\n        padding: 0px 15px 10px 15px;\n    }\n    .icon-big {\n        font-size: 3em;\n        min-height: 64px;\n\n        i{\n            font-weight: 700;\n            line-height: 59px;\n        }\n    }\n}\n\n  .card-stats{\n    .card-body{\n        padding: 15px 15px 0px;\n\n        .numbers{\n            font-size: 1.8rem;\n            text-align: right;\n\n            p{\n                margin-bottom: 0;\n            }\n        }\n    }\n    .card-footer{\n        padding: 0px 15px 10px 15px;\n\n\n    }\n\n    .icon-big {\n        font-size: 3em;\n        min-height: 64px;\n\n        i{\n            font-weight: 700;\n            line-height: 59px;\n        }\n    }\n}\n\n.img-xxl {\n  width: 60px !important;\n  height: 60px !important;\n  padding: 0px;\n}\n\n  //-------------------Dashboard-----------------------------------------------------------------------------------\n\n  @media only screen and (min-width: 427px) and (max-width: 768px) {\n    .reloj1 {\n      color:  rgba(21,67,139,1) !important;\n      font-size: 0.6rem !important;\n      text-align: center !important;\n      justify-content: center !important;\n    }\n\n    .centerPie{\n      display: block;\n      margin-left: auto;\n      margin-right: auto;\n      font-size: 0.8rem !important;\n    }\n\n    .col-titulo-login{\n        border: 1px solid #eeeeee !important;\n        background-color: #fff !important;\n        border-radius: 5px !important;\n        box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;\n        margin-bottom: 10px !important;\n        padding: 10px !important;\n        margin-top: 10%;\n        margin-right: auto;\n        margin-left: auto;\n        height: 100%;\n        width: 90vw;\n        min-height: 2.5rem;\n        min-width: 2.5rem;\n      }\n\n      .btn{\n        margin-top: 20px !important;\n        padding-left: 2.5rem;\n        padding-right: 2.5rem;\n      }\n\n      .CHDivider{\n        padding: 0px !important;\n        margin-top: 0px !important;\n        margin-bottom: 0px !important;\n      }\n\n      .center-texto {\n        margin-top: 20px !important;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n\n      .left-texto {\n        justify-content: center;\n        align-items: center;\n      }\n\n      .logo-empresa {\n        width: 45%;\n        background: #FFFFFF!important;\n        border-radius: 5px !important;\n        margin-top: 0px !important;\n      }\n\n      .logo-empresa1 {\n        text-align: center !important;\n        justify-content: center !important;\n        width: 100% !important;\n        background: #FFFFFF !important;\n        border-radius: 5px !important;\n        margin-top: 0px !important;\n      }\n\n  }\n  //-------------Login---------------------------------------------------------------------------\n\n  //-----------------------------Misdenuncias------------------------------------------------------\n  .leaflet-containerCasosAct{\n\n    width: 100%;\n    height: 100%; \n  \n  }\n\n  .img-DenunciaDetalleDespacho {\n    padding: 0.1rem;\n    height: 60px;\n    max-width: 100%;\n    border-radius: 5%;\n    cursor: pointer;\n    box-shadow: 3px 5px 7px rgba(0,0,0,0.5);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .img-DenunciaDetalle {\n    padding: 0.3rem;\n    height: 80px;\n    max-width: 100%;\n    border-radius: 5%;\n    cursor: pointer;\n    box-shadow: 3px 5px 7px rgba(0,0,0,0.5);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .img-DenunciaDetalle0 {\n    padding: 0.3rem;\n    height: 120px;\n    border-radius: 5%;\n    box-shadow: 3px 5px 7px rgba(0,0,0,0.5);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .img-DenunciaDetalle1 {\n    padding: 0.5rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .Row-leaflet-containerDen {\n    padding: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #eeeeee !important;\n    background-color: #fff !important;\n    border-radius: 5px !important;\n    box-shadow: 0 2px 3px rgba(212, 207, 207, 20%), 0 3px 3px rgba(212, 207, 207, 20%) !important;\n    margin-bottom: 10px !important;\n    height: 87vh !important;\n  }\n\n  .Row-leaflet-containerDenMapa {\n    padding: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #eeeeee !important;\n    background-color: #fff !important;\n    border-radius: 5px !important;\n    box-shadow: 0 2px 3px rgba(212, 207, 207, 20%), 0 3px 3px rgba(212, 207, 207, 20%) !important;\n    margin-bottom: 10px !important;\n    height: 33vh !important;\n  }\n\n  .Row-leaflet-containerInspeccion {\n    padding: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #eeeeee !important;\n    background-color: #fff !important;\n    border-radius: 5px !important;\n    box-shadow: 0 2px 3px rgba(212, 207, 207, 20%), 0 3px 3px rgba(212, 207, 207, 20%) !important;\n    margin-bottom: 10px !important;\n    height: 66vh !important;\n  }\n\n  .Row-leaflet-containerDenAdm {\n    padding: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #eeeeee !important;\n    background-color: #fff !important;\n    border-radius: 5px !important;\n    box-shadow: 0 2px 3px rgba(212, 207, 207, 20%), 0 3px 3px rgba(212, 207, 207, 20%) !important;\n    margin-bottom: 10px !important;\n    height: 30vh !important;\n  }\n\n  .Row-leaflet-containerDenAnt {\n    padding: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #eeeeee !important;\n    background-color: #fff !important;\n    border-radius: 5px !important;\n    box-shadow: 0 2px 3px rgba(212, 207, 207, 20%), 0 3px 3px rgba(212, 207, 207, 20%) !important;\n    margin-bottom: 10px !important;\n    height: 40vh;\n  }\n\n  .Row-leaflet-containerDenGrab {\n    padding: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #eeeeee !important;\n    background-color: #fff !important;\n    border-radius: 5px !important;\n    box-shadow: 0 2px 3px rgba(212, 207, 207, 20%), 0 3px 3px rgba(212, 207, 207, 20%) !important;\n    margin-bottom: 10px !important;\n    height: 60vh !important;\n  }\n\n  .request-popup{\n    top: -340px !important;\n  }\n\n  .request-popupDistancia{\n    top: -240px !important;\n  }\n\n  .img-Denuncia {\n  \n    height: 100px;\n    max-width: 100%;\n  \n    border-radius: 5%;\n    cursor: pointer;\n    box-shadow: 3px 5px 7px rgba(0,0,0,0.5);\n  }\n\n  .img-Denuncia-despacho {\n  \n    height: 50px;\n    max-width: 100%;\n  \n    border-radius: 5%;\n    cursor: pointer;\n    box-shadow: 3px 5px 7px rgba(0,0,0,0.5);\n  }\n\n  .img-DenunciaDetalle1 {\n    padding: 0.5rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .img-DenunciaDetalle {\n    padding: 0.3rem;\n    height: 80px;\n    max-width: 100%;\n    border-radius: 5%;\n    cursor: pointer;\n    box-shadow: 3px 5px 7px rgba(0,0,0,0.5);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .img-DenunciaDetalle0 {\n    padding: 0.3rem;\n    height: 120px;\n    border-radius: 5%;\n    box-shadow: 3px 5px 7px rgba(0,0,0,0.5);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .textoCuadroDespacho {\n    font-size: 0.7rem !important;\n  }\n\n  .textoCuadroPosicion {\n    font-size: 1rem !important;\n  }\n\n  .textocentradoAntecedentes1 {\n    color: $text-color3 !important;\n    font-size: 0.8rem !important;\n  }\n  .textocentradoAntecedentes2 {\n    color: $base-color !important;\n    font-size: 0.8rem !important;\n  }\n  \n  .textocentradoAntecedentes1Titulo {\n    color: $text-color3 !important;\n    font-size: 1rem !important;\n  }\n\n  .textocentradoAntecedentes1TituloTurno {\n    color: $blue-color1 !important;\n    font-size: 1.2rem !important;\n  }\n\n  .textocentradoAntecedentes2Titulo {\n    color: $base-color !important;\n    font-size: 1rem !important;\n  }\n\n  .text-primary, .text-primary:hover{\n    color: #1D62F0 !important;\n}\n\n\n.card-stats{\n  .card-body{\n      padding: 15px 15px 0px;\n\n      .numbers{\n          font-size: 1.8rem;\n          text-align: right;\n\n          p{\n              margin-bottom: 0;\n          }\n      }\n  }\n  .card-footer{\n      padding: 0px 15px 10px 15px;\n\n\n  }\n  .icon-big {\n      font-size: 3em;\n      min-height: 64px;\n\n      i{\n          font-weight: 700;\n          line-height: 59px;\n      }\n  }\n\n\n}\n\n.img-pointer {\n  cursor: pointer;\n}\n\n.inputfile {\n\twidth: 0.1px;\n\theight: 0.1px;\n\topacity: 0;\n\toverflow: hidden;\n\tposition: absolute;\n\tz-index: -1;\n}\n\n.fondo_antecedentes{\n  box-shadow: 3px 5px 7px rgba(0,0,0,0.5);\n  border: 3px solid rgb(204, 204, 204);\n}\n\n.img-DenunciaAntecedente {\n  height: 4rem;\n  width: 4rem;\n  min-height: 4rem;\n  min-width: 4rem;\n  color: #fff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 600;\n  border-radius: 50%;\n  padding: 0.1rem;\n  cursor: pointer;\n  box-shadow: 3px 5px 7px rgba(0,0,0,0.5);\n  align-items: center;\n}\n\n.custom-checkbox-reverse {\n  padding-left: 0;\n  padding-right: 1.5rem;\n}\n\n.custom-checkbox-reverse .custom-control-label::before,\n.custom-checkbox-reverse .custom-control-label::after {\n  left: auto;\n  right: -1.5rem;\n}\n\n\n.offcanvas-start {\n  transform: translateX(-100%) !important;\n}\n\n.offcanvas-end {\n  transform: translateX(100%) !important;\n}\n\n.offcanvas.show {\n  -webkit-transform: none !important;\n  transform: none !important;\n}\n    //-----------------------------Misdenuncias------------------------------------------------------\n\n\n    //-----------------------Registro User ----------------------------------------------------------\n\n    .flag-img1{\n      width: 55px;\n      height: 25px;\n      position: flex;\n      border-radius: 5px;\n      border: 1px solid;\n    }\n\n    .icon-login{\n      font-size: 35px !important;\n      padding: 0px 0 0 5px !important;\n      position: flex !important;\n      border-radius: 5px !important;\n    }\n\n    .form-control.input-error {\n      border: 1px solid #f21e08 !important;\n    }\n\n    .text-danger, .text-danger:hover{\n      color: $blue-color1 !important;\n  }\n\n    .um_data {\n      border: 1px solid #eeeeee !important;\n      border-radius: 4px;\n      box-shadow: 0 2px 3px rgba(212, 207, 207, 20%), 0 3px 3px rgba(212, 207, 207, 20%) !important;\n      padding: 5px 10px 5px;\n      margin-bottom: 10px;\n    \n    }\n\n    .leaflet-container{\n      border-radius: 5px;\n      width: 100%; \n      height: 160px; \n      border: 1px \n      solid #c0c0c0 !important;\n    }\n\n    .col-texto-registro {\n      display: flex !important;\n      font-size: 1.5rem !important;\n      justify-content: center !important;\n    }\n\n    .col-titulo-registro{\n\n      background-color: #fff !important;\n      border-radius: 5px !important;\n      text-align: center;\n      padding: 10px !important;\n    }\n\n\n    .steps {\n      display: flex;\n      justify-content: center;\n    \n      margin-top: 0rem;\n    \n      .step {\n        margin: 0.5rem 1.5rem;\n        display: flex;\n        color: #ccc !important;\n        \n    \n        a {\n          color: $base-color;\n        }\n    \n        div:first-of-type {\n          border: 1px solid #ccc !important;\n          padding: 5px;\n          border-radius: 50%;\n          margin-right: 0.5rem;\n          width: 2.5rem;\n          height: 2rem;\n          text-align: center;\n          line-height: 100%;\n          padding-top: 2%;\n          font-size: 1.5rem;\n        }\n    \n        :last-child {\n          margin-top: 3%;\n        }\n    \n        &.active {\n          div:first-of-type {\n            background-color: $blue-color;\n            border: 1px solid transparent;\n            color: #fff;\n          }\n    \n          div:last-of-type {\n            color: $blue-color;\n          }\n        }\n      }\n    }\n\n    .col-titulo-loginR{\n      border: 1px solid #eeeeee !important;\n      background-color: #fff !important;\n      border-radius: 5px !important;\n      box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;\n      margin-bottom: 10px !important;\n      padding: 10px !important;\n      margin-top: 3%;\n      margin-right: auto;\n      margin-left: auto;\n      height: 100%;\n      width: 45vw;\n      min-height: 2.5rem;\n      min-width: 2.5rem;\n    }\n\n\n    .react-tel-input {\n      font-size: 0.9rem !important;\n    }\n    \n    .react-tel-input .form-control {\n      margin-top: 0 !important;\n      margin-bottom: 0 !important;\n      height: 3.5rem !important;\n      position: relative;\n      letter-spacing: .01rem;\n      border-radius: 0 !important;\n      margin-top: 0 !important;\n      margin-bottom: 0 !important;\n      width: 100% !important;\n      font-size: 0.9rem !important;\n    }\n\n\n    //-----------------------Registro User -------------------------------------------------------------\n\n    //-----------------------MapaCasos-------------------------------------------------------------------\n    .col-titulo-denuncia{\n      border: 1px solid #eeeeee !important;\n      background-color: #fff !important;\n      border-radius: 5px !important;\n      box-shadow: 0 2px 3px rgba(212, 207, 207, 20%), 0 3px 3px rgba(212, 207, 207, 20%) !important;\n      margin-bottom: 5px !important;\n      padding: 5px !important;\n    \n    }\n\n    .col-texto-denuncia {\n      display: flex !important;\n      font-size: 1.5rem !important;\n      justify-content: center !important;\n    }\n\n    .logo-titulos {\n      width: 50px; \n      height: 50px;\n      alt: \"\";\n      \n    }\n\n    .logo-titulosDenuncia {\n      width: 50px; \n      height: 50px;\n      padding: 0.2rem;\n    }\n\n    .logo-titulos-inspeccion {\n      width: 30px; \n      height: 30px;\n      alt: \"\";\n      \n    }\n    .Row-leaflet-containerCasosAct {\n      min-height: 31vh;\n      padding: 1.5rem;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      border: 1px solid #eeeeee !important;\n      background-color: #fff !important;\n      border-radius: 5px !important;\n      box-shadow: 0 2px 3px rgba(212, 207, 207, 20%), 0 3px 3px rgba(212, 207, 207, 20%) !important;\n      margin-bottom: 10px !important;\n    \n    }\n\n    .Row-leaflet-containerTurnos {\n      min-height: 31vh;\n      padding: 0.5rem;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      border: 1px solid #eeeeee !important;\n      background-color: #fff !important;\n      border-radius: 5px !important;\n      box-shadow: 0 2px 3px rgba(212, 207, 207, 20%), 0 3px 3px rgba(212, 207, 207, 20%) !important;\n      margin-bottom: 10px !important;\n    \n    }\n\n    .img-DenunciaAntecedente2 {\n      height: 3rem;\n      width: 3rem;\n      min-height: 3rem;\n      min-width: 3rem;\n      color: #e67e22 !important;\n      font-size: 0.6rem !important;\n      font-weight:bold !important;\n      border-radius: 50%;\n      padding: 0.1rem;\n      cursor: pointer;\n      box-shadow: 3px 5px 7px rgba(0,0,0,0.5);\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n    }\n\n    .circleTip {\n      box-shadow: none;\n      border-radius: 6px;\n      border: 1px solid #007BFF;\n      padding: 5px;\n      font-size: 10px;\n      font-weight: 600;\n      text-align: center;\n    }\n    \n    .circleTipclassic1 {\n      background: #fdfde1; \n      border: 1px solid #FFAD33;\n      font-weight: 800;\n    }\n    \n    .circleTipclassic {\n      background: #fdfde1; \n      background-color: rgba(255, 255, 255, 0.4);\n      border: 0px solid #FFAD33;\n      font-size: 0.6rem !important;\n      font-weight:bold !important;\n      white-space: pre-wrap;\n      text-align: center;\n    }\n    \n    .classic { background: #FFFFAA; border: 1px solid #FFAD33; } \n    .critical { background: #FFCCAA; border: 1px solid #FF3334; } \n    .help { background: #9FDAEE; border: 1px solid #2BB0D7; } \n    .info { background: #9FDAEE; border: 1px solid #2BB0D7; } .warning { background: #FFFFAA; border: 1px solid #FFAD33; }\n\n        //-----------------------MapaCasos-------------------------------------------------------------------\n\n\n         //-----------------------Perfil-------------------------------------------------------------------\n\n    .card-user{\n          .card-image{\n              height: 110px;\n          }\n          .card-image-plain{\n              height: 0;\n              margin-top: 110px;\n          }\n          .author{\n              text-align: center;\n              text-transform: none;\n              margin-top: -70px;\n          }\n          .avatar{\n              width: 124px;\n              height: 124px;\n              border: 5px solid #FFFFFF;\n              position: relative;\n              margin-bottom: 15px;\n      \n              &.border-gray{\n                  border-color: #EEEEEE;\n              }\n          }\n          .title{\n              line-height: 24px;\n              font-size: 12px;\n          }\n          .card-body{\n              min-height: 240px;\n          }\n    }\n      \n      .card-user,\n      .card-price{\n          .card-footer{\n              padding: 5px 15px 10px;\n          }\n          hr{\n              margin: 5px 15px;\n          }\n      }\n\n      .img-avatar {\n          width: 40px;\n          height: 40px;\n          \n          cursor: pointer;\n        }\n\n        .img-avatar-Despacho {\n          width: 40px;\n          height: 30px;\n          cursor: pointer;\n        }\n\n          //-----------------------Perfil-------------------------------------------------------------------\n\n          .mymarker svg path { fill: black; }\n    .mymarker {\n      transition: transform 0.5s linear;\n    }\n    .indicator {\n      font-family: \"Aldrich\",\"Helvetica Neue\",Arial,sans-serif;\n      background-color: white;\n      border: 1px solid dodgerblue;\n      border-radius: 6px;\n      color: dodgerblue;\n      font-size: 8px;\n      font-weight: 400;\n      padding: 2px 4px;\n      position: relative;\n      bottom: 25px;\n      white-space: nowrap;\n      transition: transform 0.5s linear;\n      top: 25px;\n      left: -20px;\n    }\n\n    .indicator1 {\n      font-family: \"Aldrich\",\"Helvetica Neue\",Arial,sans-serif;\n      background-color: white;\n      border: 1px solid #e67e22;\n      border-radius: 6px;\n      color: #e67e22;\n      font-size: 8px;\n      font-weight: 400;\n      padding: 2px 4px;\n      position: relative;\n      bottom: 25px;\n      \n      white-space: nowrap;\n      transition: transform 0.5s linear;\n      top: 25px;\n      left: -20px;\n    }\n\n    .indicatorD {\n      font-family: \"Aldrich\",\"Helvetica Neue\",Arial,sans-serif;\n      background-color: white;\n      border: 1px solid #22ac11;\n      border-radius: 6px;\n      color: #22ac11;\n      font-size: 8px;\n      font-weight: 400;\n      padding: 2px 4px;\n      position: relative;\n      bottom: 25px;\n      white-space: nowrap;\n      transition: transform 0.5s linear;\n      top: 25px;\n      left: -20px;\n    }\n\n    .indicatorND {\n      font-family: \"Aldrich\",\"Helvetica Neue\",Arial,sans-serif;\n      background-color: white;\n      border: 1px solid #DC3545;\n      border-radius: 6px;\n      color: #DC3545;\n      font-size: 8px;\n      font-weight: 400;\n      padding: 2px 4px;\n      position: relative;\n      bottom: 25px;\n      white-space: nowrap;\n      transition: transform 0.5s linear;\n      top: 25px;\n      left: -20px;\n    }\n\n    .indicatorY {\n      font-family: \"Aldrich\",\"Helvetica Neue\",Arial,sans-serif;\n      background-color: white;\n      border: 1px solid dodgerblue;\n      border-radius: 6px;\n      color: dodgerblue;\n      font-size: 8px;\n      font-weight: 400;\n      padding: 2px 4px;\n      position: relative;\n      bottom: 25px;\n      white-space: nowrap;\n      transition: transform 0.5s linear;\n      top: 5px;\n      left: -20px;\n    }\n\n    .StyleSelect {\n      font-size: 1.8rem !important; \n      resize: 'none' !important\n    }\n\n    .StyleSelectPrioridad {\n      font-size: 1.0rem !important; \n      resize: 'none' !important\n    }\n\n    .StyleSelectFechas{\n      font-size: 1.5rem !important; \n      resize: 'none' !important\n    }\n\n    .StyleSelectFechasJPL{\n      font-size: 1.3rem !important; \n      resize: 'none' !important\n    }\n    \n\n    .datetimeControl p {\n      margin: 0;\n      font-size: 16px;\n  }\n\n  .audioControl{\n    width: 550px !important; \n    height: 50px !important;\n  }\n  \n    @media screen and (max-width:426px) {\n      .textoOption {\n        font-size: 0.7rem !important;\n      }\n\n      .col-texto-denuncia {\n        display: flex !important;\n        font-size: 1.0rem !important;\n        justify-content: center !important;\n      }\n      \n      .col-titulo-login{\n        border: 1px solid #eeeeee !important;\n        background-color: #fff !important;\n        border-radius: 5px !important;\n        box-shadow: 0 2px 3px #d4cfcf, 0 3px 3px #d4cfcf !important;\n        margin-bottom: 10px !important;\n        padding: 10px !important;\n        margin-top: 3%;\n        margin-right: auto;\n        margin-left: auto;\n        height: 100%;\n        width: 90vw;\n        min-height: 2.5rem;\n        min-width: 2.5rem;\n      }\n\n      .centerT {\n        margin-top: -5px !important;\n        display: flex;\n        align-items: center;\n        width: 45%;\n      }\n\n      .reloj1 {\n        color:  rgba(21,67,139,1) !important;\n        font-size: 0.5rem !important;\n        text-align: center !important;\n        justify-content: center !important;\n      }\n\n      .centerPie{\n        display: block;\n        margin-left: auto;\n        margin-right: auto;\n        font-size: 0.6rem !important;\n      }\n\n      .steps {\n        display: flex;\n        justify-content: center;\n      \n        margin-top: 0rem;\n      \n        .step {\n          margin: 0.5rem 1.0rem;\n          display: flex;\n          color: #ccc !important;\n          \n      \n          a {\n            color: $base-color;\n          }\n      \n          div:first-of-type {\n            border: 1px solid #ccc !important;\n            padding: 5px;\n            border-radius: 50%;\n            margin-right: 0.5rem;\n            width: 1.5rem;\n            height: 1.5rem;\n            text-align: center;\n            line-height: 100%;\n            padding-top: 2%;\n            font-size: 1.0rem;\n          }\n      \n          :last-child {\n            margin-top: 2%;\n          }\n      \n          &.active {\n            div:first-of-type {\n              background-color: $blue-color;\n              border: 1px solid transparent;\n              color: #fff;\n            }\n      \n            div:last-of-type {\n              color: $blue-color;\n            }\n          }\n        }\n      }\n\n      .StyleSelect {\n        font-size: 1.2rem !important; \n        resize: 'none' !important\n      }\n\n      .StyleSelectFechas{\n        font-size: 1.0rem !important; \n        resize: 'none' !important\n      }\n\n      .StyleSelectFechasJPL{\n        font-size: 1.0rem !important; \n        resize: 'none' !important\n      }\n      \n\n      .audioControl{\n        width: 250px !important; \n        height: 50px !important;\n      }\n\n      .logo-empresa1 {\n        text-align: center !important;\n        justify-content: center !important;\n        width: 100% !important;\n        background: #FFFFFF !important;\n        border-radius: 5px !important;\n        margin-top: 5px !important;\n      }\n      \n      .logo-empresaT {\n        width: 100% !important;\n        background: #FFFFFF !important;\n        border-radius: 5px !important;\n        margin-top: 2px !important;\n      }\n\n      .logo-empresaT_MAHO {\n        width: 100%;\n        background: #FFFFFF !important;\n        border-radius: 5px !important;\n        margin-top: 2px !important;\n      }\n      .Row-leaflet-containerDen {\n        padding: 1.5rem;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        border: 1px solid #eeeeee !important;\n        background-color: #fff !important;\n        border-radius: 5px !important;\n        box-shadow: 0 2px 3px rgba(212, 207, 207, 20%), 0 3px 3px rgba(212, 207, 207, 20%) !important;\n        margin-bottom: 10px !important;\n        height: 60vh !important;\n      }\n\n      .Row-leaflet-containerDenMapa {\n        padding: 1.5rem;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        border: 1px solid #eeeeee !important;\n        background-color: #fff !important;\n        border-radius: 5px !important;\n        box-shadow: 0 2px 3px rgba(212, 207, 207, 20%), 0 3px 3px rgba(212, 207, 207, 20%) !important;\n        margin-bottom: 10px !important;\n        height: 60vh !important;\n      }\n\n      .Row-leaflet-containerInspeccion {\n        padding: 1.5rem;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        border: 1px solid #eeeeee !important;\n        background-color: #fff !important;\n        border-radius: 5px !important;\n        box-shadow: 0 2px 3px rgba(212, 207, 207, 20%), 0 3px 3px rgba(212, 207, 207, 20%) !important;\n        margin-bottom: 10px !important;\n        height: 40vh !important;\n      }\n      \n\n      .textoTurno {\n        font-size: 0.8rem !important;\n      }\n\n    }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
